
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9YEav", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("fJThW", function(module, exports) {
/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ 
var $lLL9c = parcelRequire("lLL9c");
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$elementMap = new Map();
const $b755f21505b17578$var$Data = {
    set (element, key, instance) {
        if (!$b755f21505b17578$var$elementMap.has(element)) $b755f21505b17578$var$elementMap.set(element, new Map());
        const instanceMap = $b755f21505b17578$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($b755f21505b17578$var$elementMap.has(element)) return $b755f21505b17578$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$b755f21505b17578$var$elementMap.has(element)) return;
        const instanceMap = $b755f21505b17578$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $b755f21505b17578$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $b755f21505b17578$var$MAX_UID = 1000000;
const $b755f21505b17578$var$MILLISECONDS_MULTIPLIER = 1000;
const $b755f21505b17578$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $b755f21505b17578$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $b755f21505b17578$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $b755f21505b17578$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $b755f21505b17578$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $b755f21505b17578$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $b755f21505b17578$var$MILLISECONDS_MULTIPLIER;
};
const $b755f21505b17578$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($b755f21505b17578$var$TRANSITION_END));
};
const $b755f21505b17578$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $b755f21505b17578$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($b755f21505b17578$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($b755f21505b17578$var$parseSelector(object));
    return null;
};
const $b755f21505b17578$var$isVisible = (element)=>{
    if (!$b755f21505b17578$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $b755f21505b17578$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $b755f21505b17578$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $b755f21505b17578$var$findShadowRoot(element.parentNode);
};
const $b755f21505b17578$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $b755f21505b17578$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $b755f21505b17578$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $b755f21505b17578$var$DOMContentLoadedCallbacks = [];
const $b755f21505b17578$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$b755f21505b17578$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $b755f21505b17578$var$DOMContentLoadedCallbacks)callback();
        });
        $b755f21505b17578$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $b755f21505b17578$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $b755f21505b17578$var$defineJQueryPlugin = (plugin)=>{
    $b755f21505b17578$var$onDOMContentLoaded(()=>{
        const $ = $b755f21505b17578$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $b755f21505b17578$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback(...args) : defaultValue;
};
const $b755f21505b17578$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $b755f21505b17578$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $b755f21505b17578$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($b755f21505b17578$var$TRANSITION_END, handler);
        $b755f21505b17578$var$execute(callback);
    };
    transitionElement.addEventListener($b755f21505b17578$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $b755f21505b17578$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $b755f21505b17578$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $b755f21505b17578$var$stripNameRegex = /\..*/;
const $b755f21505b17578$var$stripUidRegex = /::\d+$/;
const $b755f21505b17578$var$eventRegistry = {}; // Events storage
let $b755f21505b17578$var$uidEvent = 1;
const $b755f21505b17578$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $b755f21505b17578$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $b755f21505b17578$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$b755f21505b17578$var$uidEvent++}` || element.uidEvent || $b755f21505b17578$var$uidEvent++;
}
function $b755f21505b17578$var$getElementEvents(element) {
    const uid = $b755f21505b17578$var$makeEventUid(element);
    element.uidEvent = uid;
    $b755f21505b17578$var$eventRegistry[uid] = $b755f21505b17578$var$eventRegistry[uid] || {};
    return $b755f21505b17578$var$eventRegistry[uid];
}
function $b755f21505b17578$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $b755f21505b17578$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $b755f21505b17578$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $b755f21505b17578$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $b755f21505b17578$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $b755f21505b17578$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $b755f21505b17578$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $b755f21505b17578$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $b755f21505b17578$var$getTypeEvent(originalTypeEvent);
    if (!$b755f21505b17578$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $b755f21505b17578$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $b755f21505b17578$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $b755f21505b17578$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $b755f21505b17578$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $b755f21505b17578$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $b755f21505b17578$var$makeEventUid(callable, originalTypeEvent.replace($b755f21505b17578$var$namespaceRegex, ''));
    const fn = isDelegated ? $b755f21505b17578$var$bootstrapDelegationHandler(element, handler, callable) : $b755f21505b17578$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $b755f21505b17578$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $b755f21505b17578$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $b755f21505b17578$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $b755f21505b17578$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $b755f21505b17578$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($b755f21505b17578$var$stripNameRegex, '');
    return $b755f21505b17578$var$customEvents[event] || event;
}
const $b755f21505b17578$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $b755f21505b17578$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $b755f21505b17578$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $b755f21505b17578$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $b755f21505b17578$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $b755f21505b17578$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$b755f21505b17578$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($b755f21505b17578$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $b755f21505b17578$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $b755f21505b17578$var$getjQuery();
        const typeEvent = $b755f21505b17578$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $b755f21505b17578$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $b755f21505b17578$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $b755f21505b17578$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $b755f21505b17578$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $b755f21505b17578$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$b755f21505b17578$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$b755f21505b17578$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $b755f21505b17578$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $b755f21505b17578$var$normalizeData(element.getAttribute(`data-bs-${$b755f21505b17578$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $b755f21505b17578$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $b755f21505b17578$var$isElement(element) ? $b755f21505b17578$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$b755f21505b17578$var$isElement(element) ? $b755f21505b17578$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $b755f21505b17578$var$isElement(value) ? 'element' : $b755f21505b17578$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$VERSION = '5.3.3';
/**
 * Class definition
 */ class $b755f21505b17578$var$BaseComponent extends $b755f21505b17578$var$Config {
    constructor(element, config){
        super();
        element = $b755f21505b17578$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $b755f21505b17578$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $b755f21505b17578$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $b755f21505b17578$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $b755f21505b17578$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $b755f21505b17578$var$Data.get($b755f21505b17578$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $b755f21505b17578$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $b755f21505b17578$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$b755f21505b17578$var$parseSelector(sel)).join(',') : null;
};
const $b755f21505b17578$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$b755f21505b17578$var$isDisabled(el) && $b755f21505b17578$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $b755f21505b17578$var$getSelector(element);
        if (selector) return $b755f21505b17578$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $b755f21505b17578$var$getSelector(element);
        return selector ? $b755f21505b17578$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $b755f21505b17578$var$getSelector(element);
        return selector ? $b755f21505b17578$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $b755f21505b17578$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $b755f21505b17578$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($b755f21505b17578$var$isDisabled(this)) return;
        const target = $b755f21505b17578$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$NAME$f = 'alert';
const $b755f21505b17578$var$DATA_KEY$a = 'bs.alert';
const $b755f21505b17578$var$EVENT_KEY$b = `.${$b755f21505b17578$var$DATA_KEY$a}`;
const $b755f21505b17578$var$EVENT_CLOSE = `close${$b755f21505b17578$var$EVENT_KEY$b}`;
const $b755f21505b17578$var$EVENT_CLOSED = `closed${$b755f21505b17578$var$EVENT_KEY$b}`;
const $b755f21505b17578$var$CLASS_NAME_FADE$5 = 'fade';
const $b755f21505b17578$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $b755f21505b17578$export$caec2af78bcc877f extends $b755f21505b17578$var$BaseComponent {
    // Getters
    static get NAME() {
        return $b755f21505b17578$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($b755f21505b17578$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($b755f21505b17578$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b755f21505b17578$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $b755f21505b17578$var$enableDismissTrigger($b755f21505b17578$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $b755f21505b17578$var$defineJQueryPlugin($b755f21505b17578$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$NAME$e = 'button';
const $b755f21505b17578$var$DATA_KEY$9 = 'bs.button';
const $b755f21505b17578$var$EVENT_KEY$a = `.${$b755f21505b17578$var$DATA_KEY$9}`;
const $b755f21505b17578$var$DATA_API_KEY$6 = '.data-api';
const $b755f21505b17578$var$CLASS_NAME_ACTIVE$3 = 'active';
const $b755f21505b17578$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $b755f21505b17578$var$EVENT_CLICK_DATA_API$6 = `click${$b755f21505b17578$var$EVENT_KEY$a}${$b755f21505b17578$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $b755f21505b17578$export$353f5b6fc5456de1 extends $b755f21505b17578$var$BaseComponent {
    // Getters
    static get NAME() {
        return $b755f21505b17578$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($b755f21505b17578$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b755f21505b17578$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $b755f21505b17578$var$EventHandler.on(document, $b755f21505b17578$var$EVENT_CLICK_DATA_API$6, $b755f21505b17578$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($b755f21505b17578$var$SELECTOR_DATA_TOGGLE$5);
    const data = $b755f21505b17578$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $b755f21505b17578$var$defineJQueryPlugin($b755f21505b17578$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$NAME$d = 'swipe';
const $b755f21505b17578$var$EVENT_KEY$9 = '.bs.swipe';
const $b755f21505b17578$var$EVENT_TOUCHSTART = `touchstart${$b755f21505b17578$var$EVENT_KEY$9}`;
const $b755f21505b17578$var$EVENT_TOUCHMOVE = `touchmove${$b755f21505b17578$var$EVENT_KEY$9}`;
const $b755f21505b17578$var$EVENT_TOUCHEND = `touchend${$b755f21505b17578$var$EVENT_KEY$9}`;
const $b755f21505b17578$var$EVENT_POINTERDOWN = `pointerdown${$b755f21505b17578$var$EVENT_KEY$9}`;
const $b755f21505b17578$var$EVENT_POINTERUP = `pointerup${$b755f21505b17578$var$EVENT_KEY$9}`;
const $b755f21505b17578$var$POINTER_TYPE_TOUCH = 'touch';
const $b755f21505b17578$var$POINTER_TYPE_PEN = 'pen';
const $b755f21505b17578$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $b755f21505b17578$var$SWIPE_THRESHOLD = 40;
const $b755f21505b17578$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $b755f21505b17578$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $b755f21505b17578$var$Swipe extends $b755f21505b17578$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$b755f21505b17578$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $b755f21505b17578$var$Default$c;
    }
    static get DefaultType() {
        return $b755f21505b17578$var$DefaultType$c;
    }
    static get NAME() {
        return $b755f21505b17578$var$NAME$d;
    }
    // Public
    dispose() {
        $b755f21505b17578$var$EventHandler.off(this._element, $b755f21505b17578$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $b755f21505b17578$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $b755f21505b17578$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $b755f21505b17578$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $b755f21505b17578$var$EventHandler.on(this._element, $b755f21505b17578$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $b755f21505b17578$var$EventHandler.on(this._element, $b755f21505b17578$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($b755f21505b17578$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $b755f21505b17578$var$EventHandler.on(this._element, $b755f21505b17578$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $b755f21505b17578$var$EventHandler.on(this._element, $b755f21505b17578$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $b755f21505b17578$var$EventHandler.on(this._element, $b755f21505b17578$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $b755f21505b17578$var$POINTER_TYPE_PEN || event.pointerType === $b755f21505b17578$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$NAME$c = 'carousel';
const $b755f21505b17578$var$DATA_KEY$8 = 'bs.carousel';
const $b755f21505b17578$var$EVENT_KEY$8 = `.${$b755f21505b17578$var$DATA_KEY$8}`;
const $b755f21505b17578$var$DATA_API_KEY$5 = '.data-api';
const $b755f21505b17578$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $b755f21505b17578$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $b755f21505b17578$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $b755f21505b17578$var$ORDER_NEXT = 'next';
const $b755f21505b17578$var$ORDER_PREV = 'prev';
const $b755f21505b17578$var$DIRECTION_LEFT = 'left';
const $b755f21505b17578$var$DIRECTION_RIGHT = 'right';
const $b755f21505b17578$var$EVENT_SLIDE = `slide${$b755f21505b17578$var$EVENT_KEY$8}`;
const $b755f21505b17578$var$EVENT_SLID = `slid${$b755f21505b17578$var$EVENT_KEY$8}`;
const $b755f21505b17578$var$EVENT_KEYDOWN$1 = `keydown${$b755f21505b17578$var$EVENT_KEY$8}`;
const $b755f21505b17578$var$EVENT_MOUSEENTER$1 = `mouseenter${$b755f21505b17578$var$EVENT_KEY$8}`;
const $b755f21505b17578$var$EVENT_MOUSELEAVE$1 = `mouseleave${$b755f21505b17578$var$EVENT_KEY$8}`;
const $b755f21505b17578$var$EVENT_DRAG_START = `dragstart${$b755f21505b17578$var$EVENT_KEY$8}`;
const $b755f21505b17578$var$EVENT_LOAD_DATA_API$3 = `load${$b755f21505b17578$var$EVENT_KEY$8}${$b755f21505b17578$var$DATA_API_KEY$5}`;
const $b755f21505b17578$var$EVENT_CLICK_DATA_API$5 = `click${$b755f21505b17578$var$EVENT_KEY$8}${$b755f21505b17578$var$DATA_API_KEY$5}`;
const $b755f21505b17578$var$CLASS_NAME_CAROUSEL = 'carousel';
const $b755f21505b17578$var$CLASS_NAME_ACTIVE$2 = 'active';
const $b755f21505b17578$var$CLASS_NAME_SLIDE = 'slide';
const $b755f21505b17578$var$CLASS_NAME_END = 'carousel-item-end';
const $b755f21505b17578$var$CLASS_NAME_START = 'carousel-item-start';
const $b755f21505b17578$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $b755f21505b17578$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $b755f21505b17578$var$SELECTOR_ACTIVE = '.active';
const $b755f21505b17578$var$SELECTOR_ITEM = '.carousel-item';
const $b755f21505b17578$var$SELECTOR_ACTIVE_ITEM = $b755f21505b17578$var$SELECTOR_ACTIVE + $b755f21505b17578$var$SELECTOR_ITEM;
const $b755f21505b17578$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $b755f21505b17578$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $b755f21505b17578$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $b755f21505b17578$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $b755f21505b17578$var$KEY_TO_DIRECTION = {
    [$b755f21505b17578$var$ARROW_LEFT_KEY$1]: $b755f21505b17578$var$DIRECTION_RIGHT,
    [$b755f21505b17578$var$ARROW_RIGHT_KEY$1]: $b755f21505b17578$var$DIRECTION_LEFT
};
const $b755f21505b17578$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $b755f21505b17578$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $b755f21505b17578$export$144901db2ea8e967 extends $b755f21505b17578$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $b755f21505b17578$var$SelectorEngine.findOne($b755f21505b17578$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $b755f21505b17578$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $b755f21505b17578$var$Default$b;
    }
    static get DefaultType() {
        return $b755f21505b17578$var$DefaultType$b;
    }
    static get NAME() {
        return $b755f21505b17578$var$NAME$c;
    }
    // Public
    next() {
        this._slide($b755f21505b17578$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $b755f21505b17578$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($b755f21505b17578$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $b755f21505b17578$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $b755f21505b17578$var$EventHandler.one(this._element, $b755f21505b17578$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $b755f21505b17578$var$EventHandler.one(this._element, $b755f21505b17578$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $b755f21505b17578$var$ORDER_NEXT : $b755f21505b17578$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $b755f21505b17578$var$EventHandler.on(this._element, $b755f21505b17578$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $b755f21505b17578$var$EventHandler.on(this._element, $b755f21505b17578$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $b755f21505b17578$var$EventHandler.on(this._element, $b755f21505b17578$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $b755f21505b17578$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $b755f21505b17578$var$SelectorEngine.find($b755f21505b17578$var$SELECTOR_ITEM_IMG, this._element))$b755f21505b17578$var$EventHandler.on(img, $b755f21505b17578$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $b755f21505b17578$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($b755f21505b17578$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($b755f21505b17578$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $b755f21505b17578$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $b755f21505b17578$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $b755f21505b17578$var$SelectorEngine.findOne($b755f21505b17578$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($b755f21505b17578$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $b755f21505b17578$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($b755f21505b17578$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $b755f21505b17578$var$ORDER_NEXT;
        const nextElement = element || $b755f21505b17578$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $b755f21505b17578$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($b755f21505b17578$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $b755f21505b17578$var$CLASS_NAME_START : $b755f21505b17578$var$CLASS_NAME_END;
        const orderClassName = isNext ? $b755f21505b17578$var$CLASS_NAME_NEXT : $b755f21505b17578$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $b755f21505b17578$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($b755f21505b17578$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($b755f21505b17578$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($b755f21505b17578$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($b755f21505b17578$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $b755f21505b17578$var$SelectorEngine.findOne($b755f21505b17578$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $b755f21505b17578$var$SelectorEngine.find($b755f21505b17578$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($b755f21505b17578$var$isRTL()) return direction === $b755f21505b17578$var$DIRECTION_LEFT ? $b755f21505b17578$var$ORDER_PREV : $b755f21505b17578$var$ORDER_NEXT;
        return direction === $b755f21505b17578$var$DIRECTION_LEFT ? $b755f21505b17578$var$ORDER_NEXT : $b755f21505b17578$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($b755f21505b17578$var$isRTL()) return order === $b755f21505b17578$var$ORDER_PREV ? $b755f21505b17578$var$DIRECTION_LEFT : $b755f21505b17578$var$DIRECTION_RIGHT;
        return order === $b755f21505b17578$var$ORDER_PREV ? $b755f21505b17578$var$DIRECTION_RIGHT : $b755f21505b17578$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b755f21505b17578$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $b755f21505b17578$var$EventHandler.on(document, $b755f21505b17578$var$EVENT_CLICK_DATA_API$5, $b755f21505b17578$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $b755f21505b17578$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($b755f21505b17578$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $b755f21505b17578$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($b755f21505b17578$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$b755f21505b17578$var$EventHandler.on(window, $b755f21505b17578$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $b755f21505b17578$var$SelectorEngine.find($b755f21505b17578$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$b755f21505b17578$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $b755f21505b17578$var$defineJQueryPlugin($b755f21505b17578$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$NAME$b = 'collapse';
const $b755f21505b17578$var$DATA_KEY$7 = 'bs.collapse';
const $b755f21505b17578$var$EVENT_KEY$7 = `.${$b755f21505b17578$var$DATA_KEY$7}`;
const $b755f21505b17578$var$DATA_API_KEY$4 = '.data-api';
const $b755f21505b17578$var$EVENT_SHOW$6 = `show${$b755f21505b17578$var$EVENT_KEY$7}`;
const $b755f21505b17578$var$EVENT_SHOWN$6 = `shown${$b755f21505b17578$var$EVENT_KEY$7}`;
const $b755f21505b17578$var$EVENT_HIDE$6 = `hide${$b755f21505b17578$var$EVENT_KEY$7}`;
const $b755f21505b17578$var$EVENT_HIDDEN$6 = `hidden${$b755f21505b17578$var$EVENT_KEY$7}`;
const $b755f21505b17578$var$EVENT_CLICK_DATA_API$4 = `click${$b755f21505b17578$var$EVENT_KEY$7}${$b755f21505b17578$var$DATA_API_KEY$4}`;
const $b755f21505b17578$var$CLASS_NAME_SHOW$7 = 'show';
const $b755f21505b17578$var$CLASS_NAME_COLLAPSE = 'collapse';
const $b755f21505b17578$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $b755f21505b17578$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $b755f21505b17578$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$b755f21505b17578$var$CLASS_NAME_COLLAPSE} .${$b755f21505b17578$var$CLASS_NAME_COLLAPSE}`;
const $b755f21505b17578$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $b755f21505b17578$var$WIDTH = 'width';
const $b755f21505b17578$var$HEIGHT = 'height';
const $b755f21505b17578$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $b755f21505b17578$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $b755f21505b17578$var$Default$a = {
    parent: null,
    toggle: true
};
const $b755f21505b17578$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $b755f21505b17578$export$78768a9af065a7b extends $b755f21505b17578$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $b755f21505b17578$var$SelectorEngine.find($b755f21505b17578$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $b755f21505b17578$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $b755f21505b17578$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $b755f21505b17578$var$Default$a;
    }
    static get DefaultType() {
        return $b755f21505b17578$var$DefaultType$a;
    }
    static get NAME() {
        return $b755f21505b17578$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($b755f21505b17578$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$b755f21505b17578$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($b755f21505b17578$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($b755f21505b17578$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($b755f21505b17578$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($b755f21505b17578$var$CLASS_NAME_COLLAPSE, $b755f21505b17578$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $b755f21505b17578$var$reflow(this._element);
        this._element.classList.add($b755f21505b17578$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($b755f21505b17578$var$CLASS_NAME_COLLAPSE, $b755f21505b17578$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $b755f21505b17578$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($b755f21505b17578$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($b755f21505b17578$var$CLASS_NAME_COLLAPSE);
            $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($b755f21505b17578$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $b755f21505b17578$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($b755f21505b17578$var$CLASS_NAME_HORIZONTAL) ? $b755f21505b17578$var$WIDTH : $b755f21505b17578$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($b755f21505b17578$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $b755f21505b17578$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $b755f21505b17578$var$SelectorEngine.find($b755f21505b17578$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $b755f21505b17578$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($b755f21505b17578$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $b755f21505b17578$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $b755f21505b17578$var$EventHandler.on(document, $b755f21505b17578$var$EVENT_CLICK_DATA_API$4, $b755f21505b17578$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $b755f21505b17578$var$SelectorEngine.getMultipleElementsFromSelector(this))$b755f21505b17578$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $b755f21505b17578$var$defineJQueryPlugin($b755f21505b17578$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$NAME$a = 'dropdown';
const $b755f21505b17578$var$DATA_KEY$6 = 'bs.dropdown';
const $b755f21505b17578$var$EVENT_KEY$6 = `.${$b755f21505b17578$var$DATA_KEY$6}`;
const $b755f21505b17578$var$DATA_API_KEY$3 = '.data-api';
const $b755f21505b17578$var$ESCAPE_KEY$2 = 'Escape';
const $b755f21505b17578$var$TAB_KEY$1 = 'Tab';
const $b755f21505b17578$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $b755f21505b17578$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $b755f21505b17578$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $b755f21505b17578$var$EVENT_HIDE$5 = `hide${$b755f21505b17578$var$EVENT_KEY$6}`;
const $b755f21505b17578$var$EVENT_HIDDEN$5 = `hidden${$b755f21505b17578$var$EVENT_KEY$6}`;
const $b755f21505b17578$var$EVENT_SHOW$5 = `show${$b755f21505b17578$var$EVENT_KEY$6}`;
const $b755f21505b17578$var$EVENT_SHOWN$5 = `shown${$b755f21505b17578$var$EVENT_KEY$6}`;
const $b755f21505b17578$var$EVENT_CLICK_DATA_API$3 = `click${$b755f21505b17578$var$EVENT_KEY$6}${$b755f21505b17578$var$DATA_API_KEY$3}`;
const $b755f21505b17578$var$EVENT_KEYDOWN_DATA_API = `keydown${$b755f21505b17578$var$EVENT_KEY$6}${$b755f21505b17578$var$DATA_API_KEY$3}`;
const $b755f21505b17578$var$EVENT_KEYUP_DATA_API = `keyup${$b755f21505b17578$var$EVENT_KEY$6}${$b755f21505b17578$var$DATA_API_KEY$3}`;
const $b755f21505b17578$var$CLASS_NAME_SHOW$6 = 'show';
const $b755f21505b17578$var$CLASS_NAME_DROPUP = 'dropup';
const $b755f21505b17578$var$CLASS_NAME_DROPEND = 'dropend';
const $b755f21505b17578$var$CLASS_NAME_DROPSTART = 'dropstart';
const $b755f21505b17578$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $b755f21505b17578$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $b755f21505b17578$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $b755f21505b17578$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$b755f21505b17578$var$SELECTOR_DATA_TOGGLE$3}.${$b755f21505b17578$var$CLASS_NAME_SHOW$6}`;
const $b755f21505b17578$var$SELECTOR_MENU = '.dropdown-menu';
const $b755f21505b17578$var$SELECTOR_NAVBAR = '.navbar';
const $b755f21505b17578$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $b755f21505b17578$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $b755f21505b17578$var$PLACEMENT_TOP = $b755f21505b17578$var$isRTL() ? 'top-end' : 'top-start';
const $b755f21505b17578$var$PLACEMENT_TOPEND = $b755f21505b17578$var$isRTL() ? 'top-start' : 'top-end';
const $b755f21505b17578$var$PLACEMENT_BOTTOM = $b755f21505b17578$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $b755f21505b17578$var$PLACEMENT_BOTTOMEND = $b755f21505b17578$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $b755f21505b17578$var$PLACEMENT_RIGHT = $b755f21505b17578$var$isRTL() ? 'left-start' : 'right-start';
const $b755f21505b17578$var$PLACEMENT_LEFT = $b755f21505b17578$var$isRTL() ? 'right-start' : 'left-start';
const $b755f21505b17578$var$PLACEMENT_TOPCENTER = 'top';
const $b755f21505b17578$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $b755f21505b17578$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $b755f21505b17578$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $b755f21505b17578$export$931cbfb6bfb85fc extends $b755f21505b17578$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $b755f21505b17578$var$SelectorEngine.next(this._element, $b755f21505b17578$var$SELECTOR_MENU)[0] || $b755f21505b17578$var$SelectorEngine.prev(this._element, $b755f21505b17578$var$SELECTOR_MENU)[0] || $b755f21505b17578$var$SelectorEngine.findOne($b755f21505b17578$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $b755f21505b17578$var$Default$9;
    }
    static get DefaultType() {
        return $b755f21505b17578$var$DefaultType$9;
    }
    static get NAME() {
        return $b755f21505b17578$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($b755f21505b17578$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($b755f21505b17578$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$b755f21505b17578$var$EventHandler.on(element, 'mouseover', $b755f21505b17578$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($b755f21505b17578$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($b755f21505b17578$var$CLASS_NAME_SHOW$6);
        $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($b755f21505b17578$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$b755f21505b17578$var$EventHandler.off(element, 'mouseover', $b755f21505b17578$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($b755f21505b17578$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($b755f21505b17578$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $b755f21505b17578$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$b755f21505b17578$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$b755f21505b17578$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $lLL9c === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($b755f21505b17578$var$isElement(this._config.reference)) referenceElement = $b755f21505b17578$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $lLL9c.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($b755f21505b17578$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($b755f21505b17578$var$CLASS_NAME_DROPEND)) return $b755f21505b17578$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($b755f21505b17578$var$CLASS_NAME_DROPSTART)) return $b755f21505b17578$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($b755f21505b17578$var$CLASS_NAME_DROPUP_CENTER)) return $b755f21505b17578$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($b755f21505b17578$var$CLASS_NAME_DROPDOWN_CENTER)) return $b755f21505b17578$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($b755f21505b17578$var$CLASS_NAME_DROPUP)) return isEnd ? $b755f21505b17578$var$PLACEMENT_TOPEND : $b755f21505b17578$var$PLACEMENT_TOP;
        return isEnd ? $b755f21505b17578$var$PLACEMENT_BOTTOMEND : $b755f21505b17578$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($b755f21505b17578$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $b755f21505b17578$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$b755f21505b17578$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $b755f21505b17578$var$SelectorEngine.find($b755f21505b17578$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$b755f21505b17578$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $b755f21505b17578$var$getNextActiveElement(items, target, key === $b755f21505b17578$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b755f21505b17578$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $b755f21505b17578$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $b755f21505b17578$var$TAB_KEY$1) return;
        const openToggles = $b755f21505b17578$var$SelectorEngine.find($b755f21505b17578$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $b755f21505b17578$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $b755f21505b17578$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $b755f21505b17578$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $b755f21505b17578$var$ARROW_UP_KEY$1,
            $b755f21505b17578$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($b755f21505b17578$var$SELECTOR_DATA_TOGGLE$3) ? this : $b755f21505b17578$var$SelectorEngine.prev(this, $b755f21505b17578$var$SELECTOR_DATA_TOGGLE$3)[0] || $b755f21505b17578$var$SelectorEngine.next(this, $b755f21505b17578$var$SELECTOR_DATA_TOGGLE$3)[0] || $b755f21505b17578$var$SelectorEngine.findOne($b755f21505b17578$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $b755f21505b17578$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $b755f21505b17578$var$EventHandler.on(document, $b755f21505b17578$var$EVENT_KEYDOWN_DATA_API, $b755f21505b17578$var$SELECTOR_DATA_TOGGLE$3, $b755f21505b17578$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$b755f21505b17578$var$EventHandler.on(document, $b755f21505b17578$var$EVENT_KEYDOWN_DATA_API, $b755f21505b17578$var$SELECTOR_MENU, $b755f21505b17578$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$b755f21505b17578$var$EventHandler.on(document, $b755f21505b17578$var$EVENT_CLICK_DATA_API$3, $b755f21505b17578$export$931cbfb6bfb85fc.clearMenus);
$b755f21505b17578$var$EventHandler.on(document, $b755f21505b17578$var$EVENT_KEYUP_DATA_API, $b755f21505b17578$export$931cbfb6bfb85fc.clearMenus);
$b755f21505b17578$var$EventHandler.on(document, $b755f21505b17578$var$EVENT_CLICK_DATA_API$3, $b755f21505b17578$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $b755f21505b17578$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $b755f21505b17578$var$defineJQueryPlugin($b755f21505b17578$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$NAME$9 = 'backdrop';
const $b755f21505b17578$var$CLASS_NAME_FADE$4 = 'fade';
const $b755f21505b17578$var$CLASS_NAME_SHOW$5 = 'show';
const $b755f21505b17578$var$EVENT_MOUSEDOWN = `mousedown.bs.${$b755f21505b17578$var$NAME$9}`;
const $b755f21505b17578$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $b755f21505b17578$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $b755f21505b17578$var$Backdrop extends $b755f21505b17578$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $b755f21505b17578$var$Default$8;
    }
    static get DefaultType() {
        return $b755f21505b17578$var$DefaultType$8;
    }
    static get NAME() {
        return $b755f21505b17578$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $b755f21505b17578$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $b755f21505b17578$var$reflow(element);
        element.classList.add($b755f21505b17578$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $b755f21505b17578$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $b755f21505b17578$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($b755f21505b17578$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $b755f21505b17578$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $b755f21505b17578$var$EventHandler.off(this._element, $b755f21505b17578$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($b755f21505b17578$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $b755f21505b17578$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $b755f21505b17578$var$EventHandler.on(element, $b755f21505b17578$var$EVENT_MOUSEDOWN, ()=>{
            $b755f21505b17578$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $b755f21505b17578$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$NAME$8 = 'focustrap';
const $b755f21505b17578$var$DATA_KEY$5 = 'bs.focustrap';
const $b755f21505b17578$var$EVENT_KEY$5 = `.${$b755f21505b17578$var$DATA_KEY$5}`;
const $b755f21505b17578$var$EVENT_FOCUSIN$2 = `focusin${$b755f21505b17578$var$EVENT_KEY$5}`;
const $b755f21505b17578$var$EVENT_KEYDOWN_TAB = `keydown.tab${$b755f21505b17578$var$EVENT_KEY$5}`;
const $b755f21505b17578$var$TAB_KEY = 'Tab';
const $b755f21505b17578$var$TAB_NAV_FORWARD = 'forward';
const $b755f21505b17578$var$TAB_NAV_BACKWARD = 'backward';
const $b755f21505b17578$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $b755f21505b17578$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $b755f21505b17578$var$FocusTrap extends $b755f21505b17578$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $b755f21505b17578$var$Default$7;
    }
    static get DefaultType() {
        return $b755f21505b17578$var$DefaultType$7;
    }
    static get NAME() {
        return $b755f21505b17578$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $b755f21505b17578$var$EventHandler.off(document, $b755f21505b17578$var$EVENT_KEY$5); // guard against infinite focus loop
        $b755f21505b17578$var$EventHandler.on(document, $b755f21505b17578$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $b755f21505b17578$var$EventHandler.on(document, $b755f21505b17578$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $b755f21505b17578$var$EventHandler.off(document, $b755f21505b17578$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $b755f21505b17578$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $b755f21505b17578$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $b755f21505b17578$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $b755f21505b17578$var$TAB_NAV_BACKWARD : $b755f21505b17578$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $b755f21505b17578$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $b755f21505b17578$var$PROPERTY_PADDING = 'padding-right';
const $b755f21505b17578$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $b755f21505b17578$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $b755f21505b17578$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($b755f21505b17578$var$SELECTOR_FIXED_CONTENT, $b755f21505b17578$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($b755f21505b17578$var$SELECTOR_STICKY_CONTENT, $b755f21505b17578$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $b755f21505b17578$var$PROPERTY_PADDING);
        this._resetElementAttributes($b755f21505b17578$var$SELECTOR_FIXED_CONTENT, $b755f21505b17578$var$PROPERTY_PADDING);
        this._resetElementAttributes($b755f21505b17578$var$SELECTOR_STICKY_CONTENT, $b755f21505b17578$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $b755f21505b17578$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $b755f21505b17578$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $b755f21505b17578$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($b755f21505b17578$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $b755f21505b17578$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$NAME$7 = 'modal';
const $b755f21505b17578$var$DATA_KEY$4 = 'bs.modal';
const $b755f21505b17578$var$EVENT_KEY$4 = `.${$b755f21505b17578$var$DATA_KEY$4}`;
const $b755f21505b17578$var$DATA_API_KEY$2 = '.data-api';
const $b755f21505b17578$var$ESCAPE_KEY$1 = 'Escape';
const $b755f21505b17578$var$EVENT_HIDE$4 = `hide${$b755f21505b17578$var$EVENT_KEY$4}`;
const $b755f21505b17578$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$b755f21505b17578$var$EVENT_KEY$4}`;
const $b755f21505b17578$var$EVENT_HIDDEN$4 = `hidden${$b755f21505b17578$var$EVENT_KEY$4}`;
const $b755f21505b17578$var$EVENT_SHOW$4 = `show${$b755f21505b17578$var$EVENT_KEY$4}`;
const $b755f21505b17578$var$EVENT_SHOWN$4 = `shown${$b755f21505b17578$var$EVENT_KEY$4}`;
const $b755f21505b17578$var$EVENT_RESIZE$1 = `resize${$b755f21505b17578$var$EVENT_KEY$4}`;
const $b755f21505b17578$var$EVENT_CLICK_DISMISS = `click.dismiss${$b755f21505b17578$var$EVENT_KEY$4}`;
const $b755f21505b17578$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$b755f21505b17578$var$EVENT_KEY$4}`;
const $b755f21505b17578$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$b755f21505b17578$var$EVENT_KEY$4}`;
const $b755f21505b17578$var$EVENT_CLICK_DATA_API$2 = `click${$b755f21505b17578$var$EVENT_KEY$4}${$b755f21505b17578$var$DATA_API_KEY$2}`;
const $b755f21505b17578$var$CLASS_NAME_OPEN = 'modal-open';
const $b755f21505b17578$var$CLASS_NAME_FADE$3 = 'fade';
const $b755f21505b17578$var$CLASS_NAME_SHOW$4 = 'show';
const $b755f21505b17578$var$CLASS_NAME_STATIC = 'modal-static';
const $b755f21505b17578$var$OPEN_SELECTOR$1 = '.modal.show';
const $b755f21505b17578$var$SELECTOR_DIALOG = '.modal-dialog';
const $b755f21505b17578$var$SELECTOR_MODAL_BODY = '.modal-body';
const $b755f21505b17578$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $b755f21505b17578$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $b755f21505b17578$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $b755f21505b17578$export$2b77a92f1a5ad772 extends $b755f21505b17578$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $b755f21505b17578$var$SelectorEngine.findOne($b755f21505b17578$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $b755f21505b17578$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $b755f21505b17578$var$Default$6;
    }
    static get DefaultType() {
        return $b755f21505b17578$var$DefaultType$6;
    }
    static get NAME() {
        return $b755f21505b17578$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($b755f21505b17578$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($b755f21505b17578$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $b755f21505b17578$var$EventHandler.off(window, $b755f21505b17578$var$EVENT_KEY$4);
        $b755f21505b17578$var$EventHandler.off(this._dialog, $b755f21505b17578$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $b755f21505b17578$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $b755f21505b17578$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $b755f21505b17578$var$SelectorEngine.findOne($b755f21505b17578$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $b755f21505b17578$var$reflow(this._element);
        this._element.classList.add($b755f21505b17578$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $b755f21505b17578$var$EventHandler.on(this._element, $b755f21505b17578$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $b755f21505b17578$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $b755f21505b17578$var$EventHandler.on(window, $b755f21505b17578$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $b755f21505b17578$var$EventHandler.on(this._element, $b755f21505b17578$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $b755f21505b17578$var$EventHandler.one(this._element, $b755f21505b17578$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($b755f21505b17578$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($b755f21505b17578$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($b755f21505b17578$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($b755f21505b17578$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($b755f21505b17578$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $b755f21505b17578$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $b755f21505b17578$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $b755f21505b17578$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $b755f21505b17578$var$EventHandler.on(document, $b755f21505b17578$var$EVENT_CLICK_DATA_API$2, $b755f21505b17578$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $b755f21505b17578$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $b755f21505b17578$var$EventHandler.one(target, $b755f21505b17578$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $b755f21505b17578$var$EventHandler.one(target, $b755f21505b17578$var$EVENT_HIDDEN$4, ()=>{
            if ($b755f21505b17578$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $b755f21505b17578$var$SelectorEngine.findOne($b755f21505b17578$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $b755f21505b17578$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $b755f21505b17578$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$b755f21505b17578$var$enableDismissTrigger($b755f21505b17578$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $b755f21505b17578$var$defineJQueryPlugin($b755f21505b17578$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$NAME$6 = 'offcanvas';
const $b755f21505b17578$var$DATA_KEY$3 = 'bs.offcanvas';
const $b755f21505b17578$var$EVENT_KEY$3 = `.${$b755f21505b17578$var$DATA_KEY$3}`;
const $b755f21505b17578$var$DATA_API_KEY$1 = '.data-api';
const $b755f21505b17578$var$EVENT_LOAD_DATA_API$2 = `load${$b755f21505b17578$var$EVENT_KEY$3}${$b755f21505b17578$var$DATA_API_KEY$1}`;
const $b755f21505b17578$var$ESCAPE_KEY = 'Escape';
const $b755f21505b17578$var$CLASS_NAME_SHOW$3 = 'show';
const $b755f21505b17578$var$CLASS_NAME_SHOWING$1 = 'showing';
const $b755f21505b17578$var$CLASS_NAME_HIDING = 'hiding';
const $b755f21505b17578$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $b755f21505b17578$var$OPEN_SELECTOR = '.offcanvas.show';
const $b755f21505b17578$var$EVENT_SHOW$3 = `show${$b755f21505b17578$var$EVENT_KEY$3}`;
const $b755f21505b17578$var$EVENT_SHOWN$3 = `shown${$b755f21505b17578$var$EVENT_KEY$3}`;
const $b755f21505b17578$var$EVENT_HIDE$3 = `hide${$b755f21505b17578$var$EVENT_KEY$3}`;
const $b755f21505b17578$var$EVENT_HIDE_PREVENTED = `hidePrevented${$b755f21505b17578$var$EVENT_KEY$3}`;
const $b755f21505b17578$var$EVENT_HIDDEN$3 = `hidden${$b755f21505b17578$var$EVENT_KEY$3}`;
const $b755f21505b17578$var$EVENT_RESIZE = `resize${$b755f21505b17578$var$EVENT_KEY$3}`;
const $b755f21505b17578$var$EVENT_CLICK_DATA_API$1 = `click${$b755f21505b17578$var$EVENT_KEY$3}${$b755f21505b17578$var$DATA_API_KEY$1}`;
const $b755f21505b17578$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$b755f21505b17578$var$EVENT_KEY$3}`;
const $b755f21505b17578$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $b755f21505b17578$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $b755f21505b17578$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $b755f21505b17578$export$591ca0244c9dfcd4 extends $b755f21505b17578$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $b755f21505b17578$var$Default$5;
    }
    static get DefaultType() {
        return $b755f21505b17578$var$DefaultType$5;
    }
    static get NAME() {
        return $b755f21505b17578$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $b755f21505b17578$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($b755f21505b17578$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($b755f21505b17578$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($b755f21505b17578$var$CLASS_NAME_SHOWING$1);
            $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($b755f21505b17578$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($b755f21505b17578$var$CLASS_NAME_SHOW$3, $b755f21505b17578$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $b755f21505b17578$var$ScrollBarHelper().reset();
            $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $b755f21505b17578$var$Backdrop({
            className: $b755f21505b17578$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $b755f21505b17578$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $b755f21505b17578$var$EventHandler.on(this._element, $b755f21505b17578$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $b755f21505b17578$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b755f21505b17578$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $b755f21505b17578$var$EventHandler.on(document, $b755f21505b17578$var$EVENT_CLICK_DATA_API$1, $b755f21505b17578$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $b755f21505b17578$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($b755f21505b17578$var$isDisabled(this)) return;
    $b755f21505b17578$var$EventHandler.one(target, $b755f21505b17578$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($b755f21505b17578$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $b755f21505b17578$var$SelectorEngine.findOne($b755f21505b17578$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $b755f21505b17578$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $b755f21505b17578$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$b755f21505b17578$var$EventHandler.on(window, $b755f21505b17578$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $b755f21505b17578$var$SelectorEngine.find($b755f21505b17578$var$OPEN_SELECTOR))$b755f21505b17578$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$b755f21505b17578$var$EventHandler.on(window, $b755f21505b17578$var$EVENT_RESIZE, ()=>{
    for (const element of $b755f21505b17578$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $b755f21505b17578$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$b755f21505b17578$var$enableDismissTrigger($b755f21505b17578$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $b755f21505b17578$var$defineJQueryPlugin($b755f21505b17578$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $b755f21505b17578$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $b755f21505b17578$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $b755f21505b17578$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $b755f21505b17578$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $b755f21505b17578$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $b755f21505b17578$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($b755f21505b17578$var$uriAttributes.has(attributeName)) return Boolean($b755f21505b17578$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $b755f21505b17578$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$b755f21505b17578$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$NAME$5 = 'TemplateFactory';
const $b755f21505b17578$var$Default$4 = {
    allowList: $b755f21505b17578$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $b755f21505b17578$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $b755f21505b17578$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $b755f21505b17578$var$TemplateFactory extends $b755f21505b17578$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $b755f21505b17578$var$Default$4;
    }
    static get DefaultType() {
        return $b755f21505b17578$var$DefaultType$4;
    }
    static get NAME() {
        return $b755f21505b17578$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $b755f21505b17578$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $b755f21505b17578$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($b755f21505b17578$var$isElement(content)) {
            this._putElementInTemplate($b755f21505b17578$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $b755f21505b17578$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $b755f21505b17578$var$execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$NAME$4 = 'tooltip';
const $b755f21505b17578$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $b755f21505b17578$var$CLASS_NAME_FADE$2 = 'fade';
const $b755f21505b17578$var$CLASS_NAME_MODAL = 'modal';
const $b755f21505b17578$var$CLASS_NAME_SHOW$2 = 'show';
const $b755f21505b17578$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $b755f21505b17578$var$SELECTOR_MODAL = `.${$b755f21505b17578$var$CLASS_NAME_MODAL}`;
const $b755f21505b17578$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $b755f21505b17578$var$TRIGGER_HOVER = 'hover';
const $b755f21505b17578$var$TRIGGER_FOCUS = 'focus';
const $b755f21505b17578$var$TRIGGER_CLICK = 'click';
const $b755f21505b17578$var$TRIGGER_MANUAL = 'manual';
const $b755f21505b17578$var$EVENT_HIDE$2 = 'hide';
const $b755f21505b17578$var$EVENT_HIDDEN$2 = 'hidden';
const $b755f21505b17578$var$EVENT_SHOW$2 = 'show';
const $b755f21505b17578$var$EVENT_SHOWN$2 = 'shown';
const $b755f21505b17578$var$EVENT_INSERTED = 'inserted';
const $b755f21505b17578$var$EVENT_CLICK$1 = 'click';
const $b755f21505b17578$var$EVENT_FOCUSIN$1 = 'focusin';
const $b755f21505b17578$var$EVENT_FOCUSOUT$1 = 'focusout';
const $b755f21505b17578$var$EVENT_MOUSEENTER = 'mouseenter';
const $b755f21505b17578$var$EVENT_MOUSELEAVE = 'mouseleave';
const $b755f21505b17578$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $b755f21505b17578$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $b755f21505b17578$var$isRTL() ? 'right' : 'left'
};
const $b755f21505b17578$var$Default$3 = {
    allowList: $b755f21505b17578$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $b755f21505b17578$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $b755f21505b17578$export$28c660c63b792dea extends $b755f21505b17578$var$BaseComponent {
    constructor(element, config){
        if (typeof $lLL9c === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $b755f21505b17578$var$Default$3;
    }
    static get DefaultType() {
        return $b755f21505b17578$var$DefaultType$3;
    }
    static get NAME() {
        return $b755f21505b17578$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $b755f21505b17578$var$EventHandler.off(this._element.closest($b755f21505b17578$var$SELECTOR_MODAL), $b755f21505b17578$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $b755f21505b17578$var$EventHandler.trigger(this._element, this.constructor.eventName($b755f21505b17578$var$EVENT_SHOW$2));
        const shadowRoot = $b755f21505b17578$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $b755f21505b17578$var$EventHandler.trigger(this._element, this.constructor.eventName($b755f21505b17578$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($b755f21505b17578$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$b755f21505b17578$var$EventHandler.on(element, 'mouseover', $b755f21505b17578$var$noop);
        const complete = ()=>{
            $b755f21505b17578$var$EventHandler.trigger(this._element, this.constructor.eventName($b755f21505b17578$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $b755f21505b17578$var$EventHandler.trigger(this._element, this.constructor.eventName($b755f21505b17578$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($b755f21505b17578$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$b755f21505b17578$var$EventHandler.off(element, 'mouseover', $b755f21505b17578$var$noop);
        this._activeTrigger[$b755f21505b17578$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$b755f21505b17578$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$b755f21505b17578$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $b755f21505b17578$var$EventHandler.trigger(this._element, this.constructor.eventName($b755f21505b17578$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($b755f21505b17578$var$CLASS_NAME_FADE$2, $b755f21505b17578$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $b755f21505b17578$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($b755f21505b17578$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $b755f21505b17578$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$b755f21505b17578$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($b755f21505b17578$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($b755f21505b17578$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $b755f21505b17578$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $b755f21505b17578$var$AttachmentMap[placement.toUpperCase()];
        return $lLL9c.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $b755f21505b17578$var$execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$b755f21505b17578$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $b755f21505b17578$var$EventHandler.on(this._element, this.constructor.eventName($b755f21505b17578$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $b755f21505b17578$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $b755f21505b17578$var$TRIGGER_HOVER ? this.constructor.eventName($b755f21505b17578$var$EVENT_MOUSEENTER) : this.constructor.eventName($b755f21505b17578$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $b755f21505b17578$var$TRIGGER_HOVER ? this.constructor.eventName($b755f21505b17578$var$EVENT_MOUSELEAVE) : this.constructor.eventName($b755f21505b17578$var$EVENT_FOCUSOUT$1);
                $b755f21505b17578$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $b755f21505b17578$var$TRIGGER_FOCUS : $b755f21505b17578$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $b755f21505b17578$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $b755f21505b17578$var$TRIGGER_FOCUS : $b755f21505b17578$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $b755f21505b17578$var$EventHandler.on(this._element.closest($b755f21505b17578$var$SELECTOR_MODAL), $b755f21505b17578$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $b755f21505b17578$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($b755f21505b17578$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $b755f21505b17578$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b755f21505b17578$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $b755f21505b17578$var$defineJQueryPlugin($b755f21505b17578$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$NAME$3 = 'popover';
const $b755f21505b17578$var$SELECTOR_TITLE = '.popover-header';
const $b755f21505b17578$var$SELECTOR_CONTENT = '.popover-body';
const $b755f21505b17578$var$Default$2 = {
    ...$b755f21505b17578$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $b755f21505b17578$var$DefaultType$2 = {
    ...$b755f21505b17578$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $b755f21505b17578$export$5b6b19405a83ff9d extends $b755f21505b17578$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $b755f21505b17578$var$Default$2;
    }
    static get DefaultType() {
        return $b755f21505b17578$var$DefaultType$2;
    }
    static get NAME() {
        return $b755f21505b17578$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$b755f21505b17578$var$SELECTOR_TITLE]: this._getTitle(),
            [$b755f21505b17578$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b755f21505b17578$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $b755f21505b17578$var$defineJQueryPlugin($b755f21505b17578$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$NAME$2 = 'scrollspy';
const $b755f21505b17578$var$DATA_KEY$2 = 'bs.scrollspy';
const $b755f21505b17578$var$EVENT_KEY$2 = `.${$b755f21505b17578$var$DATA_KEY$2}`;
const $b755f21505b17578$var$DATA_API_KEY = '.data-api';
const $b755f21505b17578$var$EVENT_ACTIVATE = `activate${$b755f21505b17578$var$EVENT_KEY$2}`;
const $b755f21505b17578$var$EVENT_CLICK = `click${$b755f21505b17578$var$EVENT_KEY$2}`;
const $b755f21505b17578$var$EVENT_LOAD_DATA_API$1 = `load${$b755f21505b17578$var$EVENT_KEY$2}${$b755f21505b17578$var$DATA_API_KEY}`;
const $b755f21505b17578$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $b755f21505b17578$var$CLASS_NAME_ACTIVE$1 = 'active';
const $b755f21505b17578$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $b755f21505b17578$var$SELECTOR_TARGET_LINKS = '[href]';
const $b755f21505b17578$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $b755f21505b17578$var$SELECTOR_NAV_LINKS = '.nav-link';
const $b755f21505b17578$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $b755f21505b17578$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $b755f21505b17578$var$SELECTOR_LINK_ITEMS = `${$b755f21505b17578$var$SELECTOR_NAV_LINKS}, ${$b755f21505b17578$var$SELECTOR_NAV_ITEMS} > ${$b755f21505b17578$var$SELECTOR_NAV_LINKS}, ${$b755f21505b17578$var$SELECTOR_LIST_ITEMS}`;
const $b755f21505b17578$var$SELECTOR_DROPDOWN = '.dropdown';
const $b755f21505b17578$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $b755f21505b17578$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $b755f21505b17578$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $b755f21505b17578$export$a6472a5298a374be extends $b755f21505b17578$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $b755f21505b17578$var$Default$1;
    }
    static get DefaultType() {
        return $b755f21505b17578$var$DefaultType$1;
    }
    static get NAME() {
        return $b755f21505b17578$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $b755f21505b17578$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $b755f21505b17578$var$EventHandler.off(this._config.target, $b755f21505b17578$var$EVENT_CLICK);
        $b755f21505b17578$var$EventHandler.on(this._config.target, $b755f21505b17578$var$EVENT_CLICK, $b755f21505b17578$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $b755f21505b17578$var$SelectorEngine.find($b755f21505b17578$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $b755f21505b17578$var$isDisabled(anchor)) continue;
            const observableSection = $b755f21505b17578$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($b755f21505b17578$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($b755f21505b17578$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($b755f21505b17578$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $b755f21505b17578$var$SelectorEngine.findOne($b755f21505b17578$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($b755f21505b17578$var$SELECTOR_DROPDOWN)).classList.add($b755f21505b17578$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $b755f21505b17578$var$SelectorEngine.parents(target, $b755f21505b17578$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $b755f21505b17578$var$SelectorEngine.prev(listGroup, $b755f21505b17578$var$SELECTOR_LINK_ITEMS))item.classList.add($b755f21505b17578$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($b755f21505b17578$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $b755f21505b17578$var$SelectorEngine.find(`${$b755f21505b17578$var$SELECTOR_TARGET_LINKS}.${$b755f21505b17578$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($b755f21505b17578$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b755f21505b17578$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $b755f21505b17578$var$EventHandler.on(window, $b755f21505b17578$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $b755f21505b17578$var$SelectorEngine.find($b755f21505b17578$var$SELECTOR_DATA_SPY))$b755f21505b17578$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $b755f21505b17578$var$defineJQueryPlugin($b755f21505b17578$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$NAME$1 = 'tab';
const $b755f21505b17578$var$DATA_KEY$1 = 'bs.tab';
const $b755f21505b17578$var$EVENT_KEY$1 = `.${$b755f21505b17578$var$DATA_KEY$1}`;
const $b755f21505b17578$var$EVENT_HIDE$1 = `hide${$b755f21505b17578$var$EVENT_KEY$1}`;
const $b755f21505b17578$var$EVENT_HIDDEN$1 = `hidden${$b755f21505b17578$var$EVENT_KEY$1}`;
const $b755f21505b17578$var$EVENT_SHOW$1 = `show${$b755f21505b17578$var$EVENT_KEY$1}`;
const $b755f21505b17578$var$EVENT_SHOWN$1 = `shown${$b755f21505b17578$var$EVENT_KEY$1}`;
const $b755f21505b17578$var$EVENT_CLICK_DATA_API = `click${$b755f21505b17578$var$EVENT_KEY$1}`;
const $b755f21505b17578$var$EVENT_KEYDOWN = `keydown${$b755f21505b17578$var$EVENT_KEY$1}`;
const $b755f21505b17578$var$EVENT_LOAD_DATA_API = `load${$b755f21505b17578$var$EVENT_KEY$1}`;
const $b755f21505b17578$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $b755f21505b17578$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $b755f21505b17578$var$ARROW_UP_KEY = 'ArrowUp';
const $b755f21505b17578$var$ARROW_DOWN_KEY = 'ArrowDown';
const $b755f21505b17578$var$HOME_KEY = 'Home';
const $b755f21505b17578$var$END_KEY = 'End';
const $b755f21505b17578$var$CLASS_NAME_ACTIVE = 'active';
const $b755f21505b17578$var$CLASS_NAME_FADE$1 = 'fade';
const $b755f21505b17578$var$CLASS_NAME_SHOW$1 = 'show';
const $b755f21505b17578$var$CLASS_DROPDOWN = 'dropdown';
const $b755f21505b17578$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $b755f21505b17578$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $b755f21505b17578$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$b755f21505b17578$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $b755f21505b17578$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $b755f21505b17578$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $b755f21505b17578$var$SELECTOR_INNER = `.nav-link${$b755f21505b17578$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$b755f21505b17578$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$b755f21505b17578$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $b755f21505b17578$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $b755f21505b17578$var$SELECTOR_INNER_ELEM = `${$b755f21505b17578$var$SELECTOR_INNER}, ${$b755f21505b17578$var$SELECTOR_DATA_TOGGLE}`;
const $b755f21505b17578$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$b755f21505b17578$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$b755f21505b17578$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$b755f21505b17578$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $b755f21505b17578$export$3e41faf802a29e71 extends $b755f21505b17578$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($b755f21505b17578$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $b755f21505b17578$var$EventHandler.on(this._element, $b755f21505b17578$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $b755f21505b17578$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $b755f21505b17578$var$EventHandler.trigger(active, $b755f21505b17578$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $b755f21505b17578$var$EventHandler.trigger(innerElem, $b755f21505b17578$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($b755f21505b17578$var$CLASS_NAME_ACTIVE);
        this._activate($b755f21505b17578$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($b755f21505b17578$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $b755f21505b17578$var$EventHandler.trigger(element, $b755f21505b17578$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($b755f21505b17578$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($b755f21505b17578$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($b755f21505b17578$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($b755f21505b17578$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $b755f21505b17578$var$EventHandler.trigger(element, $b755f21505b17578$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($b755f21505b17578$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $b755f21505b17578$var$ARROW_LEFT_KEY,
            $b755f21505b17578$var$ARROW_RIGHT_KEY,
            $b755f21505b17578$var$ARROW_UP_KEY,
            $b755f21505b17578$var$ARROW_DOWN_KEY,
            $b755f21505b17578$var$HOME_KEY,
            $b755f21505b17578$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$b755f21505b17578$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $b755f21505b17578$var$HOME_KEY,
            $b755f21505b17578$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $b755f21505b17578$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $b755f21505b17578$var$ARROW_RIGHT_KEY,
                $b755f21505b17578$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $b755f21505b17578$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $b755f21505b17578$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $b755f21505b17578$var$SelectorEngine.find($b755f21505b17578$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $b755f21505b17578$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($b755f21505b17578$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $b755f21505b17578$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($b755f21505b17578$var$SELECTOR_DROPDOWN_TOGGLE, $b755f21505b17578$var$CLASS_NAME_ACTIVE);
        toggle($b755f21505b17578$var$SELECTOR_DROPDOWN_MENU, $b755f21505b17578$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($b755f21505b17578$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($b755f21505b17578$var$SELECTOR_INNER_ELEM) ? elem : $b755f21505b17578$var$SelectorEngine.findOne($b755f21505b17578$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($b755f21505b17578$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b755f21505b17578$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $b755f21505b17578$var$EventHandler.on(document, $b755f21505b17578$var$EVENT_CLICK_DATA_API, $b755f21505b17578$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($b755f21505b17578$var$isDisabled(this)) return;
    $b755f21505b17578$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $b755f21505b17578$var$EventHandler.on(window, $b755f21505b17578$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $b755f21505b17578$var$SelectorEngine.find($b755f21505b17578$var$SELECTOR_DATA_TOGGLE_ACTIVE))$b755f21505b17578$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $b755f21505b17578$var$defineJQueryPlugin($b755f21505b17578$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $b755f21505b17578$var$NAME = 'toast';
const $b755f21505b17578$var$DATA_KEY = 'bs.toast';
const $b755f21505b17578$var$EVENT_KEY = `.${$b755f21505b17578$var$DATA_KEY}`;
const $b755f21505b17578$var$EVENT_MOUSEOVER = `mouseover${$b755f21505b17578$var$EVENT_KEY}`;
const $b755f21505b17578$var$EVENT_MOUSEOUT = `mouseout${$b755f21505b17578$var$EVENT_KEY}`;
const $b755f21505b17578$var$EVENT_FOCUSIN = `focusin${$b755f21505b17578$var$EVENT_KEY}`;
const $b755f21505b17578$var$EVENT_FOCUSOUT = `focusout${$b755f21505b17578$var$EVENT_KEY}`;
const $b755f21505b17578$var$EVENT_HIDE = `hide${$b755f21505b17578$var$EVENT_KEY}`;
const $b755f21505b17578$var$EVENT_HIDDEN = `hidden${$b755f21505b17578$var$EVENT_KEY}`;
const $b755f21505b17578$var$EVENT_SHOW = `show${$b755f21505b17578$var$EVENT_KEY}`;
const $b755f21505b17578$var$EVENT_SHOWN = `shown${$b755f21505b17578$var$EVENT_KEY}`;
const $b755f21505b17578$var$CLASS_NAME_FADE = 'fade';
const $b755f21505b17578$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $b755f21505b17578$var$CLASS_NAME_SHOW = 'show';
const $b755f21505b17578$var$CLASS_NAME_SHOWING = 'showing';
const $b755f21505b17578$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $b755f21505b17578$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $b755f21505b17578$export$8d8dc7d5f743331b extends $b755f21505b17578$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $b755f21505b17578$var$Default;
    }
    static get DefaultType() {
        return $b755f21505b17578$var$DefaultType;
    }
    static get NAME() {
        return $b755f21505b17578$var$NAME;
    }
    // Public
    show() {
        const showEvent = $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($b755f21505b17578$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($b755f21505b17578$var$CLASS_NAME_SHOWING);
            $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($b755f21505b17578$var$CLASS_NAME_HIDE); // @deprecated
        $b755f21505b17578$var$reflow(this._element);
        this._element.classList.add($b755f21505b17578$var$CLASS_NAME_SHOW, $b755f21505b17578$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($b755f21505b17578$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($b755f21505b17578$var$CLASS_NAME_SHOWING, $b755f21505b17578$var$CLASS_NAME_SHOW);
            $b755f21505b17578$var$EventHandler.trigger(this._element, $b755f21505b17578$var$EVENT_HIDDEN);
        };
        this._element.classList.add($b755f21505b17578$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($b755f21505b17578$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($b755f21505b17578$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $b755f21505b17578$var$EventHandler.on(this._element, $b755f21505b17578$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $b755f21505b17578$var$EventHandler.on(this._element, $b755f21505b17578$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $b755f21505b17578$var$EventHandler.on(this._element, $b755f21505b17578$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $b755f21505b17578$var$EventHandler.on(this._element, $b755f21505b17578$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $b755f21505b17578$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $b755f21505b17578$var$enableDismissTrigger($b755f21505b17578$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $b755f21505b17578$var$defineJQueryPlugin($b755f21505b17578$export$8d8dc7d5f743331b);

});
parcelRegister("lLL9c", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return (parcelRequire("3R5LO")).popperGenerator; });
$parcel$export(module.exports, "detectOverflow", function () { return (parcelRequire("5FNfR")).default; });
$parcel$export(module.exports, "createPopperBase", function () { return (parcelRequire("3R5LO")).createPopper; });
$parcel$export(module.exports, "createPopper", function () { return (parcelRequire("679H6")).createPopper; });
$parcel$export(module.exports, "createPopperLite", function () { return (parcelRequire("4cDNL")).createPopper; });

var $kx5Nn = parcelRequire("kx5Nn");

var $hw6fU = parcelRequire("hw6fU");

var $3R5LO = parcelRequire("3R5LO");
var $5FNfR = parcelRequire("5FNfR");

var $679H6 = parcelRequire("679H6");

var $4cDNL = parcelRequire("4cDNL");
$parcel$exportWildcard(module.exports, $kx5Nn);
$parcel$exportWildcard(module.exports, $hw6fU);

});
parcelRegister("kx5Nn", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $ef2b62913723cf9a$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $ef2b62913723cf9a$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $ef2b62913723cf9a$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $ef2b62913723cf9a$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $ef2b62913723cf9a$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $ef2b62913723cf9a$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $ef2b62913723cf9a$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $ef2b62913723cf9a$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $ef2b62913723cf9a$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $ef2b62913723cf9a$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $ef2b62913723cf9a$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $ef2b62913723cf9a$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $ef2b62913723cf9a$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $ef2b62913723cf9a$export$803cd8101b6c182b; });
$parcel$export(module.exports, "beforeRead", function () { return $ef2b62913723cf9a$export$421679a7c3d56e; });
$parcel$export(module.exports, "read", function () { return $ef2b62913723cf9a$export$aafa59e2e03f2942; });
$parcel$export(module.exports, "afterRead", function () { return $ef2b62913723cf9a$export$6964f6c886723980; });
$parcel$export(module.exports, "beforeMain", function () { return $ef2b62913723cf9a$export$c65e99957a05207c; });
$parcel$export(module.exports, "main", function () { return $ef2b62913723cf9a$export$f22da7240b7add18; });
$parcel$export(module.exports, "afterMain", function () { return $ef2b62913723cf9a$export$bab79516f2d662fe; });
$parcel$export(module.exports, "beforeWrite", function () { return $ef2b62913723cf9a$export$8d4d2d70e7d46032; });
$parcel$export(module.exports, "write", function () { return $ef2b62913723cf9a$export$68d8715fc104d294; });
$parcel$export(module.exports, "afterWrite", function () { return $ef2b62913723cf9a$export$70a6e5159acce2e6; });
$parcel$export(module.exports, "modifierPhases", function () { return $ef2b62913723cf9a$export$d087d3878fdf71d5; });
var $ef2b62913723cf9a$export$1e95b668f3b82d = 'top';
var $ef2b62913723cf9a$export$40e543e69a8b3fbb = 'bottom';
var $ef2b62913723cf9a$export$79ffe56a765070d2 = 'right';
var $ef2b62913723cf9a$export$eabcd2c8791e7bf4 = 'left';
var $ef2b62913723cf9a$export$dfb5619354ba860 = 'auto';
var $ef2b62913723cf9a$export$aec2ce47c367b8c3 = [
    $ef2b62913723cf9a$export$1e95b668f3b82d,
    $ef2b62913723cf9a$export$40e543e69a8b3fbb,
    $ef2b62913723cf9a$export$79ffe56a765070d2,
    $ef2b62913723cf9a$export$eabcd2c8791e7bf4
];
var $ef2b62913723cf9a$export$b3571188c770cc5a = 'start';
var $ef2b62913723cf9a$export$bd5df0f255a350f8 = 'end';
var $ef2b62913723cf9a$export$390fd549c5303b4d = 'clippingParents';
var $ef2b62913723cf9a$export$d7b7311ec04a3e8f = 'viewport';
var $ef2b62913723cf9a$export$ae5ab1c730825774 = 'popper';
var $ef2b62913723cf9a$export$ca50aac9f3ba507f = 'reference';
var $ef2b62913723cf9a$export$368f9a87e87fa4e1 = /*#__PURE__*/ $ef2b62913723cf9a$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $ef2b62913723cf9a$export$b3571188c770cc5a,
        placement + "-" + $ef2b62913723cf9a$export$bd5df0f255a350f8
    ]);
}, []);
var $ef2b62913723cf9a$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($ef2b62913723cf9a$export$aec2ce47c367b8c3, [
    $ef2b62913723cf9a$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $ef2b62913723cf9a$export$b3571188c770cc5a,
        placement + "-" + $ef2b62913723cf9a$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $ef2b62913723cf9a$export$421679a7c3d56e = 'beforeRead';
var $ef2b62913723cf9a$export$aafa59e2e03f2942 = 'read';
var $ef2b62913723cf9a$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $ef2b62913723cf9a$export$c65e99957a05207c = 'beforeMain';
var $ef2b62913723cf9a$export$f22da7240b7add18 = 'main';
var $ef2b62913723cf9a$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $ef2b62913723cf9a$export$8d4d2d70e7d46032 = 'beforeWrite';
var $ef2b62913723cf9a$export$68d8715fc104d294 = 'write';
var $ef2b62913723cf9a$export$70a6e5159acce2e6 = 'afterWrite';
var $ef2b62913723cf9a$export$d087d3878fdf71d5 = [
    $ef2b62913723cf9a$export$421679a7c3d56e,
    $ef2b62913723cf9a$export$aafa59e2e03f2942,
    $ef2b62913723cf9a$export$6964f6c886723980,
    $ef2b62913723cf9a$export$c65e99957a05207c,
    $ef2b62913723cf9a$export$f22da7240b7add18,
    $ef2b62913723cf9a$export$bab79516f2d662fe,
    $ef2b62913723cf9a$export$8d4d2d70e7d46032,
    $ef2b62913723cf9a$export$68d8715fc104d294,
    $ef2b62913723cf9a$export$70a6e5159acce2e6
];

});

parcelRegister("hw6fU", function(module, exports) {

$parcel$export(module.exports, "applyStyles", function () { return (parcelRequire("8g5qY")).default; });
$parcel$export(module.exports, "arrow", function () { return (parcelRequire("5WuLn")).default; });
$parcel$export(module.exports, "computeStyles", function () { return (parcelRequire("ioLYA")).default; });
$parcel$export(module.exports, "eventListeners", function () { return (parcelRequire("lezd9")).default; });
$parcel$export(module.exports, "flip", function () { return (parcelRequire("h2z53")).default; });
$parcel$export(module.exports, "hide", function () { return (parcelRequire("fXXDC")).default; });
$parcel$export(module.exports, "offset", function () { return (parcelRequire("cKqpw")).default; });
$parcel$export(module.exports, "popperOffsets", function () { return (parcelRequire("9ANQJ")).default; });
$parcel$export(module.exports, "preventOverflow", function () { return (parcelRequire("kGdM1")).default; });

var $8g5qY = parcelRequire("8g5qY");

var $5WuLn = parcelRequire("5WuLn");

var $ioLYA = parcelRequire("ioLYA");

var $lezd9 = parcelRequire("lezd9");

var $h2z53 = parcelRequire("h2z53");

var $fXXDC = parcelRequire("fXXDC");

var $cKqpw = parcelRequire("cKqpw");

var $9ANQJ = parcelRequire("9ANQJ");

var $kGdM1 = parcelRequire("kGdM1");

});
parcelRegister("8g5qY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6034086c73b6946d$export$2e2bcd8739ae039; });

var $bJ5QM = parcelRequire("bJ5QM");

var $fY2As = parcelRequire("fY2As");
// and applies them to the HTMLElements such as popper and arrow
function $6034086c73b6946d$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $fY2As.isHTMLElement)(element) || !(0, $bJ5QM.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $6034086c73b6946d$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $fY2As.isHTMLElement)(element) || !(0, $bJ5QM.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $6034086c73b6946d$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $6034086c73b6946d$var$applyStyles,
    effect: $6034086c73b6946d$var$effect,
    requires: [
        'computeStyles'
    ]
};

});
parcelRegister("bJ5QM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88986f6818a8e25e$export$2e2bcd8739ae039; });
function $88986f6818a8e25e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("fY2As", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $b9fe775c9053ef26$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $b9fe775c9053ef26$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $b9fe775c9053ef26$export$af51f0f06c0f328a; });

var $dFT7w = parcelRequire("dFT7w");
function $b9fe775c9053ef26$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $dFT7w.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b9fe775c9053ef26$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $dFT7w.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b9fe775c9053ef26$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $dFT7w.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("dFT7w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f49dc6c67115f71$export$2e2bcd8739ae039; });
function $9f49dc6c67115f71$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("5WuLn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $453a3b72579d3fe2$export$2e2bcd8739ae039; });

var $9pPZE = parcelRequire("9pPZE");

var $fCmHA = parcelRequire("fCmHA");

var $19vEv = parcelRequire("19vEv");

var $hpLOs = parcelRequire("hpLOs");

var $cSjS8 = parcelRequire("cSjS8");

var $bSr9i = parcelRequire("bSr9i");

var $dWtRP = parcelRequire("dWtRP");

var $9R516 = parcelRequire("9R516");

var $kx5Nn = parcelRequire("kx5Nn");
var $453a3b72579d3fe2$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $dWtRP.default)(typeof padding !== 'number' ? padding : (0, $9R516.default)(padding, (0, $kx5Nn.basePlacements)));
};
function $453a3b72579d3fe2$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $9pPZE.default)(state.placement);
    var axis = (0, $cSjS8.default)(basePlacement);
    var isVertical = [
        (0, $kx5Nn.left),
        (0, $kx5Nn.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $453a3b72579d3fe2$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $fCmHA.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $kx5Nn.top) : (0, $kx5Nn.left);
    var maxProp = axis === 'y' ? (0, $kx5Nn.bottom) : (0, $kx5Nn.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $hpLOs.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $bSr9i.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $453a3b72579d3fe2$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $19vEv.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $453a3b72579d3fe2$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $453a3b72579d3fe2$var$arrow,
    effect: $453a3b72579d3fe2$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});
parcelRegister("9pPZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6daec7a686e81d46$export$2e2bcd8739ae039; });

function $6daec7a686e81d46$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("fCmHA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5ec03c115a522d1$export$2e2bcd8739ae039; });

var $3noUm = parcelRequire("3noUm");
function $b5ec03c115a522d1$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $3noUm.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("3noUm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2756d747346a9d18$export$2e2bcd8739ae039; });

var $fY2As = parcelRequire("fY2As");

var $8Uayh = parcelRequire("8Uayh");

var $dFT7w = parcelRequire("dFT7w");

var $k7jrB = parcelRequire("k7jrB");
function $2756d747346a9d18$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $fY2As.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8Uayh.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8Uayh.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $fY2As.isElement)(element) ? (0, $dFT7w.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $k7jrB.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("8Uayh", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $67bbbd13c9885ab1$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $67bbbd13c9885ab1$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $67bbbd13c9885ab1$export$2077e0241d6afd3c; });
var $67bbbd13c9885ab1$export$8960430cfd85939f = Math.max;
var $67bbbd13c9885ab1$export$96ec731ed4dcb222 = Math.min;
var $67bbbd13c9885ab1$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("k7jrB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea538b51842f9e8b$export$2e2bcd8739ae039; });

var $87zxl = parcelRequire("87zxl");
function $ea538b51842f9e8b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $87zxl.default)());
}

});
parcelRegister("87zxl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e9a8b07dde1d306$export$2e2bcd8739ae039; });
function $5e9a8b07dde1d306$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});




parcelRegister("19vEv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d6f2f2d850e261c$export$2e2bcd8739ae039; });

var $fY2As = parcelRequire("fY2As");
function $0d6f2f2d850e261c$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $fY2As.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("hpLOs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cad9dc1a3155ce56$export$2e2bcd8739ae039; });

var $dFT7w = parcelRequire("dFT7w");

var $bJ5QM = parcelRequire("bJ5QM");

var $12JGU = parcelRequire("12JGU");

var $fY2As = parcelRequire("fY2As");

var $5maqO = parcelRequire("5maqO");

var $c1SvV = parcelRequire("c1SvV");

var $87zxl = parcelRequire("87zxl");
function $cad9dc1a3155ce56$var$getTrueOffsetParent(element) {
    if (!(0, $fY2As.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $12JGU.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $cad9dc1a3155ce56$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $87zxl.default)());
    var isIE = /Trident/i.test((0, $87zxl.default)());
    if (isIE && (0, $fY2As.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $12JGU.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $c1SvV.default)(element);
    if ((0, $fY2As.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $fY2As.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $bJ5QM.default)(currentNode)) < 0){
        var css = (0, $12JGU.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $cad9dc1a3155ce56$export$2e2bcd8739ae039(element) {
    var window = (0, $dFT7w.default)(element);
    var offsetParent = $cad9dc1a3155ce56$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $5maqO.default)(offsetParent) && (0, $12JGU.default)(offsetParent).position === 'static')offsetParent = $cad9dc1a3155ce56$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $bJ5QM.default)(offsetParent) === 'html' || (0, $bJ5QM.default)(offsetParent) === 'body' && (0, $12JGU.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $cad9dc1a3155ce56$var$getContainingBlock(element) || window;
}

});
parcelRegister("12JGU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c296ba4af3e8b37$export$2e2bcd8739ae039; });

var $dFT7w = parcelRequire("dFT7w");
function $0c296ba4af3e8b37$export$2e2bcd8739ae039(element) {
    return (0, $dFT7w.default)(element).getComputedStyle(element);
}

});

parcelRegister("5maqO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e67194ee491e602$export$2e2bcd8739ae039; });

var $bJ5QM = parcelRequire("bJ5QM");
function $3e67194ee491e602$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $bJ5QM.default)(element)) >= 0;
}

});

parcelRegister("c1SvV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c1fdd5f395b4116$export$2e2bcd8739ae039; });

var $bJ5QM = parcelRequire("bJ5QM");

var $7o4Zx = parcelRequire("7o4Zx");

var $fY2As = parcelRequire("fY2As");
function $8c1fdd5f395b4116$export$2e2bcd8739ae039(element) {
    if ((0, $bJ5QM.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $fY2As.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7o4Zx.default)(element) // fallback
    );
}

});
parcelRegister("7o4Zx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $560ea58937ee30ef$export$2e2bcd8739ae039; });

var $fY2As = parcelRequire("fY2As");
function $560ea58937ee30ef$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $fY2As.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("cSjS8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95f9f162173be53e$export$2e2bcd8739ae039; });
function $95f9f162173be53e$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});

parcelRegister("bSr9i", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $8a59cc0d6e372cf8$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $8a59cc0d6e372cf8$export$86c8af6d3ef0b4a; });

var $8Uayh = parcelRequire("8Uayh");
function $8a59cc0d6e372cf8$export$f28d906d67a997f3(min, value, max) {
    return (0, $8Uayh.max)(min, (0, $8Uayh.min)(value, max));
}
function $8a59cc0d6e372cf8$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $8a59cc0d6e372cf8$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("dWtRP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a267dc243fee6691$export$2e2bcd8739ae039; });

var $cjSqp = parcelRequire("cjSqp");
function $a267dc243fee6691$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $cjSqp.default)(), paddingObject);
}

});
parcelRegister("cjSqp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f817a0ef55d9fed$export$2e2bcd8739ae039; });
function $8f817a0ef55d9fed$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("9R516", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72ccf486fe5afcfd$export$2e2bcd8739ae039; });
function $72ccf486fe5afcfd$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("ioLYA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d64faef1400e2569$export$2e2bcd8739ae039; });

var $kx5Nn = parcelRequire("kx5Nn");

var $hpLOs = parcelRequire("hpLOs");

var $dFT7w = parcelRequire("dFT7w");

var $7o4Zx = parcelRequire("7o4Zx");

var $12JGU = parcelRequire("12JGU");

var $9pPZE = parcelRequire("9pPZE");

var $3Mvm9 = parcelRequire("3Mvm9");

var $8Uayh = parcelRequire("8Uayh");
var $d64faef1400e2569$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $d64faef1400e2569$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8Uayh.round)(x * dpr) / dpr || 0,
        y: (0, $8Uayh.round)(y * dpr) / dpr || 0
    };
}
function $d64faef1400e2569$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $kx5Nn.left);
    var sideY = (0, $kx5Nn.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $hpLOs.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $dFT7w.default)(popper)) {
            offsetParent = (0, $7o4Zx.default)(popper);
            if ((0, $12JGU.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $kx5Nn.top) || (placement === (0, $kx5Nn.left) || placement === (0, $kx5Nn.right)) && variation === (0, $kx5Nn.end)) {
            sideY = (0, $kx5Nn.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $kx5Nn.left) || (placement === (0, $kx5Nn.top) || placement === (0, $kx5Nn.bottom)) && variation === (0, $kx5Nn.end)) {
            sideX = (0, $kx5Nn.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $d64faef1400e2569$var$unsetSides);
    var _ref4 = roundOffsets === true ? $d64faef1400e2569$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $dFT7w.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $d64faef1400e2569$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $9pPZE.default)(state.placement),
        variation: (0, $3Mvm9.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $d64faef1400e2569$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $d64faef1400e2569$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $d64faef1400e2569$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $d64faef1400e2569$var$computeStyles,
    data: {}
};

});
parcelRegister("3Mvm9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c0e2d7bc9debb82$export$2e2bcd8739ae039; });
function $2c0e2d7bc9debb82$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});


parcelRegister("lezd9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f75637f3e23f0896$export$2e2bcd8739ae039; });

var $dFT7w = parcelRequire("dFT7w");
var $f75637f3e23f0896$var$passive = {
    passive: true
};
function $f75637f3e23f0896$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $dFT7w.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $f75637f3e23f0896$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $f75637f3e23f0896$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $f75637f3e23f0896$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $f75637f3e23f0896$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $f75637f3e23f0896$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $f75637f3e23f0896$var$effect,
    data: {}
};

});

parcelRegister("h2z53", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c67dd5d879857ed6$export$2e2bcd8739ae039; });

var $gUPdG = parcelRequire("gUPdG");

var $9pPZE = parcelRequire("9pPZE");

var $bbB3t = parcelRequire("bbB3t");

var $5FNfR = parcelRequire("5FNfR");

var $6p0V1 = parcelRequire("6p0V1");

var $kx5Nn = parcelRequire("kx5Nn");

var $3Mvm9 = parcelRequire("3Mvm9");
function $c67dd5d879857ed6$var$getExpandedFallbackPlacements(placement) {
    if ((0, $9pPZE.default)(placement) === (0, $kx5Nn.auto)) return [];
    var oppositePlacement = (0, $gUPdG.default)(placement);
    return [
        (0, $bbB3t.default)(placement),
        oppositePlacement,
        (0, $bbB3t.default)(oppositePlacement)
    ];
}
function $c67dd5d879857ed6$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $9pPZE.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $gUPdG.default)(preferredPlacement)
    ] : $c67dd5d879857ed6$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $9pPZE.default)(placement) === (0, $kx5Nn.auto) ? (0, $6p0V1.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $9pPZE.default)(placement);
        var isStartVariation = (0, $3Mvm9.default)(placement) === (0, $kx5Nn.start);
        var isVertical = [
            (0, $kx5Nn.top),
            (0, $kx5Nn.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $5FNfR.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $kx5Nn.right) : (0, $kx5Nn.left) : isStartVariation ? (0, $kx5Nn.bottom) : (0, $kx5Nn.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $gUPdG.default)(mainVariationSide);
        var altVariationSide = (0, $gUPdG.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $c67dd5d879857ed6$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $c67dd5d879857ed6$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("gUPdG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5099b772841f3b5$export$2e2bcd8739ae039; });
var $c5099b772841f3b5$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $c5099b772841f3b5$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $c5099b772841f3b5$var$hash[matched];
    });
}

});

parcelRegister("bbB3t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $824d771f8cded69b$export$2e2bcd8739ae039; });
var $824d771f8cded69b$var$hash = {
    start: 'end',
    end: 'start'
};
function $824d771f8cded69b$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $824d771f8cded69b$var$hash[matched];
    });
}

});

parcelRegister("5FNfR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4216fd0b46e32cb3$export$2e2bcd8739ae039; });

var $krTO6 = parcelRequire("krTO6");

var $7o4Zx = parcelRequire("7o4Zx");

var $3noUm = parcelRequire("3noUm");

var $aZY66 = parcelRequire("aZY66");

var $ei3u1 = parcelRequire("ei3u1");

var $kx5Nn = parcelRequire("kx5Nn");

var $fY2As = parcelRequire("fY2As");

var $dWtRP = parcelRequire("dWtRP");

var $9R516 = parcelRequire("9R516");
function $4216fd0b46e32cb3$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $kx5Nn.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $kx5Nn.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $kx5Nn.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $dWtRP.default)(typeof padding !== 'number' ? padding : (0, $9R516.default)(padding, (0, $kx5Nn.basePlacements)));
    var altContext = elementContext === (0, $kx5Nn.popper) ? (0, $kx5Nn.reference) : (0, $kx5Nn.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $krTO6.default)((0, $fY2As.isElement)(element) ? element : element.contextElement || (0, $7o4Zx.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $3noUm.default)(state.elements.reference);
    var popperOffsets = (0, $aZY66.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $ei3u1.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $kx5Nn.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $kx5Nn.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $kx5Nn.right),
                (0, $kx5Nn.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $kx5Nn.top),
                (0, $kx5Nn.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("krTO6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee319e674792884c$export$2e2bcd8739ae039; });

var $kx5Nn = parcelRequire("kx5Nn");

var $8J1b0 = parcelRequire("8J1b0");

var $dThGU = parcelRequire("dThGU");

var $9CHId = parcelRequire("9CHId");

var $hpLOs = parcelRequire("hpLOs");

var $7o4Zx = parcelRequire("7o4Zx");

var $12JGU = parcelRequire("12JGU");

var $fY2As = parcelRequire("fY2As");

var $3noUm = parcelRequire("3noUm");

var $c1SvV = parcelRequire("c1SvV");

var $19vEv = parcelRequire("19vEv");

var $bJ5QM = parcelRequire("bJ5QM");

var $ei3u1 = parcelRequire("ei3u1");

var $8Uayh = parcelRequire("8Uayh");
function $ee319e674792884c$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $3noUm.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $ee319e674792884c$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $kx5Nn.viewport) ? (0, $ei3u1.default)((0, $8J1b0.default)(element, strategy)) : (0, $fY2As.isElement)(clippingParent) ? $ee319e674792884c$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ei3u1.default)((0, $dThGU.default)((0, $7o4Zx.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $ee319e674792884c$var$getClippingParents(element) {
    var clippingParents = (0, $9CHId.default)((0, $c1SvV.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $12JGU.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $fY2As.isHTMLElement)(element) ? (0, $hpLOs.default)(element) : element;
    if (!(0, $fY2As.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $fY2As.isElement)(clippingParent) && (0, $19vEv.default)(clippingParent, clipperElement) && (0, $bJ5QM.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $ee319e674792884c$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $ee319e674792884c$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $ee319e674792884c$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8Uayh.max)(rect.top, accRect.top);
        accRect.right = (0, $8Uayh.min)(rect.right, accRect.right);
        accRect.bottom = (0, $8Uayh.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8Uayh.max)(rect.left, accRect.left);
        return accRect;
    }, $ee319e674792884c$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("8J1b0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65a37054f9e20540$export$2e2bcd8739ae039; });

var $dFT7w = parcelRequire("dFT7w");

var $7o4Zx = parcelRequire("7o4Zx");

var $lvmV1 = parcelRequire("lvmV1");

var $k7jrB = parcelRequire("k7jrB");
function $65a37054f9e20540$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $dFT7w.default)(element);
    var html = (0, $7o4Zx.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $k7jrB.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $lvmV1.default)(element),
        y: y
    };
}

});
parcelRegister("lvmV1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa7e456b12dc8ed2$export$2e2bcd8739ae039; });

var $3noUm = parcelRequire("3noUm");

var $7o4Zx = parcelRequire("7o4Zx");

var $ed1Jo = parcelRequire("ed1Jo");
function $fa7e456b12dc8ed2$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $3noUm.default)((0, $7o4Zx.default)(element)).left + (0, $ed1Jo.default)(element).scrollLeft;
}

});
parcelRegister("ed1Jo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5839f61410db004$export$2e2bcd8739ae039; });

var $dFT7w = parcelRequire("dFT7w");
function $a5839f61410db004$export$2e2bcd8739ae039(node) {
    var win = (0, $dFT7w.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("dThGU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1ce22849d91e062$export$2e2bcd8739ae039; });

var $7o4Zx = parcelRequire("7o4Zx");

var $12JGU = parcelRequire("12JGU");

var $lvmV1 = parcelRequire("lvmV1");

var $ed1Jo = parcelRequire("ed1Jo");

var $8Uayh = parcelRequire("8Uayh");
function $a1ce22849d91e062$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7o4Zx.default)(element);
    var winScroll = (0, $ed1Jo.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8Uayh.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8Uayh.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $lvmV1.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $12JGU.default)(body || html).direction === 'rtl') x += (0, $8Uayh.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("9CHId", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $701991f7a25c129f$export$2e2bcd8739ae039; });

var $fvHUq = parcelRequire("fvHUq");

var $c1SvV = parcelRequire("c1SvV");

var $dFT7w = parcelRequire("dFT7w");

var $anEaF = parcelRequire("anEaF");
function $701991f7a25c129f$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $fvHUq.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $dFT7w.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $anEaF.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($701991f7a25c129f$export$2e2bcd8739ae039((0, $c1SvV.default)(target)));
}

});
parcelRegister("fvHUq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4abcfb5da1a8542$export$2e2bcd8739ae039; });

var $c1SvV = parcelRequire("c1SvV");

var $anEaF = parcelRequire("anEaF");

var $bJ5QM = parcelRequire("bJ5QM");

var $fY2As = parcelRequire("fY2As");
function $b4abcfb5da1a8542$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $bJ5QM.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $fY2As.isHTMLElement)(node) && (0, $anEaF.default)(node)) return node;
    return $b4abcfb5da1a8542$export$2e2bcd8739ae039((0, $c1SvV.default)(node));
}

});
parcelRegister("anEaF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78eb36842059dbcb$export$2e2bcd8739ae039; });

var $12JGU = parcelRequire("12JGU");
function $78eb36842059dbcb$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $12JGU.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("ei3u1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a67572d4a8c06c0e$export$2e2bcd8739ae039; });
function $a67572d4a8c06c0e$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("aZY66", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $801e380100f1a998$export$2e2bcd8739ae039; });

var $9pPZE = parcelRequire("9pPZE");

var $3Mvm9 = parcelRequire("3Mvm9");

var $cSjS8 = parcelRequire("cSjS8");

var $kx5Nn = parcelRequire("kx5Nn");
function $801e380100f1a998$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $9pPZE.default)(placement) : null;
    var variation = placement ? (0, $3Mvm9.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $kx5Nn.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $kx5Nn.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $kx5Nn.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $kx5Nn.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $cSjS8.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $kx5Nn.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $kx5Nn.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("6p0V1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a95ca4cd9769f6d$export$2e2bcd8739ae039; });

var $3Mvm9 = parcelRequire("3Mvm9");

var $kx5Nn = parcelRequire("kx5Nn");

var $5FNfR = parcelRequire("5FNfR");

var $9pPZE = parcelRequire("9pPZE");
function $4a95ca4cd9769f6d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $kx5Nn.placements) : _options$allowedAutoP;
    var variation = (0, $3Mvm9.default)(placement);
    var placements = variation ? flipVariations ? (0, $kx5Nn.variationPlacements) : (0, $kx5Nn.variationPlacements).filter(function(placement) {
        return (0, $3Mvm9.default)(placement) === variation;
    }) : (0, $kx5Nn.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $5FNfR.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $9pPZE.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("fXXDC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9faa08bc56b9737$export$2e2bcd8739ae039; });

var $kx5Nn = parcelRequire("kx5Nn");

var $5FNfR = parcelRequire("5FNfR");
function $b9faa08bc56b9737$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $b9faa08bc56b9737$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $kx5Nn.top),
        (0, $kx5Nn.right),
        (0, $kx5Nn.bottom),
        (0, $kx5Nn.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $b9faa08bc56b9737$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $5FNfR.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $5FNfR.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $b9faa08bc56b9737$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $b9faa08bc56b9737$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $b9faa08bc56b9737$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $b9faa08bc56b9737$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $b9faa08bc56b9737$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $b9faa08bc56b9737$var$hide
};

});

parcelRegister("cKqpw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $947e4483bf491cda$export$2e2bcd8739ae039; });

var $9pPZE = parcelRequire("9pPZE");

var $kx5Nn = parcelRequire("kx5Nn");
function $947e4483bf491cda$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $9pPZE.default)(placement);
    var invertDistance = [
        (0, $kx5Nn.left),
        (0, $kx5Nn.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $kx5Nn.left),
        (0, $kx5Nn.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $947e4483bf491cda$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $kx5Nn.placements).reduce(function(acc, placement) {
        acc[placement] = $947e4483bf491cda$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $947e4483bf491cda$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $947e4483bf491cda$var$offset
};

});

parcelRegister("9ANQJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fbe24eae4b0ecf1$export$2e2bcd8739ae039; });

var $aZY66 = parcelRequire("aZY66");
function $6fbe24eae4b0ecf1$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $aZY66.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $6fbe24eae4b0ecf1$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $6fbe24eae4b0ecf1$var$popperOffsets,
    data: {}
};

});

parcelRegister("kGdM1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0e26a02508d54ba$export$2e2bcd8739ae039; });

var $kx5Nn = parcelRequire("kx5Nn");

var $9pPZE = parcelRequire("9pPZE");

var $cSjS8 = parcelRequire("cSjS8");

var $5JrFS = parcelRequire("5JrFS");

var $bSr9i = parcelRequire("bSr9i");

var $fCmHA = parcelRequire("fCmHA");

var $hpLOs = parcelRequire("hpLOs");

var $5FNfR = parcelRequire("5FNfR");

var $3Mvm9 = parcelRequire("3Mvm9");

var $cjSqp = parcelRequire("cjSqp");

var $8Uayh = parcelRequire("8Uayh");
function $f0e26a02508d54ba$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $5FNfR.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $9pPZE.default)(state.placement);
    var variation = (0, $3Mvm9.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $cSjS8.default)(basePlacement);
    var altAxis = (0, $5JrFS.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $kx5Nn.top) : (0, $kx5Nn.left);
        var altSide = mainAxis === 'y' ? (0, $kx5Nn.bottom) : (0, $kx5Nn.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $kx5Nn.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $kx5Nn.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $fCmHA.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $cjSqp.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $bSr9i.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $hpLOs.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $bSr9i.within)(tether ? (0, $8Uayh.min)(min, tetherMin) : min, offset, tether ? (0, $8Uayh.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $kx5Nn.top) : (0, $kx5Nn.left);
        var _altSide = mainAxis === 'x' ? (0, $kx5Nn.bottom) : (0, $kx5Nn.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $kx5Nn.top),
            (0, $kx5Nn.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $bSr9i.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $bSr9i.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f0e26a02508d54ba$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $f0e26a02508d54ba$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("5JrFS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42c69f47a25db2c3$export$2e2bcd8739ae039; });
function $42c69f47a25db2c3$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});



parcelRegister("3R5LO", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $2ceacc2debbc4507$export$ed5e13716264f202; });
$parcel$export(module.exports, "createPopper", function () { return $2ceacc2debbc4507$export$8f7491d57c8f97a9; });

var $hMiTr = parcelRequire("hMiTr");

var $fCmHA = parcelRequire("fCmHA");

var $9CHId = parcelRequire("9CHId");

var $hpLOs = parcelRequire("hpLOs");

var $kTUAf = parcelRequire("kTUAf");

var $fUSQx = parcelRequire("fUSQx");

var $jG1pp = parcelRequire("jG1pp");

var $5FNfR = parcelRequire("5FNfR");

var $fY2As = parcelRequire("fY2As");
var $2ceacc2debbc4507$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $2ceacc2debbc4507$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $2ceacc2debbc4507$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $2ceacc2debbc4507$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $2ceacc2debbc4507$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $fY2As.isElement)(reference) ? (0, $9CHId.default)(reference) : reference.contextElement ? (0, $9CHId.default)(reference.contextElement) : [],
                    popper: (0, $9CHId.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $kTUAf.default)((0, $jG1pp.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$2ceacc2debbc4507$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $hMiTr.default)(reference, (0, $hpLOs.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $fCmHA.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $fUSQx.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$2ceacc2debbc4507$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $2ceacc2debbc4507$export$8f7491d57c8f97a9 = /*#__PURE__*/ $2ceacc2debbc4507$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("hMiTr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf15932f7786a954$export$2e2bcd8739ae039; });

var $3noUm = parcelRequire("3noUm");

var $1339B = parcelRequire("1339B");

var $bJ5QM = parcelRequire("bJ5QM");

var $fY2As = parcelRequire("fY2As");

var $lvmV1 = parcelRequire("lvmV1");

var $7o4Zx = parcelRequire("7o4Zx");

var $anEaF = parcelRequire("anEaF");

var $8Uayh = parcelRequire("8Uayh");
function $cf15932f7786a954$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8Uayh.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8Uayh.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $cf15932f7786a954$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $fY2As.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $fY2As.isHTMLElement)(offsetParent) && $cf15932f7786a954$var$isElementScaled(offsetParent);
    var documentElement = (0, $7o4Zx.default)(offsetParent);
    var rect = (0, $3noUm.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $bJ5QM.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $anEaF.default)(documentElement)) scroll = (0, $1339B.default)(offsetParent);
        if ((0, $fY2As.isHTMLElement)(offsetParent)) {
            offsets = (0, $3noUm.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $lvmV1.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("1339B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c3884935a703d70$export$2e2bcd8739ae039; });

var $ed1Jo = parcelRequire("ed1Jo");

var $dFT7w = parcelRequire("dFT7w");

var $fY2As = parcelRequire("fY2As");

var $lEzdX = parcelRequire("lEzdX");
function $0c3884935a703d70$export$2e2bcd8739ae039(node) {
    if (node === (0, $dFT7w.default)(node) || !(0, $fY2As.isHTMLElement)(node)) return (0, $ed1Jo.default)(node);
    else return (0, $lEzdX.default)(node);
}

});
parcelRegister("lEzdX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc38a8270a2de95d$export$2e2bcd8739ae039; });
function $fc38a8270a2de95d$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("kTUAf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f374d60638bbec31$export$2e2bcd8739ae039; });

var $kx5Nn = parcelRequire("kx5Nn");
function $f374d60638bbec31$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $f374d60638bbec31$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $f374d60638bbec31$var$order(modifiers); // order based on phase
    return (0, $kx5Nn.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("fUSQx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b966a14e4a8cd39d$export$2e2bcd8739ae039; });
function $b966a14e4a8cd39d$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("jG1pp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e53308557dc58a4d$export$2e2bcd8739ae039; });
function $e53308557dc58a4d$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("679H6", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $473aea95b4917761$export$8f7491d57c8f97a9; });

var $3R5LO = parcelRequire("3R5LO");

var $lezd9 = parcelRequire("lezd9");

var $9ANQJ = parcelRequire("9ANQJ");

var $ioLYA = parcelRequire("ioLYA");

var $8g5qY = parcelRequire("8g5qY");

var $cKqpw = parcelRequire("cKqpw");

var $h2z53 = parcelRequire("h2z53");

var $kGdM1 = parcelRequire("kGdM1");

var $5WuLn = parcelRequire("5WuLn");

var $fXXDC = parcelRequire("fXXDC");


var $473aea95b4917761$export$d34966752335dd47 = [
    (0, $lezd9.default),
    (0, $9ANQJ.default),
    (0, $ioLYA.default),
    (0, $8g5qY.default),
    (0, $cKqpw.default),
    (0, $h2z53.default),
    (0, $kGdM1.default),
    (0, $5WuLn.default),
    (0, $fXXDC.default)
];
var $473aea95b4917761$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $3R5LO.popperGenerator)({
    defaultModifiers: $473aea95b4917761$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});

parcelRegister("4cDNL", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $30f7282e931b58f9$export$8f7491d57c8f97a9; });

var $3R5LO = parcelRequire("3R5LO");

var $lezd9 = parcelRequire("lezd9");

var $9ANQJ = parcelRequire("9ANQJ");

var $ioLYA = parcelRequire("ioLYA");

var $8g5qY = parcelRequire("8g5qY");
var $30f7282e931b58f9$export$d34966752335dd47 = [
    (0, $lezd9.default),
    (0, $9ANQJ.default),
    (0, $ioLYA.default),
    (0, $8g5qY.default)
];
var $30f7282e931b58f9$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $3R5LO.popperGenerator)({
    defaultModifiers: $30f7282e931b58f9$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});



parcelRegister("a9ZSp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $765abe0ad46ac84f$export$2e2bcd8739ae039; });

var $1ymGy = parcelRequire("1ymGy");
var $2sPbi = parcelRequire("2sPbi");
var $4aHme = parcelRequire("4aHme");
var $iUr39 = parcelRequire("iUr39");
var $cQkLF = parcelRequire("cQkLF");
var $4mRzG = parcelRequire("4mRzG");

var $7NTi4 = parcelRequire("7NTi4");

var $hcWLo = parcelRequire("hcWLo");

var $jfwkZ = parcelRequire("jfwkZ");

var $dnyLQ = parcelRequire("dnyLQ");

/**
 * InstantSearch is the main component of InstantSearch.js. This object
 * manages the widget and lets you add new ones.
 *
 * Two parameters are required to get you started with InstantSearch.js:
 *  - `indexName`: the main index that you will use for your new search UI
 *  - `searchClient`: the search client to plug to InstantSearch.js
 *
 * The [search client provided by Algolia](algolia.com/doc/api-client/getting-started/what-is-the-api-client/javascript/)
 * needs an `appId` and an `apiKey`. Those parameters can be found in your
 * [Algolia dashboard](https://www.algolia.com/api-keys).
 *
 * If you want to get up and running quickly with InstantSearch.js, have a
 * look at the [getting started](https://www.algolia.com/doc/guides/building-search-ui/getting-started/js/).
 */ var $765abe0ad46ac84f$var$instantsearch = function instantsearch(options) {
    return new (0, $hcWLo.default)(options);
};
$765abe0ad46ac84f$var$instantsearch.version = (0, $dnyLQ.default);
$765abe0ad46ac84f$var$instantsearch.createInfiniteHitsSessionStorageCache = (0, $jfwkZ.deprecate)((0, $7NTi4.default), "import { createInfiniteHitsSessionStorageCache } from 'instantsearch.js/es/lib/infiniteHitsCache'");
$765abe0ad46ac84f$var$instantsearch.highlight = (0, $jfwkZ.deprecate)((0, $2sPbi.default), "import { highlight } from 'instantsearch.js/es/helpers'");
$765abe0ad46ac84f$var$instantsearch.reverseHighlight = (0, $jfwkZ.deprecate)((0, $iUr39.default), "import { reverseHighlight } from 'instantsearch.js/es/helpers'");
$765abe0ad46ac84f$var$instantsearch.snippet = (0, $jfwkZ.deprecate)((0, $4mRzG.default), "import { snippet } from 'instantsearch.js/es/helpers'");
$765abe0ad46ac84f$var$instantsearch.reverseSnippet = (0, $jfwkZ.deprecate)((0, $cQkLF.default), "import { reverseSnippet } from 'instantsearch.js/es/helpers'");
$765abe0ad46ac84f$var$instantsearch.insights = (0, $4aHme.default);
$765abe0ad46ac84f$var$instantsearch.getInsightsAnonymousUserToken = (0, $1ymGy.default);
Object.defineProperty($765abe0ad46ac84f$var$instantsearch, 'widgets', {
    get: function get() {
        throw new ReferenceError("\"instantsearch.widgets\" are not available from the ES build.\n\nTo import the widgets:\n\nimport { searchBox } from 'instantsearch.js/es/widgets'");
    }
});
Object.defineProperty($765abe0ad46ac84f$var$instantsearch, 'connectors', {
    get: function get() {
        throw new ReferenceError("\"instantsearch.connectors\" are not available from the ES build.\n\nTo import the connectors:\n\nimport { connectSearchBox } from 'instantsearch.js/es/connectors'");
    }
});
Object.defineProperty($765abe0ad46ac84f$var$instantsearch, 'templates', {
    get: function get() {
        throw new ReferenceError("\"instantsearch.templates\" are not available from the ES build.\n\nTo import the templates:\n\nimport { carousel } from 'instantsearch.js/es/templates'");
    }
});
var $765abe0ad46ac84f$export$2e2bcd8739ae039 = $765abe0ad46ac84f$var$instantsearch;

});
parcelRegister("1ymGy", function(module, exports) {

$parcel$export(module.exports, "getInsightsAnonymousUserTokenInternal", function () { return $121a90447201ba95$export$61f1c6e9cd2ed687; });
$parcel$export(module.exports, "default", function () { return $121a90447201ba95$export$2e2bcd8739ae039; });

function $121a90447201ba95$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $121a90447201ba95$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $121a90447201ba95$var$_typeof(obj);
}
var $121a90447201ba95$export$d900da7fa9a86f36 = '_ALGOLIA';
function $121a90447201ba95$var$getCookie(name) {
    if ((typeof document === "undefined" ? "undefined" : $121a90447201ba95$var$_typeof(document)) !== 'object' || typeof document.cookie !== 'string') return undefined;
    var prefix = "".concat(name, "=");
    var cookies = document.cookie.split(';');
    for(var i = 0; i < cookies.length; i++){
        var cookie = cookies[i];
        while(cookie.charAt(0) === ' ')cookie = cookie.substring(1);
        if (cookie.indexOf(prefix) === 0) return cookie.substring(prefix.length, cookie.length);
    }
    return undefined;
}
function $121a90447201ba95$export$61f1c6e9cd2ed687() {
    return $121a90447201ba95$var$getCookie($121a90447201ba95$export$d900da7fa9a86f36);
}
function $121a90447201ba95$export$2e2bcd8739ae039() {
    return $121a90447201ba95$export$61f1c6e9cd2ed687();
}

});

parcelRegister("2sPbi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cb5e5cdb19bfaf7$export$2e2bcd8739ae039; });

var $8JLyQ = parcelRequire("8JLyQ");

var $jVXiW = parcelRequire("jVXiW");
var $jF7w3 = parcelRequire("jF7w3");
var $1cb5e5cdb19bfaf7$var$suit = (0, $8JLyQ.component)('Highlight');
function $1cb5e5cdb19bfaf7$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? 'mark' : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var highlightAttributeResult = (0, $jVXiW.getPropertyByPath)(hit._highlightResult, attribute);
    var _ref2 = highlightAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? '' : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $1cb5e5cdb19bfaf7$var$suit({
        descendantName: 'highlighted'
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : '');
    return attributeValue.replace(new RegExp((0, $jF7w3.TAG_REPLACEMENT).highlightPreTag, 'g'), "<".concat(highlightedTagName, " class=\"").concat(className, "\">")).replace(new RegExp((0, $jF7w3.TAG_REPLACEMENT).highlightPostTag, 'g'), "</".concat(highlightedTagName, ">"));
}

});
parcelRegister("8JLyQ", function(module, exports) {

$parcel$export(module.exports, "component", function () { return $65c76b547e42ddf7$export$d8556a2a8f973135; });
var $65c76b547e42ddf7$var$NAMESPACE = 'ais';
var $65c76b547e42ddf7$export$d8556a2a8f973135 = function component(componentName) {
    return function() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, descendantName = _ref.descendantName, modifierName = _ref.modifierName;
        var descendent = descendantName ? "-".concat(descendantName) : '';
        var modifier = modifierName ? "--".concat(modifierName) : '';
        return "".concat($65c76b547e42ddf7$var$NAMESPACE, "-").concat(componentName).concat(descendent).concat(modifier);
    };
};

});

parcelRegister("jVXiW", function(module, exports) {

$parcel$export(module.exports, "getPropertyByPath", function () { return $e83157cfd676b381$export$d14846335956eefa; });
function $e83157cfd676b381$export$d14846335956eefa(object, path) {
    var parts = Array.isArray(path) ? path : path.split('.');
    return parts.reduce(function(current, key) {
        return current && current[key];
    }, object);
}

});

parcelRegister("jF7w3", function(module, exports) {

$parcel$export(module.exports, "TAG_PLACEHOLDER", function () { return $e507ad3364380b87$export$1e7338a8952eaf35; });
$parcel$export(module.exports, "TAG_REPLACEMENT", function () { return $e507ad3364380b87$export$62e796b7905e8e6b; });
$parcel$export(module.exports, "escapeHits", function () { return $e507ad3364380b87$export$9adb036445aab889; });
$parcel$export(module.exports, "escapeFacets", function () { return $e507ad3364380b87$export$9ae2e822836b2e1a; });

var $lxPA4 = parcelRequire("lxPA4");

var $li1Dq = parcelRequire("li1Dq");
function $e507ad3364380b87$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e507ad3364380b87$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e507ad3364380b87$var$_typeof(obj);
}
function $e507ad3364380b87$var$_objectDestructuringEmpty(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function $e507ad3364380b87$var$_extends() {
    $e507ad3364380b87$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e507ad3364380b87$var$_extends.apply(this, arguments);
}
function $e507ad3364380b87$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e507ad3364380b87$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e507ad3364380b87$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e507ad3364380b87$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e507ad3364380b87$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e507ad3364380b87$var$_defineProperty(obj, key, value) {
    key = $e507ad3364380b87$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e507ad3364380b87$var$_toPropertyKey(arg) {
    var key = $e507ad3364380b87$var$_toPrimitive(arg, "string");
    return $e507ad3364380b87$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e507ad3364380b87$var$_toPrimitive(input, hint) {
    if ($e507ad3364380b87$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e507ad3364380b87$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $e507ad3364380b87$export$1e7338a8952eaf35 = {
    highlightPreTag: '__ais-highlight__',
    highlightPostTag: '__/ais-highlight__'
};
var $e507ad3364380b87$export$62e796b7905e8e6b = {
    highlightPreTag: '<mark>',
    highlightPostTag: '</mark>'
};
// @MAJOR: in the future, this should only escape, not replace
function $e507ad3364380b87$var$replaceTagsAndEscape(value) {
    return (0, $lxPA4.escape)(value).replace(new RegExp($e507ad3364380b87$export$1e7338a8952eaf35.highlightPreTag, 'g'), $e507ad3364380b87$export$62e796b7905e8e6b.highlightPreTag).replace(new RegExp($e507ad3364380b87$export$1e7338a8952eaf35.highlightPostTag, 'g'), $e507ad3364380b87$export$62e796b7905e8e6b.highlightPostTag);
}
function $e507ad3364380b87$var$recursiveEscape(input) {
    if ((0, $li1Dq.isPlainObject)(input) && typeof input.value !== 'string') return Object.keys(input).reduce(function(acc, key) {
        return $e507ad3364380b87$var$_objectSpread($e507ad3364380b87$var$_objectSpread({}, acc), {}, $e507ad3364380b87$var$_defineProperty({}, key, $e507ad3364380b87$var$recursiveEscape(input[key])));
    }, {});
    if (Array.isArray(input)) return input.map($e507ad3364380b87$var$recursiveEscape);
    return $e507ad3364380b87$var$_objectSpread($e507ad3364380b87$var$_objectSpread({}, input), {}, {
        value: $e507ad3364380b87$var$replaceTagsAndEscape(input.value)
    });
}
function $e507ad3364380b87$export$9adb036445aab889(hits) {
    if (hits.__escaped === undefined) {
        // We don't override the value on hit because it will mutate the raw results
        // instead we make a shallow copy and we assign the escaped values on it.
        hits = hits.map(function(_ref) {
            var hit = $e507ad3364380b87$var$_extends({}, ($e507ad3364380b87$var$_objectDestructuringEmpty(_ref), _ref));
            if (hit._highlightResult) hit._highlightResult = $e507ad3364380b87$var$recursiveEscape(hit._highlightResult);
            if (hit._snippetResult) hit._snippetResult = $e507ad3364380b87$var$recursiveEscape(hit._snippetResult);
            return hit;
        });
        hits.__escaped = true;
    }
    return hits;
}
function $e507ad3364380b87$export$9ae2e822836b2e1a(facetHits) {
    return facetHits.map(function(h) {
        return $e507ad3364380b87$var$_objectSpread($e507ad3364380b87$var$_objectSpread({}, h), {}, {
            highlighted: $e507ad3364380b87$var$replaceTagsAndEscape(h.highlighted)
        });
    });
}

});
parcelRegister("lxPA4", function(module, exports) {

$parcel$export(module.exports, "escape", function () { return $faf4b0eafa1b8b5d$export$4e7f196112fea3c5; });
$parcel$export(module.exports, "unescape", function () { return $faf4b0eafa1b8b5d$export$e8bacd2802a88316; });
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/escape.js
 */ // Used to map characters to HTML entities.
var $faf4b0eafa1b8b5d$var$htmlEntities = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
// Used to match HTML entities and HTML characters.
var $faf4b0eafa1b8b5d$var$regexUnescapedHtml = /[&<>"']/g;
var $faf4b0eafa1b8b5d$var$regexHasUnescapedHtml = RegExp($faf4b0eafa1b8b5d$var$regexUnescapedHtml.source);
function $faf4b0eafa1b8b5d$export$4e7f196112fea3c5(value) {
    return value && $faf4b0eafa1b8b5d$var$regexHasUnescapedHtml.test(value) ? value.replace($faf4b0eafa1b8b5d$var$regexUnescapedHtml, function(character) {
        return $faf4b0eafa1b8b5d$var$htmlEntities[character];
    }) : value;
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/unescape.js
 */ // Used to map HTML entities to characters.
var $faf4b0eafa1b8b5d$var$htmlCharacters = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
};
// Used to match HTML entities and HTML characters.
var $faf4b0eafa1b8b5d$var$regexEscapedHtml = /&(amp|quot|lt|gt|#39);/g;
var $faf4b0eafa1b8b5d$var$regexHasEscapedHtml = RegExp($faf4b0eafa1b8b5d$var$regexEscapedHtml.source);
function $faf4b0eafa1b8b5d$export$e8bacd2802a88316(value) {
    return value && $faf4b0eafa1b8b5d$var$regexHasEscapedHtml.test(value) ? value.replace($faf4b0eafa1b8b5d$var$regexEscapedHtml, function(character) {
        return $faf4b0eafa1b8b5d$var$htmlCharacters[character];
    }) : value;
}

});

parcelRegister("li1Dq", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $f7fc8c0ced0ca68c$export$53b83ca8eaab0383; });
function $f7fc8c0ced0ca68c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f7fc8c0ced0ca68c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f7fc8c0ced0ca68c$var$_typeof(obj);
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/master/isPlainObject.js
 */ function $f7fc8c0ced0ca68c$var$getTag(value) {
    if (value === null) return value === undefined ? '[object Undefined]' : '[object Null]';
    return Object.prototype.toString.call(value);
}
function $f7fc8c0ced0ca68c$var$isObjectLike(value) {
    return $f7fc8c0ced0ca68c$var$_typeof(value) === 'object' && value !== null;
}
function $f7fc8c0ced0ca68c$export$53b83ca8eaab0383(value) {
    if (!$f7fc8c0ced0ca68c$var$isObjectLike(value) || $f7fc8c0ced0ca68c$var$getTag(value) !== '[object Object]') return false;
    if (Object.getPrototypeOf(value) === null) return true;
    var proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}

});



parcelRegister("4aHme", function(module, exports) {

$parcel$export(module.exports, "readDataAttributes", function () { return $3099ba7b61b81c07$export$cbcfede36ce7ab2e; });
$parcel$export(module.exports, "default", function () { return $3099ba7b61b81c07$export$2e2bcd8739ae039; });

var $1ZS80 = parcelRequire("1ZS80");
function $3099ba7b61b81c07$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3099ba7b61b81c07$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3099ba7b61b81c07$var$_typeof(obj);
}
function $3099ba7b61b81c07$export$cbcfede36ce7ab2e(domElement) {
    var method = domElement.getAttribute('data-insights-method');
    var serializedPayload = domElement.getAttribute('data-insights-payload');
    if (typeof serializedPayload !== 'string') throw new Error('The insights helper expects `data-insights-payload` to be a base64-encoded JSON string.');
    try {
        var payload = (0, $1ZS80.deserializePayload)(serializedPayload);
        return {
            method: method,
            payload: payload
        };
    } catch (error) {
        throw new Error('The insights helper was unable to parse `data-insights-payload`.');
    }
}
function $3099ba7b61b81c07$export$a3453cc0ced8b97c(_ref) {
    var method = _ref.method, payload = _ref.payload;
    if ($3099ba7b61b81c07$var$_typeof(payload) !== 'object') throw new Error("The insights helper expects the payload to be an object.");
    var serializedPayload;
    try {
        serializedPayload = (0, $1ZS80.serializePayload)(payload);
    } catch (error) {
        throw new Error("Could not JSON serialize the payload object.");
    }
    return "data-insights-method=\"".concat(method, "\" data-insights-payload=\"").concat(serializedPayload, "\"");
}
function $3099ba7b61b81c07$export$2e2bcd8739ae039(method, payload) {
    return $3099ba7b61b81c07$export$a3453cc0ced8b97c({
        method: method,
        payload: payload
    });
}

});
parcelRegister("1ZS80", function(module, exports) {

$parcel$export(module.exports, "serializePayload", function () { return $174579b10a8cf089$export$44b4521aa38272f2; });
$parcel$export(module.exports, "deserializePayload", function () { return $174579b10a8cf089$export$706ea24b0964bee9; });
function $174579b10a8cf089$export$44b4521aa38272f2(payload) {
    return btoa(encodeURIComponent(JSON.stringify(payload)));
}
function $174579b10a8cf089$export$706ea24b0964bee9(serialized) {
    return JSON.parse(decodeURIComponent(atob(serialized)));
}

});


parcelRegister("iUr39", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc42707febe64692$export$2e2bcd8739ae039; });

var $8JLyQ = parcelRequire("8JLyQ");

var $gfKQV = parcelRequire("gfKQV");
var $Vh0Bs = parcelRequire("Vh0Bs");
var $jVXiW = parcelRequire("jVXiW");
var $dDBH5 = parcelRequire("dDBH5");
var $jF7w3 = parcelRequire("jF7w3");
var $dc42707febe64692$var$suit = (0, $8JLyQ.component)('ReverseHighlight');
function $dc42707febe64692$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? 'mark' : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var highlightAttributeResult = (0, $jVXiW.getPropertyByPath)(hit._highlightResult, attribute);
    var _ref2 = highlightAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? '' : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $dc42707febe64692$var$suit({
        descendantName: 'highlighted'
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : '');
    var reverseHighlightedValue = (0, $gfKQV.concatHighlightedParts)((0, $dDBH5.reverseHighlightedParts)((0, $Vh0Bs.getHighlightedParts)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $jF7w3.TAG_REPLACEMENT).highlightPreTag, 'g'), "<".concat(highlightedTagName, " class=\"").concat(className, "\">")).replace(new RegExp((0, $jF7w3.TAG_REPLACEMENT).highlightPostTag, 'g'), "</".concat(highlightedTagName, ">"));
}

});
parcelRegister("gfKQV", function(module, exports) {

$parcel$export(module.exports, "concatHighlightedParts", function () { return $bd5264004869787c$export$a34fe2fceda1929e; });

var $jF7w3 = parcelRequire("jF7w3");
function $bd5264004869787c$export$a34fe2fceda1929e(parts) {
    var highlightPreTag = (0, $jF7w3.TAG_REPLACEMENT).highlightPreTag, highlightPostTag = (0, $jF7w3.TAG_REPLACEMENT).highlightPostTag;
    return parts.map(function(part) {
        return part.isHighlighted ? highlightPreTag + part.value + highlightPostTag : part.value;
    }).join('');
}

});

parcelRegister("Vh0Bs", function(module, exports) {

$parcel$export(module.exports, "getHighlightedParts", function () { return $0ac2849097f63511$export$e04d28e65b830ebf; });

var $jF7w3 = parcelRequire("jF7w3");
function $0ac2849097f63511$export$e04d28e65b830ebf(highlightedValue) {
    // @MAJOR: this should use TAG_PLACEHOLDER
    var highlightPostTag = (0, $jF7w3.TAG_REPLACEMENT).highlightPostTag, highlightPreTag = (0, $jF7w3.TAG_REPLACEMENT).highlightPreTag;
    var splitByPreTag = highlightedValue.split(highlightPreTag);
    var firstValue = splitByPreTag.shift();
    var elements = !firstValue ? [] : [
        {
            value: firstValue,
            isHighlighted: false
        }
    ];
    splitByPreTag.forEach(function(split) {
        var splitByPostTag = split.split(highlightPostTag);
        elements.push({
            value: splitByPostTag[0],
            isHighlighted: true
        });
        if (splitByPostTag[1] !== '') elements.push({
            value: splitByPostTag[1],
            isHighlighted: false
        });
    });
    return elements;
}

});

parcelRegister("dDBH5", function(module, exports) {

$parcel$export(module.exports, "reverseHighlightedParts", function () { return $9edc2818692dda5f$export$8d1202a2cf66e93; });

var $bSGoU = parcelRequire("bSGoU");
function $9edc2818692dda5f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9edc2818692dda5f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9edc2818692dda5f$var$_typeof(obj);
}
function $9edc2818692dda5f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9edc2818692dda5f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9edc2818692dda5f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9edc2818692dda5f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9edc2818692dda5f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9edc2818692dda5f$var$_defineProperty(obj, key, value) {
    key = $9edc2818692dda5f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9edc2818692dda5f$var$_toPropertyKey(arg) {
    var key = $9edc2818692dda5f$var$_toPrimitive(arg, "string");
    return $9edc2818692dda5f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9edc2818692dda5f$var$_toPrimitive(input, hint) {
    if ($9edc2818692dda5f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9edc2818692dda5f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9edc2818692dda5f$export$8d1202a2cf66e93(parts) {
    if (!parts.some(function(part) {
        return part.isHighlighted;
    })) return parts.map(function(part) {
        return $9edc2818692dda5f$var$_objectSpread($9edc2818692dda5f$var$_objectSpread({}, part), {}, {
            isHighlighted: false
        });
    });
    return parts.map(function(part, i) {
        return $9edc2818692dda5f$var$_objectSpread($9edc2818692dda5f$var$_objectSpread({}, part), {}, {
            isHighlighted: !(0, $bSGoU.getHighlightFromSiblings)(parts, i)
        });
    });
}

});
parcelRegister("bSGoU", function(module, exports) {

$parcel$export(module.exports, "getHighlightFromSiblings", function () { return $8a65a0c6bfa65913$export$60c97785b669d08a; });

var $lxPA4 = parcelRequire("lxPA4");
var $8a65a0c6bfa65913$var$hasAlphanumeric = new RegExp(/\w/i);
function $8a65a0c6bfa65913$export$60c97785b669d08a(parts, i) {
    var _parts, _parts2;
    var current = parts[i];
    var isNextHighlighted = ((_parts = parts[i + 1]) === null || _parts === void 0 ? void 0 : _parts.isHighlighted) || true;
    var isPreviousHighlighted = ((_parts2 = parts[i - 1]) === null || _parts2 === void 0 ? void 0 : _parts2.isHighlighted) || true;
    if (!$8a65a0c6bfa65913$var$hasAlphanumeric.test((0, $lxPA4.unescape)(current.value)) && isPreviousHighlighted === isNextHighlighted) return isPreviousHighlighted;
    return current.isHighlighted;
}

});



parcelRegister("cQkLF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $959a736814d509d2$export$2e2bcd8739ae039; });

var $8JLyQ = parcelRequire("8JLyQ");

var $gfKQV = parcelRequire("gfKQV");
var $Vh0Bs = parcelRequire("Vh0Bs");
var $jVXiW = parcelRequire("jVXiW");
var $dDBH5 = parcelRequire("dDBH5");
var $jF7w3 = parcelRequire("jF7w3");
var $959a736814d509d2$var$suit = (0, $8JLyQ.component)('ReverseSnippet');
function $959a736814d509d2$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? 'mark' : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var snippetAttributeResult = (0, $jVXiW.getPropertyByPath)(hit._snippetResult, attribute);
    var _ref2 = snippetAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? '' : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $959a736814d509d2$var$suit({
        descendantName: 'highlighted'
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : '');
    var reverseHighlightedValue = (0, $gfKQV.concatHighlightedParts)((0, $dDBH5.reverseHighlightedParts)((0, $Vh0Bs.getHighlightedParts)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $jF7w3.TAG_REPLACEMENT).highlightPreTag, 'g'), "<".concat(highlightedTagName, " class=\"").concat(className, "\">")).replace(new RegExp((0, $jF7w3.TAG_REPLACEMENT).highlightPostTag, 'g'), "</".concat(highlightedTagName, ">"));
}

});

parcelRegister("4mRzG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32e2c643499b1517$export$2e2bcd8739ae039; });

var $8JLyQ = parcelRequire("8JLyQ");

var $jVXiW = parcelRequire("jVXiW");
var $jF7w3 = parcelRequire("jF7w3");
var $32e2c643499b1517$var$suit = (0, $8JLyQ.component)('Snippet');
function $32e2c643499b1517$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? 'mark' : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var snippetAttributeResult = (0, $jVXiW.getPropertyByPath)(hit._snippetResult, attribute);
    var _ref2 = snippetAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? '' : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $32e2c643499b1517$var$suit({
        descendantName: 'highlighted'
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : '');
    return attributeValue.replace(new RegExp((0, $jF7w3.TAG_REPLACEMENT).highlightPreTag, 'g'), "<".concat(highlightedTagName, " class=\"").concat(className, "\">")).replace(new RegExp((0, $jF7w3.TAG_REPLACEMENT).highlightPostTag, 'g'), "</".concat(highlightedTagName, ">"));
}

});

parcelRegister("7NTi4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ae7ff8eee21a4a3$export$2e2bcd8739ae039; });

var $cg906 = parcelRequire("cg906");
var $2AIDb = parcelRequire("2AIDb");
var $5ae7ff8eee21a4a3$var$_excluded = [
    "page"
];
function $5ae7ff8eee21a4a3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5ae7ff8eee21a4a3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5ae7ff8eee21a4a3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5ae7ff8eee21a4a3$var$getStateWithoutPage(state) {
    var _ref = state || {}, page = _ref.page, rest = $5ae7ff8eee21a4a3$var$_objectWithoutProperties(_ref, $5ae7ff8eee21a4a3$var$_excluded);
    return rest;
}
function $5ae7ff8eee21a4a3$export$2e2bcd8739ae039() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, key = _ref2.key;
    var KEY = [
        'ais.infiniteHits',
        key
    ].filter(Boolean).join(':');
    return {
        read: function read(_ref3) {
            var state = _ref3.state;
            var sessionStorage = (0, $2AIDb.safelyRunOnBrowser)(function(_ref4) {
                var window = _ref4.window;
                return window.sessionStorage;
            });
            if (!sessionStorage) return null;
            try {
                var cache = JSON.parse(// @ts-expect-error JSON.parse() requires a string, but it actually accepts null, too.
                sessionStorage.getItem(KEY));
                return cache && (0, $cg906.isEqual)(cache.state, $5ae7ff8eee21a4a3$var$getStateWithoutPage(state)) ? cache.hits : null;
            } catch (error) {
                if (error instanceof SyntaxError) try {
                    sessionStorage.removeItem(KEY);
                } catch (err) {
                // do nothing
                }
                return null;
            }
        },
        write: function write(_ref5) {
            var state = _ref5.state, hits = _ref5.hits;
            var sessionStorage = (0, $2AIDb.safelyRunOnBrowser)(function(_ref6) {
                var window = _ref6.window;
                return window.sessionStorage;
            });
            if (!sessionStorage) return;
            try {
                sessionStorage.setItem(KEY, JSON.stringify({
                    state: $5ae7ff8eee21a4a3$var$getStateWithoutPage(state),
                    hits: hits
                }));
            } catch (error) {
            // do nothing
            }
        }
    };
}

});
parcelRegister("cg906", function(module, exports) {

$parcel$export(module.exports, "isEqual", function () { return $8ecdf5fd0c78be44$export$248d38f6296296c5; });
function $8ecdf5fd0c78be44$var$isPrimitive(obj) {
    return obj !== Object(obj);
}
function $8ecdf5fd0c78be44$export$248d38f6296296c5(first, second) {
    if (first === second) return true;
    if ($8ecdf5fd0c78be44$var$isPrimitive(first) || $8ecdf5fd0c78be44$var$isPrimitive(second) || typeof first === 'function' || typeof second === 'function') return first === second;
    if (Object.keys(first).length !== Object.keys(second).length) return false;
    // @TODO avoid for..of because of the large polyfill
    // eslint-disable-next-line no-restricted-syntax
    for(var _i = 0, _Object$keys = Object.keys(first); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        if (!(key in second)) return false;
        if (!$8ecdf5fd0c78be44$export$248d38f6296296c5(first[key], second[key])) return false;
    }
    return true;
}

});

parcelRegister("2AIDb", function(module, exports) {

$parcel$export(module.exports, "safelyRunOnBrowser", function () { return $1e319057675ab094$export$39f19eed34acd2f1; });
// eslint-disable-next-line no-restricted-globals
/**
 * Runs code on browser environments safely.
 */ function $1e319057675ab094$export$39f19eed34acd2f1(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        fallback: function fallback() {
            return undefined;
        }
    }, fallback = _ref.fallback;
    // eslint-disable-next-line no-restricted-globals
    if (typeof window === 'undefined') return fallback();
    // eslint-disable-next-line no-restricted-globals
    return callback({
        window: window
    });
}

});


parcelRegister("hcWLo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c87123d41e7449ca$export$2e2bcd8739ae039; });

var $9Q85m = parcelRequire("9Q85m");

var $bU4Gg = parcelRequire("bU4Gg");

var $161bL = parcelRequire("161bL");

var $bUUx8 = parcelRequire("bUUx8");

var $gFCi8 = parcelRequire("gFCi8");

var $dKEBn = parcelRequire("dKEBn");

var $kMGlm = parcelRequire("kMGlm");

var $kooa4 = parcelRequire("kooa4");
var $3SyjT = parcelRequire("3SyjT");
var $kE47m = parcelRequire("kE47m");
var $dk3XM = parcelRequire("dk3XM");
var $fMELL = parcelRequire("fMELL");
var $kItyA = parcelRequire("kItyA");

var $dnyLQ = parcelRequire("dnyLQ");
function $c87123d41e7449ca$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c87123d41e7449ca$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c87123d41e7449ca$var$_typeof(obj);
}
function $c87123d41e7449ca$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c87123d41e7449ca$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c87123d41e7449ca$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c87123d41e7449ca$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c87123d41e7449ca$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c87123d41e7449ca$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c87123d41e7449ca$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c87123d41e7449ca$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c87123d41e7449ca$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c87123d41e7449ca$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c87123d41e7449ca$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c87123d41e7449ca$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c87123d41e7449ca$var$_setPrototypeOf(subClass, superClass);
}
function $c87123d41e7449ca$var$_setPrototypeOf(o, p) {
    $c87123d41e7449ca$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c87123d41e7449ca$var$_setPrototypeOf(o, p);
}
function $c87123d41e7449ca$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c87123d41e7449ca$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c87123d41e7449ca$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c87123d41e7449ca$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c87123d41e7449ca$var$_possibleConstructorReturn(this, result);
    };
}
function $c87123d41e7449ca$var$_possibleConstructorReturn(self, call) {
    if (call && ($c87123d41e7449ca$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c87123d41e7449ca$var$_assertThisInitialized(self);
}
function $c87123d41e7449ca$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c87123d41e7449ca$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c87123d41e7449ca$var$_getPrototypeOf(o) {
    $c87123d41e7449ca$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c87123d41e7449ca$var$_getPrototypeOf(o);
}
function $c87123d41e7449ca$var$_defineProperty(obj, key, value) {
    key = $c87123d41e7449ca$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c87123d41e7449ca$var$_toPropertyKey(arg) {
    var key = $c87123d41e7449ca$var$_toPrimitive(arg, "string");
    return $c87123d41e7449ca$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c87123d41e7449ca$var$_toPrimitive(input, hint) {
    if ($c87123d41e7449ca$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c87123d41e7449ca$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $c87123d41e7449ca$var$withUsage = (0, $kooa4.createDocumentationMessageGenerator)({
    name: 'instantsearch'
});
function $c87123d41e7449ca$var$defaultCreateURL() {
    return '#';
}
var $c87123d41e7449ca$export$8bd42a83af1ca676 = {
    preserveSharedStateOnUnmount: false,
    persistHierarchicalRootCount: false
};
/**
 * The actual implementation of the InstantSearch. This is
 * created using the `instantsearch` factory function.
 * It emits the 'render' event every time a search is done
 */ var $c87123d41e7449ca$var$InstantSearch = /*#__PURE__*/ function(_EventEmitter) {
    $c87123d41e7449ca$var$_inherits(InstantSearch, _EventEmitter);
    var _super = $c87123d41e7449ca$var$_createSuper(InstantSearch);
    function InstantSearch(options) {
        var _options$future2;
        var _this;
        $c87123d41e7449ca$var$_classCallCheck(this, InstantSearch);
        _this = _super.call(this);
        // prevent `render` event listening from causing a warning
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "client", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "indexName", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "insightsClient", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "onStateChange", null);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "future", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "helper", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "mainHelper", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "mainIndex", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "started", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "templatesConfig", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "renderState", {});
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "_stalledSearchDelay", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "_searchStalledTimer", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "_initialUiState", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "_initialResults", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "_createURL", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "_searchFunction", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "_mainHelperSearch", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "_hasSearchWidget", false);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "_hasRecommendWidget", false);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "_insights", void 0);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "middleware", []);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "sendEventToInsights", void 0);
        /**
     * The status of the search. Can be "idle", "loading", "stalled", or "error".
     */ $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "status", 'idle');
        /**
     * The last returned error from the Search API.
     * The error gets cleared when the next valid search response is rendered.
     */ $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "error", undefined);
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "scheduleSearch", (0, $3SyjT.defer)(function() {
            if (_this.started) _this.mainHelper.search();
        }));
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "scheduleRender", (0, $3SyjT.defer)(function() {
            var _this$mainHelper;
            var shouldResetStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            if (!((_this$mainHelper = _this.mainHelper) !== null && _this$mainHelper !== void 0 && _this$mainHelper.hasPendingRequests())) {
                clearTimeout(_this._searchStalledTimer);
                _this._searchStalledTimer = null;
                if (shouldResetStatus) {
                    _this.status = 'idle';
                    _this.error = undefined;
                }
            }
            _this.mainIndex.render({
                instantSearchInstance: $c87123d41e7449ca$var$_assertThisInitialized(_this)
            });
            _this.emit('render');
        }));
        $c87123d41e7449ca$var$_defineProperty($c87123d41e7449ca$var$_assertThisInitialized(_this), "onInternalStateChange", (0, $3SyjT.defer)(function() {
            var nextUiState = _this.mainIndex.getWidgetUiState({});
            _this.middleware.forEach(function(_ref) {
                var instance = _ref.instance;
                instance.onStateChange({
                    uiState: nextUiState
                });
            });
        }));
        _this.setMaxListeners(100);
        var _options$indexName = options.indexName, indexName = _options$indexName === void 0 ? '' : _options$indexName, numberLocale = options.numberLocale, _options$initialUiSta = options.initialUiState, initialUiState = _options$initialUiSta === void 0 ? {} : _options$initialUiSta, _options$routing = options.routing, routing = _options$routing === void 0 ? null : _options$routing, _options$insights = options.insights, insights = _options$insights === void 0 ? undefined : _options$insights, searchFunction = options.searchFunction, _options$stalledSearc = options.stalledSearchDelay, stalledSearchDelay = _options$stalledSearc === void 0 ? 200 : _options$stalledSearc, _options$searchClient = options.searchClient, searchClient = _options$searchClient === void 0 ? null : _options$searchClient, _options$insightsClie = options.insightsClient, insightsClient = _options$insightsClie === void 0 ? null : _options$insightsClie, _options$onStateChang = options.onStateChange, onStateChange = _options$onStateChang === void 0 ? null : _options$onStateChang, _options$future = options.future, future = _options$future === void 0 ? $c87123d41e7449ca$var$_objectSpread($c87123d41e7449ca$var$_objectSpread({}, $c87123d41e7449ca$export$8bd42a83af1ca676), options.future || {}) : _options$future;
        if (searchClient === null) throw new Error($c87123d41e7449ca$var$withUsage('The `searchClient` option is required.'));
        if (typeof searchClient.search !== 'function') throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
        if (typeof searchClient.addAlgoliaAgent === 'function') searchClient.addAlgoliaAgent("instantsearch.js (".concat((0, $dnyLQ.default), ")"));
        if (insightsClient && typeof insightsClient !== 'function') throw new Error($c87123d41e7449ca$var$withUsage('The `insightsClient` option should be a function.'));
        _this.client = searchClient;
        _this.future = future;
        _this.insightsClient = insightsClient;
        _this.indexName = indexName;
        _this.helper = null;
        _this.mainHelper = null;
        _this.mainIndex = (0, $dKEBn.default)({
            indexName: indexName
        });
        _this.onStateChange = onStateChange;
        _this.started = false;
        _this.templatesConfig = {
            helpers: (0, $kMGlm.default)({
                numberLocale: numberLocale
            }),
            compileOptions: {}
        };
        _this._stalledSearchDelay = stalledSearchDelay;
        _this._searchStalledTimer = null;
        _this._createURL = $c87123d41e7449ca$var$defaultCreateURL;
        _this._initialUiState = initialUiState;
        _this._initialResults = null;
        _this._insights = insights;
        if (searchFunction) _this._searchFunction = searchFunction;
        _this.sendEventToInsights = (0, $fMELL.noop);
        if (routing) {
            var routerOptions = typeof routing === 'boolean' ? {} : routing;
            routerOptions.$$internal = true;
            _this.use((0, $gFCi8.createRouterMiddleware)(routerOptions));
        }
        // This is the default Insights middleware,
        // added when `insights` is set to true by the user.
        // Any user-provided middleware will be added later and override this one.
        if (insights) {
            var insightsOptions = typeof insights === 'boolean' ? {} : insights;
            insightsOptions.$$internal = true;
            _this.use((0, $161bL.createInsightsMiddleware)(insightsOptions));
        }
        if ((0, $bUUx8.isMetadataEnabled)()) _this.use((0, $bUUx8.createMetadataMiddleware)({
            $$internal: true
        }));
        return _this;
    }
    /**
   * Hooks a middleware into the InstantSearch lifecycle.
   */ $c87123d41e7449ca$var$_createClass(InstantSearch, [
        {
            key: "_isSearchStalled",
            get: /**
     * @deprecated use `status === 'stalled'` instead
     */ function get() {
                return this.status === 'stalled';
            }
        },
        {
            key: "use",
            value: function use() {
                var _this2 = this;
                for(var _len = arguments.length, middleware = new Array(_len), _key = 0; _key < _len; _key++)middleware[_key] = arguments[_key];
                var newMiddlewareList = middleware.map(function(fn) {
                    var newMiddleware = $c87123d41e7449ca$var$_objectSpread({
                        $$type: '__unknown__',
                        $$internal: false,
                        subscribe: (0, $fMELL.noop),
                        started: (0, $fMELL.noop),
                        unsubscribe: (0, $fMELL.noop),
                        onStateChange: (0, $fMELL.noop)
                    }, fn({
                        instantSearchInstance: _this2
                    }));
                    _this2.middleware.push({
                        creator: fn,
                        instance: newMiddleware
                    });
                    return newMiddleware;
                });
                // If the instance has already started, we directly subscribe the
                // middleware so they're notified of changes.
                if (this.started) newMiddlewareList.forEach(function(m) {
                    m.subscribe();
                    m.started();
                });
                return this;
            }
        },
        {
            key: "unuse",
            value: function unuse() {
                for(var _len2 = arguments.length, middlewareToUnuse = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)middlewareToUnuse[_key2] = arguments[_key2];
                this.middleware.filter(function(m) {
                    return middlewareToUnuse.includes(m.creator);
                }).forEach(function(m) {
                    return m.instance.unsubscribe();
                });
                this.middleware = this.middleware.filter(function(m) {
                    return !middlewareToUnuse.includes(m.creator);
                });
                return this;
            }
        },
        {
            key: "EXPERIMENTAL_use",
            value: function EXPERIMENTAL_use() {
                return this.use.apply(this, arguments);
            }
        },
        {
            key: "addWidget",
            value: function addWidget(widget) {
                return this.addWidgets([
                    widget
                ]);
            }
        },
        {
            key: "addWidgets",
            value: function addWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($c87123d41e7449ca$var$withUsage('The `addWidgets` method expects an array of widgets. Please use `addWidget`.'));
                if (widgets.some(function(widget) {
                    return typeof widget.init !== 'function' && typeof widget.render !== 'function';
                })) throw new Error($c87123d41e7449ca$var$withUsage('The widget definition expects a `render` and/or an `init` method.'));
                this.mainIndex.addWidgets(widgets);
                return this;
            }
        },
        {
            key: "removeWidget",
            value: function removeWidget(widget) {
                return this.removeWidgets([
                    widget
                ]);
            }
        },
        {
            key: "removeWidgets",
            value: function removeWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($c87123d41e7449ca$var$withUsage('The `removeWidgets` method expects an array of widgets. Please use `removeWidget`.'));
                if (widgets.some(function(widget) {
                    return typeof widget.dispose !== 'function';
                })) throw new Error($c87123d41e7449ca$var$withUsage('The widget definition expects a `dispose` method.'));
                this.mainIndex.removeWidgets(widgets);
                return this;
            }
        },
        {
            key: "start",
            value: function start() {
                var _this3 = this;
                if (this.started) throw new Error($c87123d41e7449ca$var$withUsage('The `start` method has already been called once.'));
                // This Helper is used for the queries, we don't care about its state. The
                // states are managed at the `index` level. We use this Helper to create
                // DerivedHelper scoped into the `index` widgets.
                // In Vue InstantSearch' hydrate, a main helper gets set before start, so
                // we need to respect this helper as a way to keep all listeners correct.
                var mainHelper = this.mainHelper || (0, (/*@__PURE__*/$parcel$interopDefault($bU4Gg)))(this.client, this.indexName, undefined, {
                    persistHierarchicalRootCount: this.future.persistHierarchicalRootCount
                });
                mainHelper.search = function() {
                    _this3.status = 'loading';
                    _this3.scheduleRender(false);
                    // This solution allows us to keep the exact same API for the users but
                    // under the hood, we have a different implementation. It should be
                    // completely transparent for the rest of the codebase. Only this module
                    // is impacted.
                    if (_this3._hasSearchWidget) mainHelper.searchOnlyWithDerivedHelpers();
                    if (_this3._hasRecommendWidget) mainHelper.recommend();
                    return mainHelper;
                };
                if (this._searchFunction) {
                    // this client isn't used to actually search, but required for the helper
                    // to not throw errors
                    var fakeClient = {
                        search: function search() {
                            return new Promise((0, $fMELL.noop));
                        }
                    };
                    this._mainHelperSearch = mainHelper.search.bind(mainHelper);
                    mainHelper.search = function() {
                        var mainIndexHelper = _this3.mainIndex.getHelper();
                        var searchFunctionHelper = (0, (/*@__PURE__*/$parcel$interopDefault($bU4Gg)))(fakeClient, mainIndexHelper.state.index, mainIndexHelper.state);
                        searchFunctionHelper.once('search', function(_ref2) {
                            var state = _ref2.state;
                            mainIndexHelper.overrideStateWithoutTriggeringChangeEvent(state);
                            _this3._mainHelperSearch();
                        });
                        // Forward state changes from `searchFunctionHelper` to `mainIndexHelper`
                        searchFunctionHelper.on('change', function(_ref3) {
                            var state = _ref3.state;
                            mainIndexHelper.setState(state);
                        });
                        _this3._searchFunction(searchFunctionHelper);
                        return mainHelper;
                    };
                }
                // Only the "main" Helper emits the `error` event vs the one for `search`
                // and `results` that are also emitted on the derived one.
                mainHelper.on('error', function(_ref4) {
                    var error = _ref4.error;
                    if (!(error instanceof Error)) {
                        // typescript lies here, error is in some cases { name: string, message: string }
                        var err = error;
                        error = Object.keys(err).reduce(function(acc, key) {
                            acc[key] = err[key];
                            return acc;
                        }, new Error(err.message));
                    }
                    // If an error is emitted, it is re-thrown by events. In previous versions
                    // we emitted {error}, which is thrown as:
                    // "Uncaught, unspecified \"error\" event. ([object Object])"
                    // To avoid breaking changes, we make the error available in both
                    // `error` and `error.error`
                    // @MAJOR emit only error
                    error.error = error;
                    _this3.error = error;
                    _this3.status = 'error';
                    _this3.scheduleRender(false);
                    // This needs to execute last because it throws the error.
                    _this3.emit('error', error);
                });
                this.mainHelper = mainHelper;
                this.middleware.forEach(function(_ref5) {
                    var instance = _ref5.instance;
                    instance.subscribe();
                });
                this.mainIndex.init({
                    instantSearchInstance: this,
                    parent: null,
                    uiState: this._initialUiState
                });
                if (this._initialResults) {
                    (0, $dk3XM.hydrateSearchClient)(this.client, this._initialResults);
                    (0, $kE47m.hydrateRecommendCache)(this.mainHelper, this._initialResults);
                    var originalScheduleSearch = this.scheduleSearch;
                    // We don't schedule a first search when initial results are provided
                    // because we already have the results to render. This skips the initial
                    // network request on the browser on `start`.
                    this.scheduleSearch = (0, $3SyjT.defer)((0, $fMELL.noop));
                    // We also skip the initial network request when widgets are dynamically
                    // added in the first tick (that's the case in all the framework-based flavors).
                    // When we add a widget to `index`, it calls `scheduleSearch`. We can rely
                    // on our `defer` util to restore the original `scheduleSearch` value once
                    // widgets are added to hook back to the regular lifecycle.
                    (0, $3SyjT.defer)(function() {
                        _this3.scheduleSearch = originalScheduleSearch;
                    })();
                } else if (this.mainIndex.getWidgets().length > 0) this.scheduleSearch();
                // Keep the previous reference for legacy purpose, some pattern use
                // the direct Helper access `search.helper` (e.g multi-index).
                this.helper = this.mainIndex.getHelper();
                // track we started the search if we add more widgets,
                // to init them directly after add
                this.started = true;
                this.middleware.forEach(function(_ref6) {
                    var instance = _ref6.instance;
                    instance.started();
                });
                // This is the automatic Insights middleware,
                // added when `insights` is unset and the initial results possess `queryID`.
                // Any user-provided middleware will be added later and override this one.
                if (typeof this._insights === 'undefined') mainHelper.derivedHelpers[0].once('result', function() {
                    var hasAutomaticInsights = _this3.mainIndex.getScopedResults().some(function(_ref7) {
                        var results = _ref7.results;
                        return results === null || results === void 0 ? void 0 : results._automaticInsights;
                    });
                    if (hasAutomaticInsights) _this3.use((0, $161bL.createInsightsMiddleware)({
                        $$internal: true,
                        $$automatic: true
                    }));
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this$mainHelper2;
                this.scheduleSearch.cancel();
                this.scheduleRender.cancel();
                clearTimeout(this._searchStalledTimer);
                this.removeWidgets(this.mainIndex.getWidgets());
                this.mainIndex.dispose();
                // You can not start an instance two times, therefore a disposed instance
                // needs to set started as false otherwise this can not be restarted at a
                // later point.
                this.started = false;
                // The helper needs to be reset to perform the next search from a fresh state.
                // If not reset, it would use the state stored before calling `dispose()`.
                this.removeAllListeners();
                (_this$mainHelper2 = this.mainHelper) === null || _this$mainHelper2 === void 0 || _this$mainHelper2.removeAllListeners();
                this.mainHelper = null;
                this.helper = null;
                this.middleware.forEach(function(_ref8) {
                    var instance = _ref8.instance;
                    instance.unsubscribe();
                });
            }
        },
        {
            key: "scheduleStalledRender",
            value: function scheduleStalledRender() {
                var _this4 = this;
                if (!this._searchStalledTimer) this._searchStalledTimer = setTimeout(function() {
                    _this4.status = 'stalled';
                    _this4.scheduleRender();
                }, this._stalledSearchDelay);
            }
        },
        {
            key: "setUiState",
            value: function setUiState(uiState) {
                var _this5 = this;
                var callOnStateChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (!this.mainHelper) throw new Error($c87123d41e7449ca$var$withUsage('The `start` method needs to be called before `setUiState`.'));
                // We refresh the index UI state to update the local UI state that the
                // main index passes to the function form of `setUiState`.
                this.mainIndex.refreshUiState();
                var nextUiState = typeof uiState === 'function' ? uiState(this.mainIndex.getWidgetUiState({})) : uiState;
                if (this.onStateChange && callOnStateChange) this.onStateChange({
                    uiState: nextUiState,
                    setUiState: function setUiState(finalUiState) {
                        (0, $kItyA.setIndexHelperState)(typeof finalUiState === 'function' ? finalUiState(nextUiState) : finalUiState, _this5.mainIndex);
                        _this5.scheduleSearch();
                        _this5.onInternalStateChange();
                    }
                });
                else {
                    (0, $kItyA.setIndexHelperState)(nextUiState, this.mainIndex);
                    this.scheduleSearch();
                    this.onInternalStateChange();
                }
            }
        },
        {
            key: "getUiState",
            value: function getUiState() {
                if (this.started) // We refresh the index UI state to make sure changes from `refine` are taken in account
                this.mainIndex.refreshUiState();
                return this.mainIndex.getWidgetUiState({});
            }
        },
        {
            key: "createURL",
            value: function createURL() {
                var nextState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!this.started) throw new Error($c87123d41e7449ca$var$withUsage('The `start` method needs to be called before `createURL`.'));
                return this._createURL(nextState);
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                if (!this.mainHelper) throw new Error($c87123d41e7449ca$var$withUsage('The `start` method needs to be called before `refresh`.'));
                this.mainHelper.clearCache().search();
            }
        }
    ]);
    return InstantSearch;
}((0, (/*@__PURE__*/$parcel$interopDefault($9Q85m))));
var $c87123d41e7449ca$export$2e2bcd8739ae039 = $c87123d41e7449ca$var$InstantSearch;

});
parcelRegister("9Q85m", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $729f3df752a3c960$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
module.exports = $729f3df752a3c960$var$EventEmitter;
// Backwards-compat with node 0.10.x
// EventEmitter.EventEmitter = EventEmitter;
$729f3df752a3c960$var$EventEmitter.prototype._events = undefined;
$729f3df752a3c960$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$729f3df752a3c960$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$729f3df752a3c960$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$729f3df752a3c960$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
    this._maxListeners = n;
    return this;
};
$729f3df752a3c960$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === 'error') {
        if (!this._events.error || $729f3df752a3c960$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($729f3df752a3c960$var$isUndefined(handler)) return false;
    if ($729f3df752a3c960$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($729f3df752a3c960$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$729f3df752a3c960$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$729f3df752a3c960$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit('newListener', type, $729f3df752a3c960$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($729f3df752a3c960$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($729f3df752a3c960$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$729f3df752a3c960$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $729f3df752a3c960$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === 'function') // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$729f3df752a3c960$var$EventEmitter.prototype.on = $729f3df752a3c960$var$EventEmitter.prototype.addListener;
$729f3df752a3c960$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$729f3df752a3c960$var$isFunction(listener)) throw TypeError('listener must be a function');
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$729f3df752a3c960$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$729f3df752a3c960$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $729f3df752a3c960$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    } else if ($729f3df752a3c960$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    }
    return this;
};
$729f3df752a3c960$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($729f3df752a3c960$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$729f3df752a3c960$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($729f3df752a3c960$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$729f3df752a3c960$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($729f3df752a3c960$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$729f3df752a3c960$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $729f3df752a3c960$var$isFunction(arg) {
    return typeof arg === 'function';
}
function $729f3df752a3c960$var$isNumber(arg) {
    return typeof arg === 'number';
}
function $729f3df752a3c960$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
function $729f3df752a3c960$var$isUndefined(arg) {
    return arg === void 0;
}

});

parcelRegister("bU4Gg", function(module, exports) {
'use strict';

var $aN6H4 = parcelRequire("aN6H4");

var $azM5q = parcelRequire("azM5q");

var $kxwMq = parcelRequire("kxwMq");

var $iViQj = parcelRequire("iViQj");

var $a3F2K = parcelRequire("a3F2K");
/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 * @return {AlgoliaSearchHelper} The helper instance
 */ function $8aa88e2d89eb67a6$var$algoliasearchHelper(client, index, opts, searchResultsOptions) {
    return new $aN6H4(client, index, opts, searchResultsOptions);
}

/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */ $8aa88e2d89eb67a6$var$algoliasearchHelper.version = (parcelRequire("VtFel"));
/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */ $8aa88e2d89eb67a6$var$algoliasearchHelper.AlgoliaSearchHelper = $aN6H4;
/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */ $8aa88e2d89eb67a6$var$algoliasearchHelper.SearchParameters = $iViQj;
/**
 * Constructor for the object containing all the parameters for Recommend.
 * @member module:algoliasearchHelper.RecommendParameters
 * @type {RecommendParameters}
 */ $8aa88e2d89eb67a6$var$algoliasearchHelper.RecommendParameters = $azM5q;
/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */ $8aa88e2d89eb67a6$var$algoliasearchHelper.SearchResults = $a3F2K;
/**
 * Constructor for the object containing the results for Recommend.
 * @member module:algoliasearchHelper.RecommendResults
 * @type {RecommendResults}
 */ $8aa88e2d89eb67a6$var$algoliasearchHelper.RecommendResults = $kxwMq;
module.exports = $8aa88e2d89eb67a6$var$algoliasearchHelper;

});
parcelRegister("aN6H4", function(module, exports) {
'use strict';

var $9Q85m = parcelRequire("9Q85m");

var $jvV3E = parcelRequire("jvV3E");

var $1M3zp = parcelRequire("1M3zp");
var $7db3ac3049cd8e24$require$escapeFacetValue = $1M3zp.escapeFacetValue;

var $dU3Nl = parcelRequire("dU3Nl");

var $5wWND = parcelRequire("5wWND");

var $4ELZX = parcelRequire("4ELZX");

var $jHjkh = parcelRequire("jHjkh");

var $azM5q = parcelRequire("azM5q");

var $kxwMq = parcelRequire("kxwMq");

var $fe0RE = parcelRequire("fe0RE");

var $iViQj = parcelRequire("iViQj");

var $a3F2K = parcelRequire("a3F2K");

var $h5T11 = parcelRequire("h5T11");

var $VtFel = parcelRequire("VtFel");
/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */ /**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */ /**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */ /**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */ /**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */ /**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */ /**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */ /**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 */ function $7db3ac3049cd8e24$var$AlgoliaSearchHelper(client, index, options, searchResultsOptions) {
    if (typeof client.addAlgoliaAgent === 'function') client.addAlgoliaAgent('JS Helper (' + $VtFel + ')');
    this.setClient(client);
    var opts = options || {};
    opts.index = index;
    this.state = $iViQj.make(opts);
    this.recommendState = new $azM5q({
        params: opts.recommendState
    });
    this.lastResults = null;
    this.lastRecommendResults = null;
    this._queryId = 0;
    this._recommendQueryId = 0;
    this._lastQueryIdReceived = -1;
    this._lastRecommendQueryIdReceived = -1;
    this.derivedHelpers = [];
    this._currentNbQueries = 0;
    this._currentNbRecommendQueries = 0;
    this._searchResultsOptions = searchResultsOptions;
    this._recommendCache = {};
}
$dU3Nl($7db3ac3049cd8e24$var$AlgoliaSearchHelper, $9Q85m);
/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.search = function() {
    this._search({
        onlyWithDerivedHelpers: false
    });
    return this;
};
$7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function() {
    this._search({
        onlyWithDerivedHelpers: true
    });
    return this;
};
/**
 * Sends the recommendation queries set in the state. When the method is
 * called, it triggers a `fetch` event. The results will be available through
 * the `result` event. If an error occurs, an `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires fetch
 * @fires result
 * @fires error
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.recommend = function() {
    this._recommend();
    return this;
};
/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.getQuery = function() {
    var state = this.state;
    return $fe0RE._getHitsSearchParams(state);
};
/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [cb] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
    var tempState = !options ? this.state : this.state.setQueryParameters(options);
    var queries = $fe0RE._getQueries(tempState.index, tempState);
    // eslint-disable-next-line consistent-this
    var self = this;
    this._currentNbQueries++;
    this.emit('searchOnce', {
        state: tempState
    });
    if (cb) {
        this.client.search(queries).then(function(content) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
            cb(null, new $a3F2K(tempState, content.results), tempState);
        }).catch(function(err) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
            cb(err, null, tempState);
        });
        return undefined;
    }
    return this.client.search(queries).then(function(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        return {
            content: new $a3F2K(tempState, content.results),
            state: tempState,
            _originalResponse: content
        };
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        throw e;
    });
};
/**
 * Start the search for answers with the parameters set in the state.
 * This method returns a promise.
 * @param {Object} options - the options for answers API call
 * @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
 * @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
 * @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
 *
 * @return {promise} the answer results
 * @deprecated answers is deprecated and will be replaced with new initiatives
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.findAnswers = function(options) {
    // eslint-disable-next-line no-console
    console.warn('[algoliasearch-helper] answers is no longer supported');
    var state = this.state;
    var derivedHelper = this.derivedHelpers[0];
    if (!derivedHelper) return Promise.resolve([]);
    var derivedState = derivedHelper.getModifiedState(state);
    var data = $5wWND({
        attributesForPrediction: options.attributesForPrediction,
        nbHits: options.nbHits
    }, {
        params: $jHjkh($fe0RE._getHitsSearchParams(derivedState), [
            'attributesToSnippet',
            'hitsPerPage',
            'restrictSearchableAttributes',
            'snippetEllipsisText'
        ])
    });
    var errorMessage = 'search for answers was called, but this client does not have a function client.initIndex(index).findAnswers';
    if (typeof this.client.initIndex !== 'function') throw new Error(errorMessage);
    var index = this.client.initIndex(derivedState.index);
    if (typeof index.findAnswers !== 'function') throw new Error(errorMessage);
    return index.findAnswers(derivedState.query, options.queryLanguages, data);
};
/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */ /**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */ /**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.searchForFacetValues = function(facet, query, maxFacetHits, userState) {
    var clientHasSFFV = typeof this.client.searchForFacetValues === 'function' && // v5 has a wrong sffv signature
    typeof this.client.searchForFacets !== 'function';
    var clientHasInitIndex = typeof this.client.initIndex === 'function';
    if (!clientHasSFFV && !clientHasInitIndex && typeof this.client.search !== 'function') throw new Error('search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues');
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    var algoliaQuery = $fe0RE.getSearchForFacetQuery(facet, query, maxFacetHits, state);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    // newer algoliasearch ^3.27.1 - ~4.0.0
    if (clientHasSFFV) searchForFacetValuesPromise = this.client.searchForFacetValues([
        {
            indexName: state.index,
            params: algoliaQuery
        }
    ]);
    else if (clientHasInitIndex) searchForFacetValuesPromise = this.client.initIndex(state.index).searchForFacetValues(algoliaQuery);
    else {
        // @MAJOR only use client.search
        delete algoliaQuery.facetName;
        searchForFacetValuesPromise = this.client.search([
            {
                type: 'facet',
                facet: facet,
                indexName: state.index,
                params: algoliaQuery
            }
        ]).then(function processResponse(response) {
            return response.results[0];
        });
    }
    this.emit('searchForFacetValues', {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        content = Array.isArray(content) ? content[0] : content;
        content.facetHits.forEach(function(f) {
            f.escapedValue = $7db3ac3049cd8e24$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        throw e;
    });
};
/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.setQuery = function(q) {
    this._change({
        state: this.state.resetPage().setQuery(q),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
    this._change({
        state: this.state.resetPage().clearRefinements(name),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.clearTags = function() {
    this._change({
        state: this.state.resetPage().clearTags(),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, path) {
    this._change({
        state: this.state.resetPage().addHierarchicalFacetRefinement(facet, path),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
};
/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().addExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
};
/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.addTag = function(tag) {
    this._change({
        state: this.state.resetPage().addTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a "frequently bought together" recommendation query.
 *
 * @param {FrequentlyBoughtTogetherQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.addFrequentlyBoughtTogether = function(params) {
    this._recommendChange({
        state: this.recommendState.addFrequentlyBoughtTogether(params)
    });
    return this;
};
/**
 * Adds a "related products" recommendation query.
 *
 * @param {RelatedProductsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.addRelatedProducts = function(params) {
    this._recommendChange({
        state: this.recommendState.addRelatedProducts(params)
    });
    return this;
};
/**
 * Adds a "trending items" recommendation query.
 *
 * @param {TrendingItemsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.addTrendingItems = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingItems(params)
    });
    return this;
};
/**
 * Adds a "trending facets" recommendation query.
 *
 * @param {TrendingFacetsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.addTrendingFacets = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingFacets(params)
    });
    return this;
};
/**
 * Adds a "looking similar" recommendation query.
 *
 * @param {LookingSimilarQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.addLookingSimilar = function(params) {
    this._recommendChange({
        state: this.recommendState.addLookingSimilar(params)
    });
    return this;
};
/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
    this._change({
        state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
};
/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
};
/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.removeTag = function(tag) {
    this._change({
        state: this.state.resetPage().removeTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a "frequently bought together" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.removeFrequentlyBoughtTogether = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "related products" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.removeRelatedProducts = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending items" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.removeTrendingItems = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending facets" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.removeTrendingFacets = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "looking similar" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.removeLookingSimilar = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
    return this.toggleFacetRefinement(facet, value);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.toggleFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
};
/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
    this._change({
        state: this.state.resetPage().toggleTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.nextPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page + 1);
};
/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.previousPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page - 1);
};
/**
 * @private
 * @param {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @fires change
 */ function $7db3ac3049cd8e24$var$setCurrentPage(page) {
    if (page < 0) throw new Error('Page requested below 0.');
    this._change({
        state: this.state.setPage(page),
        isPageReset: false
    });
    return this;
}
/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.setCurrentPage = $7db3ac3049cd8e24$var$setCurrentPage;
/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.setPage = $7db3ac3049cd8e24$var$setCurrentPage;
/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.setIndex = function(name) {
    this._change({
        state: this.state.resetPage().setIndex(name),
        isPageReset: true
    });
    return this;
};
/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
    this._change({
        state: this.state.resetPage().setQueryParameter(parameter, value),
        isPageReset: true
    });
    return this;
};
/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.setState = function(newState) {
    this._change({
        state: $iViQj.make(newState),
        isPageReset: false
    });
    return this;
};
/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
    this.state = new $iViQj(newState);
    return this;
};
/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
    if ($4ELZX(this.state.getNumericRefinements(attribute))) return true;
    else if (this.state.isConjunctiveFacet(attribute)) return this.state.isFacetRefined(attribute);
    else if (this.state.isDisjunctiveFacet(attribute)) return this.state.isDisjunctiveFacetRefined(attribute);
    else if (this.state.isHierarchicalFacet(attribute)) return this.state.isHierarchicalFacetRefined(attribute);
    // there's currently no way to know that the user did call `addNumericRefinement` at some point
    // thus we cannot distinguish if there once was a numeric refinement that was cleared
    // so we will return false in every other situations to be consistent
    // while what we should do here is throw because we did not find the attribute in any type
    // of refinement
    return false;
};
/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
 * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
    return this.state.isExcludeRefined(facet, value);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
    return this.state.isDisjunctiveFacetRefined(facet, value);
};
/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean} true if the tag is currently refined
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.hasTag = function(tag) {
    return this.state.isTagRefined(tag);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
};
/**
 * Get the name of the currently used index.
 * @return {string} name of the index
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.getIndex = function() {
    return this.state.index;
};
function $7db3ac3049cd8e24$var$getCurrentPage() {
    return this.state.page;
}
/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.getCurrentPage = $7db3ac3049cd8e24$var$getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.getPage = $7db3ac3049cd8e24$var$getCurrentPage;
/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.getTags = function() {
    return this.state.tagRefinements;
};
/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
    var refinements = [];
    if (this.state.isConjunctiveFacet(facetName)) {
        var conjRefinements = this.state.getConjunctiveRefinements(facetName);
        conjRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'conjunctive'
            });
        });
        var excludeRefinements = this.state.getExcludeRefinements(facetName);
        excludeRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'exclude'
            });
        });
    } else if (this.state.isDisjunctiveFacet(facetName)) {
        var disjunctiveRefinements = this.state.getDisjunctiveRefinements(facetName);
        disjunctiveRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'disjunctive'
            });
        });
    }
    var numericRefinements = this.state.getNumericRefinements(facetName);
    Object.keys(numericRefinements).forEach(function(operator) {
        var value = numericRefinements[operator];
        refinements.push({
            value: value,
            operator: operator,
            type: 'numeric'
        });
    });
    return refinements;
};
/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
    return this.state.getNumericRefinement(attribute, operator);
};
/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
    return this.state.getHierarchicalFacetBreadcrumb(facetName);
};
// /////////// PRIVATE
/**
 * Perform the underlying queries
 * @private
 * @param {object} options options for the query
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype._search = function(options) {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    if (!options.onlyWithDerivedHelpers) {
        mainQueries = $fe0RE._getQueries(state.index, state);
        states.push({
            state: state,
            queriesCount: mainQueries.length,
            helper: this
        });
        this.emit('search', {
            state: state,
            results: this.lastResults
        });
    }
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = derivedState.index ? $fe0RE._getQueries(derivedState.index, derivedState) : [];
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit('search', {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    try {
        this.client.search(queries).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit('error', {
            error: error
        });
    }
    return undefined;
};
$7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype._recommend = function() {
    var searchState = this.state;
    var recommendState = this.recommendState;
    var index = this.getIndex();
    var states = [
        {
            state: recommendState,
            index: index,
            helper: this
        }
    ];
    var ids = recommendState.params.map(function(param) {
        return param.$$id;
    });
    this.emit('fetch', {
        recommend: {
            state: recommendState,
            results: this.lastRecommendResults
        }
    });
    var cache = this._recommendCache;
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedIndex = derivedHelper.getModifiedState(searchState).index;
        if (!derivedIndex) return [];
        // Contrary to what is done when deriving the search state, we don't want to
        // provide the current recommend state to the derived helper, as it would
        // inherit unwanted queries. We instead provide an empty recommend state.
        var derivedState = derivedHelper.getModifiedRecommendState(new $azM5q());
        states.push({
            state: derivedState,
            index: derivedIndex,
            helper: derivedHelper
        });
        ids = Array.prototype.concat.apply(ids, derivedState.params.map(function(param) {
            return param.$$id;
        }));
        derivedHelper.emit('fetch', {
            recommend: {
                state: derivedState,
                results: derivedHelper.lastRecommendResults
            }
        });
        return derivedState._buildQueries(derivedIndex, cache);
    });
    var queries = Array.prototype.concat.apply(this.recommendState._buildQueries(index, cache), derivedQueries);
    if (queries.length === 0) return;
    if (queries.length > 0 && typeof this.client.getRecommendations === 'undefined') {
        // eslint-disable-next-line no-console
        console.warn('Please update algoliasearch/lite to the latest version in order to use recommend widgets.');
        return;
    }
    var queryId = this._recommendQueryId++;
    this._currentNbRecommendQueries++;
    try {
        this.client.getRecommendations(queries).then(this._dispatchRecommendResponse.bind(this, queryId, states, ids)).catch(this._dispatchRecommendError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit('error', {
            error: error
        });
    }
    return;
};
/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>} states state used to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function(states, queryId, content) {
    // eslint-disable-next-line consistent-this
    var self = this;
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
    var results = content.results.slice();
    states.forEach(function(s) {
        var state = s.state;
        var queriesCount = s.queriesCount;
        var helper = s.helper;
        var specificResults = results.splice(0, queriesCount);
        if (!state.index) {
            helper.emit('result', {
                results: null,
                state: state
            });
            return;
        }
        helper.lastResults = new $a3F2K(state, specificResults, self._searchResultsOptions);
        helper.emit('result', {
            results: helper.lastResults,
            state: state
        });
    });
};
$7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype._dispatchRecommendResponse = function(queryId, states, ids, content) {
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    if (this._currentNbRecommendQueries === 0) this.emit('recommendQueueEmpty');
    var cache = this._recommendCache;
    var idsMap = {};
    ids.filter(function(id) {
        return cache[id] === undefined;
    }).forEach(function(id, index) {
        if (!idsMap[id]) idsMap[id] = [];
        idsMap[id].push(index);
    });
    Object.keys(idsMap).forEach(function(id) {
        var indices = idsMap[id];
        var firstResult = content.results[indices[0]];
        if (indices.length === 1) {
            cache[id] = firstResult;
            return;
        }
        cache[id] = Object.assign({}, firstResult, {
            hits: $h5T11(indices.map(function(idx) {
                return content.results[idx].hits;
            }))
        });
    });
    var results = {};
    ids.forEach(function(id) {
        results[id] = cache[id];
    });
    states.forEach(function(s) {
        var state = s.state;
        var helper = s.helper;
        if (!s.index) {
            // eslint-disable-next-line no-warning-comments
            // TODO: emit "result" event when events for Recommend are implemented
            helper.emit('recommend:result', {
                results: null,
                state: state
            });
            return;
        }
        helper.lastRecommendResults = new $kxwMq(state, results);
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "result" event when events for Recommend are implemented
        helper.emit('recommend:result', {
            recommend: {
                results: helper.lastRecommendResults,
                state: state
            }
        });
    });
};
$7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function(queryId, error) {
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    this.emit('error', {
        error: error
    });
    if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
};
$7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype._dispatchRecommendError = function(queryId, error) {
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    this.emit('error', {
        error: error
    });
    if (this._currentNbRecommendQueries === 0) this.emit('recommendQueueEmpty');
};
$7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
    return query || facetFilters.length !== 0 || numericFilters.length !== 0 || tagFilters.length !== 0;
};
/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean} true if there are refinements on this attribute
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
    return this.state.disjunctiveRefinements[facet] && this.state.disjunctiveRefinements[facet].length > 0;
};
$7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype._change = function(event) {
    var state = event.state;
    var isPageReset = event.isPageReset;
    if (state !== this.state) {
        this.state = state;
        this.emit('change', {
            state: this.state,
            results: this.lastResults,
            isPageReset: isPageReset
        });
    }
};
$7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype._recommendChange = function(event) {
    var state = event.state;
    if (state !== this.recommendState) {
        this.recommendState = state;
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "change" event when events for Recommend are implemented
        this.emit('recommend:change', {
            search: {
                results: this.lastResults,
                state: this.state
            },
            recommend: {
                results: this.lastRecommendResults,
                state: this.recommendState
            }
        });
    }
};
/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.clearCache = function() {
    if (this.client.clearCache) this.client.clearCache();
    return this;
};
/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.setClient = function(newClient) {
    if (this.client === newClient) return this;
    if (typeof newClient.addAlgoliaAgent === 'function') newClient.addAlgoliaAgent('JS Helper (' + $VtFel + ')');
    this.client = newClient;
    return this;
};
/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch} the currently used client
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.getClient = function() {
    return this.client;
};
/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @param {function} recommendFn RecommendParameters -> RecommendParameters
 * @return {DerivedHelper} a new DerivedHelper
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.derive = function(fn, recommendFn) {
    var derivedHelper = new $jvV3E(this, fn, recommendFn);
    this.derivedHelpers.push(derivedHelper);
    return derivedHelper;
};
/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @param  {DerivedHelper} derivedHelper the derived helper to detach
 * @return {undefined} nothing is returned
 * @throws Error
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.detachDerivedHelper = function(derivedHelper) {
    var pos = this.derivedHelpers.indexOf(derivedHelper);
    if (pos === -1) throw new Error('Derived helper already detached');
    this.derivedHelpers.splice(pos, 1);
};
/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */ $7db3ac3049cd8e24$var$AlgoliaSearchHelper.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
};
/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */ /**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */ module.exports = $7db3ac3049cd8e24$var$AlgoliaSearchHelper;

});
parcelRegister("jvV3E", function(module, exports) {
'use strict';

var $9Q85m = parcelRequire("9Q85m");

var $dU3Nl = parcelRequire("dU3Nl");
/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 * @param {AlgoliaSearchHelper} mainHelper the main helper
 * @param {function} fn the function to create the derived state for search
 * @param {function} recommendFn the function to create the derived state for recommendations
 */ function $e34d2c159c008fa8$var$DerivedHelper(mainHelper, fn, recommendFn) {
    this.main = mainHelper;
    this.fn = fn;
    this.recommendFn = recommendFn;
    this.lastResults = null;
    this.lastRecommendResults = null;
}
$dU3Nl($e34d2c159c008fa8$var$DerivedHelper, $9Q85m);
/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */ $e34d2c159c008fa8$var$DerivedHelper.prototype.detach = function() {
    this.removeAllListeners();
    this.main.detachDerivedHelper(this);
};
$e34d2c159c008fa8$var$DerivedHelper.prototype.getModifiedState = function(parameters) {
    return this.fn(parameters);
};
$e34d2c159c008fa8$var$DerivedHelper.prototype.getModifiedRecommendState = function(parameters) {
    return this.recommendFn(parameters);
};
module.exports = $e34d2c159c008fa8$var$DerivedHelper;

});
parcelRegister("dU3Nl", function(module, exports) {
'use strict';
function $a1f372ea55e6e4fd$var$inherits(ctor, superCtor) {
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
module.exports = $a1f372ea55e6e4fd$var$inherits;

});


parcelRegister("1M3zp", function(module, exports) {
'use strict';
/**
 * Replaces a leading - with \-
 * @private
 * @param {any} value the facet value to replace
 * @returns {any} the escaped facet value or the value if it was not a string
 */ function $14ad0b1cc0fa30c5$var$escapeFacetValue(value) {
    if (typeof value !== 'string') return value;
    return String(value).replace(/^-/, '\\-');
}
/**
 * Replaces a leading \- with -
 * @private
 * @param {any} value the escaped facet value
 * @returns {any} the unescaped facet value or the value if it was not a string
 */ function $14ad0b1cc0fa30c5$var$unescapeFacetValue(value) {
    if (typeof value !== 'string') return value;
    return value.replace(/^\\-/, '-');
}
module.exports = {
    escapeFacetValue: $14ad0b1cc0fa30c5$var$escapeFacetValue,
    unescapeFacetValue: $14ad0b1cc0fa30c5$var$unescapeFacetValue
};

});

parcelRegister("5wWND", function(module, exports) {
'use strict';
function $406d8d41b77d1e37$var$clone(value) {
    if (typeof value === 'object' && value !== null) return $406d8d41b77d1e37$var$_merge(Array.isArray(value) ? [] : {}, value);
    return value;
}
function $406d8d41b77d1e37$var$isObjectOrArrayOrFunction(value) {
    return typeof value === 'function' || Array.isArray(value) || Object.prototype.toString.call(value) === '[object Object]';
}
function $406d8d41b77d1e37$var$_merge(target, source) {
    if (target === source) return target;
    // eslint-disable-next-line no-restricted-syntax
    for(var key in source){
        if (!Object.prototype.hasOwnProperty.call(source, key) || key === '__proto__' || key === 'constructor') continue;
        var sourceVal = source[key];
        var targetVal = target[key];
        if (typeof targetVal !== 'undefined' && typeof sourceVal === 'undefined') continue;
        if ($406d8d41b77d1e37$var$isObjectOrArrayOrFunction(targetVal) && $406d8d41b77d1e37$var$isObjectOrArrayOrFunction(sourceVal)) target[key] = $406d8d41b77d1e37$var$_merge(targetVal, sourceVal);
        else target[key] = $406d8d41b77d1e37$var$clone(sourceVal);
    }
    return target;
}
/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} target The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */ function $406d8d41b77d1e37$var$merge(target) {
    if (!$406d8d41b77d1e37$var$isObjectOrArrayOrFunction(target)) target = {};
    for(var i = 1, l = arguments.length; i < l; i++){
        var source = arguments[i];
        if ($406d8d41b77d1e37$var$isObjectOrArrayOrFunction(source)) $406d8d41b77d1e37$var$_merge(target, source);
    }
    return target;
}
module.exports = $406d8d41b77d1e37$var$merge;

});

parcelRegister("4ELZX", function(module, exports) {
'use strict';
function $36402156c27112c4$var$objectHasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
}
module.exports = $36402156c27112c4$var$objectHasKeys;

});

parcelRegister("jHjkh", function(module, exports) {
'use strict';
// https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620
function $e57106373ccb2a44$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source === null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key;
    var i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        // eslint-disable-next-line no-continue
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $e57106373ccb2a44$var$_objectWithoutPropertiesLoose;

});

parcelRegister("azM5q", function(module, exports) {
'use strict';
/**
 * RecommendParameters is the data structure that contains all the information
 * usable for getting recommendations from the Algolia API. It doesn't do the
 * search itself, nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It
 * will be provided when needed.
 * @constructor
 * @classdesc contains all the parameters for recommendations
 * @param {RecommendParametersOptions} opts the options to create the object
 */ function $7b32793aa3ba1b52$var$RecommendParameters(opts) {
    opts = opts || {};
    this.params = opts.params || [];
}
$7b32793aa3ba1b52$var$RecommendParameters.prototype = {
    constructor: $7b32793aa3ba1b52$var$RecommendParameters,
    addParams: function(params) {
        var newParams = this.params.slice();
        newParams.push(params);
        return new $7b32793aa3ba1b52$var$RecommendParameters({
            params: newParams
        });
    },
    removeParams: function(id) {
        return new $7b32793aa3ba1b52$var$RecommendParameters({
            params: this.params.filter(function(param) {
                return param.$$id !== id;
            })
        });
    },
    addFrequentlyBoughtTogether: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'bought-together'
        }));
    },
    addRelatedProducts: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'related-products'
        }));
    },
    addTrendingItems: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'trending-items'
        }));
    },
    addTrendingFacets: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'trending-facets'
        }));
    },
    addLookingSimilar: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'looking-similar'
        }));
    },
    _buildQueries: function(indexName, cache) {
        return this.params.filter(function(params) {
            return cache[params.$$id] === undefined;
        }).map(function(params) {
            var query = Object.assign({}, params, {
                indexName: indexName,
                // @TODO: remove this if it ever gets handled by the API
                threshold: params.threshold || 0
            });
            delete query.$$id;
            return query;
        });
    }
};
module.exports = $7b32793aa3ba1b52$var$RecommendParameters;

});

parcelRegister("kxwMq", function(module, exports) {
'use strict';
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {RecommendParameters} state state that led to the response
 * @param {Record<string,RecommendResultItem>} results the results from algolia client
 **/ function $ef405128f9c04e7c$var$RecommendResults(state, results) {
    this._state = state;
    this._rawResults = {};
    // eslint-disable-next-line consistent-this
    var self = this;
    state.params.forEach(function(param) {
        var id = param.$$id;
        self[id] = results[id];
        self._rawResults[id] = results[id];
    });
}
$ef405128f9c04e7c$var$RecommendResults.prototype = {
    constructor: $ef405128f9c04e7c$var$RecommendResults
};
module.exports = $ef405128f9c04e7c$var$RecommendResults;

});

parcelRegister("fe0RE", function(module, exports) {
'use strict';

var $5wWND = parcelRequire("5wWND");
function $b158d57b0036e428$var$sortObject(obj) {
    return Object.keys(obj).sort().reduce(function(acc, curr) {
        acc[curr] = obj[curr];
        return acc;
    }, {});
}
var $b158d57b0036e428$var$requestBuilder = {
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {string} index The name of the index
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getQueries: function getQueries(index, state) {
        var queries = [];
        // One query for the hits
        queries.push({
            indexName: index,
            params: $b158d57b0036e428$var$requestBuilder._getHitsSearchParams(state)
        });
        // One for each disjunctive facets
        state.getRefinedDisjunctiveFacets().forEach(function(refinedFacet) {
            queries.push({
                indexName: index,
                params: $b158d57b0036e428$var$requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
            });
        });
        // More to get the parent levels of the hierarchical facets when refined
        state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
            var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
            var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            // If we are deeper than level 0 (starting from `beer > IPA`)
            // we want to get all parent values
            if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
                // We generate a map of the filters we will use for our facet values queries
                var filtersMap = currentRefinement[0].split(separator).slice(0, -1).reduce(function createFiltersMap(map, segment, level) {
                    return map.concat({
                        attribute: hierarchicalFacet.attributes[level],
                        value: level === 0 ? segment : [
                            map[map.length - 1].value,
                            segment
                        ].join(separator)
                    });
                }, []);
                filtersMap.forEach(function(filter, level) {
                    var params = $b158d57b0036e428$var$requestBuilder._getDisjunctiveFacetSearchParams(state, filter.attribute, level === 0);
                    // Keep facet filters unrelated to current hierarchical attributes
                    function hasHierarchicalFacetFilter(value) {
                        return hierarchicalFacet.attributes.some(function(attribute) {
                            return attribute === value.split(':')[0];
                        });
                    }
                    var filteredFacetFilters = (params.facetFilters || []).reduce(function(acc, facetFilter) {
                        if (Array.isArray(facetFilter)) {
                            var filtered = facetFilter.filter(function(filterValue) {
                                return !hasHierarchicalFacetFilter(filterValue);
                            });
                            if (filtered.length > 0) acc.push(filtered);
                        }
                        if (typeof facetFilter === 'string' && !hasHierarchicalFacetFilter(facetFilter)) acc.push(facetFilter);
                        return acc;
                    }, []);
                    var parent = filtersMap[level - 1];
                    if (level > 0) params.facetFilters = filteredFacetFilters.concat(parent.attribute + ':' + parent.value);
                    else if (filteredFacetFilters.length > 0) params.facetFilters = filteredFacetFilters;
                    else delete params.facetFilters;
                    queries.push({
                        indexName: index,
                        params: params
                    });
                });
            }
        });
        return queries;
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getHitsSearchParams: function(state) {
        var facets = state.facets.concat(state.disjunctiveFacets).concat($b158d57b0036e428$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $b158d57b0036e428$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $b158d57b0036e428$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $b158d57b0036e428$var$requestBuilder._getTagFilters(state);
        var additionalParams = {};
        if (facets.length > 0) additionalParams.facets = facets.indexOf('*') > -1 ? [
            '*'
        ] : facets;
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        return $b158d57b0036e428$var$sortObject($5wWND({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object} The search parameters for a disjunctive facet
   */ _getDisjunctiveFacetSearchParams: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = $b158d57b0036e428$var$requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
        var numericFilters = $b158d57b0036e428$var$requestBuilder._getNumericFilters(state, facet);
        var tagFilters = $b158d57b0036e428$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            hitsPerPage: 0,
            page: 0,
            analytics: false,
            clickAnalytics: false
        };
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        var hierarchicalFacet = state.getHierarchicalFacetByName(facet);
        if (hierarchicalFacet) additionalParams.facets = $b158d57b0036e428$var$requestBuilder._getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, hierarchicalRootLevel);
        else additionalParams.facets = facet;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        return $b158d57b0036e428$var$sortObject($5wWND({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */ _getNumericFilters: function(state, facetName) {
        if (state.numericFilters) return state.numericFilters;
        var numericFilters = [];
        Object.keys(state.numericRefinements).forEach(function(attribute) {
            var operators = state.numericRefinements[attribute] || {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator] || [];
                if (facetName !== attribute) values.forEach(function(value) {
                    if (Array.isArray(value)) {
                        var vs = value.map(function(v) {
                            return attribute + operator + v;
                        });
                        numericFilters.push(vs);
                    } else numericFilters.push(attribute + operator + value);
                });
            });
        });
        return numericFilters;
    },
    /**
   * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @return {string} Tag filters in a single string
   */ _getTagFilters: function(state) {
        if (state.tagFilters) return state.tagFilters;
        return state.tagRefinements.join(',');
    },
    /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} [facet] if set, the current disjunctive facet
   * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
   * @return {array.<string>} The facet filters in the algolia format
   */ _getFacetFilters: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = [];
        var facetsRefinements = state.facetsRefinements || {};
        Object.keys(facetsRefinements).sort().forEach(function(facetName) {
            var facetValues = facetsRefinements[facetName] || [];
            facetValues.slice().sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ':' + facetValue);
            });
        });
        var facetsExcludes = state.facetsExcludes || {};
        Object.keys(facetsExcludes).sort().forEach(function(facetName) {
            var facetValues = facetsExcludes[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ':-' + facetValue);
            });
        });
        var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
        Object.keys(disjunctiveFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = disjunctiveFacetsRefinements[facetName] || [];
            if (facetName === facet || !facetValues || facetValues.length === 0) return;
            var orFilters = [];
            facetValues.slice().sort().forEach(function(facetValue) {
                orFilters.push(facetName + ':' + facetValue);
            });
            facetFilters.push(orFilters);
        });
        var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
        Object.keys(hierarchicalFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = hierarchicalFacetsRefinements[facetName] || [];
            var facetValue = facetValues[0];
            if (facetValue === undefined) return;
            var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeToRefine;
            var attributesIndex;
            // we ask for parent facet values only when the `facet` is the current hierarchical facet
            if (facet === facetName) {
                // if we are at the root level already, no need to ask for facet values, we get them from
                // the hits query
                if (facetValue.indexOf(separator) === -1 || !rootPath && hierarchicalRootLevel === true || rootPath && rootPath.split(separator).length === facetValue.split(separator).length) return;
                if (!rootPath) {
                    attributesIndex = facetValue.split(separator).length - 2;
                    facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
                } else {
                    attributesIndex = rootPath.split(separator).length - 1;
                    facetValue = rootPath;
                }
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            } else {
                attributesIndex = facetValue.split(separator).length - 1;
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            }
            if (attributeToRefine) facetFilters.push([
                attributeToRefine + ':' + facetValue
            ]);
        });
        return facetFilters;
    },
    _getHitsHierarchicalFacetsAttributes: function(state) {
        var out = [];
        return state.hierarchicalFacets.reduce(// ask for as much levels as there's hierarchical refinements
        function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
            var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];
            // if no refinement, ask for root level
            if (!hierarchicalRefinement) {
                allAttributes.push(hierarchicalFacet.attributes[0]);
                return allAttributes;
            }
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var level = hierarchicalRefinement.split(separator).length;
            var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
            return allAttributes.concat(newAttributes);
        }, out);
    },
    _getDisjunctiveHierarchicalFacetAttribute: function(state, hierarchicalFacet, rootLevel) {
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        if (rootLevel === true) {
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeIndex = 0;
            if (rootPath) attributeIndex = rootPath.split(separator).length;
            return [
                hierarchicalFacet.attributes[attributeIndex]
            ];
        }
        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || '';
        // if refinement is 'beers > IPA > Flying dog',
        // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)
        var parentLevel = hierarchicalRefinement.split(separator).length - 1;
        return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
    },
    getSearchForFacetQuery: function(facetName, query, maxFacetHits, state) {
        var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ? state.clearRefinements(facetName) : state;
        var searchForFacetSearchParameters = {
            facetQuery: query,
            facetName: facetName
        };
        if (typeof maxFacetHits === 'number') searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
        return $b158d57b0036e428$var$sortObject($5wWND({}, $b158d57b0036e428$var$requestBuilder._getHitsSearchParams(stateForSearchForFacetValues), searchForFacetSearchParameters));
    }
};
module.exports = $b158d57b0036e428$var$requestBuilder;

});

parcelRegister("iViQj", function(module, exports) {
'use strict';

var $kNVGd = parcelRequire("kNVGd");

var $PVtFJ = parcelRequire("PVtFJ");

var $7FlyD = parcelRequire("7FlyD");

var $5wWND = parcelRequire("5wWND");

var $4ELZX = parcelRequire("4ELZX");

var $jHjkh = parcelRequire("jHjkh");

var $6l2Vl = parcelRequire("6l2Vl");

var $aQSeG = parcelRequire("aQSeG");

var $dGgIP = parcelRequire("dGgIP");
/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 * @param {any} a numeric refinement value
 * @param {any} b numeric refinement value
 * @return {boolean} true if the values are equal
 */ function $dc6c2aaad6d989e7$var$isEqualNumericRefinement(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every(function(el, i) {
        return $dc6c2aaad6d989e7$var$isEqualNumericRefinement(b[i], el);
    });
    return a === b;
}
/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */ function $dc6c2aaad6d989e7$var$findArray(array, searchedValue) {
    return $PVtFJ(array, function(currentValue) {
        return $dc6c2aaad6d989e7$var$isEqualNumericRefinement(currentValue, searchedValue);
    });
}
/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */ /**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */ /**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */ function $dc6c2aaad6d989e7$var$SearchParameters(newParameters) {
    var params = newParameters ? $dc6c2aaad6d989e7$var$SearchParameters._parseNumbers(newParameters) : {};
    if (params.userToken !== undefined && !$aQSeG(params.userToken)) // eslint-disable-next-line no-console
    console.warn('[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}');
    /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.facets = params.facets || [];
    /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.disjunctiveFacets = params.disjunctiveFacets || [];
    /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */ this.hierarchicalFacets = params.hierarchicalFacets || [];
    // Refinements
    /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsRefinements = params.facetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsExcludes = params.facetsExcludes || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */ this.numericRefinements = params.numericRefinements || {};
    /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */ this.tagRefinements = params.tagRefinements || [];
    /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
    // eslint-disable-next-line consistent-this
    var self = this;
    Object.keys(params).forEach(function(paramName) {
        var isKeyKnown = $dc6c2aaad6d989e7$var$SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
        var isValueDefined = params[paramName] !== undefined;
        if (!isKeyKnown && isValueDefined) self[paramName] = params[paramName];
    });
}
/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */ $dc6c2aaad6d989e7$var$SearchParameters.PARAMETERS = Object.keys(new $dc6c2aaad6d989e7$var$SearchParameters());
/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */ $dc6c2aaad6d989e7$var$SearchParameters._parseNumbers = function(partialState) {
    // Do not parse numbers again in SearchParameters, they ought to be parsed already
    if (partialState instanceof $dc6c2aaad6d989e7$var$SearchParameters) return partialState;
    var numbers = {};
    var numberKeys = [
        'aroundPrecision',
        'aroundRadius',
        'getRankingInfo',
        'minWordSizefor2Typos',
        'minWordSizefor1Typo',
        'page',
        'maxValuesPerFacet',
        'distinct',
        'minimumAroundRadius',
        'hitsPerPage',
        'minProximity'
    ];
    numberKeys.forEach(function(k) {
        var value = partialState[k];
        if (typeof value === 'string') {
            var parsedValue = parseFloat(value);
            // global isNaN is ok to use here, value is only number or NaN
            numbers[k] = isNaN(parsedValue) ? value : parsedValue;
        }
    });
    // there's two formats of insideBoundingBox, we need to parse
    // the one which is an array of float geo rectangles
    if (Array.isArray(partialState.insideBoundingBox)) numbers.insideBoundingBox = partialState.insideBoundingBox.map(function(geoRect) {
        if (Array.isArray(geoRect)) return geoRect.map(function(value) {
            return parseFloat(value);
        });
        return geoRect;
    });
    if (partialState.numericRefinements) {
        var numericRefinements = {};
        Object.keys(partialState.numericRefinements).forEach(function(attribute) {
            var operators = partialState.numericRefinements[attribute] || {};
            numericRefinements[attribute] = {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator];
                var parsedValues = values.map(function(v) {
                    if (Array.isArray(v)) return v.map(function(vPrime) {
                        if (typeof vPrime === 'string') return parseFloat(vPrime);
                        return vPrime;
                    });
                    else if (typeof v === 'string') return parseFloat(v);
                    return v;
                });
                numericRefinements[attribute][operator] = parsedValues;
            });
        });
        numbers.numericRefinements = numericRefinements;
    }
    return $5wWND(partialState, numbers);
};
/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */ $dc6c2aaad6d989e7$var$SearchParameters.make = function makeSearchParameters(newParameters) {
    var instance = new $dc6c2aaad6d989e7$var$SearchParameters(newParameters);
    var hierarchicalFacets = newParameters.hierarchicalFacets || [];
    hierarchicalFacets.forEach(function(facet) {
        if (facet.rootPath) {
            var currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) instance = instance.clearRefinements(facet.name);
            // get it again in case it has been cleared
            currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length === 0) instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
        }
    });
    return instance;
};
/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */ $dc6c2aaad6d989e7$var$SearchParameters.validate = function(currentState, parameters) {
    var params = parameters || {};
    if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) return new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.");
    if (currentState.tagRefinements.length > 0 && params.tagFilters) return new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.");
    if (currentState.numericFilters && params.numericRefinements && $4ELZX(params.numericRefinements)) return new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    if ($4ELZX(currentState.numericRefinements) && params.numericFilters) return new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    return null;
};
$dc6c2aaad6d989e7$var$SearchParameters.prototype = {
    constructor: $dc6c2aaad6d989e7$var$SearchParameters,
    /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters} new instance with filters cleared
   */ clearRefinements: function clearRefinements(attribute) {
        var patch = {
            numericRefinements: this._clearNumericRefinements(attribute),
            facetsRefinements: $dGgIP.clearRefinement(this.facetsRefinements, attribute, 'conjunctiveFacet'),
            facetsExcludes: $dGgIP.clearRefinement(this.facetsExcludes, attribute, 'exclude'),
            disjunctiveFacetsRefinements: $dGgIP.clearRefinement(this.disjunctiveFacetsRefinements, attribute, 'disjunctiveFacet'),
            hierarchicalFacetsRefinements: $dGgIP.clearRefinement(this.hierarchicalFacetsRefinements, attribute, 'hierarchicalFacet')
        };
        if (patch.numericRefinements === this.numericRefinements && patch.facetsRefinements === this.facetsRefinements && patch.facetsExcludes === this.facetsExcludes && patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements) return this;
        return this.setQueryParameters(patch);
    },
    /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters} new instance with tags cleared
   */ clearTags: function clearTags() {
        if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
        return this.setQueryParameters({
            tagFilters: undefined,
            tagRefinements: []
        });
    },
    /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters} new instance
   */ setIndex: function setIndex(index) {
        if (index === this.index) return this;
        return this.setQueryParameters({
            index: index
        });
    },
    /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters} new instance
   */ setQuery: function setQuery(newQuery) {
        if (newQuery === this.query) return this;
        return this.setQueryParameters({
            query: newQuery
        });
    },
    /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters} new instance
   */ setPage: function setPage(newPage) {
        if (newPage === this.page) return this;
        return this.setQueryParameters({
            page: newPage
        });
    },
    /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters} new instance
   */ setFacets: function setFacets(facets) {
        return this.setQueryParameters({
            facets: facets
        });
    },
    /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters} new instance
   */ setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
        return this.setQueryParameters({
            disjunctiveFacets: facets
        });
    },
    /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters} new instance
   */ setHitsPerPage: function setHitsPerPage(n) {
        if (this.hitsPerPage === n) return this;
        return this.setQueryParameters({
            hitsPerPage: n
        });
    },
    /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters} new instance
   */ setTypoTolerance: function setTypoTolerance(typoTolerance) {
        if (this.typoTolerance === typoTolerance) return this;
        return this.setQueryParameters({
            typoTolerance: typoTolerance
        });
    },
    /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters} new instance
   * @example
   * // for price = 50 or 40
   * state.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * state.addNumericRefinement('size', '=', 38);
   * state.addNumericRefinement('size', '=', 40);
   */ addNumericRefinement: function(attribute, operator, value) {
        var val = $6l2Vl(value);
        if (this.isNumericRefined(attribute, operator, val)) return this;
        var mod = $5wWND({}, this.numericRefinements);
        mod[attribute] = $5wWND({}, mod[attribute]);
        if (mod[attribute][operator]) {
            // Array copy
            mod[attribute][operator] = mod[attribute][operator].slice();
            // Add the element. Concat can't be used here because value can be an array.
            mod[attribute][operator].push(val);
        } else mod[attribute][operator] = [
            val
        ];
        return this.setQueryParameters({
            numericRefinements: mod
        });
    },
    /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getConjunctiveRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsRefinements[facetName] || [];
    },
    /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getDisjunctiveRefinements: function(facetName) {
        if (!this.isDisjunctiveFacet(facetName)) return [];
        return this.disjunctiveFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getHierarchicalRefinement: function(facetName) {
        // we send an array but we currently do not support multiple
        // hierarchicalRefinements for a hierarchicalFacet
        return this.hierarchicalFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getExcludeRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsExcludes[facetName] || [];
    },
    /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters} new instance
   */ removeNumericRefinement: function(attribute, operator, number) {
        var paramValue = number;
        if (paramValue !== undefined) {
            if (!this.isNumericRefined(attribute, operator, paramValue)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator && $dc6c2aaad6d989e7$var$isEqualNumericRefinement(value.val, $6l2Vl(paramValue));
                })
            });
        } else if (operator !== undefined) {
            if (!this.isNumericRefined(attribute, operator)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator;
                })
            });
        }
        if (!this.isNumericRefined(attribute)) return this;
        return this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function(value, key) {
                return key === attribute;
            })
        });
    },
    /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */ getNumericRefinements: function(facetName) {
        return this.numericRefinements[facetName] || {};
    },
    /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */ getNumericRefinement: function(attribute, operator) {
        return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
    },
    /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>} new numeric refinements
   */ _clearNumericRefinements: function _clearNumericRefinements(attribute) {
        if (attribute === undefined) {
            if (!$4ELZX(this.numericRefinements)) return this.numericRefinements;
            return {};
        } else if (typeof attribute === 'string') return $jHjkh(this.numericRefinements, [
            attribute
        ]);
        else if (typeof attribute === 'function') {
            var hasChanged = false;
            var numericRefinements = this.numericRefinements;
            var newNumericRefinements = Object.keys(numericRefinements).reduce(function(memo, key) {
                var operators = numericRefinements[key];
                var operatorList = {};
                operators = operators || {};
                Object.keys(operators).forEach(function(operator) {
                    var values = operators[operator] || [];
                    var outValues = [];
                    values.forEach(function(value) {
                        var predicateResult = attribute({
                            val: value,
                            op: operator
                        }, key, 'numeric');
                        if (!predicateResult) outValues.push(value);
                    });
                    if (outValues.length !== values.length) hasChanged = true;
                    operatorList[operator] = outValues;
                });
                memo[key] = operatorList;
                return memo;
            }, {});
            if (hasChanged) return newNumericRefinements;
            return this.numericRefinements;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters} new instance
   */ addFacet: function addFacet(facet) {
        if (this.isConjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            facets: this.facets.concat([
                facet
            ])
        });
    },
    /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
        if (this.isDisjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.concat([
                facet
            ])
        });
    },
    /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters} new instance
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */ addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
        if (this.isHierarchicalFacet(hierarchicalFacet.name)) throw new Error('Cannot declare two hierarchical facets with the same name: `' + hierarchicalFacet.name + '`');
        return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([
                hierarchicalFacet
            ])
        });
    },
    /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addFacetRefinement: function addFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if ($dGgIP.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $dGgIP.addRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addExcludeRefinement: function addExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if ($dGgIP.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $dGgIP.addRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        if ($dGgIP.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $dGgIP.addRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters} new instance
   */ addTagRefinement: function addTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.concat(tag)
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters} new instance
   */ removeFacet: function removeFacet(facet) {
        if (!this.isConjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            facets: this.facets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
        if (!this.isDisjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters} new instance
   */ removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
        if (!this.isHierarchicalFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.filter(function(f) {
                return f.name !== facet;
            })
        });
    },
    /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters} new instance
   */ removeFacetRefinement: function removeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if (!$dGgIP.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $dGgIP.removeRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if (!$dGgIP.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $dGgIP.removeRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        if (!$dGgIP.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $dGgIP.removeRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters} new instance
   */ removeTagRefinement: function removeTagRefinement(tag) {
        if (!this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.filter(function(t) {
                return t !== tag;
            })
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */ toggleRefinement: function toggleRefinement(facet, value) {
        return this.toggleFacetRefinement(facet, value);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */ toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
        if (this.isHierarchicalFacet(facet)) return this.toggleHierarchicalFacetRefinement(facet, value);
        else if (this.isConjunctiveFacet(facet)) return this.toggleConjunctiveFacetRefinement(facet, value);
        else if (this.isDisjunctiveFacet(facet)) return this.toggleDisjunctiveFacetRefinement(facet, value);
        throw new Error('Cannot refine the undeclared facet ' + facet + '; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets');
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        return this.setQueryParameters({
            facetsRefinements: $dGgIP.toggleRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        return this.setQueryParameters({
            facetsExcludes: $dGgIP.toggleRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $dGgIP.toggleRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration');
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));
        var mod = {};
        var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined && this.hierarchicalFacetsRefinements[facet].length > 0 && // remove current refinement:
        // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
        (this.hierarchicalFacetsRefinements[facet][0] === value || // remove a parent refinement of the current refinement:
        //  - refinement was 'beer > IPA > Flying dog'
        //  - call is toggleRefine('beer > IPA')
        //  - refinement should be `beer`
        this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0);
        if (upOneOrMultipleLevel) {
            if (value.indexOf(separator) === -1) // go back to root level
            mod[facet] = [];
            else mod[facet] = [
                value.slice(0, value.lastIndexOf(separator))
            ];
        } else mod[facet] = [
            value
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $kNVGd(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */ addHierarchicalFacetRefinement: function(facet, path) {
        if (this.isHierarchicalFacetRefined(facet)) throw new Error(facet + ' is already refined.');
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration.');
        var mod = {};
        mod[facet] = [
            path
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $kNVGd(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */ removeHierarchicalFacetRefinement: function(facet) {
        if (!this.isHierarchicalFacetRefined(facet)) return this;
        var mod = {};
        mod[facet] = [];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $kNVGd(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters} new instance
   */ toggleTagRefinement: function toggleTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this.removeTagRefinement(tag);
        return this.addTagRefinement(tag);
    },
    /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a disjunctive facet
   */ isDisjunctiveFacet: function(facet) {
        return this.disjunctiveFacets.indexOf(facet) > -1;
    },
    /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean} true if facetName is a hierarchical facet
   */ isHierarchicalFacet: function(facetName) {
        return this.getHierarchicalFacetByName(facetName) !== undefined;
    },
    /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a conjunctive facet
   */ isConjunctiveFacet: function(facet) {
        return this.facets.indexOf(facet) > -1;
    },
    /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isFacetRefined: function isFacetRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $dGgIP.isRefined(this.facetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isExcludeRefined: function isExcludeRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $dGgIP.isRefined(this.facetsExcludes, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) return false;
        return $dGgIP.isRefined(this.disjunctiveFacetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
        if (!this.isHierarchicalFacet(facet)) return false;
        var refinements = this.getHierarchicalRefinement(facet);
        if (!value) return refinements.length > 0;
        return refinements.indexOf(value) !== -1;
    },
    /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */ isNumericRefined: function isNumericRefined(attribute, operator, value) {
        if (value === undefined && operator === undefined) return Boolean(this.numericRefinements[attribute]);
        var isOperatorDefined = this.numericRefinements[attribute] && this.numericRefinements[attribute][operator] !== undefined;
        if (value === undefined || !isOperatorDefined) return isOperatorDefined;
        var parsedValue = $6l2Vl(value);
        var isAttributeValueDefined = $dc6c2aaad6d989e7$var$findArray(this.numericRefinements[attribute][operator], parsedValue) !== undefined;
        return isOperatorDefined && isAttributeValueDefined;
    },
    /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean} true if tag is refined
   */ isTagRefined: function isTagRefined(tag) {
        return this.tagRefinements.indexOf(tag) !== -1;
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        // attributes used for numeric filter can also be disjunctive
        var disjunctiveNumericRefinedFacets = $7FlyD(Object.keys(this.numericRefinements).filter(function(facet) {
            return Object.keys(self.numericRefinements[facet]).length > 0;
        }), this.disjunctiveFacets);
        return Object.keys(this.disjunctiveFacetsRefinements).filter(function(facet) {
            return self.disjunctiveFacetsRefinements[facet].length > 0;
        }).concat(disjunctiveNumericRefinedFacets).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        return $7FlyD(// enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(facet) {
            return facet.name;
        }), Object.keys(this.hierarchicalFacetsRefinements).filter(function(facet) {
            return self.hierarchicalFacetsRefinements[facet].length > 0;
        })).sort();
    },
    /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]} returns the list of facets that are not refined
   */ getUnrefinedDisjunctiveFacets: function() {
        var refinedFacets = this.getRefinedDisjunctiveFacets();
        return this.disjunctiveFacets.filter(function(f) {
            return refinedFacets.indexOf(f) === -1;
        });
    },
    managedParameters: [
        'index',
        'facets',
        'disjunctiveFacets',
        'facetsRefinements',
        'hierarchicalFacets',
        'facetsExcludes',
        'disjunctiveFacetsRefinements',
        'numericRefinements',
        'tagRefinements',
        'hierarchicalFacetsRefinements'
    ],
    getQueryParams: function getQueryParams() {
        var managedParameters = this.managedParameters;
        var queryParams = {};
        // eslint-disable-next-line consistent-this
        var self = this;
        Object.keys(this).forEach(function(paramName) {
            var paramValue = self[paramName];
            if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) queryParams[paramName] = paramValue;
        });
        return queryParams;
    },
    /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */ setQueryParameter: function setParameter(parameter, value) {
        if (this[parameter] === value) return this;
        var modification = {};
        modification[parameter] = value;
        return this.setQueryParameters(modification);
    },
    /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */ setQueryParameters: function setQueryParameters(params) {
        if (!params) return this;
        var error = $dc6c2aaad6d989e7$var$SearchParameters.validate(this, params);
        if (error) throw error;
        // eslint-disable-next-line consistent-this
        var self = this;
        var nextWithNumbers = $dc6c2aaad6d989e7$var$SearchParameters._parseNumbers(params);
        var previousPlainObject = Object.keys(this).reduce(function(acc, key) {
            acc[key] = self[key];
            return acc;
        }, {});
        var nextPlainObject = Object.keys(nextWithNumbers).reduce(function(previous, key) {
            var isPreviousValueDefined = previous[key] !== undefined;
            var isNextValueDefined = nextWithNumbers[key] !== undefined;
            if (isPreviousValueDefined && !isNextValueDefined) return $jHjkh(previous, [
                key
            ]);
            if (isNextValueDefined) previous[key] = nextWithNumbers[key];
            return previous;
        }, previousPlainObject);
        return new this.constructor(nextPlainObject);
    },
    /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */ resetPage: function() {
        if (this.page === undefined) return this;
        return this.setPage(0);
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSortBy: function(hierarchicalFacet) {
        return hierarchicalFacet.sortBy || [
            'isRefined:desc',
            'name:asc'
        ];
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSeparator: function(hierarchicalFacet) {
        return hierarchicalFacet.separator || ' > ';
    },
    /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */ _getHierarchicalRootPath: function(hierarchicalFacet) {
        return hierarchicalFacet.rootPath || null;
    },
    /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */ _getHierarchicalShowParentLevel: function(hierarchicalFacet) {
        if (typeof hierarchicalFacet.showParentLevel === 'boolean') return hierarchicalFacet.showParentLevel;
        return true;
    },
    /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName the hierarchicalFacet name
   * @return {object} a hierarchicalFacet
   */ getHierarchicalFacetByName: function(hierarchicalFacetName) {
        return $PVtFJ(this.hierarchicalFacets, function(f) {
            return f.name === hierarchicalFacetName;
        });
    },
    /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */ getHierarchicalFacetBreadcrumb: function(facetName) {
        if (!this.isHierarchicalFacet(facetName)) return [];
        var refinement = this.getHierarchicalRefinement(facetName)[0];
        if (!refinement) return [];
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facetName));
        var path = refinement.split(separator);
        return path.map(function(part) {
            return part.trim();
        });
    },
    toString: function() {
        return JSON.stringify(this, null, 2);
    }
};
/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */ module.exports = $dc6c2aaad6d989e7$var$SearchParameters;

});
parcelRegister("kNVGd", function(module, exports) {
'use strict';
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order
module.exports = function defaultsPure() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            if (source[key] === undefined) return;
            if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
            delete acc[key];
            acc[key] = source[key];
        });
        return acc;
    }, {});
};

});

parcelRegister("PVtFJ", function(module, exports) {
'use strict';
// @MAJOR can be replaced by native Array#find when we change support
module.exports = function find(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
    return undefined;
};

});

parcelRegister("7FlyD", function(module, exports) {
'use strict';
function $594d159ef3ea821f$var$intersection(arr1, arr2) {
    return arr1.filter(function(value, index) {
        return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index /* skips duplicates */ ;
    });
}
module.exports = $594d159ef3ea821f$var$intersection;

});

parcelRegister("6l2Vl", function(module, exports) {
'use strict';
function $49d6f8df538994fc$var$valToNumber(v) {
    if (typeof v === 'number') return v;
    else if (typeof v === 'string') return parseFloat(v);
    else if (Array.isArray(v)) return v.map($49d6f8df538994fc$var$valToNumber);
    throw new Error('The value should be a number, a parsable string or an array of those.');
}
module.exports = $49d6f8df538994fc$var$valToNumber;

});

parcelRegister("aQSeG", function(module, exports) {
'use strict';
module.exports = function isValidUserToken(userToken) {
    if (userToken === null) return false;
    return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};

});

parcelRegister("dGgIP", function(module, exports) {
'use strict';

var $kNVGd = parcelRequire("kNVGd");

var $4ELZX = parcelRequire("4ELZX");

var $jHjkh = parcelRequire("jHjkh");
var $9f5c2b45f992d0ae$var$lib = {
    /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */ addRefinement: function addRefinement(refinementList, attribute, value) {
        if ($9f5c2b45f992d0ae$var$lib.isRefined(refinementList, attribute, value)) return refinementList;
        var valueAsString = '' + value;
        var facetRefinement = !refinementList[attribute] ? [
            valueAsString
        ] : refinementList[attribute].concat(valueAsString);
        var mod = {};
        mod[attribute] = facetRefinement;
        return $kNVGd(mod, refinementList);
    },
    /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */ removeRefinement: function removeRefinement(refinementList, attribute, value) {
        if (value === undefined) // we use the "filter" form of clearRefinement, since it leaves empty values as-is
        // the form with a string will remove the attribute completely
        return $9f5c2b45f992d0ae$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f;
        });
        var valueAsString = '' + value;
        return $9f5c2b45f992d0ae$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f && valueAsString === v;
        });
    },
    /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */ toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
        if (value === undefined) throw new Error('toggleRefinement should be used with a value');
        if ($9f5c2b45f992d0ae$var$lib.isRefined(refinementList, attribute, value)) return $9f5c2b45f992d0ae$var$lib.removeRefinement(refinementList, attribute, value);
        return $9f5c2b45f992d0ae$var$lib.addRefinement(refinementList, attribute, value);
    },
    /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */ clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
        if (attribute === undefined) {
            // return the same object if the list is already empty
            // this is mainly for tests, as it doesn't have much impact on performance
            if (!$4ELZX(refinementList)) return refinementList;
            return {};
        } else if (typeof attribute === 'string') return $jHjkh(refinementList, [
            attribute
        ]);
        else if (typeof attribute === 'function') {
            var hasChanged = false;
            var newRefinementList = Object.keys(refinementList).reduce(function(memo, key) {
                var values = refinementList[key] || [];
                var facetList = values.filter(function(value) {
                    return !attribute(value, key, refinementType);
                });
                if (facetList.length !== values.length) hasChanged = true;
                memo[key] = facetList;
                return memo;
            }, {});
            if (hasChanged) return newRefinementList;
            return refinementList;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean} true if the attribute is refined, false otherwise
   */ isRefined: function isRefined(refinementList, attribute, refinementValue) {
        var containsRefinements = Boolean(refinementList[attribute]) && refinementList[attribute].length > 0;
        if (refinementValue === undefined || !containsRefinements) return containsRefinements;
        var refinementValueAsString = '' + refinementValue;
        return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
    }
};
module.exports = $9f5c2b45f992d0ae$var$lib;

});


parcelRegister("a3F2K", function(module, exports) {
'use strict';

var $4JX1q = parcelRequire("4JX1q");

var $kNVGd = parcelRequire("kNVGd");

var $1M3zp = parcelRequire("1M3zp");

var $PVtFJ = parcelRequire("PVtFJ");

var $3X9jf = parcelRequire("3X9jf");

var $aitre = parcelRequire("aitre");

var $hV6KZ = parcelRequire("hV6KZ");
var $01e3c6485b0ffbe5$var$escapeFacetValue = $1M3zp.escapeFacetValue;
var $01e3c6485b0ffbe5$var$unescapeFacetValue = $1M3zp.unescapeFacetValue;

var $cYj6U = parcelRequire("cYj6U");
/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */ /**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */ /**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */ /**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */ /**
 * Turn an array of attributes in an object of attributes with their position in the array as value
 * @param {string[]} attributes the list of attributes in the record
 * @return {object} the list of attributes indexed by attribute name
 */ function $01e3c6485b0ffbe5$var$getIndices(attributes) {
    var indices = {};
    attributes.forEach(function(val, idx) {
        indices[val] = idx;
    });
    return indices;
}
function $01e3c6485b0ffbe5$var$assignFacetStats(dest, facetStats, key) {
    if (facetStats && facetStats[key]) dest.stats = facetStats[key];
}
/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */ /**
 * @param {HierarchicalFacet[]} hierarchicalFacets All hierarchical facets
 * @param {string} hierarchicalAttributeName The name of the hierarchical attribute
 * @return {HierarchicalFacet} The hierarchical facet matching the attribute name
 */ function $01e3c6485b0ffbe5$var$findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
    return $PVtFJ(hierarchicalFacets, function facetKeyMatchesAttribute(hierarchicalFacet) {
        var facetNames = hierarchicalFacet.attributes || [];
        return facetNames.indexOf(hierarchicalAttributeName) > -1;
    });
}
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @param {object} options options to control results content
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/ function $01e3c6485b0ffbe5$var$SearchResults(state, results, options) {
    var mainSubResponse = results[0] || {};
    this._rawResults = results;
    // eslint-disable-next-line consistent-this
    var self = this;
    // https://www.algolia.com/doc/api-reference/api-methods/search/#response
    Object.keys(mainSubResponse).forEach(function(key) {
        self[key] = mainSubResponse[key];
    });
    // Make every key of the result options reachable from the instance
    var opts = $kNVGd(options, {
        persistHierarchicalRootCount: false
    });
    Object.keys(opts).forEach(function(key) {
        self[key] = opts[key];
    });
    /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   * - `value` : the value of the facet highlighted (html)
   * - `matchLevel`: `full`, `partial` or `none`, depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */ /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */ /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */ /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * sum of the processing time of all the queries
   * @name processingTimeMS
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ this.processingTimeMS = results.reduce(function(sum, result) {
        return result.processingTimeMS === undefined ? sum : sum + result.processingTimeMS;
    }, 0);
    /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */ this.disjunctiveFacets = [];
    /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */ this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
        return [];
    });
    /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */ this.facets = [];
    var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
    var facetsIndices = $01e3c6485b0ffbe5$var$getIndices(state.facets);
    var disjunctiveFacetsIndices = $01e3c6485b0ffbe5$var$getIndices(state.disjunctiveFacets);
    var nextDisjunctiveResult = 1;
    // Since we send request only for disjunctive facets that have been refined,
    // we get the facets information from the first, general, response.
    var mainFacets = mainSubResponse.facets || {};
    Object.keys(mainFacets).forEach(function(facetKey) {
        var facetValueObject = mainFacets[facetKey];
        var hierarchicalFacet = $01e3c6485b0ffbe5$var$findMatchingHierarchicalFacetFromAttributeName(state.hierarchicalFacets, facetKey);
        if (hierarchicalFacet) {
            // Place the hierarchicalFacet data at the correct index depending on
            // the attributes order that was defined at the helper initialization
            var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
            var idxAttributeName = $3X9jf(state.hierarchicalFacets, function(f) {
                return f.name === hierarchicalFacet.name;
            });
            self.hierarchicalFacets[idxAttributeName][facetIndex] = {
                attribute: facetKey,
                data: facetValueObject,
                exhaustive: mainSubResponse.exhaustiveFacetsCount
            };
        } else {
            var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
            var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
            var position;
            if (isFacetDisjunctive) {
                position = disjunctiveFacetsIndices[facetKey];
                self.disjunctiveFacets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $01e3c6485b0ffbe5$var$assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
            }
            if (isFacetConjunctive) {
                position = facetsIndices[facetKey];
                self.facets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $01e3c6485b0ffbe5$var$assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
            }
        }
    });
    // Make sure we do not keep holes within the hierarchical facets
    this.hierarchicalFacets = $4JX1q(this.hierarchicalFacets);
    // aggregate the refined disjunctive facets
    disjunctiveFacets.forEach(function(disjunctiveFacet) {
        var result = results[nextDisjunctiveResult];
        var facets = result && result.facets ? result.facets : {};
        var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);
        // There should be only item in facets.
        Object.keys(facets).forEach(function(dfacet) {
            var facetResults = facets[dfacet];
            var position;
            if (hierarchicalFacet) {
                position = $3X9jf(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $3X9jf(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                self.hierarchicalFacets[position][attributeIndex].data = self.persistHierarchicalRootCount ? $kNVGd(self.hierarchicalFacets[position][attributeIndex].data, facetResults) : $kNVGd(facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            } else {
                position = disjunctiveFacetsIndices[dfacet];
                var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
                self.disjunctiveFacets[position] = {
                    name: dfacet,
                    data: $kNVGd(dataFromMainRequest, facetResults),
                    exhaustive: result.exhaustiveFacetsCount
                };
                $01e3c6485b0ffbe5$var$assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);
                if (state.disjunctiveFacetsRefinements[dfacet]) state.disjunctiveFacetsRefinements[dfacet].forEach(function(refinementValue) {
                    // add the disjunctive refinements if it is no more retrieved
                    if (!self.disjunctiveFacets[position].data[refinementValue] && state.disjunctiveFacetsRefinements[dfacet].indexOf($01e3c6485b0ffbe5$var$unescapeFacetValue(refinementValue)) > -1) self.disjunctiveFacets[position].data[refinementValue] = 0;
                });
            }
        });
        nextDisjunctiveResult++;
    });
    // if we have some parent level values for hierarchical facets, merge them
    state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
        var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
        // if we are already at a root refinement (or no refinement at all), there is no
        // root level values request
        if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) return;
        results.slice(nextDisjunctiveResult).forEach(function(result) {
            var facets = result && result.facets ? result.facets : {};
            Object.keys(facets).forEach(function(dfacet) {
                var facetResults = facets[dfacet];
                var position = $3X9jf(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $3X9jf(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
                // then the disjunctive values will be `beers` (count: 100),
                // but we do not want to display
                //   | beers (100)
                //     > IPA (5)
                // We want
                //   | beers (5)
                //     > IPA (5)
                // @MAJOR: remove this legacy behaviour in next major version
                var defaultData = {};
                if (currentRefinement.length > 0 && !self.persistHierarchicalRootCount) {
                    var root = currentRefinement[0].split(separator)[0];
                    defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
                }
                self.hierarchicalFacets[position][attributeIndex].data = $kNVGd(defaultData, facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            });
            nextDisjunctiveResult++;
        });
    });
    // add the excludes
    Object.keys(state.facetsExcludes).forEach(function(facetName) {
        var excludes = state.facetsExcludes[facetName];
        var position = facetsIndices[facetName];
        self.facets[position] = {
            name: facetName,
            data: mainFacets[facetName],
            exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        excludes.forEach(function(facetValue) {
            self.facets[position] = self.facets[position] || {
                name: facetName
            };
            self.facets[position].data = self.facets[position].data || {};
            self.facets[position].data[facetValue] = 0;
        });
    });
    /**
   * @type {Array}
   */ this.hierarchicalFacets = this.hierarchicalFacets.map($cYj6U(state));
    /**
   * @type {Array}
   */ this.facets = $4JX1q(this.facets);
    /**
   * @type {Array}
   */ this.disjunctiveFacets = $4JX1q(this.disjunctiveFacets);
    this._state = state;
}
/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */ $01e3c6485b0ffbe5$var$SearchResults.prototype.getFacetByName = function(name) {
    function predicate(facet) {
        return facet.name === name;
    }
    return $PVtFJ(this.facets, predicate) || $PVtFJ(this.disjunctiveFacets, predicate) || $PVtFJ(this.hierarchicalFacets, predicate);
};
/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */ function $01e3c6485b0ffbe5$var$extractNormalizedFacetValues(results, attribute) {
    function predicate(facet) {
        return facet.name === attribute;
    }
    if (results._state.isConjunctiveFacet(attribute)) {
        var facet = $PVtFJ(results.facets, predicate);
        if (!facet) return [];
        return Object.keys(facet.data).map(function(name) {
            var value = $01e3c6485b0ffbe5$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: facet.data[name],
                isRefined: results._state.isFacetRefined(attribute, value),
                isExcluded: results._state.isExcludeRefined(attribute, name)
            };
        });
    } else if (results._state.isDisjunctiveFacet(attribute)) {
        var disjunctiveFacet = $PVtFJ(results.disjunctiveFacets, predicate);
        if (!disjunctiveFacet) return [];
        return Object.keys(disjunctiveFacet.data).map(function(name) {
            var value = $01e3c6485b0ffbe5$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: disjunctiveFacet.data[name],
                isRefined: results._state.isDisjunctiveFacetRefined(attribute, value)
            };
        });
    } else if (results._state.isHierarchicalFacet(attribute)) {
        var hierarchicalFacetValues = $PVtFJ(results.hierarchicalFacets, predicate);
        if (!hierarchicalFacetValues) return hierarchicalFacetValues;
        var hierarchicalFacet = results._state.getHierarchicalFacetByName(attribute);
        var separator = results._state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = $01e3c6485b0ffbe5$var$unescapeFacetValue(results._state.getHierarchicalRefinement(attribute)[0] || '');
        if (currentRefinement.indexOf(hierarchicalFacet.rootPath) === 0) currentRefinement = currentRefinement.replace(hierarchicalFacet.rootPath + separator, '');
        var currentRefinementSplit = currentRefinement.split(separator);
        currentRefinementSplit.unshift(attribute);
        $01e3c6485b0ffbe5$var$setIsRefined(hierarchicalFacetValues, currentRefinementSplit, 0);
        return hierarchicalFacetValues;
    }
    return undefined;
}
/**
 * Set the isRefined of a hierarchical facet result based on the current state.
 * @param {SearchResults.HierarchicalFacet} item Hierarchical facet to fix
 * @param {string[]} currentRefinement array of parts of the current hierarchical refinement
 * @param {number} depth recursion depth in the currentRefinement
 * @return {undefined} function mutates the item
 */ function $01e3c6485b0ffbe5$var$setIsRefined(item, currentRefinement, depth) {
    item.isRefined = item.name === (currentRefinement[depth] && currentRefinement[depth].trim());
    if (item.data) item.data.forEach(function(child) {
        $01e3c6485b0ffbe5$var$setIsRefined(child, currentRefinement, depth + 1);
    });
}
/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn sort function to apply
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 * @return {HierarchicalFacet|Array} sorted node
 */ function $01e3c6485b0ffbe5$var$recSort(sortFn, node, names, level) {
    level = level || 0;
    if (Array.isArray(node)) return sortFn(node, names[level]);
    if (!node.data || node.data.length === 0) return node;
    var children = node.data.map(function(childNode) {
        return $01e3c6485b0ffbe5$var$recSort(sortFn, childNode, names, level + 1);
    });
    var sortedChildren = sortFn(children, names[level]);
    var newNode = $kNVGd({
        data: sortedChildren
    }, node);
    return newNode;
}
$01e3c6485b0ffbe5$var$SearchResults.DEFAULT_SORT = [
    'isRefined:desc',
    'count:desc',
    'name:asc'
];
function $01e3c6485b0ffbe5$var$vanillaSortFn(order, data) {
    return data.sort(order);
}
/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */ /**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array} the sorted facet values
 */ function $01e3c6485b0ffbe5$var$sortViaFacetOrdering(facetValues, facetOrdering) {
    var orderedFacets = [];
    var remainingFacets = [];
    var hide = facetOrdering.hide || [];
    var order = facetOrdering.order || [];
    /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */ var reverseOrder = order.reduce(function(acc, name, i) {
        acc[name] = i;
        return acc;
    }, {});
    facetValues.forEach(function(item) {
        // hierarchical facets get sorted using their raw name
        var name = item.path || item.name;
        var hidden = hide.indexOf(name) > -1;
        if (!hidden && reverseOrder[name] !== undefined) orderedFacets[reverseOrder[name]] = item;
        else if (!hidden) remainingFacets.push(item);
    });
    orderedFacets = orderedFacets.filter(function(facet) {
        return facet;
    });
    var sortRemainingBy = facetOrdering.sortRemainingBy;
    var ordering;
    if (sortRemainingBy === 'hidden') return orderedFacets;
    else if (sortRemainingBy === 'alpha') ordering = [
        [
            'path',
            'name'
        ],
        [
            'asc',
            'asc'
        ]
    ];
    else ordering = [
        [
            'count'
        ],
        [
            'desc'
        ]
    ];
    return orderedFacets.concat($hV6KZ(remainingFacets, ordering[0], ordering[1]));
}
/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering | undefined} the facet ordering
 */ function $01e3c6485b0ffbe5$var$getFacetOrdering(results, attribute) {
    return results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.values && results.renderingContent.facetOrdering.values[attribute];
}
/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */ $01e3c6485b0ffbe5$var$SearchResults.prototype.getFacetValues = function(attribute, opts) {
    var facetValues = $01e3c6485b0ffbe5$var$extractNormalizedFacetValues(this, attribute);
    if (!facetValues) return undefined;
    var options = $kNVGd(opts, {
        sortBy: $01e3c6485b0ffbe5$var$SearchResults.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(opts && opts.sortBy)
    });
    // eslint-disable-next-line consistent-this
    var results = this;
    var attributes;
    if (Array.isArray(facetValues)) attributes = [
        attribute
    ];
    else {
        var config = results._state.getHierarchicalFacetByName(facetValues.name);
        attributes = config.attributes;
    }
    return $01e3c6485b0ffbe5$var$recSort(function(data, facetName) {
        if (options.facetOrdering) {
            var facetOrdering = $01e3c6485b0ffbe5$var$getFacetOrdering(results, facetName);
            if (facetOrdering) return $01e3c6485b0ffbe5$var$sortViaFacetOrdering(data, facetOrdering);
        }
        if (Array.isArray(options.sortBy)) {
            var order = $aitre(options.sortBy, $01e3c6485b0ffbe5$var$SearchResults.DEFAULT_SORT);
            return $hV6KZ(data, order[0], order[1]);
        } else if (typeof options.sortBy === 'function') return $01e3c6485b0ffbe5$var$vanillaSortFn(options.sortBy, data);
        throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, facetValues, attributes);
};
/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */ $01e3c6485b0ffbe5$var$SearchResults.prototype.getFacetStats = function(attribute) {
    if (this._state.isConjunctiveFacet(attribute)) return $01e3c6485b0ffbe5$var$getFacetStatsIfAvailable(this.facets, attribute);
    else if (this._state.isDisjunctiveFacet(attribute)) return $01e3c6485b0ffbe5$var$getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
    return undefined;
};
/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */ /**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName The attribute to look for
 * @return {object|undefined} The stats of the facet
 */ function $01e3c6485b0ffbe5$var$getFacetStatsIfAvailable(facetList, facetName) {
    var data = $PVtFJ(facetList, function(facet) {
        return facet.name === facetName;
    });
    return data && data.stats;
}
/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */ $01e3c6485b0ffbe5$var$SearchResults.prototype.getRefinements = function() {
    var state = this._state;
    // eslint-disable-next-line consistent-this
    var results = this;
    var res = [];
    Object.keys(state.facetsRefinements).forEach(function(attributeName) {
        state.facetsRefinements[attributeName].forEach(function(name) {
            res.push($01e3c6485b0ffbe5$var$getRefinement(state, 'facet', attributeName, name, results.facets));
        });
    });
    Object.keys(state.facetsExcludes).forEach(function(attributeName) {
        state.facetsExcludes[attributeName].forEach(function(name) {
            res.push($01e3c6485b0ffbe5$var$getRefinement(state, 'exclude', attributeName, name, results.facets));
        });
    });
    Object.keys(state.disjunctiveFacetsRefinements).forEach(function(attributeName) {
        state.disjunctiveFacetsRefinements[attributeName].forEach(function(name) {
            res.push($01e3c6485b0ffbe5$var$getRefinement(state, 'disjunctive', attributeName, name, results.disjunctiveFacets));
        });
    });
    Object.keys(state.hierarchicalFacetsRefinements).forEach(function(attributeName) {
        state.hierarchicalFacetsRefinements[attributeName].forEach(function(name) {
            res.push($01e3c6485b0ffbe5$var$getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
        });
    });
    Object.keys(state.numericRefinements).forEach(function(attributeName) {
        var operators = state.numericRefinements[attributeName];
        Object.keys(operators).forEach(function(operator) {
            operators[operator].forEach(function(value) {
                res.push({
                    type: 'numeric',
                    attributeName: attributeName,
                    name: value,
                    numericValue: value,
                    operator: operator
                });
            });
        });
    });
    state.tagRefinements.forEach(function(name) {
        res.push({
            type: 'tag',
            attributeName: '_tags',
            name: name
        });
    });
    return res;
};
/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */ /**
 * @param {SearchParameters} state the current state
 * @param {string} type the type of the refinement
 * @param {string} attributeName The attribute of the facet
 * @param {*} name The name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {Refinement} the refinement
 */ function $01e3c6485b0ffbe5$var$getRefinement(state, type, attributeName, name, resultsFacets) {
    var facet = $PVtFJ(resultsFacets, function(f) {
        return f.name === attributeName;
    });
    var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
    var exhaustive = facet && facet.exhaustive || false;
    return {
        type: type,
        attributeName: attributeName,
        name: name,
        count: count,
        exhaustive: exhaustive
    };
}
/**
 * @param {SearchParameters} state the current state
 * @param {string} attributeName the attribute of the hierarchical facet
 * @param {string} name the name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {HierarchicalFacet} the hierarchical facet
 */ function $01e3c6485b0ffbe5$var$getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
    var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
    var separator = state._getHierarchicalFacetSeparator(facetDeclaration);
    var split = name.split(separator);
    var rootFacet = $PVtFJ(resultsFacets, function(facet) {
        return facet.name === attributeName;
    });
    var facet = split.reduce(function(intermediateFacet, part) {
        var newFacet = intermediateFacet && $PVtFJ(intermediateFacet.data, function(f) {
            return f.name === part;
        });
        return newFacet !== undefined ? newFacet : intermediateFacet;
    }, rootFacet);
    var count = facet && facet.count || 0;
    var exhaustive = facet && facet.exhaustive || false;
    var path = facet && facet.path || '';
    return {
        type: 'hierarchical',
        attributeName: attributeName,
        name: path,
        count: count,
        exhaustive: exhaustive
    };
}
module.exports = $01e3c6485b0ffbe5$var$SearchResults;

});
parcelRegister("4JX1q", function(module, exports) {
'use strict';
module.exports = function compact(array) {
    if (!Array.isArray(array)) return [];
    return array.filter(Boolean);
};

});

parcelRegister("3X9jf", function(module, exports) {
'use strict';
// @MAJOR can be replaced by native Array#findIndex when we change support
module.exports = function find(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
};

});

parcelRegister("aitre", function(module, exports) {
'use strict';

var $PVtFJ = parcelRequire("PVtFJ");
/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */ module.exports = function formatSort(sortBy, defaults) {
    var defaultInstructions = (defaults || []).map(function(sort) {
        return sort.split(':');
    });
    return sortBy.reduce(function preparePredicate(out, sort) {
        var sortInstruction = sort.split(':');
        var matchingDefault = $PVtFJ(defaultInstructions, function(defaultInstruction) {
            return defaultInstruction[0] === sortInstruction[0];
        });
        if (sortInstruction.length > 1 || !matchingDefault) {
            out[0].push(sortInstruction[0]);
            out[1].push(sortInstruction[1]);
            return out;
        }
        out[0].push(matchingDefault[0]);
        out[1].push(matchingDefault[1]);
        return out;
    }, [
        [],
        []
    ]);
};

});

parcelRegister("hV6KZ", function(module, exports) {
'use strict';
function $d0bd005253f56abb$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined;
        var valIsNull = value === null;
        var othIsDefined = other !== undefined;
        var othIsNull = other === null;
        if (!othIsNull && value > other || valIsNull && othIsDefined || !valIsDefined) return 1;
        if (!valIsNull && value < other || othIsNull && valIsDefined || !othIsDefined) return -1;
    }
    return 0;
}
/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 * @return {Array<object>} sorted collection
 */ function $d0bd005253f56abb$var$orderBy(collection, iteratees, orders) {
    if (!Array.isArray(collection)) return [];
    if (!Array.isArray(orders)) orders = [];
    var result = collection.map(function(value, index) {
        return {
            criteria: iteratees.map(function(iteratee) {
                return value[iteratee];
            }),
            index: index,
            value: value
        };
    });
    result.sort(function comparer(object, other) {
        var index = -1;
        while(++index < object.criteria.length){
            var res = $d0bd005253f56abb$var$compareAscending(object.criteria[index], other.criteria[index]);
            if (res) {
                if (index >= orders.length) return res;
                if (orders[index] === 'desc') return -res;
                return res;
            }
        }
        // This ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    });
    return result.map(function(res) {
        return res.value;
    });
}
module.exports = $d0bd005253f56abb$var$orderBy;

});

parcelRegister("cYj6U", function(module, exports) {
'use strict';
module.exports = $9719e98eaaabc30b$var$generateTrees;

var $1M3zp = parcelRequire("1M3zp");

var $PVtFJ = parcelRequire("PVtFJ");

var $aitre = parcelRequire("aitre");

var $hV6KZ = parcelRequire("hV6KZ");
var $9719e98eaaabc30b$var$escapeFacetValue = $1M3zp.escapeFacetValue;
var $9719e98eaaabc30b$var$unescapeFacetValue = $1M3zp.unescapeFacetValue;
function $9719e98eaaabc30b$var$generateTrees(state) {
    return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
        var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
        var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] && state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || '';
        var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);
        var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);
        var sortBy = $aitre(state._getHierarchicalFacetSortBy(hierarchicalFacet));
        var rootExhaustive = hierarchicalFacetResult.every(function(facetResult) {
            return facetResult.exhaustive;
        });
        var generateTreeFn = $9719e98eaaabc30b$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, hierarchicalFacetRefinement);
        var results = hierarchicalFacetResult;
        if (hierarchicalRootPath) results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
        return results.reduce(generateTreeFn, {
            name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
            count: null,
            isRefined: true,
            path: null,
            escapedValue: null,
            exhaustive: rootExhaustive,
            data: null
        });
    };
}
function $9719e98eaaabc30b$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, currentRefinement) {
    return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
        var parent = hierarchicalTree;
        if (currentHierarchicalLevel > 0) {
            var level = 0;
            parent = hierarchicalTree;
            while(level < currentHierarchicalLevel){
                /**
         * @type {object[]]} hierarchical data
         */ var data = parent && Array.isArray(parent.data) ? parent.data : [];
                parent = $PVtFJ(data, function(subtree) {
                    return subtree.isRefined;
                });
                level++;
            }
        }
        // we found a refined parent, let's add current level data under it
        if (parent) {
            // filter values in case an object has multiple categories:
            //   {
            //     categories: {
            //       level0: ['beers', 'bières'],
            //       level1: ['beers > IPA', 'bières > Belges']
            //     }
            //   }
            //
            // If parent refinement is `beers`, then we do not want to have `bières > Belges`
            // showing up
            var picked = Object.keys(hierarchicalFacetResult.data).map(function(facetValue) {
                return [
                    facetValue,
                    hierarchicalFacetResult.data[facetValue]
                ];
            }).filter(function(tuple) {
                var facetValue = tuple[0];
                return $9719e98eaaabc30b$var$onlyMatchingTree(facetValue, parent.path || hierarchicalRootPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
            });
            parent.data = $hV6KZ(picked.map(function(tuple) {
                var facetValue = tuple[0];
                var facetCount = tuple[1];
                return $9719e98eaaabc30b$var$format(facetCount, facetValue, hierarchicalSeparator, $9719e98eaaabc30b$var$unescapeFacetValue(currentRefinement), hierarchicalFacetResult.exhaustive);
            }), sortBy[0], sortBy[1]);
        }
        return hierarchicalTree;
    };
}
// eslint-disable-next-line max-params
function $9719e98eaaabc30b$var$onlyMatchingTree(facetValue, parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel) {
    // we want the facetValue is a child of hierarchicalRootPath
    if (hierarchicalRootPath && (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) return false;
    // we always want root levels (only when there is no prefix path)
    return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    hierarchicalRootPath && facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    facetValue.indexOf(hierarchicalSeparator) === -1 && currentRefinement.indexOf(hierarchicalSeparator) === -1 || // currentRefinement is a child of the facet value
    currentRefinement.indexOf(facetValue) === 0 || // facetValue is a child of the current parent, add it
    facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 && (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
}
function $9719e98eaaabc30b$var$format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, exhaustive) {
    var parts = facetValue.split(hierarchicalSeparator);
    return {
        name: parts[parts.length - 1].trim(),
        path: facetValue,
        escapedValue: $9719e98eaaabc30b$var$escapeFacetValue(facetValue),
        count: facetCount,
        isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
        exhaustive: exhaustive,
        data: null
    };
}

});


parcelRegister("h5T11", function(module, exports) {
'use strict';

var $PVtFJ = parcelRequire("PVtFJ");

var $4xw3a = parcelRequire("4xw3a");
function $c71d9435aab7e814$var$getAverageIndices(indexTracker, nrOfObjs) {
    var avgIndices = [];
    Object.keys(indexTracker).forEach(function(key) {
        if (indexTracker[key].count < 2) indexTracker[key].indexSum += 100;
        avgIndices.push({
            objectID: key,
            avgOfIndices: indexTracker[key].indexSum / nrOfObjs
        });
    });
    return avgIndices.sort(function(a, b) {
        return a.avgOfIndices > b.avgOfIndices ? 1 : -1;
    });
}
function $c71d9435aab7e814$var$sortAndMergeRecommendations(results) {
    var indexTracker = {};
    results.forEach(function(hits) {
        hits.forEach(function(hit, index) {
            if (!indexTracker[hit.objectID]) indexTracker[hit.objectID] = {
                indexSum: index,
                count: 1
            };
            else indexTracker[hit.objectID] = {
                indexSum: indexTracker[hit.objectID].indexSum + index,
                count: indexTracker[hit.objectID].count + 1
            };
        });
    });
    var sortedAverageIndices = $c71d9435aab7e814$var$getAverageIndices(indexTracker, results.length);
    var finalOrder = sortedAverageIndices.reduce(function(orderedHits, avgIndexRef) {
        var result = $PVtFJ($4xw3a(results), function(hit) {
            return hit.objectID === avgIndexRef.objectID;
        });
        return result ? orderedHits.concat(result) : orderedHits;
    }, []);
    return finalOrder;
}
module.exports = $c71d9435aab7e814$var$sortAndMergeRecommendations;

});
parcelRegister("4xw3a", function(module, exports) {
// @MAJOR: remove this function and use Array.prototype.flat
module.exports = function flat(arr) {
    return arr.reduce(function(acc, val) {
        return acc.concat(val);
    }, []);
};

});


parcelRegister("VtFel", function(module, exports) {
'use strict';
module.exports = '3.22.6';

});



parcelRegister("161bL", function(module, exports) {

$parcel$export(module.exports, "createInsightsMiddleware", function () { return $0cc7460c69d4f0a7$export$91e0bf09562e2c44; });

var $1ymGy = parcelRequire("1ymGy");

var $eHfFT = parcelRequire("eHfFT");
var $gkp6v = parcelRequire("gkp6v");
var $fMELL = parcelRequire("fMELL");
var $2AIDb = parcelRequire("2AIDb");

var $5taqR = parcelRequire("5taqR");
function $0cc7460c69d4f0a7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $0cc7460c69d4f0a7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0cc7460c69d4f0a7$var$_typeof(obj);
}
function $0cc7460c69d4f0a7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0cc7460c69d4f0a7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0cc7460c69d4f0a7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0cc7460c69d4f0a7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0cc7460c69d4f0a7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0cc7460c69d4f0a7$var$_defineProperty(obj, key, value) {
    key = $0cc7460c69d4f0a7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0cc7460c69d4f0a7$var$_toPropertyKey(arg) {
    var key = $0cc7460c69d4f0a7$var$_toPrimitive(arg, "string");
    return $0cc7460c69d4f0a7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0cc7460c69d4f0a7$var$_toPrimitive(input, hint) {
    if ($0cc7460c69d4f0a7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0cc7460c69d4f0a7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0cc7460c69d4f0a7$var$_slicedToArray(arr, i) {
    return $0cc7460c69d4f0a7$var$_arrayWithHoles(arr) || $0cc7460c69d4f0a7$var$_iterableToArrayLimit(arr, i) || $0cc7460c69d4f0a7$var$_unsupportedIterableToArray(arr, i) || $0cc7460c69d4f0a7$var$_nonIterableRest();
}
function $0cc7460c69d4f0a7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0cc7460c69d4f0a7$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $0cc7460c69d4f0a7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0cc7460c69d4f0a7$var$_toConsumableArray(arr) {
    return $0cc7460c69d4f0a7$var$_arrayWithoutHoles(arr) || $0cc7460c69d4f0a7$var$_iterableToArray(arr) || $0cc7460c69d4f0a7$var$_unsupportedIterableToArray(arr) || $0cc7460c69d4f0a7$var$_nonIterableSpread();
}
function $0cc7460c69d4f0a7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0cc7460c69d4f0a7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0cc7460c69d4f0a7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0cc7460c69d4f0a7$var$_arrayLikeToArray(o, minLen);
}
function $0cc7460c69d4f0a7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $0cc7460c69d4f0a7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $0cc7460c69d4f0a7$var$_arrayLikeToArray(arr);
}
function $0cc7460c69d4f0a7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $0cc7460c69d4f0a7$var$ALGOLIA_INSIGHTS_VERSION = '2.17.2';
var $0cc7460c69d4f0a7$var$ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@".concat($0cc7460c69d4f0a7$var$ALGOLIA_INSIGHTS_VERSION, "/dist/search-insights.min.js");
function $0cc7460c69d4f0a7$export$91e0bf09562e2c44() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _insightsClient = props.insightsClient, insightsInitParams = props.insightsInitParams, onEvent = props.onEvent, _props$$$internal = props.$$internal, $$internal = _props$$$internal === void 0 ? false : _props$$$internal, _props$$$automatic = props.$$automatic, $$automatic = _props$$$automatic === void 0 ? false : _props$$$automatic;
    var potentialInsightsClient = _insightsClient;
    if (!_insightsClient && _insightsClient !== null) (0, $2AIDb.safelyRunOnBrowser)(function(_ref) {
        var window = _ref.window;
        var pointer = window.AlgoliaAnalyticsObject || 'aa';
        if (typeof pointer === 'string') potentialInsightsClient = window[pointer];
        if (!potentialInsightsClient) {
            window.AlgoliaAnalyticsObject = pointer;
            if (!window[pointer]) {
                window[pointer] = function() {
                    if (!window[pointer].queue) window[pointer].queue = [];
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    window[pointer].queue.push(args);
                };
                window[pointer].version = $0cc7460c69d4f0a7$var$ALGOLIA_INSIGHTS_VERSION;
                window[pointer].shouldAddScript = true;
            }
            potentialInsightsClient = window[pointer];
        }
    });
    // if still no insightsClient was found, we use a noop
    var insightsClient = potentialInsightsClient || (0, $fMELL.noop);
    return function(_ref2) {
        var instantSearchInstance = _ref2.instantSearchInstance;
        // remove existing default insights middleware
        // user-provided insights middleware takes precedence
        var existingInsightsMiddlewares = instantSearchInstance.middleware.filter(function(m) {
            return m.instance.$$type === 'ais.insights' && m.instance.$$internal;
        }).map(function(m) {
            return m.creator;
        });
        instantSearchInstance.unuse.apply(instantSearchInstance, $0cc7460c69d4f0a7$var$_toConsumableArray(existingInsightsMiddlewares));
        var _getAppIdAndApiKey = (0, $gkp6v.getAppIdAndApiKey)(instantSearchInstance.client), _getAppIdAndApiKey2 = $0cc7460c69d4f0a7$var$_slicedToArray(_getAppIdAndApiKey, 2), appId = _getAppIdAndApiKey2[0], apiKey = _getAppIdAndApiKey2[1];
        var queuedInitParams = undefined;
        var queuedUserToken = undefined;
        var userTokenBeforeInit = undefined;
        var queue = insightsClient.queue;
        if (Array.isArray(queue)) {
            // Context: The umd build of search-insights is asynchronously loaded by the snippet.
            //
            // When user calls `aa('setUserToken', 'my-user-token')` before `search-insights` is loaded,
            // ['setUserToken', 'my-user-token'] gets stored in `aa.queue`.
            // Whenever `search-insights` is finally loaded, it will process the queue.
            //
            // But here's the reason why we handle it here:
            // At this point, even though `search-insights` is not loaded yet,
            // we still want to read the token from the queue.
            // Otherwise, the first search call will be fired without the token.
            var _map = [
                'setUserToken',
                'init'
            ].map(function(key) {
                var _ref3 = (0, $eHfFT.find)(queue.slice().reverse(), function(_ref5) {
                    var _ref6 = $0cc7460c69d4f0a7$var$_slicedToArray(_ref5, 1), method = _ref6[0];
                    return method === key;
                }) || [], _ref4 = $0cc7460c69d4f0a7$var$_slicedToArray(_ref3, 2), value = _ref4[1];
                return value;
            });
            var _map2 = $0cc7460c69d4f0a7$var$_slicedToArray(_map, 2);
            queuedUserToken = _map2[0];
            queuedInitParams = _map2[1];
        }
        // If user called `aa('setUserToken')` before creating the Insights middleware,
        // we temporarily store the token and set it later on.
        //
        // Otherwise, the `init` call might override them with anonymous user token.
        insightsClient('getUserToken', null, function(_error, userToken) {
            userTokenBeforeInit = $0cc7460c69d4f0a7$var$normalizeUserToken(userToken);
        });
        // Only `init` if the `insightsInitParams` option is passed or
        // if the `insightsClient` version doesn't supports optional `init` calling.
        if (insightsInitParams || !$0cc7460c69d4f0a7$var$isModernInsightsClient(insightsClient)) insightsClient('init', $0cc7460c69d4f0a7$var$_objectSpread({
            appId: appId,
            apiKey: apiKey,
            partial: true
        }, insightsInitParams));
        var initialParameters;
        var helper;
        return {
            $$type: 'ais.insights',
            $$internal: $$internal,
            $$automatic: $$automatic,
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                if (!insightsClient.shouldAddScript) return;
                var errorMessage = '[insights middleware]: could not load search-insights.js. Please load it manually following https://alg.li/insights-init';
                try {
                    var script = document.createElement('script');
                    script.async = true;
                    script.src = $0cc7460c69d4f0a7$var$ALGOLIA_INSIGHTS_SRC;
                    script.onerror = function() {
                        instantSearchInstance.emit('error', new Error(errorMessage));
                    };
                    document.body.appendChild(script);
                    insightsClient.shouldAddScript = false;
                } catch (cause) {
                    insightsClient.shouldAddScript = false;
                    instantSearchInstance.emit('error', new Error(errorMessage));
                }
            },
            started: function started() {
                insightsClient('addAlgoliaAgent', 'insights-middleware');
                helper = instantSearchInstance.mainHelper;
                var queueAtStart = insightsClient.queue;
                if (Array.isArray(queueAtStart)) {
                    var _map3 = [
                        'setUserToken',
                        'init'
                    ].map(function(key) {
                        var _ref7 = (0, $eHfFT.find)(queueAtStart.slice().reverse(), function(_ref9) {
                            var _ref10 = $0cc7460c69d4f0a7$var$_slicedToArray(_ref9, 1), method = _ref10[0];
                            return method === key;
                        }) || [], _ref8 = $0cc7460c69d4f0a7$var$_slicedToArray(_ref7, 2), value = _ref8[1];
                        return value;
                    });
                    var _map4 = $0cc7460c69d4f0a7$var$_slicedToArray(_map3, 2);
                    queuedUserToken = _map4[0];
                    queuedInitParams = _map4[1];
                }
                initialParameters = $0cc7460c69d4f0a7$var$getInitialParameters(instantSearchInstance);
                // We don't want to force clickAnalytics when the insights is enabled from the search response.
                // This means we don't enable insights for indices that don't opt in
                if (!$$automatic) helper.overrideStateWithoutTriggeringChangeEvent($0cc7460c69d4f0a7$var$_objectSpread($0cc7460c69d4f0a7$var$_objectSpread({}, helper.state), {}, {
                    clickAnalytics: true
                }));
                if (!$$internal) instantSearchInstance.scheduleSearch();
                var setUserTokenToSearch = function setUserTokenToSearch(userToken) {
                    var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    var normalizedUserToken = $0cc7460c69d4f0a7$var$normalizeUserToken(userToken);
                    if (!normalizedUserToken) return;
                    var existingToken = helper.state.userToken;
                    function applyToken() {
                        helper.overrideStateWithoutTriggeringChangeEvent($0cc7460c69d4f0a7$var$_objectSpread($0cc7460c69d4f0a7$var$_objectSpread({}, helper.state), {}, {
                            userToken: normalizedUserToken
                        }));
                        if (existingToken && existingToken !== userToken) instantSearchInstance.scheduleSearch();
                    }
                    // Delay the token application to the next render cycle
                    if (!immediate) setTimeout(applyToken, 0);
                    else applyToken();
                };
                function setUserToken(token) {
                    setUserTokenToSearch(token, true);
                    insightsClient('setUserToken', token);
                }
                var anonymousUserToken = undefined;
                var anonymousTokenFromInsights = (0, $1ymGy.getInsightsAnonymousUserTokenInternal)();
                if (anonymousTokenFromInsights) // When `aa('init', { ... })` is called, it creates an anonymous user token in cookie.
                // We can set it as userToken on instantsearch and insights. If it's not set as an insights
                // userToken before a sendEvent, insights automatically generates a new anonymous token,
                // causing a state change and an unnecessary query on instantsearch.
                anonymousUserToken = anonymousTokenFromInsights;
                else {
                    var token = "anonymous-".concat((0, $5taqR.createUUID)());
                    anonymousUserToken = token;
                }
                var userTokenFromInit;
                // With SSR, the token could be be set on the state. We make sure
                // that insights is in sync with that token since, there is no
                // insights lib on the server.
                var tokenFromSearchParameters = initialParameters.userToken;
                // When the first query is sent, the token is possibly not yet set by
                // the insights onChange callbacks (if insights isn't yet loaded).
                // It is explicitly being set here so that the first query has the
                // initial tokens set and ensure a second query isn't automatically
                // made when the onChange callback actually changes the state.
                if (insightsInitParams !== null && insightsInitParams !== void 0 && insightsInitParams.userToken) userTokenFromInit = insightsInitParams.userToken;
                if (userTokenFromInit) setUserToken(userTokenFromInit);
                else if (tokenFromSearchParameters) setUserToken(tokenFromSearchParameters);
                else if (userTokenBeforeInit) setUserToken(userTokenBeforeInit);
                else if (queuedUserToken) setUserToken(queuedUserToken);
                else if (anonymousUserToken) {
                    var _queuedInitParams;
                    setUserToken(anonymousUserToken);
                    if (insightsInitParams !== null && insightsInitParams !== void 0 && insightsInitParams.useCookie || (_queuedInitParams = queuedInitParams) !== null && _queuedInitParams !== void 0 && _queuedInitParams.useCookie) {
                        var _queuedInitParams2;
                        $0cc7460c69d4f0a7$var$saveTokenAsCookie(anonymousUserToken, (insightsInitParams === null || insightsInitParams === void 0 ? void 0 : insightsInitParams.cookieDuration) || ((_queuedInitParams2 = queuedInitParams) === null || _queuedInitParams2 === void 0 ? void 0 : _queuedInitParams2.cookieDuration));
                    }
                }
                // This updates userToken which is set explicitly by `aa('setUserToken', userToken)`
                insightsClient('onUserTokenChange', function(token) {
                    return setUserTokenToSearch(token, true);
                }, {
                    immediate: true
                });
                var insightsClientWithLocalCredentials = insightsClient;
                if ($0cc7460c69d4f0a7$var$isModernInsightsClient(insightsClient)) insightsClientWithLocalCredentials = function insightsClientWithLocalCredentials(method, payload) {
                    var extraParams = {
                        headers: {
                            'X-Algolia-Application-Id': appId,
                            'X-Algolia-API-Key': apiKey
                        }
                    };
                    // @ts-ignore we are calling this only when we know that the client actually is correct
                    return insightsClient(method, payload, extraParams);
                };
                var viewedObjectIDs = new Set();
                var lastQueryId;
                instantSearchInstance.mainHelper.derivedHelpers[0].on('result', function(_ref11) {
                    var results = _ref11.results;
                    if (results && (!results.queryID || results.queryID !== lastQueryId)) {
                        lastQueryId = results.queryID;
                        viewedObjectIDs.clear();
                    }
                });
                instantSearchInstance.sendEventToInsights = function(event) {
                    if (onEvent) onEvent(event, insightsClientWithLocalCredentials);
                    else if (event.insightsMethod) {
                        if (event.insightsMethod === 'viewedObjectIDs') {
                            var _payload = event.payload;
                            var difference = _payload.objectIDs.filter(function(objectID) {
                                return !viewedObjectIDs.has(objectID);
                            });
                            if (difference.length === 0) return;
                            difference.forEach(function(objectID) {
                                return viewedObjectIDs.add(objectID);
                            });
                            _payload.objectIDs = difference;
                        }
                        // Source is used to differentiate events sent by instantsearch from those sent manually.
                        event.payload.algoliaSource = [
                            'instantsearch'
                        ];
                        if ($$automatic) event.payload.algoliaSource.push('instantsearch-automatic');
                        if (event.eventModifier === 'internal') event.payload.algoliaSource.push('instantsearch-internal');
                        insightsClientWithLocalCredentials(event.insightsMethod, event.payload);
                    }
                };
            },
            unsubscribe: function unsubscribe() {
                insightsClient('onUserTokenChange', undefined);
                instantSearchInstance.sendEventToInsights = (0, $fMELL.noop);
                if (helper && initialParameters) {
                    helper.overrideStateWithoutTriggeringChangeEvent($0cc7460c69d4f0a7$var$_objectSpread($0cc7460c69d4f0a7$var$_objectSpread({}, helper.state), initialParameters));
                    instantSearchInstance.scheduleSearch();
                }
            }
        };
    };
}
function $0cc7460c69d4f0a7$var$getInitialParameters(instantSearchInstance) {
    var _instantSearchInstanc, _instantSearchInstanc2;
    // in SSR, the initial state we use in this domain is set on the main index
    var stateFromInitialResults = ((_instantSearchInstanc = instantSearchInstance._initialResults) === null || _instantSearchInstanc === void 0 ? void 0 : (_instantSearchInstanc2 = _instantSearchInstanc[instantSearchInstance.indexName]) === null || _instantSearchInstanc2 === void 0 ? void 0 : _instantSearchInstanc2.state) || {};
    var stateFromHelper = instantSearchInstance.mainHelper.state;
    return {
        userToken: stateFromInitialResults.userToken || stateFromHelper.userToken,
        clickAnalytics: stateFromInitialResults.clickAnalytics || stateFromHelper.clickAnalytics
    };
}
function $0cc7460c69d4f0a7$var$saveTokenAsCookie(token, cookieDuration) {
    var MONTH = 2592000000;
    var d = new Date();
    d.setTime(d.getTime() + (cookieDuration || MONTH * 6));
    var expires = "expires=".concat(d.toUTCString());
    document.cookie = "_ALGOLIA=".concat(token, ";").concat(expires, ";path=/");
}
/**
 * Determines if a given insights `client` supports the optional call to `init`
 * and the ability to set credentials via extra parameters when sending events.
 */ function $0cc7460c69d4f0a7$var$isModernInsightsClient(client) {
    var _split$map = (client.version || '').split('.').map(Number), _split$map2 = $0cc7460c69d4f0a7$var$_slicedToArray(_split$map, 2), major = _split$map2[0], minor = _split$map2[1];
    /* eslint-disable @typescript-eslint/naming-convention */ var v3 = major >= 3;
    var v2_6 = major === 2 && minor >= 6;
    var v1_10 = major === 1 && minor >= 10;
    /* eslint-enable @typescript-eslint/naming-convention */ return v3 || v2_6 || v1_10;
}
/**
 * While `search-insights` supports both string and number user tokens,
 * the Search API only accepts strings. This function normalizes the user token.
 */ function $0cc7460c69d4f0a7$var$normalizeUserToken(userToken) {
    if (!userToken) return undefined;
    return typeof userToken === 'number' ? userToken.toString() : userToken;
}

});
parcelRegister("eHfFT", function(module, exports) {

$parcel$export(module.exports, "find", function () { return $ab313d831a66ed8b$export$71aa6c912b956294; });
// We aren't using the native `Array.prototype.find` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `find` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.find` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
function $ab313d831a66ed8b$export$71aa6c912b956294(items, predicate) {
    var value;
    for(var i = 0; i < items.length; i++){
        value = items[i];
        // inlined for performance: if (Call(predicate, thisArg, [value, i, list])) {
        if (predicate(value, i, items)) return value;
    }
    return undefined;
}

});

parcelRegister("gkp6v", function(module, exports) {

$parcel$export(module.exports, "getAppIdAndApiKey", function () { return $be31fcbaf562e5af$export$58f35ab8a1251bc0; });
// typed as any, since it accepts the _real_ js clients, not the interface we otherwise expect
function $be31fcbaf562e5af$export$58f35ab8a1251bc0(searchClient) {
    if (searchClient.transporter) {
        // searchClient v4 or v5
        var transporter = searchClient.transporter;
        var headers = transporter.headers || transporter.baseHeaders;
        var queryParameters = transporter.queryParameters || transporter.baseQueryParameters;
        var APP_ID = 'x-algolia-application-id';
        var API_KEY = 'x-algolia-api-key';
        var appId = headers[APP_ID] || queryParameters[APP_ID];
        var apiKey = headers[API_KEY] || queryParameters[API_KEY];
        return [
            appId,
            apiKey
        ];
    } else // searchClient v3
    return [
        searchClient.applicationID,
        searchClient.apiKey
    ];
}

});

parcelRegister("fMELL", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $b7daf6a2ab83b8af$export$8793edee2d425525; });
function $b7daf6a2ab83b8af$export$8793edee2d425525() {}

});

parcelRegister("5taqR", function(module, exports) {

$parcel$export(module.exports, "createUUID", function () { return $3fb7c0cc8893af82$export$5dbf9a24b655dde4; });
/**
 * Create UUID according to
 * https://www.ietf.org/rfc/rfc4122.txt.
 *
 * @returns Generated UUID.
 */ function $3fb7c0cc8893af82$export$5dbf9a24b655dde4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        /* eslint-disable no-bitwise */ var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        /* eslint-enable */ return v.toString(16);
    });
}

});


parcelRegister("bUUx8", function(module, exports) {

$parcel$export(module.exports, "isMetadataEnabled", function () { return $8ad0c705ced57515$export$4b4254890acf93e7; });
$parcel$export(module.exports, "createMetadataMiddleware", function () { return $8ad0c705ced57515$export$8ee9d2447935ed96; });

var $hPOUL = parcelRequire("hPOUL");
var $2AIDb = parcelRequire("2AIDb");
function $8ad0c705ced57515$var$extractWidgetPayload(widgets, instantSearchInstance, payload) {
    var initOptions = (0, $hPOUL.createInitArgs)(instantSearchInstance, instantSearchInstance.mainIndex, instantSearchInstance._initialUiState);
    widgets.forEach(function(widget) {
        var widgetParams = {};
        if (widget.getWidgetRenderState) {
            var renderState = widget.getWidgetRenderState(initOptions);
            if (renderState && renderState.widgetParams) // casting, as we just earlier checked widgetParams exists, and thus an object
            widgetParams = renderState.widgetParams;
        }
        // since we destructure in all widgets, the parameters with defaults are set to "undefined"
        var params = Object.keys(widgetParams).filter(function(key) {
            return widgetParams[key] !== undefined;
        });
        payload.widgets.push({
            type: widget.$$type,
            widgetType: widget.$$widgetType,
            params: params
        });
        if (widget.$$type === 'ais.index') $8ad0c705ced57515$var$extractWidgetPayload(widget.getWidgets(), instantSearchInstance, payload);
    });
}
function $8ad0c705ced57515$export$4b4254890acf93e7() {
    return (0, $2AIDb.safelyRunOnBrowser)(function(_ref) {
        var _window$navigator, _window$navigator$use;
        var window = _ref.window;
        return ((_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : (_window$navigator$use = _window$navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.indexOf('Algolia Crawler')) > -1;
    }, {
        fallback: function fallback() {
            return false;
        }
    });
}
function $8ad0c705ced57515$export$8ee9d2447935ed96() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$$$internal = _ref2.$$internal, $$internal = _ref2$$$internal === void 0 ? false : _ref2$$$internal;
    return function(_ref3) {
        var instantSearchInstance = _ref3.instantSearchInstance;
        var payload = {
            widgets: []
        };
        var payloadContainer = document.createElement('meta');
        var refNode = document.querySelector('head');
        payloadContainer.name = 'instantsearch:widgets';
        return {
            $$type: 'ais.metadata',
            $$internal: $$internal,
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                // using setTimeout here to delay extraction until widgets have been added in a tick (e.g. Vue)
                setTimeout(function() {
                    var client = instantSearchInstance.client;
                    payload.ua = client.transporter && client.transporter.userAgent ? client.transporter.userAgent.value : client._ua;
                    $8ad0c705ced57515$var$extractWidgetPayload(instantSearchInstance.mainIndex.getWidgets(), instantSearchInstance, payload);
                    instantSearchInstance.middleware.forEach(function(middleware) {
                        return payload.widgets.push({
                            middleware: true,
                            type: middleware.instance.$$type,
                            internal: middleware.instance.$$internal
                        });
                    });
                    payloadContainer.content = JSON.stringify(payload);
                    refNode.appendChild(payloadContainer);
                }, 0);
            },
            started: function started() {},
            unsubscribe: function unsubscribe() {
                payloadContainer.remove();
            }
        };
    };
}

});
parcelRegister("hPOUL", function(module, exports) {

$parcel$export(module.exports, "createInitArgs", function () { return $cfbeb1a5d9108e0f$export$dbf1227de6c1fbc6; });
$parcel$export(module.exports, "createRenderArgs", function () { return $cfbeb1a5d9108e0f$export$c3ba97e79c76dd38; });
function $cfbeb1a5d9108e0f$export$dbf1227de6c1fbc6(instantSearchInstance, parent, uiState) {
    var helper = parent.getHelper();
    return {
        uiState: uiState,
        helper: helper,
        parent: parent,
        instantSearchInstance: instantSearchInstance,
        state: helper.state,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        createURL: parent.createURL,
        scopedResults: [],
        searchMetadata: {
            isSearchStalled: instantSearchInstance.status === 'stalled'
        },
        status: instantSearchInstance.status,
        error: instantSearchInstance.error
    };
}
function $cfbeb1a5d9108e0f$export$c3ba97e79c76dd38(instantSearchInstance, parent, widget) {
    var results = parent.getResultsForWidget(widget);
    var helper = parent.getHelper();
    return {
        helper: helper,
        parent: parent,
        instantSearchInstance: instantSearchInstance,
        results: results,
        scopedResults: parent.getScopedResults(),
        state: results && '_state' in results ? results._state : helper.state,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        createURL: parent.createURL,
        searchMetadata: {
            isSearchStalled: instantSearchInstance.status === 'stalled'
        },
        status: instantSearchInstance.status,
        error: instantSearchInstance.error
    };
}

});


parcelRegister("gFCi8", function(module, exports) {

$parcel$export(module.exports, "createRouterMiddleware", function () { return $c22e2d939af33ef4$export$1fe5128387816284; });

var $8kn2n = parcelRequire("8kn2n");

var $fpY1C = parcelRequire("fpY1C");

var $cg906 = parcelRequire("cg906");
function $c22e2d939af33ef4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c22e2d939af33ef4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c22e2d939af33ef4$var$_typeof(obj);
}
function $c22e2d939af33ef4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c22e2d939af33ef4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c22e2d939af33ef4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c22e2d939af33ef4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c22e2d939af33ef4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c22e2d939af33ef4$var$_defineProperty(obj, key, value) {
    key = $c22e2d939af33ef4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c22e2d939af33ef4$var$_toPropertyKey(arg) {
    var key = $c22e2d939af33ef4$var$_toPrimitive(arg, "string");
    return $c22e2d939af33ef4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c22e2d939af33ef4$var$_toPrimitive(input, hint) {
    if ($c22e2d939af33ef4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c22e2d939af33ef4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $c22e2d939af33ef4$export$1fe5128387816284 = function createRouterMiddleware() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$router = props.router, router = _props$router === void 0 ? (0, $8kn2n.default)() : _props$router, _props$stateMapping = props.stateMapping, stateMapping = _props$stateMapping === void 0 ? (0, $fpY1C.default)() : _props$stateMapping, _props$$$internal = props.$$internal, $$internal = _props$$$internal === void 0 ? false : _props$$$internal;
    return function(_ref) {
        var instantSearchInstance = _ref.instantSearchInstance;
        function topLevelCreateURL(nextState) {
            var previousUiState = // If only the mainIndex is initialized, we don't yet know what other
            // index widgets are used. Therefore we fall back to the initialUiState.
            // We can't indiscriminately use the initialUiState because then we
            // reintroduce state that was changed by the user.
            // When there are no widgets, we are sure the user can't yet have made
            // any changes.
            instantSearchInstance.mainIndex.getWidgets().length === 0 ? instantSearchInstance._initialUiState : instantSearchInstance.mainIndex.getWidgetUiState({});
            var uiState = Object.keys(nextState).reduce(function(acc, indexId) {
                return $c22e2d939af33ef4$var$_objectSpread($c22e2d939af33ef4$var$_objectSpread({}, acc), {}, $c22e2d939af33ef4$var$_defineProperty({}, indexId, nextState[indexId]));
            }, previousUiState);
            var route = stateMapping.stateToRoute(uiState);
            return router.createURL(route);
        }
        // casting to UiState here to keep createURL unaware of custom UiState
        // (as long as it's an object, it's ok)
        instantSearchInstance._createURL = topLevelCreateURL;
        var lastRouteState = undefined;
        var initialUiState = instantSearchInstance._initialUiState;
        return {
            $$type: "ais.router({router:".concat(router.$$type || '__unknown__', ", stateMapping:").concat(stateMapping.$$type || '__unknown__', "})"),
            $$internal: $$internal,
            onStateChange: function onStateChange(_ref2) {
                var uiState = _ref2.uiState;
                var routeState = stateMapping.stateToRoute(uiState);
                if (lastRouteState === undefined || !(0, $cg906.isEqual)(lastRouteState, routeState)) {
                    router.write(routeState);
                    lastRouteState = routeState;
                }
            },
            subscribe: function subscribe() {
                instantSearchInstance._initialUiState = $c22e2d939af33ef4$var$_objectSpread($c22e2d939af33ef4$var$_objectSpread({}, initialUiState), stateMapping.routeToState(router.read()));
                router.onUpdate(function(route) {
                    if (instantSearchInstance.mainIndex.getWidgets().length > 0) instantSearchInstance.setUiState(stateMapping.routeToState(route));
                });
            },
            started: function started() {
                var _router$start;
                (_router$start = router.start) === null || _router$start === void 0 || _router$start.call(router);
            },
            unsubscribe: function unsubscribe() {
                router.dispose();
            }
        };
    };
};

});
parcelRegister("8kn2n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61020fb25245d451$export$2e2bcd8739ae039; });

var $2kfB7 = parcelRequire("2kfB7");

var $2AIDb = parcelRequire("2AIDb");
function $61020fb25245d451$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $61020fb25245d451$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $61020fb25245d451$var$_typeof(obj);
}
function $61020fb25245d451$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $61020fb25245d451$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $61020fb25245d451$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $61020fb25245d451$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $61020fb25245d451$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $61020fb25245d451$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $61020fb25245d451$var$_defineProperty(obj, key, value) {
    key = $61020fb25245d451$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $61020fb25245d451$var$_toPropertyKey(arg) {
    var key = $61020fb25245d451$var$_toPrimitive(arg, "string");
    return $61020fb25245d451$var$_typeof(key) === "symbol" ? key : String(key);
}
function $61020fb25245d451$var$_toPrimitive(input, hint) {
    if ($61020fb25245d451$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($61020fb25245d451$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $61020fb25245d451$var$setWindowTitle = function setWindowTitle(title) {
    if (title) // This function is only executed on browsers so we can disable this check.
    // eslint-disable-next-line no-restricted-globals
    window.document.title = title;
};
var $61020fb25245d451$var$BrowserHistory = /*#__PURE__*/ function() {
    /**
   * Initializes a new storage provider that syncs the search state to the URL
   * using web APIs (`window.location.pushState` and `onpopstate` event).
   */ function BrowserHistory(_ref) {
        var _this = this;
        var windowTitle = _ref.windowTitle, _ref$writeDelay = _ref.writeDelay, writeDelay = _ref$writeDelay === void 0 ? 400 : _ref$writeDelay, createURL = _ref.createURL, parseURL = _ref.parseURL, getLocation = _ref.getLocation, start = _ref.start, dispose = _ref.dispose, push = _ref.push, cleanUrlOnDispose = _ref.cleanUrlOnDispose;
        $61020fb25245d451$var$_classCallCheck(this, BrowserHistory);
        $61020fb25245d451$var$_defineProperty(this, "$$type", 'ais.browser');
        /**
     * Transforms a UI state into a title for the page.
     */ $61020fb25245d451$var$_defineProperty(this, "windowTitle", void 0);
        /**
     * Time in milliseconds before performing a write in the history.
     * It prevents from adding too many entries in the history and
     * makes the back button more usable.
     *
     * @default 400
     */ $61020fb25245d451$var$_defineProperty(this, "writeDelay", void 0);
        /**
     * Creates a full URL based on the route state.
     * The storage adaptor maps all syncable keys to the query string of the URL.
     */ $61020fb25245d451$var$_defineProperty(this, "_createURL", void 0);
        /**
     * Parses the URL into a route state.
     * It should be symmetrical to `createURL`.
     */ $61020fb25245d451$var$_defineProperty(this, "parseURL", void 0);
        /**
     * Returns the location to store in the history.
     * @default () => window.location
     */ $61020fb25245d451$var$_defineProperty(this, "getLocation", void 0);
        $61020fb25245d451$var$_defineProperty(this, "writeTimer", void 0);
        $61020fb25245d451$var$_defineProperty(this, "_onPopState", void 0);
        /**
     * Indicates if last action was back/forward in the browser.
     */ $61020fb25245d451$var$_defineProperty(this, "inPopState", false);
        /**
     * Indicates whether the history router is disposed or not.
     */ $61020fb25245d451$var$_defineProperty(this, "isDisposed", false);
        /**
     * Indicates the window.history.length before the last call to
     * window.history.pushState (called in `write`).
     * It allows to determine if a `pushState` has been triggered elsewhere,
     * and thus to prevent the `write` method from calling `pushState`.
     */ $61020fb25245d451$var$_defineProperty(this, "latestAcknowledgedHistory", 0);
        $61020fb25245d451$var$_defineProperty(this, "_start", void 0);
        $61020fb25245d451$var$_defineProperty(this, "_dispose", void 0);
        $61020fb25245d451$var$_defineProperty(this, "_push", void 0);
        $61020fb25245d451$var$_defineProperty(this, "_cleanUrlOnDispose", void 0);
        this.windowTitle = windowTitle;
        this.writeTimer = undefined;
        this.writeDelay = writeDelay;
        this._createURL = createURL;
        this.parseURL = parseURL;
        this.getLocation = getLocation;
        this._start = start;
        this._dispose = dispose;
        this._push = push;
        this._cleanUrlOnDispose = typeof cleanUrlOnDispose === 'undefined' ? true : cleanUrlOnDispose;
        (0, $2AIDb.safelyRunOnBrowser)(function(_ref2) {
            var window1 = _ref2.window;
            var title = _this.windowTitle && _this.windowTitle(_this.read());
            $61020fb25245d451$var$setWindowTitle(title);
            _this.latestAcknowledgedHistory = window1.history.length;
        });
    }
    /**
   * Reads the URL and returns a syncable UI search state.
   */ $61020fb25245d451$var$_createClass(BrowserHistory, [
        {
            key: "read",
            value: function read() {
                return this.parseURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($2kfB7))),
                    location: this.getLocation()
                });
            }
        },
        {
            key: "write",
            value: function write(routeState) {
                var _this2 = this;
                (0, $2AIDb.safelyRunOnBrowser)(function(_ref3) {
                    var window1 = _ref3.window;
                    var url = _this2.createURL(routeState);
                    var title = _this2.windowTitle && _this2.windowTitle(routeState);
                    if (_this2.writeTimer) clearTimeout(_this2.writeTimer);
                    _this2.writeTimer = setTimeout(function() {
                        $61020fb25245d451$var$setWindowTitle(title);
                        if (_this2.shouldWrite(url)) {
                            if (_this2._push) _this2._push(url);
                            else window1.history.pushState(routeState, title || '', url);
                            _this2.latestAcknowledgedHistory = window1.history.length;
                        }
                        _this2.inPopState = false;
                        _this2.writeTimer = undefined;
                    }, _this2.writeDelay);
                });
            }
        },
        {
            key: "onUpdate",
            value: function onUpdate(callback) {
                var _this3 = this;
                if (this._start) this._start(function() {
                    callback(_this3.read());
                });
                this._onPopState = function() {
                    if (_this3.writeTimer) {
                        clearTimeout(_this3.writeTimer);
                        _this3.writeTimer = undefined;
                    }
                    _this3.inPopState = true;
                    // We always read the state from the URL because the state of the history
                    // can be incorect in some cases (e.g. using React Router).
                    callback(_this3.read());
                };
                (0, $2AIDb.safelyRunOnBrowser)(function(_ref4) {
                    var window1 = _ref4.window;
                    window1.addEventListener('popstate', _this3._onPopState);
                });
            }
        },
        {
            key: "createURL",
            value: function createURL(routeState) {
                var url = this._createURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($2kfB7))),
                    routeState: routeState,
                    location: this.getLocation()
                });
                var e;
                return url;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this4 = this;
                if (this._dispose) this._dispose();
                this.isDisposed = true;
                (0, $2AIDb.safelyRunOnBrowser)(function(_ref5) {
                    var window1 = _ref5.window;
                    if (_this4._onPopState) window1.removeEventListener('popstate', _this4._onPopState);
                });
                if (this.writeTimer) clearTimeout(this.writeTimer);
                if (this._cleanUrlOnDispose) this.write({});
            }
        },
        {
            key: "start",
            value: function start() {
                this.isDisposed = false;
            }
        },
        {
            key: "shouldWrite",
            value: function shouldWrite(url) {
                var _this5 = this;
                return (0, $2AIDb.safelyRunOnBrowser)(function(_ref6) {
                    var window1 = _ref6.window;
                    // When disposed and the cleanUrlOnDispose is set to false, we do not want to write the URL.
                    if (_this5.isDisposed && !_this5._cleanUrlOnDispose) return false;
                    // We do want to `pushState` if:
                    // - the router is not disposed, IS.js needs to update the URL
                    // OR
                    // - the last write was from InstantSearch.js
                    // (unlike a SPA, where it would have last written)
                    var lastPushWasByISAfterDispose = !(_this5.isDisposed && _this5.latestAcknowledgedHistory !== window1.history.length);
                    return(// When the last state change was through popstate, the IS.js state changes,
                    // but that should not write the URL.
                    !_this5.inPopState && // When the previous pushState after dispose was by IS.js, we want to write the URL.
                    lastPushWasByISAfterDispose && // When the URL is the same as the current one, we do not want to write it.
                    url !== window1.location.href);
                });
            }
        }
    ]);
    return BrowserHistory;
}();
function $61020fb25245d451$export$2e2bcd8739ae039() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref7$createURL = _ref7.createURL, createURL = _ref7$createURL === void 0 ? function(_ref8) {
        var qsModule = _ref8.qsModule, routeState = _ref8.routeState, location = _ref8.location;
        var protocol = location.protocol, hostname = location.hostname, _location$port = location.port, port = _location$port === void 0 ? '' : _location$port, pathname = location.pathname, hash = location.hash;
        var queryString = qsModule.stringify(routeState);
        var portWithPrefix = port === '' ? '' : ":".concat(port);
        // IE <= 11 has no proper `location.origin` so we cannot rely on it.
        if (!queryString) return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname).concat(hash);
        return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname, "?").concat(queryString).concat(hash);
    } : _ref7$createURL, _ref7$parseURL = _ref7.parseURL, parseURL = _ref7$parseURL === void 0 ? function(_ref9) {
        var qsModule = _ref9.qsModule, location = _ref9.location;
        // `qs` by default converts arrays with more than 20 items to an object.
        // We want to avoid this because the data structure manipulated can therefore vary.
        // Setting the limit to `100` seems a good number because the engine's default is 100
        // (it can go up to 1000 but it is very unlikely to select more than 100 items in the UI).
        //
        // Using an `arrayLimit` of `n` allows `n + 1` items.
        //
        // See:
        //   - https://github.com/ljharb/qs#parsing-arrays
        //   - https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/
        return qsModule.parse(location.search.slice(1), {
            arrayLimit: 99
        });
    } : _ref7$parseURL, _ref7$writeDelay = _ref7.writeDelay, writeDelay = _ref7$writeDelay === void 0 ? 400 : _ref7$writeDelay, windowTitle = _ref7.windowTitle, _ref7$getLocation = _ref7.getLocation, getLocation = _ref7$getLocation === void 0 ? function() {
        return (0, $2AIDb.safelyRunOnBrowser)(function(_ref10) {
            var window1 = _ref10.window;
            return window1.location;
        }, {
            fallback: function fallback() {
                throw new Error('You need to provide `getLocation` to the `history` router in environments where `window` does not exist.');
            }
        });
    } : _ref7$getLocation, start = _ref7.start, dispose = _ref7.dispose, push = _ref7.push, cleanUrlOnDispose = _ref7.cleanUrlOnDispose;
    return new $61020fb25245d451$var$BrowserHistory({
        createURL: createURL,
        parseURL: parseURL,
        writeDelay: writeDelay,
        windowTitle: windowTitle,
        getLocation: getLocation,
        start: start,
        dispose: dispose,
        push: push,
        cleanUrlOnDispose: cleanUrlOnDispose
    });
}

});
parcelRegister("2kfB7", function(module, exports) {
'use strict';

var $cazay = parcelRequire("cazay");

var $7D9rB = parcelRequire("7D9rB");

var $haZmR = parcelRequire("haZmR");
module.exports = {
    formats: $haZmR,
    parse: $7D9rB,
    stringify: $cazay
};

});
parcelRegister("cazay", function(module, exports) {
'use strict';

var $fftQu = parcelRequire("fftQu");

var $haZmR = parcelRequire("haZmR");
var $8dc1b317dd5e8fc8$var$has = Object.prototype.hasOwnProperty;
var $8dc1b317dd5e8fc8$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $8dc1b317dd5e8fc8$var$isArray = Array.isArray;
var $8dc1b317dd5e8fc8$var$split = String.prototype.split;
var $8dc1b317dd5e8fc8$var$push = Array.prototype.push;
var $8dc1b317dd5e8fc8$var$pushToArray = function(arr, valueOrArray) {
    $8dc1b317dd5e8fc8$var$push.apply(arr, $8dc1b317dd5e8fc8$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $8dc1b317dd5e8fc8$var$toISO = Date.prototype.toISOString;
var $8dc1b317dd5e8fc8$var$defaultFormat = $haZmR.default;
var $8dc1b317dd5e8fc8$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: $fftQu.encode,
    encodeValuesOnly: false,
    format: $8dc1b317dd5e8fc8$var$defaultFormat,
    formatter: $haZmR.formatters[$8dc1b317dd5e8fc8$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $8dc1b317dd5e8fc8$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $8dc1b317dd5e8fc8$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $8dc1b317dd5e8fc8$var$stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset) {
    var obj = object;
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $8dc1b317dd5e8fc8$var$isArray(obj)) obj = $fftQu.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $8dc1b317dd5e8fc8$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($8dc1b317dd5e8fc8$var$isNonNullishPrimitive(obj) || $fftQu.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $8dc1b317dd5e8fc8$var$defaults.encoder, charset, 'key', format);
            if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
                var valuesArray = $8dc1b317dd5e8fc8$var$split.call(String(obj), ',');
                var valuesJoined = '';
                for(var i = 0; i < valuesArray.length; ++i)valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], $8dc1b317dd5e8fc8$var$defaults.encoder, charset, 'value', format));
                return [
                    formatter(keyValue) + '=' + valuesJoined
                ];
            }
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $8dc1b317dd5e8fc8$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $8dc1b317dd5e8fc8$var$isArray(obj)) // we need to join elements in
    objKeys = [
        {
            value: obj.length > 0 ? obj.join(',') || null : void 0
        }
    ];
    else if ($8dc1b317dd5e8fc8$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $8dc1b317dd5e8fc8$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? '.' + key : '[' + key + ']');
        $8dc1b317dd5e8fc8$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset));
    }
    return values;
};
var $8dc1b317dd5e8fc8$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $8dc1b317dd5e8fc8$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $8dc1b317dd5e8fc8$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $haZmR.default;
    if (typeof opts.format !== 'undefined') {
        if (!$8dc1b317dd5e8fc8$var$has.call($haZmR.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $haZmR.formatters[format];
    var filter = $8dc1b317dd5e8fc8$var$defaults.filter;
    if (typeof opts.filter === 'function' || $8dc1b317dd5e8fc8$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $8dc1b317dd5e8fc8$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? $8dc1b317dd5e8fc8$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $8dc1b317dd5e8fc8$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? $8dc1b317dd5e8fc8$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $8dc1b317dd5e8fc8$var$defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $8dc1b317dd5e8fc8$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $8dc1b317dd5e8fc8$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $8dc1b317dd5e8fc8$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $8dc1b317dd5e8fc8$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $8dc1b317dd5e8fc8$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $8dc1b317dd5e8fc8$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($8dc1b317dd5e8fc8$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var arrayFormat;
    if (opts && opts.arrayFormat in $8dc1b317dd5e8fc8$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && 'indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = 'indices';
    var generateArrayPrefix = $8dc1b317dd5e8fc8$var$arrayPrefixGenerators[arrayFormat];
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $8dc1b317dd5e8fc8$var$pushToArray(keys, $8dc1b317dd5e8fc8$var$stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("fftQu", function(module, exports) {
'use strict';

var $haZmR = parcelRequire("haZmR");
var $b19f6878873a864b$var$has = Object.prototype.hasOwnProperty;
var $b19f6878873a864b$var$isArray = Array.isArray;
var $b19f6878873a864b$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $b19f6878873a864b$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($b19f6878873a864b$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $b19f6878873a864b$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $b19f6878873a864b$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object') {
        if ($b19f6878873a864b$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$b19f6878873a864b$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($b19f6878873a864b$var$isArray(target) && !$b19f6878873a864b$var$isArray(source)) mergeTarget = $b19f6878873a864b$var$arrayToObject(target, options);
    if ($b19f6878873a864b$var$isArray(target) && $b19f6878873a864b$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($b19f6878873a864b$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($b19f6878873a864b$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $b19f6878873a864b$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $b19f6878873a864b$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $b19f6878873a864b$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $haZmR.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $b19f6878873a864b$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($b19f6878873a864b$var$hexTable[0xC0 | c >> 6] + $b19f6878873a864b$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($b19f6878873a864b$var$hexTable[0xE0 | c >> 12] + $b19f6878873a864b$var$hexTable[0x80 | c >> 6 & 0x3F] + $b19f6878873a864b$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $b19f6878873a864b$var$hexTable[0xF0 | c >> 18] + $b19f6878873a864b$var$hexTable[0x80 | c >> 12 & 0x3F] + $b19f6878873a864b$var$hexTable[0x80 | c >> 6 & 0x3F] + $b19f6878873a864b$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $b19f6878873a864b$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $b19f6878873a864b$var$compactQueue(queue);
    return value;
};
var $b19f6878873a864b$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $b19f6878873a864b$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $b19f6878873a864b$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $b19f6878873a864b$var$maybeMap = function maybeMap(val, fn) {
    if ($b19f6878873a864b$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $b19f6878873a864b$var$arrayToObject,
    assign: $b19f6878873a864b$var$assign,
    combine: $b19f6878873a864b$var$combine,
    compact: $b19f6878873a864b$var$compact,
    decode: $b19f6878873a864b$var$decode,
    encode: $b19f6878873a864b$var$encode,
    isBuffer: $b19f6878873a864b$var$isBuffer,
    isRegExp: $b19f6878873a864b$var$isRegExp,
    maybeMap: $b19f6878873a864b$var$maybeMap,
    merge: $b19f6878873a864b$var$merge
};

});
parcelRegister("haZmR", function(module, exports) {
'use strict';
var $c812f936f670bc39$var$replace = String.prototype.replace;
var $c812f936f670bc39$var$percentTwenties = /%20/g;
var $c812f936f670bc39$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $c812f936f670bc39$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $c812f936f670bc39$var$replace.call(value, $c812f936f670bc39$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $c812f936f670bc39$var$Format.RFC1738,
    RFC3986: $c812f936f670bc39$var$Format.RFC3986
};

});



parcelRegister("7D9rB", function(module, exports) {
'use strict';

var $fftQu = parcelRequire("fftQu");
var $58e38056c11b3d5f$var$has = Object.prototype.hasOwnProperty;
var $58e38056c11b3d5f$var$isArray = Array.isArray;
var $58e38056c11b3d5f$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: $fftQu.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $58e38056c11b3d5f$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $58e38056c11b3d5f$var$parseArrayValue = function(val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $58e38056c11b3d5f$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $58e38056c11b3d5f$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $58e38056c11b3d5f$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $58e38056c11b3d5f$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $58e38056c11b3d5f$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $58e38056c11b3d5f$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $58e38056c11b3d5f$var$defaults.decoder, charset, 'key');
            val = $fftQu.maybeMap($58e38056c11b3d5f$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $58e38056c11b3d5f$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $58e38056c11b3d5f$var$interpretNumericEntities(val);
        if (part.indexOf('[]=') > -1) val = $58e38056c11b3d5f$var$isArray(val) ? [
            val
        ] : val;
        if ($58e38056c11b3d5f$var$has.call(obj, key)) obj[key] = $fftQu.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $58e38056c11b3d5f$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $58e38056c11b3d5f$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $58e38056c11b3d5f$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $58e38056c11b3d5f$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $58e38056c11b3d5f$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push('[' + key.slice(segment.index) + ']');
    return $58e38056c11b3d5f$var$parseObject(keys, val, options, valuesParsed);
};
var $58e38056c11b3d5f$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $58e38056c11b3d5f$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var charset = typeof opts.charset === 'undefined' ? $58e38056c11b3d5f$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === 'undefined' ? $58e38056c11b3d5f$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $58e38056c11b3d5f$var$defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $58e38056c11b3d5f$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $58e38056c11b3d5f$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $58e38056c11b3d5f$var$defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $58e38056c11b3d5f$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $fftQu.isRegExp(opts.delimiter) ? opts.delimiter : $58e38056c11b3d5f$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $58e38056c11b3d5f$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $58e38056c11b3d5f$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $58e38056c11b3d5f$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $58e38056c11b3d5f$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $58e38056c11b3d5f$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $58e38056c11b3d5f$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === 'string' ? $58e38056c11b3d5f$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $58e38056c11b3d5f$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $fftQu.merge(obj, newObj, options);
    }
    return $fftQu.compact(obj);
};

});



parcelRegister("fpY1C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b397c0910df3da3b$export$2e2bcd8739ae039; });
function $b397c0910df3da3b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b397c0910df3da3b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b397c0910df3da3b$var$_typeof(obj);
}
var $b397c0910df3da3b$var$_excluded = [
    "configure"
];
function $b397c0910df3da3b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b397c0910df3da3b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b397c0910df3da3b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b397c0910df3da3b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b397c0910df3da3b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b397c0910df3da3b$var$_defineProperty(obj, key, value) {
    key = $b397c0910df3da3b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b397c0910df3da3b$var$_toPropertyKey(arg) {
    var key = $b397c0910df3da3b$var$_toPrimitive(arg, "string");
    return $b397c0910df3da3b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b397c0910df3da3b$var$_toPrimitive(input, hint) {
    if ($b397c0910df3da3b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b397c0910df3da3b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b397c0910df3da3b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b397c0910df3da3b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b397c0910df3da3b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b397c0910df3da3b$var$getIndexStateWithoutConfigure(uiState) {
    var configure = uiState.configure, trackedUiState = $b397c0910df3da3b$var$_objectWithoutProperties(uiState, $b397c0910df3da3b$var$_excluded);
    return trackedUiState;
}
function $b397c0910df3da3b$export$2e2bcd8739ae039() {
    return {
        $$type: 'ais.simple',
        stateToRoute: function stateToRoute(uiState) {
            return Object.keys(uiState).reduce(function(state, indexId) {
                return $b397c0910df3da3b$var$_objectSpread($b397c0910df3da3b$var$_objectSpread({}, state), {}, $b397c0910df3da3b$var$_defineProperty({}, indexId, $b397c0910df3da3b$var$getIndexStateWithoutConfigure(uiState[indexId])));
            }, {});
        },
        routeToState: function routeToState() {
            var routeState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return Object.keys(routeState).reduce(function(state, indexId) {
                return $b397c0910df3da3b$var$_objectSpread($b397c0910df3da3b$var$_objectSpread({}, state), {}, $b397c0910df3da3b$var$_defineProperty({}, indexId, $b397c0910df3da3b$var$getIndexStateWithoutConfigure(routeState[indexId])));
            }, {});
        }
    };
}

});


parcelRegister("dKEBn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a02f10ebbb61b496$export$2e2bcd8739ae039; });

var $bU4Gg = parcelRequire("bU4Gg");

var $kooa4 = parcelRequire("kooa4");
var $hPOUL = parcelRequire("hPOUL");
var $eRloN = parcelRequire("eRloN");
var $bIKD8 = parcelRequire("bIKD8");
var $jHy5A = parcelRequire("jHy5A");

var $4PXEL = parcelRequire("4PXEL");
function $a02f10ebbb61b496$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a02f10ebbb61b496$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a02f10ebbb61b496$var$_typeof(obj);
}
var $a02f10ebbb61b496$var$_excluded = [
    "initialSearchParameters"
], $a02f10ebbb61b496$var$_excluded2 = [
    "initialRecommendParameters"
];
function $a02f10ebbb61b496$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a02f10ebbb61b496$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a02f10ebbb61b496$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a02f10ebbb61b496$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a02f10ebbb61b496$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a02f10ebbb61b496$var$_defineProperty(obj, key, value) {
    key = $a02f10ebbb61b496$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a02f10ebbb61b496$var$_toPropertyKey(arg) {
    var key = $a02f10ebbb61b496$var$_toPrimitive(arg, "string");
    return $a02f10ebbb61b496$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a02f10ebbb61b496$var$_toPrimitive(input, hint) {
    if ($a02f10ebbb61b496$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a02f10ebbb61b496$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $a02f10ebbb61b496$var$_toConsumableArray(arr) {
    return $a02f10ebbb61b496$var$_arrayWithoutHoles(arr) || $a02f10ebbb61b496$var$_iterableToArray(arr) || $a02f10ebbb61b496$var$_unsupportedIterableToArray(arr) || $a02f10ebbb61b496$var$_nonIterableSpread();
}
function $a02f10ebbb61b496$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a02f10ebbb61b496$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a02f10ebbb61b496$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a02f10ebbb61b496$var$_arrayLikeToArray(o, minLen);
}
function $a02f10ebbb61b496$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a02f10ebbb61b496$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a02f10ebbb61b496$var$_arrayLikeToArray(arr);
}
function $a02f10ebbb61b496$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a02f10ebbb61b496$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a02f10ebbb61b496$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a02f10ebbb61b496$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a02f10ebbb61b496$var$withUsage = (0, $kooa4.createDocumentationMessageGenerator)({
    name: 'index-widget'
});
/**
 * This is the same content as helper._change / setState, but allowing for extra
 * UiState to be synchronized.
 * see: https://github.com/algolia/algoliasearch-helper-js/blob/6b835ffd07742f2d6b314022cce6848f5cfecd4a/src/algoliasearch.helper.js#L1311-L1324
 */ function $a02f10ebbb61b496$var$privateHelperSetState(helper, _ref) {
    var state = _ref.state, recommendState = _ref.recommendState, isPageReset = _ref.isPageReset, _uiState = _ref._uiState;
    if (state !== helper.state) {
        helper.state = state;
        helper.emit('change', {
            state: helper.state,
            results: helper.lastResults,
            isPageReset: isPageReset,
            _uiState: _uiState
        });
    }
    if (recommendState !== helper.recommendState) helper.recommendState = recommendState;
}
function $a02f10ebbb61b496$var$getLocalWidgetsUiState(widgets, widgetStateOptions) {
    var initialUiState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return widgets.reduce(function(uiState, widget) {
        if ((0, $eRloN.isIndexWidget)(widget)) return uiState;
        if (!widget.getWidgetUiState && !widget.getWidgetState) return uiState;
        if (widget.getWidgetUiState) return widget.getWidgetUiState(uiState, widgetStateOptions);
        return widget.getWidgetState(uiState, widgetStateOptions);
    }, initialUiState);
}
function $a02f10ebbb61b496$var$getLocalWidgetsSearchParameters(widgets, widgetSearchParametersOptions) {
    var initialSearchParameters = widgetSearchParametersOptions.initialSearchParameters, rest = $a02f10ebbb61b496$var$_objectWithoutProperties(widgetSearchParametersOptions, $a02f10ebbb61b496$var$_excluded);
    return widgets.reduce(function(state, widget) {
        if (!widget.getWidgetSearchParameters || (0, $eRloN.isIndexWidget)(widget)) return state;
        if (widget.dependsOn === 'search' && widget.getWidgetParameters) return widget.getWidgetParameters(state, rest);
        return widget.getWidgetSearchParameters(state, rest);
    }, initialSearchParameters);
}
function $a02f10ebbb61b496$var$getLocalWidgetsRecommendParameters(widgets, widgetRecommendParametersOptions) {
    var initialRecommendParameters = widgetRecommendParametersOptions.initialRecommendParameters, rest = $a02f10ebbb61b496$var$_objectWithoutProperties(widgetRecommendParametersOptions, $a02f10ebbb61b496$var$_excluded2);
    return widgets.reduce(function(state, widget) {
        if (!(0, $eRloN.isIndexWidget)(widget) && widget.dependsOn === 'recommend' && widget.getWidgetParameters) return widget.getWidgetParameters(state, rest);
        return state;
    }, initialRecommendParameters);
}
function $a02f10ebbb61b496$var$resetPageFromWidgets(widgets) {
    var indexWidgets = widgets.filter((0, $eRloN.isIndexWidget));
    if (indexWidgets.length === 0) return;
    indexWidgets.forEach(function(widget) {
        var widgetHelper = widget.getHelper();
        $a02f10ebbb61b496$var$privateHelperSetState(widgetHelper, {
            state: widgetHelper.state.resetPage(),
            recommendState: widgetHelper.recommendState,
            isPageReset: true
        });
        $a02f10ebbb61b496$var$resetPageFromWidgets(widget.getWidgets());
    });
}
function $a02f10ebbb61b496$var$resolveScopedResultsFromWidgets(widgets) {
    var indexWidgets = widgets.filter((0, $eRloN.isIndexWidget));
    return indexWidgets.reduce(function(scopedResults, current) {
        return scopedResults.concat.apply(scopedResults, [
            {
                indexId: current.getIndexId(),
                results: current.getResults(),
                helper: current.getHelper()
            }
        ].concat($a02f10ebbb61b496$var$_toConsumableArray($a02f10ebbb61b496$var$resolveScopedResultsFromWidgets(current.getWidgets()))));
    }, []);
}
var $a02f10ebbb61b496$var$index = function index(widgetParams) {
    if (widgetParams === undefined || widgetParams.indexName === undefined) throw new Error($a02f10ebbb61b496$var$withUsage('The `indexName` option is required.'));
    var indexName = widgetParams.indexName, _widgetParams$indexId = widgetParams.indexId, indexId = _widgetParams$indexId === void 0 ? indexName : _widgetParams$indexId;
    var localWidgets = [];
    var localUiState = {};
    var localInstantSearchInstance = null;
    var localParent = null;
    var helper = null;
    var derivedHelper = null;
    var lastValidSearchParameters = null;
    var hasRecommendWidget = false;
    var hasSearchWidget = false;
    return {
        $$type: 'ais.index',
        $$widgetType: 'ais.index',
        getIndexName: function getIndexName() {
            return indexName;
        },
        getIndexId: function getIndexId() {
            return indexId;
        },
        getHelper: function getHelper() {
            return helper;
        },
        getResults: function getResults() {
            var _derivedHelper;
            if (!((_derivedHelper = derivedHelper) !== null && _derivedHelper !== void 0 && _derivedHelper.lastResults)) return null;
            // To make the UI optimistic, we patch the state to display to the current
            // one instead of the one associated with the latest results.
            // This means user-driven UI changes (e.g., checked checkbox) are reflected
            // immediately instead of waiting for Algolia to respond, regardless of
            // the status of the network request.
            derivedHelper.lastResults._state = helper.state;
            return derivedHelper.lastResults;
        },
        getResultsForWidget: function getResultsForWidget(widget) {
            var _helper;
            if (widget.dependsOn !== 'recommend' || (0, $eRloN.isIndexWidget)(widget) || widget.$$id === undefined) return this.getResults();
            if (!((_helper = helper) !== null && _helper !== void 0 && _helper.lastRecommendResults)) return null;
            return helper.lastRecommendResults[widget.$$id];
        },
        getPreviousState: function getPreviousState() {
            return lastValidSearchParameters;
        },
        getScopedResults: function getScopedResults() {
            var widgetParent = this.getParent();
            var widgetSiblings;
            if (widgetParent) widgetSiblings = widgetParent.getWidgets();
            else if (indexName.length === 0) // The widget is the root but has no index name:
            // we resolve results from its children index widgets
            widgetSiblings = this.getWidgets();
            else // The widget is the root and has an index name:
            // we consider itself as the only sibling
            widgetSiblings = [
                this
            ];
            return $a02f10ebbb61b496$var$resolveScopedResultsFromWidgets(widgetSiblings);
        },
        getParent: function getParent() {
            return localParent;
        },
        createURL: function createURL(nextState) {
            if (typeof nextState === 'function') return localInstantSearchInstance._createURL($a02f10ebbb61b496$var$_defineProperty({}, indexId, nextState(localUiState)));
            return localInstantSearchInstance._createURL($a02f10ebbb61b496$var$_defineProperty({}, indexId, $a02f10ebbb61b496$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: nextState,
                helper: helper
            })));
        },
        getWidgets: function getWidgets() {
            return localWidgets;
        },
        addWidgets: function addWidgets(widgets) {
            var _this = this;
            if (!Array.isArray(widgets)) throw new Error($a02f10ebbb61b496$var$withUsage('The `addWidgets` method expects an array of widgets.'));
            if (widgets.some(function(widget) {
                return typeof widget.init !== 'function' && typeof widget.render !== 'function';
            })) throw new Error($a02f10ebbb61b496$var$withUsage('The widget definition expects a `render` and/or an `init` method.'));
            widgets.forEach(function(widget) {
                if ((0, $eRloN.isIndexWidget)(widget)) return;
                if (localInstantSearchInstance && widget.dependsOn === 'recommend') localInstantSearchInstance._hasRecommendWidget = true;
                else if (localInstantSearchInstance) localInstantSearchInstance._hasSearchWidget = true;
                else if (widget.dependsOn === 'recommend') hasRecommendWidget = true;
                else hasSearchWidget = true;
                (0, $4PXEL.addWidgetId)(widget);
            });
            localWidgets = localWidgets.concat(widgets);
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                $a02f10ebbb61b496$var$privateHelperSetState(helper, {
                    state: $a02f10ebbb61b496$var$getLocalWidgetsSearchParameters(localWidgets, {
                        uiState: localUiState,
                        initialSearchParameters: helper.state
                    }),
                    recommendState: $a02f10ebbb61b496$var$getLocalWidgetsRecommendParameters(localWidgets, {
                        uiState: localUiState,
                        initialRecommendParameters: helper.recommendState
                    }),
                    _uiState: localUiState
                });
                // We compute the render state before calling `init` in a separate loop
                // to construct the whole render state object that is then passed to
                // `init`.
                widgets.forEach(function(widget) {
                    if (widget.getRenderState) {
                        var renderState = widget.getRenderState(localInstantSearchInstance.renderState[_this.getIndexId()] || {}, (0, $hPOUL.createInitArgs)(localInstantSearchInstance, _this, localInstantSearchInstance._initialUiState));
                        $a02f10ebbb61b496$var$storeRenderState({
                            renderState: renderState,
                            instantSearchInstance: localInstantSearchInstance,
                            parent: _this
                        });
                    }
                });
                widgets.forEach(function(widget) {
                    if (widget.init) widget.init((0, $hPOUL.createInitArgs)(localInstantSearchInstance, _this, localInstantSearchInstance._initialUiState));
                });
                localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        removeWidgets: function removeWidgets(widgets) {
            var _this2 = this;
            if (!Array.isArray(widgets)) throw new Error($a02f10ebbb61b496$var$withUsage('The `removeWidgets` method expects an array of widgets.'));
            if (widgets.some(function(widget) {
                return typeof widget.dispose !== 'function';
            })) throw new Error($a02f10ebbb61b496$var$withUsage('The widget definition expects a `dispose` method.'));
            localWidgets = localWidgets.filter(function(widget) {
                return widgets.indexOf(widget) === -1;
            });
            localWidgets.forEach(function(widget) {
                if ((0, $eRloN.isIndexWidget)(widget)) return;
                if (localInstantSearchInstance && widget.dependsOn === 'recommend') localInstantSearchInstance._hasRecommendWidget = true;
                else if (localInstantSearchInstance) localInstantSearchInstance._hasSearchWidget = true;
                else if (widget.dependsOn === 'recommend') hasRecommendWidget = true;
                else hasSearchWidget = true;
            });
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                var _widgets$reduce = widgets.reduce(function(states, widget) {
                    // the `dispose` method exists at this point we already assert it
                    var next = widget.dispose({
                        helper: helper,
                        state: states.cleanedSearchState,
                        recommendState: states.cleanedRecommendState,
                        parent: _this2
                    });
                    if (next instanceof (0, (/*@__PURE__*/$parcel$interopDefault($bU4Gg))).RecommendParameters) states.cleanedRecommendState = next;
                    else if (next) states.cleanedSearchState = next;
                    return states;
                }, {
                    cleanedSearchState: helper.state,
                    cleanedRecommendState: helper.recommendState
                }), cleanedSearchState = _widgets$reduce.cleanedSearchState, cleanedRecommendState = _widgets$reduce.cleanedRecommendState;
                var newState = localInstantSearchInstance.future.preserveSharedStateOnUnmount ? $a02f10ebbb61b496$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: localUiState,
                    initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($bU4Gg))).SearchParameters({
                        index: this.getIndexName()
                    })
                }) : $a02f10ebbb61b496$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: $a02f10ebbb61b496$var$getLocalWidgetsUiState(localWidgets, {
                        searchParameters: cleanedSearchState,
                        helper: helper
                    }),
                    initialSearchParameters: cleanedSearchState
                });
                localUiState = $a02f10ebbb61b496$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: newState,
                    helper: helper
                });
                helper.setState(newState);
                helper.recommendState = cleanedRecommendState;
                if (localWidgets.length) localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        init: function init(_ref2) {
            var _this3 = this, _instantSearchInstanc;
            var instantSearchInstance = _ref2.instantSearchInstance, parent = _ref2.parent, uiState = _ref2.uiState;
            if (helper !== null) // helper is already initialized, therefore we do not need to set up
            // any listeners
            return;
            localInstantSearchInstance = instantSearchInstance;
            localParent = parent;
            localUiState = uiState[indexId] || {};
            // The `mainHelper` is already defined at this point. The instance is created
            // inside InstantSearch at the `start` method, which occurs before the `init`
            // step.
            var mainHelper = instantSearchInstance.mainHelper;
            var parameters = $a02f10ebbb61b496$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: localUiState,
                initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($bU4Gg))).SearchParameters({
                    index: indexName
                })
            });
            var recommendParameters = $a02f10ebbb61b496$var$getLocalWidgetsRecommendParameters(localWidgets, {
                uiState: localUiState,
                initialRecommendParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($bU4Gg))).RecommendParameters()
            });
            // This Helper is only used for state management we do not care about the
            // `searchClient`. Only the "main" Helper created at the `InstantSearch`
            // level is aware of the client.
            helper = (0, (/*@__PURE__*/$parcel$interopDefault($bU4Gg)))({}, parameters.index, parameters);
            helper.recommendState = recommendParameters;
            // We forward the call to `search` to the "main" instance of the Helper
            // which is responsible for managing the queries (it's the only one that is
            // aware of the `searchClient`).
            helper.search = function() {
                if (instantSearchInstance.onStateChange) {
                    instantSearchInstance.onStateChange({
                        uiState: instantSearchInstance.mainIndex.getWidgetUiState({}),
                        setUiState: function setUiState(nextState) {
                            return instantSearchInstance.setUiState(nextState, false);
                        }
                    });
                    // We don't trigger a search when controlled because it becomes the
                    // responsibility of `setUiState`.
                    return mainHelper;
                }
                return mainHelper.search();
            };
            helper.searchWithoutTriggeringOnStateChange = function() {
                return mainHelper.search();
            };
            // We use the same pattern for the `searchForFacetValues`.
            helper.searchForFacetValues = function(facetName, facetValue, maxFacetHits, userState) {
                var state = helper.state.setQueryParameters(userState);
                return mainHelper.searchForFacetValues(facetName, facetValue, maxFacetHits, state);
            };
            derivedHelper = mainHelper.derive(function() {
                return (0, $bIKD8.mergeSearchParameters).apply(void 0, [
                    mainHelper.state
                ].concat($a02f10ebbb61b496$var$_toConsumableArray((0, $jHy5A.resolveSearchParameters)(_this3))));
            }, function() {
                return _this3.getHelper().recommendState;
            });
            var indexInitialResults = (_instantSearchInstanc = instantSearchInstance._initialResults) === null || _instantSearchInstanc === void 0 ? void 0 : _instantSearchInstanc[this.getIndexId()];
            if (indexInitialResults !== null && indexInitialResults !== void 0 && indexInitialResults.results) {
                // We restore the shape of the results provided to the instance to respect
                // the helper's structure.
                var results = new (0, (/*@__PURE__*/$parcel$interopDefault($bU4Gg))).SearchResults(new (0, (/*@__PURE__*/$parcel$interopDefault($bU4Gg))).SearchParameters(indexInitialResults.state), indexInitialResults.results);
                derivedHelper.lastResults = results;
                helper.lastResults = results;
            }
            if (indexInitialResults !== null && indexInitialResults !== void 0 && indexInitialResults.recommendResults) {
                var recommendResults = new (0, (/*@__PURE__*/$parcel$interopDefault($bU4Gg))).RecommendResults(new (0, (/*@__PURE__*/$parcel$interopDefault($bU4Gg))).RecommendParameters({
                    params: indexInitialResults.recommendResults.params
                }), indexInitialResults.recommendResults.results);
                derivedHelper.lastRecommendResults = recommendResults;
                helper.lastRecommendResults = recommendResults;
            }
            // Subscribe to the Helper state changes for the page before widgets
            // are initialized. This behavior mimics the original one of the Helper.
            // It makes sense to replicate it at the `init` step. We have another
            // listener on `change` below, once `init` is done.
            helper.on('change', function(_ref3) {
                var isPageReset = _ref3.isPageReset;
                if (isPageReset) $a02f10ebbb61b496$var$resetPageFromWidgets(localWidgets);
            });
            derivedHelper.on('search', function() {
                // The index does not manage the "staleness" of the search. This is the
                // responsibility of the main instance. It does not make sense to manage
                // it at the index level because it's either: all of them or none of them
                // that are stalled. The queries are performed into a single network request.
                instantSearchInstance.scheduleStalledRender();
            });
            derivedHelper.on('result', function(_ref4) {
                var results = _ref4.results;
                // The index does not render the results it schedules a new render
                // to let all the other indices emit their own results. It allows us to
                // run the render process in one pass.
                instantSearchInstance.scheduleRender();
                // the derived helper is the one which actually searches, but the helper
                // which is exposed e.g. via instance.helper, doesn't search, and thus
                // does not have access to lastResults, which it used to in pre-federated
                // search behavior.
                helper.lastResults = results;
                lastValidSearchParameters = results === null || results === void 0 ? void 0 : results._state;
            });
            // eslint-disable-next-line no-warning-comments
            // TODO: listen to "result" event when events for Recommend are implemented
            derivedHelper.on('recommend:result', function(_ref5) {
                var recommend = _ref5.recommend;
                // The index does not render the results it schedules a new render
                // to let all the other indices emit their own results. It allows us to
                // run the render process in one pass.
                instantSearchInstance.scheduleRender();
                // the derived helper is the one which actually searches, but the helper
                // which is exposed e.g. via instance.helper, doesn't search, and thus
                // does not have access to lastRecommendResults.
                helper.lastRecommendResults = recommend.results;
            });
            // We compute the render state before calling `init` in a separate loop
            // to construct the whole render state object that is then passed to
            // `init`.
            localWidgets.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this3.getIndexId()] || {}, (0, $hPOUL.createInitArgs)(instantSearchInstance, _this3, uiState));
                    $a02f10ebbb61b496$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this3
                    });
                }
            });
            localWidgets.forEach(function(widget) {
                if (widget.init) widget.init((0, $hPOUL.createInitArgs)(instantSearchInstance, _this3, uiState));
            });
            // Subscribe to the Helper state changes for the `uiState` once widgets
            // are initialized. Until the first render, state changes are part of the
            // configuration step. This is mainly for backward compatibility with custom
            // widgets. When the subscription happens before the `init` step, the (static)
            // configuration of the widget is pushed in the URL. That's what we want to avoid.
            // https://github.com/algolia/instantsearch/pull/994/commits/4a672ae3fd78809e213de0368549ef12e9dc9454
            helper.on('change', function(event) {
                var state = event.state;
                var _uiState = event._uiState;
                localUiState = $a02f10ebbb61b496$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: state,
                    helper: helper
                }, _uiState || {});
                // We don't trigger an internal change when controlled because it
                // becomes the responsibility of `setUiState`.
                if (!instantSearchInstance.onStateChange) instantSearchInstance.onInternalStateChange();
            });
            if (indexInitialResults) // If there are initial results, we're not notified of the next results
            // because we don't trigger an initial search. We therefore need to directly
            // schedule a render that will render the results injected on the helper.
            instantSearchInstance.scheduleRender();
            if (hasRecommendWidget) instantSearchInstance._hasRecommendWidget = true;
            if (hasSearchWidget) instantSearchInstance._hasSearchWidget = true;
        },
        render: function render(_ref6) {
            var _derivedHelper2, _this4 = this;
            var instantSearchInstance = _ref6.instantSearchInstance;
            // we can't attach a listener to the error event of search, as the error
            // then would no longer be thrown for global handlers.
            if (instantSearchInstance.status === 'error' && !instantSearchInstance.mainHelper.hasPendingRequests() && lastValidSearchParameters) helper.setState(lastValidSearchParameters);
            // We only render index widgets if there are no results.
            // This makes sure `render` is never called with `results` being `null`.
            var widgetsToRender = this.getResults() || (_derivedHelper2 = derivedHelper) !== null && _derivedHelper2 !== void 0 && _derivedHelper2.lastRecommendResults ? localWidgets : localWidgets.filter((0, $eRloN.isIndexWidget));
            widgetsToRender = widgetsToRender.filter(function(widget) {
                if (!widget.shouldRender) return true;
                return widget.shouldRender({
                    instantSearchInstance: instantSearchInstance
                });
            });
            widgetsToRender.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this4.getIndexId()] || {}, (0, $hPOUL.createRenderArgs)(instantSearchInstance, _this4, widget));
                    $a02f10ebbb61b496$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this4
                    });
                }
            });
            widgetsToRender.forEach(function(widget) {
                // At this point, all the variables used below are set. Both `helper`
                // and `derivedHelper` have been created at the `init` step. The attribute
                // `lastResults` might be `null` though. It's possible that a stalled render
                // happens before the result e.g with a dynamically added index the request might
                // be delayed. The render is triggered for the complete tree but some parts do
                // not have results yet.
                if (widget.render) widget.render((0, $hPOUL.createRenderArgs)(instantSearchInstance, _this4, widget));
            });
        },
        dispose: function dispose() {
            var _this5 = this, _helper2, _derivedHelper3;
            localWidgets.forEach(function(widget) {
                if (widget.dispose && helper) // The dispose function is always called once the instance is started
                // (it's an effect of `removeWidgets`). The index is initialized and
                // the Helper is available. We don't care about the return value of
                // `dispose` because the index is removed. We can't call `removeWidgets`
                // because we want to keep the widgets on the instance, to allow idempotent
                // operations on `add` & `remove`.
                widget.dispose({
                    helper: helper,
                    state: helper.state,
                    recommendState: helper.recommendState,
                    parent: _this5
                });
            });
            localInstantSearchInstance = null;
            localParent = null;
            (_helper2 = helper) === null || _helper2 === void 0 || _helper2.removeAllListeners();
            helper = null;
            (_derivedHelper3 = derivedHelper) === null || _derivedHelper3 === void 0 || _derivedHelper3.detach();
            derivedHelper = null;
        },
        getWidgetUiState: function getWidgetUiState(uiState) {
            return localWidgets.filter((0, $eRloN.isIndexWidget)).reduce(function(previousUiState, innerIndex) {
                return innerIndex.getWidgetUiState(previousUiState);
            }, $a02f10ebbb61b496$var$_objectSpread($a02f10ebbb61b496$var$_objectSpread({}, uiState), {}, $a02f10ebbb61b496$var$_defineProperty({}, indexId, $a02f10ebbb61b496$var$_objectSpread($a02f10ebbb61b496$var$_objectSpread({}, uiState[indexId]), localUiState))));
        },
        getWidgetState: function getWidgetState(uiState) {
            return this.getWidgetUiState(uiState);
        },
        getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref7) {
            var uiState = _ref7.uiState;
            return $a02f10ebbb61b496$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: uiState,
                initialSearchParameters: searchParameters
            });
        },
        refreshUiState: function refreshUiState() {
            localUiState = $a02f10ebbb61b496$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: this.getHelper().state,
                helper: this.getHelper()
            }, localUiState);
        },
        setIndexUiState: function setIndexUiState(indexUiState) {
            var nextIndexUiState = typeof indexUiState === 'function' ? indexUiState(localUiState) : indexUiState;
            localInstantSearchInstance.setUiState(function(state) {
                return $a02f10ebbb61b496$var$_objectSpread($a02f10ebbb61b496$var$_objectSpread({}, state), {}, $a02f10ebbb61b496$var$_defineProperty({}, indexId, nextIndexUiState));
            });
        }
    };
};
var $a02f10ebbb61b496$export$2e2bcd8739ae039 = $a02f10ebbb61b496$var$index;
function $a02f10ebbb61b496$var$storeRenderState(_ref8) {
    var renderState = _ref8.renderState, instantSearchInstance = _ref8.instantSearchInstance, parent = _ref8.parent;
    var parentIndexName = parent ? parent.getIndexId() : instantSearchInstance.mainIndex.getIndexId();
    instantSearchInstance.renderState = $a02f10ebbb61b496$var$_objectSpread($a02f10ebbb61b496$var$_objectSpread({}, instantSearchInstance.renderState), {}, $a02f10ebbb61b496$var$_defineProperty({}, parentIndexName, $a02f10ebbb61b496$var$_objectSpread($a02f10ebbb61b496$var$_objectSpread({}, instantSearchInstance.renderState[parentIndexName]), renderState)));
}

});
parcelRegister("kooa4", function(module, exports) {

$parcel$export(module.exports, "createDocumentationMessageGenerator", function () { return $ed88ca84a74c80eb$export$2fde5bffc340821e; });
function $ed88ca84a74c80eb$export$110679b26359d23d(_ref) {
    var name = _ref.name, _ref$connector = _ref.connector, connector = _ref$connector === void 0 ? false : _ref$connector;
    return [
        'https://www.algolia.com/doc/api-reference/widgets/',
        name,
        '/js/',
        connector ? '#connector' : ''
    ].join('');
}
function $ed88ca84a74c80eb$export$2fde5bffc340821e() {
    for(var _len = arguments.length, widgets = new Array(_len), _key = 0; _key < _len; _key++)widgets[_key] = arguments[_key];
    var links = widgets.map(function(widget) {
        return $ed88ca84a74c80eb$export$110679b26359d23d(widget);
    }).join(', ');
    return function(message) {
        return [
            message,
            "See documentation: ".concat(links)
        ].filter(Boolean).join('\n\n');
    };
}

});

parcelRegister("eRloN", function(module, exports) {

$parcel$export(module.exports, "isIndexWidget", function () { return $ad169d4f4638241a$export$a9c9a0d43506297d; });
function $ad169d4f4638241a$export$a9c9a0d43506297d(widget) {
    return widget.$$type === 'ais.index';
}

});

parcelRegister("bIKD8", function(module, exports) {

$parcel$export(module.exports, "mergeSearchParameters", function () { return $8887f992e1e0a9c0$export$8049d91f25899769; });

var $hBXqP = parcelRequire("hBXqP");

var $7DrFa = parcelRequire("7DrFa");
function $8887f992e1e0a9c0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8887f992e1e0a9c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8887f992e1e0a9c0$var$_typeof(obj);
}
var $8887f992e1e0a9c0$var$_excluded = [
    "facets",
    "disjunctiveFacets",
    "facetsRefinements",
    "facetsExcludes",
    "disjunctiveFacetsRefinements",
    "numericRefinements",
    "tagRefinements",
    "hierarchicalFacets",
    "hierarchicalFacetsRefinements",
    "ruleContexts"
];
function $8887f992e1e0a9c0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8887f992e1e0a9c0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8887f992e1e0a9c0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8887f992e1e0a9c0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8887f992e1e0a9c0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8887f992e1e0a9c0$var$_defineProperty(obj, key, value) {
    key = $8887f992e1e0a9c0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8887f992e1e0a9c0$var$_toPropertyKey(arg) {
    var key = $8887f992e1e0a9c0$var$_toPrimitive(arg, "string");
    return $8887f992e1e0a9c0$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8887f992e1e0a9c0$var$_toPrimitive(input, hint) {
    if ($8887f992e1e0a9c0$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8887f992e1e0a9c0$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8887f992e1e0a9c0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8887f992e1e0a9c0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8887f992e1e0a9c0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $8887f992e1e0a9c0$var$mergeWithRest = function mergeWithRest(left, right) {
    var facets = right.facets, disjunctiveFacets = right.disjunctiveFacets, facetsRefinements = right.facetsRefinements, facetsExcludes = right.facetsExcludes, disjunctiveFacetsRefinements = right.disjunctiveFacetsRefinements, numericRefinements = right.numericRefinements, tagRefinements = right.tagRefinements, hierarchicalFacets = right.hierarchicalFacets, hierarchicalFacetsRefinements = right.hierarchicalFacetsRefinements, ruleContexts = right.ruleContexts, rest = $8887f992e1e0a9c0$var$_objectWithoutProperties(right, $8887f992e1e0a9c0$var$_excluded);
    return left.setQueryParameters(rest);
};
// Merge facets
var $8887f992e1e0a9c0$var$mergeFacets = function mergeFacets(left, right) {
    return right.facets.reduce(function(_, name) {
        return _.addFacet(name);
    }, left);
};
var $8887f992e1e0a9c0$var$mergeDisjunctiveFacets = function mergeDisjunctiveFacets(left, right) {
    return right.disjunctiveFacets.reduce(function(_, name) {
        return _.addDisjunctiveFacet(name);
    }, left);
};
var $8887f992e1e0a9c0$var$mergeHierarchicalFacets = function mergeHierarchicalFacets(left, right) {
    return left.setQueryParameters({
        hierarchicalFacets: right.hierarchicalFacets.reduce(function(facets, facet) {
            var index = (0, $hBXqP.findIndex)(facets, function(_) {
                return _.name === facet.name;
            });
            if (index === -1) return facets.concat(facet);
            var nextFacets = facets.slice();
            nextFacets.splice(index, 1, facet);
            return nextFacets;
        }, left.hierarchicalFacets)
    });
};
// Merge facet refinements
var $8887f992e1e0a9c0$var$mergeTagRefinements = function mergeTagRefinements(left, right) {
    return right.tagRefinements.reduce(function(_, value) {
        return _.addTagRefinement(value);
    }, left);
};
var $8887f992e1e0a9c0$var$mergeFacetRefinements = function mergeFacetRefinements(left, right) {
    return left.setQueryParameters({
        facetsRefinements: $8887f992e1e0a9c0$var$_objectSpread($8887f992e1e0a9c0$var$_objectSpread({}, left.facetsRefinements), right.facetsRefinements)
    });
};
var $8887f992e1e0a9c0$var$mergeFacetsExcludes = function mergeFacetsExcludes(left, right) {
    return left.setQueryParameters({
        facetsExcludes: $8887f992e1e0a9c0$var$_objectSpread($8887f992e1e0a9c0$var$_objectSpread({}, left.facetsExcludes), right.facetsExcludes)
    });
};
var $8887f992e1e0a9c0$var$mergeDisjunctiveFacetsRefinements = function mergeDisjunctiveFacetsRefinements(left, right) {
    return left.setQueryParameters({
        disjunctiveFacetsRefinements: $8887f992e1e0a9c0$var$_objectSpread($8887f992e1e0a9c0$var$_objectSpread({}, left.disjunctiveFacetsRefinements), right.disjunctiveFacetsRefinements)
    });
};
var $8887f992e1e0a9c0$var$mergeNumericRefinements = function mergeNumericRefinements(left, right) {
    return left.setQueryParameters({
        numericRefinements: $8887f992e1e0a9c0$var$_objectSpread($8887f992e1e0a9c0$var$_objectSpread({}, left.numericRefinements), right.numericRefinements)
    });
};
var $8887f992e1e0a9c0$var$mergeHierarchicalFacetsRefinements = function mergeHierarchicalFacetsRefinements(left, right) {
    return left.setQueryParameters({
        hierarchicalFacetsRefinements: $8887f992e1e0a9c0$var$_objectSpread($8887f992e1e0a9c0$var$_objectSpread({}, left.hierarchicalFacetsRefinements), right.hierarchicalFacetsRefinements)
    });
};
var $8887f992e1e0a9c0$var$mergeRuleContexts = function mergeRuleContexts(left, right) {
    var ruleContexts = (0, $7DrFa.uniq)([].concat(left.ruleContexts).concat(right.ruleContexts).filter(Boolean));
    if (ruleContexts.length > 0) return left.setQueryParameters({
        ruleContexts: ruleContexts
    });
    return left;
};
var $8887f992e1e0a9c0$export$8049d91f25899769 = function mergeSearchParameters() {
    for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++)parameters[_key] = arguments[_key];
    return parameters.reduce(function(left, right) {
        var hierarchicalFacetsRefinementsMerged = $8887f992e1e0a9c0$var$mergeHierarchicalFacetsRefinements(left, right);
        var hierarchicalFacetsMerged = $8887f992e1e0a9c0$var$mergeHierarchicalFacets(hierarchicalFacetsRefinementsMerged, right);
        var tagRefinementsMerged = $8887f992e1e0a9c0$var$mergeTagRefinements(hierarchicalFacetsMerged, right);
        var numericRefinementsMerged = $8887f992e1e0a9c0$var$mergeNumericRefinements(tagRefinementsMerged, right);
        var disjunctiveFacetsRefinementsMerged = $8887f992e1e0a9c0$var$mergeDisjunctiveFacetsRefinements(numericRefinementsMerged, right);
        var facetsExcludesMerged = $8887f992e1e0a9c0$var$mergeFacetsExcludes(disjunctiveFacetsRefinementsMerged, right);
        var facetRefinementsMerged = $8887f992e1e0a9c0$var$mergeFacetRefinements(facetsExcludesMerged, right);
        var disjunctiveFacetsMerged = $8887f992e1e0a9c0$var$mergeDisjunctiveFacets(facetRefinementsMerged, right);
        var ruleContextsMerged = $8887f992e1e0a9c0$var$mergeRuleContexts(disjunctiveFacetsMerged, right);
        var facetsMerged = $8887f992e1e0a9c0$var$mergeFacets(ruleContextsMerged, right);
        return $8887f992e1e0a9c0$var$mergeWithRest(facetsMerged, right);
    });
};

});
parcelRegister("hBXqP", function(module, exports) {

$parcel$export(module.exports, "findIndex", function () { return $cd23fe40c345bb9c$export$de3a4d4a0d731119; });
// We aren't using the native `Array.prototype.findIndex` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `findIndex` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.findIndex` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
function $cd23fe40c345bb9c$export$de3a4d4a0d731119(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
}

});

parcelRegister("7DrFa", function(module, exports) {

$parcel$export(module.exports, "uniq", function () { return $58f1a2344e838782$export$f70730c3d1fc524e; });
function $58f1a2344e838782$export$f70730c3d1fc524e(array) {
    return array.filter(function(value, index, self) {
        return self.indexOf(value) === index;
    });
}

});


parcelRegister("jHy5A", function(module, exports) {

$parcel$export(module.exports, "resolveSearchParameters", function () { return $e57c79dd24dde896$export$1c33c9881dac6797; });
function $e57c79dd24dde896$export$1c33c9881dac6797(current) {
    var parent = current.getParent();
    var states = [
        current.getHelper().state
    ];
    while(parent !== null){
        states = [
            parent.getHelper().state
        ].concat(states);
        parent = parent.getParent();
    }
    return states;
}

});

parcelRegister("4PXEL", function(module, exports) {

$parcel$export(module.exports, "addWidgetId", function () { return $385a3362b94f626a$export$50b3ac0e47148c0b; });
var $385a3362b94f626a$var$id = 0;
function $385a3362b94f626a$export$50b3ac0e47148c0b(widget) {
    if (widget.dependsOn !== 'recommend') return;
    widget.$$id = $385a3362b94f626a$var$id++;
}
function $385a3362b94f626a$export$13e2e3d76152aecf() {
    $385a3362b94f626a$var$id = 0;
}

});


parcelRegister("kMGlm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f21922dfc55cd938$export$2e2bcd8739ae039; });

var $2sPbi = parcelRequire("2sPbi");
var $4aHme = parcelRequire("4aHme");
var $iUr39 = parcelRequire("iUr39");
var $cQkLF = parcelRequire("cQkLF");
var $4mRzG = parcelRequire("4mRzG");

var $fxVpM = parcelRequire("fxVpM");
function $f21922dfc55cd938$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f21922dfc55cd938$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f21922dfc55cd938$var$_typeof(obj);
}
function $f21922dfc55cd938$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f21922dfc55cd938$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f21922dfc55cd938$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f21922dfc55cd938$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f21922dfc55cd938$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f21922dfc55cd938$var$_defineProperty(obj, key, value) {
    key = $f21922dfc55cd938$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f21922dfc55cd938$var$_toPropertyKey(arg) {
    var key = $f21922dfc55cd938$var$_toPrimitive(arg, "string");
    return $f21922dfc55cd938$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f21922dfc55cd938$var$_toPrimitive(input, hint) {
    if ($f21922dfc55cd938$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f21922dfc55cd938$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f21922dfc55cd938$export$2e2bcd8739ae039(_ref) {
    var numberLocale = _ref.numberLocale;
    return {
        formatNumber: function formatNumber(value, render) {
            return (0, $fxVpM.formatNumber)(Number(render(value)), numberLocale);
        },
        highlight: function highlight(options, render) {
            try {
                var highlightOptions = JSON.parse(options);
                return render((0, $2sPbi.default)($f21922dfc55cd938$var$_objectSpread($f21922dfc55cd938$var$_objectSpread({}, highlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error("\nThe highlight helper expects a JSON object of the format:\n{ \"attribute\": \"name\", \"highlightedTagName\": \"mark\" }");
            }
        },
        reverseHighlight: function reverseHighlight(options, render) {
            try {
                var reverseHighlightOptions = JSON.parse(options);
                return render((0, $iUr39.default)($f21922dfc55cd938$var$_objectSpread($f21922dfc55cd938$var$_objectSpread({}, reverseHighlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error("\n  The reverseHighlight helper expects a JSON object of the format:\n  { \"attribute\": \"name\", \"highlightedTagName\": \"mark\" }");
            }
        },
        snippet: function snippet(options, render) {
            try {
                var snippetOptions = JSON.parse(options);
                return render((0, $4mRzG.default)($f21922dfc55cd938$var$_objectSpread($f21922dfc55cd938$var$_objectSpread({}, snippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error("\nThe snippet helper expects a JSON object of the format:\n{ \"attribute\": \"name\", \"highlightedTagName\": \"mark\" }");
            }
        },
        reverseSnippet: function reverseSnippet(options, render) {
            try {
                var reverseSnippetOptions = JSON.parse(options);
                return render((0, $cQkLF.default)($f21922dfc55cd938$var$_objectSpread($f21922dfc55cd938$var$_objectSpread({}, reverseSnippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error("\n  The reverseSnippet helper expects a JSON object of the format:\n  { \"attribute\": \"name\", \"highlightedTagName\": \"mark\" }");
            }
        },
        insights: function insights(options, render) {
            try {
                var _JSON$parse = JSON.parse(options), method = _JSON$parse.method, payload = _JSON$parse.payload;
                return render((0, $4aHme.default)(method, $f21922dfc55cd938$var$_objectSpread({
                    objectIDs: [
                        this.objectID
                    ]
                }, payload)));
            } catch (error) {
                throw new Error("\nThe insights helper expects a JSON object of the format:\n{ \"method\": \"method-name\", \"payload\": { \"eventName\": \"name of the event\" } }");
            }
        }
    };
}

});
parcelRegister("fxVpM", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $b516797a17fb67d0$export$f5dd818bff069720; });
function $b516797a17fb67d0$export$f5dd818bff069720(value, numberLocale) {
    return value.toLocaleString(numberLocale);
}

});


parcelRegister("3SyjT", function(module, exports) {

$parcel$export(module.exports, "defer", function () { return $2d310979811b1fb8$export$260e5c0943f31606; });
var $2d310979811b1fb8$var$nextMicroTask = Promise.resolve();
function $2d310979811b1fb8$export$260e5c0943f31606(callback) {
    var progress = null;
    var cancelled = false;
    var fn = function fn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (progress !== null) return;
        progress = $2d310979811b1fb8$var$nextMicroTask.then(function() {
            progress = null;
            if (cancelled) {
                cancelled = false;
                return;
            }
            callback.apply(void 0, args);
        });
    };
    fn.wait = function() {
        if (progress === null) throw new Error('The deferred function should be called before calling `wait()`');
        return progress;
    };
    fn.cancel = function() {
        if (progress === null) return;
        cancelled = true;
    };
    return fn;
}

});

parcelRegister("kE47m", function(module, exports) {

$parcel$export(module.exports, "hydrateRecommendCache", function () { return $f07abcbe14f4eb75$export$53ef00b131a96aa6; });
function $f07abcbe14f4eb75$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f07abcbe14f4eb75$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f07abcbe14f4eb75$var$_typeof(obj);
}
function $f07abcbe14f4eb75$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f07abcbe14f4eb75$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f07abcbe14f4eb75$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f07abcbe14f4eb75$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f07abcbe14f4eb75$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f07abcbe14f4eb75$var$_defineProperty(obj, key, value) {
    key = $f07abcbe14f4eb75$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f07abcbe14f4eb75$var$_toPropertyKey(arg) {
    var key = $f07abcbe14f4eb75$var$_toPrimitive(arg, "string");
    return $f07abcbe14f4eb75$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f07abcbe14f4eb75$var$_toPrimitive(input, hint) {
    if ($f07abcbe14f4eb75$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f07abcbe14f4eb75$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f07abcbe14f4eb75$export$53ef00b131a96aa6(helper, initialResults) {
    var recommendCache = Object.keys(initialResults).reduce(function(acc, indexName) {
        var initialResult = initialResults[indexName];
        if (initialResult.recommendResults) // @MAJOR: Use `Object.assign` instead of spread operator
        return $f07abcbe14f4eb75$var$_objectSpread($f07abcbe14f4eb75$var$_objectSpread({}, acc), initialResult.recommendResults.results);
        return acc;
    }, {});
    helper._recommendCache = recommendCache;
}

});

parcelRegister("dk3XM", function(module, exports) {

$parcel$export(module.exports, "hydrateSearchClient", function () { return $9b3037a58dacd04c$export$7edf4eca27ca3a19; });
function $9b3037a58dacd04c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9b3037a58dacd04c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9b3037a58dacd04c$var$_typeof(obj);
}
function $9b3037a58dacd04c$var$_slicedToArray(arr, i) {
    return $9b3037a58dacd04c$var$_arrayWithHoles(arr) || $9b3037a58dacd04c$var$_iterableToArrayLimit(arr, i) || $9b3037a58dacd04c$var$_unsupportedIterableToArray(arr, i) || $9b3037a58dacd04c$var$_nonIterableRest();
}
function $9b3037a58dacd04c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9b3037a58dacd04c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9b3037a58dacd04c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9b3037a58dacd04c$var$_arrayLikeToArray(o, minLen);
}
function $9b3037a58dacd04c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9b3037a58dacd04c$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $9b3037a58dacd04c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9b3037a58dacd04c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9b3037a58dacd04c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9b3037a58dacd04c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9b3037a58dacd04c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9b3037a58dacd04c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9b3037a58dacd04c$var$_defineProperty(obj, key, value) {
    key = $9b3037a58dacd04c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9b3037a58dacd04c$var$_toPropertyKey(arg) {
    var key = $9b3037a58dacd04c$var$_toPrimitive(arg, "string");
    return $9b3037a58dacd04c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9b3037a58dacd04c$var$_toPrimitive(input, hint) {
    if ($9b3037a58dacd04c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9b3037a58dacd04c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9b3037a58dacd04c$export$7edf4eca27ca3a19(client, results) {
    if (!results) return;
    // Disable cache hydration on:
    // - Algoliasearch API Client < v4 with cache disabled
    // - Third party clients (detected by the `addAlgoliaAgent` function missing)
    if ((!('transporter' in client) || client._cacheHydrated) && (!client._useCache || typeof client.addAlgoliaAgent !== 'function')) return;
    var cachedRequest = [
        Object.keys(results).reduce(function(acc, key) {
            var _results$key = results[key], state = _results$key.state, requestParams = _results$key.requestParams, serverResults = _results$key.results;
            var mappedResults = serverResults && state ? serverResults.map(function(result, idx) {
                return $9b3037a58dacd04c$var$_objectSpread({
                    indexName: state.index || result.index
                }, requestParams !== null && requestParams !== void 0 && requestParams[idx] || result.params ? {
                    params: $9b3037a58dacd04c$var$serializeQueryParameters((requestParams === null || requestParams === void 0 ? void 0 : requestParams[idx]) || $9b3037a58dacd04c$var$deserializeQueryParameters(result.params))
                } : {});
            }) : [];
            return acc.concat(mappedResults);
        }, [])
    ];
    var cachedResults = Object.keys(results).reduce(function(acc, key) {
        var res = results[key].results;
        if (!res) return acc;
        return acc.concat(res);
    }, []);
    // Algoliasearch API Client >= v4
    // To hydrate the client we need to populate the cache with the data from
    // the server (done in `hydrateSearchClientWithMultiIndexRequest` or
    // `hydrateSearchClientWithSingleIndexRequest`). But since there is no way
    // for us to compute the key the same way as `algoliasearch-client` we need
    // to populate it on a custom key and override the `search` method to
    // search on it first.
    if ('transporter' in client && !client._cacheHydrated) {
        client._cacheHydrated = true;
        var baseMethod = client.search.bind(client);
        // @ts-ignore wanting type checks for v3 on this would make this too complex
        client.search = function(requests) {
            for(var _len = arguments.length, methodArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)methodArgs[_key - 1] = arguments[_key];
            var requestsWithSerializedParams = requests.map(function(request) {
                return $9b3037a58dacd04c$var$_objectSpread($9b3037a58dacd04c$var$_objectSpread({}, request), {}, {
                    params: $9b3037a58dacd04c$var$serializeQueryParameters(request.params)
                });
            });
            return client.transporter.responsesCache.get({
                method: 'search',
                args: [
                    requestsWithSerializedParams
                ].concat(methodArgs)
            }, function() {
                return baseMethod.apply(void 0, [
                    requests
                ].concat(methodArgs));
            });
        };
        client.transporter.responsesCache.set({
            method: 'search',
            args: cachedRequest
        }, {
            results: cachedResults
        });
    }
    // Algoliasearch API Client < v4
    // Prior to client v4 we didn't have a proper API to hydrate the client
    // cache from the outside. The following code populates the cache with
    // a single-index result. You can find more information about the
    // computation of the key inside the client (see link below).
    // https://github.com/algolia/algoliasearch-client-javascript/blob/c27e89ff92b2a854ae6f40dc524bffe0f0cbc169/src/AlgoliaSearchCore.js#L232-L240
    if (!('transporter' in client)) {
        var cacheKey = "/1/indexes/*/queries_body_".concat(JSON.stringify({
            requests: cachedRequest
        }));
        client.cache = $9b3037a58dacd04c$var$_objectSpread($9b3037a58dacd04c$var$_objectSpread({}, client.cache), {}, $9b3037a58dacd04c$var$_defineProperty({}, cacheKey, JSON.stringify({
            results: Object.keys(results).map(function(key) {
                return results[key].results;
            })
        })));
    }
}
function $9b3037a58dacd04c$var$deserializeQueryParameters(parameters) {
    return parameters.split('&').reduce(function(acc, parameter) {
        var _parameter$split = parameter.split('='), _parameter$split2 = $9b3037a58dacd04c$var$_slicedToArray(_parameter$split, 2), key = _parameter$split2[0], value = _parameter$split2[1];
        acc[key] = value ? decodeURIComponent(value) : '';
        return acc;
    }, {});
}
// This function is copied from the algoliasearch v4 API Client. If modified,
// consider updating it also in `serializeQueryParameters` from `@algolia/transporter`.
function $9b3037a58dacd04c$var$serializeQueryParameters(parameters) {
    var isObjectOrArray = function isObjectOrArray(value) {
        return Object.prototype.toString.call(value) === '[object Object]' || Object.prototype.toString.call(value) === '[object Array]';
    };
    var encode = function encode(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        var i = 0;
        return format.replace(/%s/g, function() {
            return encodeURIComponent(args[i++]);
        });
    };
    return Object.keys(parameters).map(function(key) {
        return encode('%s=%s', key, isObjectOrArray(parameters[key]) ? JSON.stringify(parameters[key]) : parameters[key]);
    }).join('&');
}

});

parcelRegister("kItyA", function(module, exports) {

$parcel$export(module.exports, "setIndexHelperState", function () { return $f14ed8143dbf9952$export$fd5e8f1329b3d5e0; });


var $eRloN = parcelRequire("eRloN");
function $f14ed8143dbf9952$export$fd5e8f1329b3d5e0(finalUiState, indexWidget) {
    var nextIndexUiState = finalUiState[indexWidget.getIndexId()] || {};
    indexWidget.getHelper().setState(indexWidget.getWidgetSearchParameters(indexWidget.getHelper().state, {
        uiState: nextIndexUiState
    }));
    indexWidget.getWidgets().filter((0, $eRloN.isIndexWidget)).forEach(function(widget) {
        return $f14ed8143dbf9952$export$fd5e8f1329b3d5e0(finalUiState, widget);
    });
}

});

parcelRegister("dnyLQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bd8650d9ad965a4$export$2e2bcd8739ae039; });
var $9bd8650d9ad965a4$export$2e2bcd8739ae039 = '4.75.6';

});


parcelRegister("jfwkZ", function(module, exports) {

$parcel$export(module.exports, "deprecate", function () { return $e0388094b86183be$export$b680e6b2c82f8c2f; });

var $fMELL = parcelRequire("fMELL");
/**
 * Logs a warning when this function is called, in development environment only.
 */ var $e0388094b86183be$export$b680e6b2c82f8c2f = function deprecate(fn, message) {
    return fn;
};
/**
 * Logs a warning
 * This is used to log issues in development environment only.
 */ var $e0388094b86183be$export$c106dd0671a0fc2d = (0, $fMELL.noop);
/**
 * Logs a warning if the condition is not met.
 * This is used to log issues in development environment only.
 */ var $e0388094b86183be$export$491112666e282270 = (0, $fMELL.noop);

});


parcelRegister("hHIOY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce39385a57ec79fb$export$2e2bcd8739ae039; });

var $kSIRZ = parcelRequire("kSIRZ");

var $fMELL = parcelRequire("fMELL");
function $ce39385a57ec79fb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ce39385a57ec79fb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ce39385a57ec79fb$var$_typeof(obj);
}
function $ce39385a57ec79fb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ce39385a57ec79fb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ce39385a57ec79fb$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ce39385a57ec79fb$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ce39385a57ec79fb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ce39385a57ec79fb$var$_defineProperty(obj, key, value) {
    key = $ce39385a57ec79fb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ce39385a57ec79fb$var$_toPropertyKey(arg) {
    var key = $ce39385a57ec79fb$var$_toPrimitive(arg, "string");
    return $ce39385a57ec79fb$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ce39385a57ec79fb$var$_toPrimitive(input, hint) {
    if ($ce39385a57ec79fb$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ce39385a57ec79fb$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/**
 * A list of [search parameters](https://www.algolia.com/doc/api-reference/search-api-parameters/)
 * to enable when the widget mounts.
 */ var $ce39385a57ec79fb$var$configure = function configure(widgetParams) {
    // This is a renderless widget that falls back to the connector's
    // noop render and unmount functions.
    var makeWidget = (0, $kSIRZ.default)((0, $fMELL.noop));
    return $ce39385a57ec79fb$var$_objectSpread($ce39385a57ec79fb$var$_objectSpread({}, makeWidget({
        searchParameters: widgetParams
    })), {}, {
        $$widgetType: 'ais.configure'
    });
};
var $ce39385a57ec79fb$export$2e2bcd8739ae039 = $ce39385a57ec79fb$var$configure;

});
parcelRegister("kSIRZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f33ba8068baf9dd7$export$2e2bcd8739ae039; });

var $bU4Gg = parcelRequire("bU4Gg");

var $kooa4 = parcelRequire("kooa4");
var $li1Dq = parcelRequire("li1Dq");
var $bIKD8 = parcelRequire("bIKD8");
var $fMELL = parcelRequire("fMELL");
function $f33ba8068baf9dd7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f33ba8068baf9dd7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f33ba8068baf9dd7$var$_typeof(obj);
}
function $f33ba8068baf9dd7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f33ba8068baf9dd7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f33ba8068baf9dd7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f33ba8068baf9dd7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f33ba8068baf9dd7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f33ba8068baf9dd7$var$_defineProperty(obj, key, value) {
    key = $f33ba8068baf9dd7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f33ba8068baf9dd7$var$_toPropertyKey(arg) {
    var key = $f33ba8068baf9dd7$var$_toPrimitive(arg, "string");
    return $f33ba8068baf9dd7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f33ba8068baf9dd7$var$_toPrimitive(input, hint) {
    if ($f33ba8068baf9dd7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f33ba8068baf9dd7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/**
 * Refine the given search parameters.
 */ var $f33ba8068baf9dd7$var$withUsage = (0, $kooa4.createDocumentationMessageGenerator)({
    name: 'configure',
    connector: true
});
function $f33ba8068baf9dd7$var$getInitialSearchParameters(state, widgetParams) {
    // We leverage the helper internals to remove the `widgetParams` from
    // the state. The function `setQueryParameters` omits the values that
    // are `undefined` on the next state.
    return state.setQueryParameters(Object.keys(widgetParams.searchParameters).reduce(function(acc, key) {
        return $f33ba8068baf9dd7$var$_objectSpread($f33ba8068baf9dd7$var$_objectSpread({}, acc), {}, $f33ba8068baf9dd7$var$_defineProperty({}, key, undefined));
    }, {}));
}
var $f33ba8068baf9dd7$var$connectConfigure = function connectConfigure() {
    var renderFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $fMELL.noop);
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $fMELL.noop);
    return function(widgetParams) {
        if (!widgetParams || !(0, $li1Dq.isPlainObject)(widgetParams.searchParameters)) throw new Error($f33ba8068baf9dd7$var$withUsage('The `searchParameters` option expects an object.'));
        var connectorState = {};
        function refine(helper) {
            return function(searchParameters) {
                // Merge new `searchParameters` with the ones set from other widgets
                var actualState = $f33ba8068baf9dd7$var$getInitialSearchParameters(helper.state, widgetParams);
                var nextSearchParameters = (0, $bIKD8.mergeSearchParameters)(actualState, new (0, (/*@__PURE__*/$parcel$interopDefault($bU4Gg))).SearchParameters(searchParameters));
                // Update original `widgetParams.searchParameters` to the new refined one
                widgetParams.searchParameters = searchParameters;
                // Trigger a search with the resolved search parameters
                helper.setState(nextSearchParameters).search();
            };
        }
        return {
            $$type: 'ais.configure',
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($f33ba8068baf9dd7$var$_objectSpread($f33ba8068baf9dd7$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($f33ba8068baf9dd7$var$_objectSpread($f33ba8068baf9dd7$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref) {
                var state = _ref.state;
                unmountFn();
                return $f33ba8068baf9dd7$var$getInitialSearchParameters(state, widgetParams);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                var _renderState$configur;
                var widgetRenderState = this.getWidgetRenderState(renderOptions);
                return $f33ba8068baf9dd7$var$_objectSpread($f33ba8068baf9dd7$var$_objectSpread({}, renderState), {}, {
                    configure: $f33ba8068baf9dd7$var$_objectSpread($f33ba8068baf9dd7$var$_objectSpread({}, widgetRenderState), {}, {
                        widgetParams: $f33ba8068baf9dd7$var$_objectSpread($f33ba8068baf9dd7$var$_objectSpread({}, widgetRenderState.widgetParams), {}, {
                            searchParameters: (0, $bIKD8.mergeSearchParameters)(new (0, (/*@__PURE__*/$parcel$interopDefault($bU4Gg))).SearchParameters((_renderState$configur = renderState.configure) === null || _renderState$configur === void 0 ? void 0 : _renderState$configur.widgetParams.searchParameters), new (0, (/*@__PURE__*/$parcel$interopDefault($bU4Gg))).SearchParameters(widgetRenderState.widgetParams.searchParameters)).getQueryParams()
                        })
                    })
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var helper = _ref2.helper;
                if (!connectorState.refine) connectorState.refine = refine(helper);
                return {
                    refine: connectorState.refine,
                    widgetParams: widgetParams
                };
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(state, _ref3) {
                var uiState = _ref3.uiState;
                return (0, $bIKD8.mergeSearchParameters)(state, new (0, (/*@__PURE__*/$parcel$interopDefault($bU4Gg))).SearchParameters($f33ba8068baf9dd7$var$_objectSpread($f33ba8068baf9dd7$var$_objectSpread({}, uiState.configure), widgetParams.searchParameters)));
            },
            getWidgetUiState: function getWidgetUiState(uiState) {
                return $f33ba8068baf9dd7$var$_objectSpread($f33ba8068baf9dd7$var$_objectSpread({}, uiState), {}, {
                    configure: $f33ba8068baf9dd7$var$_objectSpread($f33ba8068baf9dd7$var$_objectSpread({}, uiState.configure), widgetParams.searchParameters)
                });
            }
        };
    };
};
var $f33ba8068baf9dd7$export$2e2bcd8739ae039 = $f33ba8068baf9dd7$var$connectConfigure;

});


parcelRegister("e2pZd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a38568f6e3ceff32$export$2e2bcd8739ae039; });

var $5bown = parcelRequire("5bown");

var $lLkqw = parcelRequire("lLkqw");

var $7i4Uk = parcelRequire("7i4Uk");

var $d9qzk = parcelRequire("d9qzk");

var $8JLyQ = parcelRequire("8JLyQ");

var $kooa4 = parcelRequire("kooa4");
var $hthTp = parcelRequire("hthTp");
function $a38568f6e3ceff32$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a38568f6e3ceff32$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a38568f6e3ceff32$var$_typeof(obj);
}
function $a38568f6e3ceff32$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a38568f6e3ceff32$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a38568f6e3ceff32$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a38568f6e3ceff32$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a38568f6e3ceff32$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a38568f6e3ceff32$var$_defineProperty(obj, key, value) {
    key = $a38568f6e3ceff32$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a38568f6e3ceff32$var$_toPropertyKey(arg) {
    var key = $a38568f6e3ceff32$var$_toPrimitive(arg, "string");
    return $a38568f6e3ceff32$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a38568f6e3ceff32$var$_toPrimitive(input, hint) {
    if ($a38568f6e3ceff32$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a38568f6e3ceff32$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $a38568f6e3ceff32$var$withUsage = (0, $kooa4.createDocumentationMessageGenerator)({
    name: 'current-refinements'
});
var $a38568f6e3ceff32$var$suit = (0, $8JLyQ.component)('CurrentRefinements');
var $a38568f6e3ceff32$var$renderer = function renderer(_ref, isFirstRender) {
    var items = _ref.items, widgetParams = _ref.widgetParams, canRefine = _ref.canRefine;
    if (isFirstRender) return;
    var _ref2 = widgetParams, container = _ref2.container, cssClasses = _ref2.cssClasses;
    (0, $lLkqw.render)((0, $lLkqw.h)((0, $7i4Uk.default), {
        cssClasses: cssClasses,
        items: items,
        canRefine: canRefine
    }), container);
};
var $a38568f6e3ceff32$var$currentRefinements = function currentRefinements(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, includedAttributes = _ref3.includedAttributes, excludedAttributes = _ref3.excludedAttributes, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, transformItems = _ref3.transformItems;
    if (!container) throw new Error($a38568f6e3ceff32$var$withUsage('The `container` option is required.'));
    var containerNode = (0, $hthTp.getContainerNode)(container);
    var cssClasses = {
        root: (0, $5bown.cx)($a38568f6e3ceff32$var$suit(), userCssClasses.root),
        noRefinementRoot: (0, $5bown.cx)($a38568f6e3ceff32$var$suit({
            modifierName: 'noRefinement'
        }), userCssClasses.noRefinementRoot),
        list: (0, $5bown.cx)($a38568f6e3ceff32$var$suit({
            descendantName: 'list'
        }), userCssClasses.list),
        item: (0, $5bown.cx)($a38568f6e3ceff32$var$suit({
            descendantName: 'item'
        }), userCssClasses.item),
        label: (0, $5bown.cx)($a38568f6e3ceff32$var$suit({
            descendantName: 'label'
        }), userCssClasses.label),
        category: (0, $5bown.cx)($a38568f6e3ceff32$var$suit({
            descendantName: 'category'
        }), userCssClasses.category),
        categoryLabel: (0, $5bown.cx)($a38568f6e3ceff32$var$suit({
            descendantName: 'categoryLabel'
        }), userCssClasses.categoryLabel),
        delete: (0, $5bown.cx)($a38568f6e3ceff32$var$suit({
            descendantName: 'delete'
        }), userCssClasses.delete)
    };
    var makeWidget = (0, $d9qzk.default)($a38568f6e3ceff32$var$renderer, function() {
        return (0, $lLkqw.render)(null, containerNode);
    });
    return $a38568f6e3ceff32$var$_objectSpread($a38568f6e3ceff32$var$_objectSpread({}, makeWidget({
        container: containerNode,
        cssClasses: cssClasses,
        includedAttributes: includedAttributes,
        excludedAttributes: excludedAttributes,
        transformItems: transformItems
    })), {}, {
        $$widgetType: 'ais.currentRefinements'
    });
};
var $a38568f6e3ceff32$export$2e2bcd8739ae039 = $a38568f6e3ceff32$var$currentRefinements;

});
parcelRegister("5bown", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $3c61004171a65250$export$a274e22fb40f762e; });
function $3c61004171a65250$export$a274e22fb40f762e() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.reduce(function(acc, className) {
        if (Array.isArray(className)) return acc.concat(className);
        return acc.concat([
            className
        ]);
    }, []).filter(Boolean).join(' ');
}

});

parcelRegister("lLkqw", function(module, exports) {

$parcel$export(module.exports, "createElement", function () { return $fd7dd51da41a894a$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "createRef", function () { return $fd7dd51da41a894a$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "Fragment", function () { return $fd7dd51da41a894a$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Component", function () { return $fd7dd51da41a894a$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "render", function () { return $fd7dd51da41a894a$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "h", function () { return $fd7dd51da41a894a$export$c8a8987d4410bf2d; });
var $fd7dd51da41a894a$var$n, $fd7dd51da41a894a$export$41c562ebe57d11e2, $fd7dd51da41a894a$var$u, $fd7dd51da41a894a$export$a8257692ac88316c, $fd7dd51da41a894a$var$i, $fd7dd51da41a894a$var$o, $fd7dd51da41a894a$var$r, $fd7dd51da41a894a$var$f, $fd7dd51da41a894a$var$e, $fd7dd51da41a894a$var$c, $fd7dd51da41a894a$var$s, $fd7dd51da41a894a$var$a, $fd7dd51da41a894a$var$h = {}, $fd7dd51da41a894a$var$v = [], $fd7dd51da41a894a$var$p = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $fd7dd51da41a894a$var$y = Array.isArray;
function $fd7dd51da41a894a$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $fd7dd51da41a894a$var$_(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $fd7dd51da41a894a$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $fd7dd51da41a894a$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $fd7dd51da41a894a$var$k(l, f, i, o, null);
}
function $fd7dd51da41a894a$var$k(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$fd7dd51da41a894a$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $fd7dd51da41a894a$export$41c562ebe57d11e2.vnode && $fd7dd51da41a894a$export$41c562ebe57d11e2.vnode(f), f;
}
function $fd7dd51da41a894a$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $fd7dd51da41a894a$export$ffb0004e005737fa(n) {
    return n.children;
}
function $fd7dd51da41a894a$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $fd7dd51da41a894a$var$C(n, l) {
    if (null == l) return n.__ ? $fd7dd51da41a894a$var$C(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $fd7dd51da41a894a$var$C(n) : null;
}
function $fd7dd51da41a894a$var$x(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $fd7dd51da41a894a$var$x(n);
    }
}
function $fd7dd51da41a894a$var$P(n) {
    (!n.__d && (n.__d = !0) && $fd7dd51da41a894a$var$i.push(n) && !$fd7dd51da41a894a$var$S.__r++ || $fd7dd51da41a894a$var$o !== $fd7dd51da41a894a$export$41c562ebe57d11e2.debounceRendering) && (($fd7dd51da41a894a$var$o = $fd7dd51da41a894a$export$41c562ebe57d11e2.debounceRendering) || $fd7dd51da41a894a$var$r)($fd7dd51da41a894a$var$S);
}
function $fd7dd51da41a894a$var$S() {
    var n, u, t, o, r, e, c, s;
    for($fd7dd51da41a894a$var$i.sort($fd7dd51da41a894a$var$f); n = $fd7dd51da41a894a$var$i.shift();)n.__d && (u = $fd7dd51da41a894a$var$i.length, o = void 0, e = (r = (t = n).__v).__e, c = [], s = [], t.__P && ((o = $fd7dd51da41a894a$var$d({}, r)).__v = r.__v + 1, $fd7dd51da41a894a$export$41c562ebe57d11e2.vnode && $fd7dd51da41a894a$export$41c562ebe57d11e2.vnode(o), $fd7dd51da41a894a$var$O(t.__P, o, r, t.__n, void 0 !== t.__P.ownerSVGElement, 32 & r.__u ? [
        e
    ] : null, c, null == e ? $fd7dd51da41a894a$var$C(r) : e, !!(32 & r.__u), s), o.__v = r.__v, o.__.__k[o.__i] = o, $fd7dd51da41a894a$var$j(c, o, s), o.__e != e && $fd7dd51da41a894a$var$x(o)), $fd7dd51da41a894a$var$i.length > u && $fd7dd51da41a894a$var$i.sort($fd7dd51da41a894a$var$f));
    $fd7dd51da41a894a$var$S.__r = 0;
}
function $fd7dd51da41a894a$var$$(n, l, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, _, g = t && t.__k || $fd7dd51da41a894a$var$v, k = l.length;
    for(u.__d = e, $fd7dd51da41a894a$var$I(u, l, g), e = u.__d, a = 0; a < k; a++)null != (y = u.__k[a]) && "boolean" != typeof y && "function" != typeof y && (p = -1 === y.__i ? $fd7dd51da41a894a$var$h : g[y.__i] || $fd7dd51da41a894a$var$h, y.__i = a, $fd7dd51da41a894a$var$O(n, y, p, i, o, r, f, e, c, s), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $fd7dd51da41a894a$var$N(p.ref, null, y), s.push(y.ref, y.__c || d, y)), null == _ && null != d && (_ = d), 65536 & y.__u || p.__k === y.__k ? (e && !e.isConnected && (e = $fd7dd51da41a894a$var$C(p)), e = $fd7dd51da41a894a$var$H(y, e, n)) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = _;
}
function $fd7dd51da41a894a$var$I(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)r = t + a, null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $fd7dd51da41a894a$var$k(null, i, null, null, null) : $fd7dd51da41a894a$var$y(i) ? $fd7dd51da41a894a$var$k($fd7dd51da41a894a$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $fd7dd51da41a894a$var$k(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = $fd7dd51da41a894a$var$A(i, u, r, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f === r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : f < r ? f == r - 1 && (a = f - r) : a = 0, f !== t + a && (i.__u |= 65536))) : (o = u[r]) && null == o.key && o.__e && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $fd7dd51da41a894a$var$C(o)), $fd7dd51da41a894a$var$V(o, o, !1), u[r] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $fd7dd51da41a894a$var$C(o)), $fd7dd51da41a894a$var$V(o, o));
}
function $fd7dd51da41a894a$var$H(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $fd7dd51da41a894a$var$H(t[i], l, u));
        return l;
    }
    n.__e != l && (u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $fd7dd51da41a894a$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($fd7dd51da41a894a$var$y(n) ? n.some(function(n) {
        $fd7dd51da41a894a$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $fd7dd51da41a894a$var$A(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type && 0 == (131072 & e.__u)) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $fd7dd51da41a894a$var$F(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $fd7dd51da41a894a$var$p.test(l) ? u : u + "px";
}
function $fd7dd51da41a894a$var$L(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $fd7dd51da41a894a$var$F(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $fd7dd51da41a894a$var$F(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n || "onFocusOut" === l || "onFocusIn" === l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = $fd7dd51da41a894a$var$e, n.addEventListener(l, o ? $fd7dd51da41a894a$var$s : $fd7dd51da41a894a$var$c, o)) : n.removeEventListener(l, o ? $fd7dd51da41a894a$var$s : $fd7dd51da41a894a$var$c, o);
    else {
        if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $fd7dd51da41a894a$var$M(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $fd7dd51da41a894a$var$e++;
            else if (u.t < t.u) return;
            return t($fd7dd51da41a894a$export$41c562ebe57d11e2.event ? $fd7dd51da41a894a$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $fd7dd51da41a894a$var$O(n, u, t, i, o, r, f, e, c, s) {
    var a, h, v, p, _, g, k, b, C, x, P, S, I, H, T, A = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $fd7dd51da41a894a$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof A) try {
        if (b = u.props, C = (a = A.contextType) && i[a.__c], x = a ? C ? C.props.value : a.__ : i, t.__c ? k = (h = u.__c = t.__c).__ = h.__E : ("prototype" in A && A.prototype.render ? u.__c = h = new A(b, x) : (u.__c = h = new $fd7dd51da41a894a$export$16fa2f45be04daa8(b, x), h.constructor = A, h.render = $fd7dd51da41a894a$var$q), C && C.sub(h), h.props = b, h.state || (h.state = {}), h.context = x, h.__n = i, v = h.__d = !0, h.__h = [], h._sb = []), null == h.__s && (h.__s = h.state), null != A.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $fd7dd51da41a894a$var$d({}, h.__s)), $fd7dd51da41a894a$var$d(h.__s, A.getDerivedStateFromProps(b, h.__s))), p = h.props, _ = h.state, h.__v = u, v) null == A.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (null == A.getDerivedStateFromProps && b !== p && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, x), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, x) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), P = 0; P < h._sb.length; P++)h.__h.push(h._sb[P]);
                h._sb = [], h.__h.length && f.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, x), null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(p, _, g);
            });
        }
        if (h.context = x, h.props = b, h.__P = n, h.__e = !1, S = $fd7dd51da41a894a$export$41c562ebe57d11e2.__r, I = 0, "prototype" in A && A.prototype.render) {
            for(h.state = h.__s, h.__d = !1, S && S(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, S && S(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++I < 25);
        h.state = h.__s, null != h.getChildContext && (i = $fd7dd51da41a894a$var$d($fd7dd51da41a894a$var$d({}, i), h.getChildContext())), v || null == h.getSnapshotBeforeUpdate || (g = h.getSnapshotBeforeUpdate(p, _)), $fd7dd51da41a894a$var$$(n, $fd7dd51da41a894a$var$y(T = null != a && a.type === $fd7dd51da41a894a$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? T : [
            T
        ], u, t, i, o, r, f, e, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && f.push(h), k && (h.__E = h.__ = null);
    } catch (n) {
        u.__v = null, c || null != r ? (u.__e = e, u.__u |= c ? 160 : 32, r[r.indexOf(e)] = null) : (u.__e = t.__e, u.__k = t.__k), $fd7dd51da41a894a$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $fd7dd51da41a894a$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $fd7dd51da41a894a$export$41c562ebe57d11e2.diffed) && a(u);
}
function $fd7dd51da41a894a$var$j(n, u, t) {
    u.__d = void 0;
    for(var i = 0; i < t.length; i++)$fd7dd51da41a894a$var$N(t[i], t[++i], t[++i]);
    $fd7dd51da41a894a$export$41c562ebe57d11e2.__c && $fd7dd51da41a894a$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $fd7dd51da41a894a$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $fd7dd51da41a894a$var$z(l, u, t, i, o, r, f, e, c) {
    var s, a, v, p, d, g, k, b = t.props, m = u.props, w = u.type;
    if ("svg" === w && (o = !0), null != r) {
        for(s = 0; s < r.length; s++)if ((d = r[s]) && "setAttribute" in d == !!w && (w ? d.localName === w : 3 === d.nodeType)) {
            l = d, r[s] = null;
            break;
        }
    }
    if (null == l) {
        if (null === w) return document.createTextNode(m);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", w) : document.createElement(w, m.is && m), r = null, e = !1;
    }
    if (null === w) b === m || e && l.data === m || (l.data = m);
    else {
        if (r = r && $fd7dd51da41a894a$var$n.call(l.childNodes), b = t.props || $fd7dd51da41a894a$var$h, !e && null != r) for(b = {}, s = 0; s < l.attributes.length; s++)b[(d = l.attributes[s]).name] = d.value;
        for(s in b)if (d = b[s], "children" == s) ;
        else if ("dangerouslySetInnerHTML" == s) v = d;
        else if ("key" !== s && !(s in m)) {
            if ("value" == s && "defaultValue" in m || "checked" == s && "defaultChecked" in m) continue;
            $fd7dd51da41a894a$var$L(l, s, null, d, o);
        }
        for(s in m)d = m[s], "children" == s ? p = d : "dangerouslySetInnerHTML" == s ? a = d : "value" == s ? g = d : "checked" == s ? k = d : "key" === s || e && "function" != typeof d || b[s] === d || $fd7dd51da41a894a$var$L(l, s, d, b[s], o);
        if (a) e || v && (a.__html === v.__html || a.__html === l.innerHTML) || (l.innerHTML = a.__html), u.__k = [];
        else if (v && (l.innerHTML = ""), $fd7dd51da41a894a$var$$(l, $fd7dd51da41a894a$var$y(p) ? p : [
            p
        ], u, t, i, o && "foreignObject" !== w, r, f, r ? r[0] : t.__k && $fd7dd51da41a894a$var$C(t, 0), e, c), null != r) for(s = r.length; s--;)null != r[s] && $fd7dd51da41a894a$var$_(r[s]);
        e || (s = "value", void 0 !== g && (g !== l[s] || "progress" === w && !g || "option" === w && g !== b[s]) && $fd7dd51da41a894a$var$L(l, s, g, b[s], !1), s = "checked", void 0 !== k && k !== l[s] && $fd7dd51da41a894a$var$L(l, s, k, b[s], !1));
    }
    return l;
}
function $fd7dd51da41a894a$var$N(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $fd7dd51da41a894a$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $fd7dd51da41a894a$var$V(n, u, t) {
    var i, o;
    if ($fd7dd51da41a894a$export$41c562ebe57d11e2.unmount && $fd7dd51da41a894a$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $fd7dd51da41a894a$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $fd7dd51da41a894a$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $fd7dd51da41a894a$var$V(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $fd7dd51da41a894a$var$_(n.__e), n.__c = n.__ = n.__e = n.__d = void 0;
}
function $fd7dd51da41a894a$var$q(n, l, u) {
    return this.constructor(n, u);
}
function $fd7dd51da41a894a$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $fd7dd51da41a894a$export$41c562ebe57d11e2.__ && $fd7dd51da41a894a$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $fd7dd51da41a894a$var$O(t, u = (!o && i || t).__k = $fd7dd51da41a894a$export$c8a8987d4410bf2d($fd7dd51da41a894a$export$ffb0004e005737fa, null, [
        u
    ]), r || $fd7dd51da41a894a$var$h, $fd7dd51da41a894a$var$h, void 0 !== t.ownerSVGElement, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $fd7dd51da41a894a$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $fd7dd51da41a894a$var$j(f, u, e);
}
function $fd7dd51da41a894a$export$fa8d919ba61d84db(n, l) {
    $fd7dd51da41a894a$export$b3890eb0ae9dca99(n, l, $fd7dd51da41a894a$export$fa8d919ba61d84db);
}
function $fd7dd51da41a894a$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $fd7dd51da41a894a$var$d({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $fd7dd51da41a894a$var$n.call(arguments, 2) : t), $fd7dd51da41a894a$var$k(l.type, e, i || l.key, o || l.ref, null);
}
function $fd7dd51da41a894a$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $fd7dd51da41a894a$var$a++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $fd7dd51da41a894a$var$P(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$fd7dd51da41a894a$var$n = $fd7dd51da41a894a$var$v.slice, $fd7dd51da41a894a$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $fd7dd51da41a894a$var$u = 0, $fd7dd51da41a894a$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $fd7dd51da41a894a$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $fd7dd51da41a894a$var$d({}, this.state), "function" == typeof n && (n = n($fd7dd51da41a894a$var$d({}, u), this.props)), n && $fd7dd51da41a894a$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $fd7dd51da41a894a$var$P(this));
}, $fd7dd51da41a894a$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $fd7dd51da41a894a$var$P(this));
}, $fd7dd51da41a894a$export$16fa2f45be04daa8.prototype.render = $fd7dd51da41a894a$export$ffb0004e005737fa, $fd7dd51da41a894a$var$i = [], $fd7dd51da41a894a$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $fd7dd51da41a894a$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $fd7dd51da41a894a$var$S.__r = 0, $fd7dd51da41a894a$var$e = 0, $fd7dd51da41a894a$var$c = $fd7dd51da41a894a$var$M(!1), $fd7dd51da41a894a$var$s = $fd7dd51da41a894a$var$M(!0), $fd7dd51da41a894a$var$a = 0;

});

parcelRegister("7i4Uk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54ee0563f4ad646f$export$2e2bcd8739ae039; });

var $5bown = parcelRequire("5bown");

var $lLkqw = parcelRequire("lLkqw");

var $eY4MW = parcelRequire("eY4MW");
var $1OF97 = parcelRequire("1OF97");
var $54ee0563f4ad646f$var$createItemKey = function createItemKey(_ref) {
    var attribute = _ref.attribute, value = _ref.value, type = _ref.type, operator = _ref.operator;
    return [
        attribute,
        type,
        value,
        operator
    ].map(function(key) {
        return key;
    }).filter(Boolean).join(':');
};
var $54ee0563f4ad646f$var$handleClick = function handleClick(callback) {
    return function(event) {
        if ((0, $1OF97.isSpecialClick)(event)) return;
        event.preventDefault();
        callback();
    };
};
var $54ee0563f4ad646f$var$CurrentRefinements = function CurrentRefinements(_ref2) {
    var items = _ref2.items, cssClasses = _ref2.cssClasses, canRefine = _ref2.canRefine;
    return (0, $lLkqw.h)("div", {
        className: (0, $5bown.cx)(cssClasses.root, !canRefine && cssClasses.noRefinementRoot)
    }, (0, $lLkqw.h)("ul", {
        className: cssClasses.list
    }, items.map(function(item, index) {
        return (0, $lLkqw.h)("li", {
            key: "".concat(item.indexName, "-").concat(item.attribute, "-").concat(index),
            className: cssClasses.item
        }, (0, $lLkqw.h)("span", {
            className: cssClasses.label
        }, (0, $eY4MW.capitalize)(item.label), ": "), item.refinements.map(function(refinement) {
            return (0, $lLkqw.h)("span", {
                key: $54ee0563f4ad646f$var$createItemKey(refinement),
                className: cssClasses.category
            }, (0, $lLkqw.h)("span", {
                className: cssClasses.categoryLabel
            }, refinement.attribute === 'query' ? (0, $lLkqw.h)("q", null, refinement.label) : refinement.label), (0, $lLkqw.h)("button", {
                className: cssClasses.delete,
                type: "button",
                onClick: $54ee0563f4ad646f$var$handleClick(item.refine.bind(null, refinement))
            }, "\u2715"));
        }));
    })));
};
var $54ee0563f4ad646f$export$2e2bcd8739ae039 = $54ee0563f4ad646f$var$CurrentRefinements;

});
parcelRegister("eY4MW", function(module, exports) {

$parcel$export(module.exports, "capitalize", function () { return $ae5a622c695b3bf4$export$9a00dee1beb8f576; });
function $ae5a622c695b3bf4$export$9a00dee1beb8f576(text) {
    return text.toString().charAt(0).toUpperCase() + text.toString().slice(1);
}

});

parcelRegister("1OF97", function(module, exports) {

$parcel$export(module.exports, "isSpecialClick", function () { return $152a60b5b04d1fff$export$5b1771037ab7c451; });
function $152a60b5b04d1fff$export$5b1771037ab7c451(event) {
    var isMiddleClick = event.button === 1;
    return isMiddleClick || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
}

});


parcelRegister("d9qzk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9930b9a1a7b27bb0$export$2e2bcd8739ae039; });

var $6YH5z = parcelRequire("6YH5z");
var $kooa4 = parcelRequire("kooa4");
var $f2RAI = parcelRequire("f2RAI");
var $fMELL = parcelRequire("fMELL");
function $9930b9a1a7b27bb0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9930b9a1a7b27bb0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9930b9a1a7b27bb0$var$_typeof(obj);
}
function $9930b9a1a7b27bb0$var$_toConsumableArray(arr) {
    return $9930b9a1a7b27bb0$var$_arrayWithoutHoles(arr) || $9930b9a1a7b27bb0$var$_iterableToArray(arr) || $9930b9a1a7b27bb0$var$_unsupportedIterableToArray(arr) || $9930b9a1a7b27bb0$var$_nonIterableSpread();
}
function $9930b9a1a7b27bb0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9930b9a1a7b27bb0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9930b9a1a7b27bb0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9930b9a1a7b27bb0$var$_arrayLikeToArray(o, minLen);
}
function $9930b9a1a7b27bb0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9930b9a1a7b27bb0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9930b9a1a7b27bb0$var$_arrayLikeToArray(arr);
}
function $9930b9a1a7b27bb0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9930b9a1a7b27bb0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9930b9a1a7b27bb0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9930b9a1a7b27bb0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9930b9a1a7b27bb0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9930b9a1a7b27bb0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9930b9a1a7b27bb0$var$_defineProperty(obj, key, value) {
    key = $9930b9a1a7b27bb0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9930b9a1a7b27bb0$var$_toPropertyKey(arg) {
    var key = $9930b9a1a7b27bb0$var$_toPrimitive(arg, "string");
    return $9930b9a1a7b27bb0$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9930b9a1a7b27bb0$var$_toPrimitive(input, hint) {
    if ($9930b9a1a7b27bb0$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9930b9a1a7b27bb0$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $9930b9a1a7b27bb0$var$withUsage = (0, $kooa4.createDocumentationMessageGenerator)({
    name: 'current-refinements',
    connector: true
});
var $9930b9a1a7b27bb0$var$connectCurrentRefinements = function connectCurrentRefinements(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $fMELL.noop);
    (0, $6YH5z.checkRendering)(renderFn, $9930b9a1a7b27bb0$var$withUsage());
    return function(widgetParams) {
        if ((widgetParams || {}).includedAttributes && (widgetParams || {}).excludedAttributes) throw new Error($9930b9a1a7b27bb0$var$withUsage('The options `includedAttributes` and `excludedAttributes` cannot be used together.'));
        var _ref = widgetParams || {}, includedAttributes = _ref.includedAttributes, _ref$excludedAttribut = _ref.excludedAttributes, excludedAttributes = _ref$excludedAttribut === void 0 ? [
            'query'
        ] : _ref$excludedAttribut, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        return {
            $$type: 'ais.currentRefinements',
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($9930b9a1a7b27bb0$var$_objectSpread($9930b9a1a7b27bb0$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($9930b9a1a7b27bb0$var$_objectSpread($9930b9a1a7b27bb0$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose() {
                unmountFn();
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $9930b9a1a7b27bb0$var$_objectSpread($9930b9a1a7b27bb0$var$_objectSpread({}, renderState), {}, {
                    currentRefinements: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var results = _ref2.results, scopedResults = _ref2.scopedResults, _createURL = _ref2.createURL, helper = _ref2.helper;
                function getItems() {
                    if (!results) return transformItems($9930b9a1a7b27bb0$var$getRefinementsItems({
                        results: null,
                        helper: helper,
                        indexId: helper.state.index,
                        includedAttributes: includedAttributes,
                        excludedAttributes: excludedAttributes
                    }), {
                        results: results
                    });
                    return scopedResults.reduce(function(accResults, scopedResult) {
                        return accResults.concat(transformItems($9930b9a1a7b27bb0$var$getRefinementsItems({
                            results: scopedResult.results,
                            helper: scopedResult.helper,
                            indexId: scopedResult.indexId,
                            includedAttributes: includedAttributes,
                            excludedAttributes: excludedAttributes
                        }), {
                            results: results
                        }));
                    }, []);
                }
                var items = getItems();
                return {
                    items: items,
                    canRefine: items.length > 0,
                    refine: function refine(refinement) {
                        return $9930b9a1a7b27bb0$var$clearRefinement(helper, refinement);
                    },
                    createURL: function createURL(refinement) {
                        return _createURL($9930b9a1a7b27bb0$var$clearRefinementFromState(helper.state, refinement));
                    },
                    widgetParams: widgetParams
                };
            }
        };
    };
};
function $9930b9a1a7b27bb0$var$getRefinementsItems(_ref3) {
    var results = _ref3.results, helper = _ref3.helper, indexId = _ref3.indexId, includedAttributes = _ref3.includedAttributes, excludedAttributes = _ref3.excludedAttributes;
    var includesQuery = (includedAttributes || []).indexOf('query') !== -1 || (excludedAttributes || []).indexOf('query') === -1;
    var filterFunction = includedAttributes ? function(item) {
        return includedAttributes.indexOf(item.attribute) !== -1;
    } : function(item) {
        return excludedAttributes.indexOf(item.attribute) === -1;
    };
    var items = (0, $f2RAI.getRefinements)(results, helper.state, includesQuery).map($9930b9a1a7b27bb0$var$normalizeRefinement).filter(filterFunction);
    return items.reduce(function(allItems, currentItem) {
        return [].concat($9930b9a1a7b27bb0$var$_toConsumableArray(allItems.filter(function(item) {
            return item.attribute !== currentItem.attribute;
        })), [
            {
                indexName: helper.state.index,
                indexId: indexId,
                attribute: currentItem.attribute,
                label: currentItem.attribute,
                refinements: items.filter(function(result) {
                    return result.attribute === currentItem.attribute;
                })// We want to keep the order of refinements except the numeric ones.
                .sort(function(a, b) {
                    return a.type === 'numeric' ? a.value - b.value : 0;
                }),
                refine: function refine(refinement) {
                    return $9930b9a1a7b27bb0$var$clearRefinement(helper, refinement);
                }
            }
        ]);
    }, []);
}
function $9930b9a1a7b27bb0$var$clearRefinementFromState(state, refinement) {
    state = state.resetPage();
    switch(refinement.type){
        case 'facet':
            return state.removeFacetRefinement(refinement.attribute, String(refinement.value));
        case 'disjunctive':
            return state.removeDisjunctiveFacetRefinement(refinement.attribute, String(refinement.value));
        case 'hierarchical':
            return state.removeHierarchicalFacetRefinement(refinement.attribute);
        case 'exclude':
            return state.removeExcludeRefinement(refinement.attribute, String(refinement.value));
        case 'numeric':
            return state.removeNumericRefinement(refinement.attribute, refinement.operator, String(refinement.value));
        case 'tag':
            return state.removeTagRefinement(String(refinement.value));
        case 'query':
            return state.setQueryParameter('query', '');
        default:
            return state;
    }
}
function $9930b9a1a7b27bb0$var$clearRefinement(helper, refinement) {
    helper.setState($9930b9a1a7b27bb0$var$clearRefinementFromState(helper.state, refinement)).search();
}
function $9930b9a1a7b27bb0$var$getOperatorSymbol(operator) {
    switch(operator){
        case '>=':
            return "\u2265";
        case '<=':
            return "\u2264";
        default:
            return operator;
    }
}
function $9930b9a1a7b27bb0$var$normalizeRefinement(refinement) {
    var value = $9930b9a1a7b27bb0$var$getValue(refinement);
    var label = refinement.operator ? "".concat($9930b9a1a7b27bb0$var$getOperatorSymbol(refinement.operator), " ").concat(refinement.name) : refinement.name;
    var normalizedRefinement = {
        attribute: refinement.attribute,
        type: refinement.type,
        value: value,
        label: label
    };
    if (refinement.operator !== undefined) normalizedRefinement.operator = refinement.operator;
    if (refinement.count !== undefined) normalizedRefinement.count = refinement.count;
    if (refinement.exhaustive !== undefined) normalizedRefinement.exhaustive = refinement.exhaustive;
    return normalizedRefinement;
}
function $9930b9a1a7b27bb0$var$getValue(refinement) {
    if (refinement.type === 'numeric') return Number(refinement.name);
    if ('escapedValue' in refinement) return refinement.escapedValue;
    return refinement.name;
}
var $9930b9a1a7b27bb0$export$2e2bcd8739ae039 = $9930b9a1a7b27bb0$var$connectCurrentRefinements;

});
parcelRegister("6YH5z", function(module, exports) {

$parcel$export(module.exports, "checkRendering", function () { return $5149c53d90e27d0c$export$adc2a8e09aa583ee; });

var $1a98E = parcelRequire("1a98E");
function $5149c53d90e27d0c$export$adc2a8e09aa583ee(rendering, usage) {
    if (rendering === undefined || typeof rendering !== 'function') throw new Error("The render function is not valid (received type ".concat((0, $1a98E.getObjectType)(rendering), ").\n\n").concat(usage));
}

});
parcelRegister("1a98E", function(module, exports) {

$parcel$export(module.exports, "getObjectType", function () { return $0d8dd0571a532b02$export$11cc42aebef2ef3a; });
function $0d8dd0571a532b02$export$11cc42aebef2ef3a(object) {
    return Object.prototype.toString.call(object).slice(8, -1);
}

});


parcelRegister("f2RAI", function(module, exports) {

$parcel$export(module.exports, "getRefinements", function () { return $af409d02bc19367a$export$d9f33760e70a0a; });

var $85MFt = parcelRequire("85MFt");

var $eHfFT = parcelRequire("eHfFT");
function $af409d02bc19367a$var$getRefinement(state, type, attribute, name) {
    var resultsFacets = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var res = {
        type: type,
        attribute: attribute,
        name: name,
        escapedValue: (0, $85MFt.escapeFacetValue)(name)
    };
    var facet = (0, $eHfFT.find)(resultsFacets, function(resultsFacet) {
        return resultsFacet.name === attribute;
    });
    var count;
    if (type === 'hierarchical') {
        var facetDeclaration = state.getHierarchicalFacetByName(attribute);
        var nameParts = name.split(facetDeclaration.separator);
        var getFacetRefinement = function getFacetRefinement(facetData) {
            return function(refinementKey) {
                return facetData[refinementKey];
            };
        };
        var _loop = function _loop(i) {
            facet = facet && facet.data && (0, $eHfFT.find)(Object.keys(facet.data).map(getFacetRefinement(facet.data)), function(refinement) {
                return refinement.name === nameParts[i];
            });
        };
        for(var i = 0; facet !== undefined && i < nameParts.length; ++i)_loop(i);
        count = facet && facet.count;
    } else count = facet && facet.data && facet.data[res.name];
    if (count !== undefined) res.count = count;
    if (facet && facet.exhaustive !== undefined) res.exhaustive = facet.exhaustive;
    return res;
}
function $af409d02bc19367a$export$d9f33760e70a0a(_results, state) {
    var includesQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var results = _results || {};
    var refinements = [];
    var _state$facetsRefineme = state.facetsRefinements, facetsRefinements = _state$facetsRefineme === void 0 ? {} : _state$facetsRefineme, _state$facetsExcludes = state.facetsExcludes, facetsExcludes = _state$facetsExcludes === void 0 ? {} : _state$facetsExcludes, _state$disjunctiveFac = state.disjunctiveFacetsRefinements, disjunctiveFacetsRefinements = _state$disjunctiveFac === void 0 ? {} : _state$disjunctiveFac, _state$hierarchicalFa = state.hierarchicalFacetsRefinements, hierarchicalFacetsRefinements = _state$hierarchicalFa === void 0 ? {} : _state$hierarchicalFa, _state$numericRefinem = state.numericRefinements, numericRefinements = _state$numericRefinem === void 0 ? {} : _state$numericRefinem, _state$tagRefinements = state.tagRefinements, tagRefinements = _state$tagRefinements === void 0 ? [] : _state$tagRefinements;
    Object.keys(facetsRefinements).forEach(function(attribute) {
        var refinementNames = facetsRefinements[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push($af409d02bc19367a$var$getRefinement(state, 'facet', attribute, refinementName, results.facets));
        });
    });
    Object.keys(facetsExcludes).forEach(function(attribute) {
        var refinementNames = facetsExcludes[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push({
                type: 'exclude',
                attribute: attribute,
                name: refinementName,
                exclude: true
            });
        });
    });
    Object.keys(disjunctiveFacetsRefinements).forEach(function(attribute) {
        var refinementNames = disjunctiveFacetsRefinements[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push($af409d02bc19367a$var$getRefinement(state, 'disjunctive', attribute, // We unescape any disjunctive refined values with `unescapeFacetValue` because
            // they can be escaped on negative numeric values with `escapeFacetValue`.
            (0, $85MFt.unescapeFacetValue)(refinementName), results.disjunctiveFacets));
        });
    });
    Object.keys(hierarchicalFacetsRefinements).forEach(function(attribute) {
        var refinementNames = hierarchicalFacetsRefinements[attribute];
        refinementNames.forEach(function(refinement) {
            refinements.push($af409d02bc19367a$var$getRefinement(state, 'hierarchical', attribute, refinement, results.hierarchicalFacets));
        });
    });
    Object.keys(numericRefinements).forEach(function(attribute) {
        var operators = numericRefinements[attribute];
        Object.keys(operators).forEach(function(operatorOriginal) {
            var operator = operatorOriginal;
            var valueOrValues = operators[operator];
            var refinementNames = Array.isArray(valueOrValues) ? valueOrValues : [
                valueOrValues
            ];
            refinementNames.forEach(function(refinementName) {
                refinements.push({
                    type: 'numeric',
                    attribute: attribute,
                    name: "".concat(refinementName),
                    numericValue: refinementName,
                    operator: operator
                });
            });
        });
    });
    tagRefinements.forEach(function(refinementName) {
        refinements.push({
            type: 'tag',
            attribute: '_tags',
            name: refinementName
        });
    });
    if (includesQuery && state.query && state.query.trim()) refinements.push({
        attribute: 'query',
        type: 'query',
        name: state.query,
        query: state.query
    });
    return refinements;
}

});
parcelRegister("85MFt", function(module, exports) {

$parcel$export(module.exports, "unescapeFacetValue", function () { return $5e448acad90e0d95$export$ad628980c7383a99; });
$parcel$export(module.exports, "escapeFacetValue", function () { return $5e448acad90e0d95$export$40415fcf01f0c9e8; });
function $5e448acad90e0d95$export$ad628980c7383a99(value) {
    if (typeof value === 'string') return value.replace(/^\\-/, '-');
    return value;
}
function $5e448acad90e0d95$export$40415fcf01f0c9e8(value) {
    if (typeof value === 'number' && value < 0 || typeof value === 'string') return String(value).replace(/^-/, '\\-');
    return value;
}

});



parcelRegister("hthTp", function(module, exports) {

$parcel$export(module.exports, "getContainerNode", function () { return $cb830635cafeec67$export$ffb2c7b8d67c359a; });

var $fc41g = parcelRequire("fc41g");
function $cb830635cafeec67$export$ffb2c7b8d67c359a(selectorOrHTMLElement) {
    var isSelectorString = typeof selectorOrHTMLElement === 'string';
    var domElement = isSelectorString ? document.querySelector(selectorOrHTMLElement) : selectorOrHTMLElement;
    if (!(0, $fc41g.isDomElement)(domElement)) {
        var errorMessage = 'Container must be `string` or `HTMLElement`.';
        if (isSelectorString) errorMessage += " Unable to find ".concat(selectorOrHTMLElement);
        throw new Error(errorMessage);
    }
    return domElement;
}

});
parcelRegister("fc41g", function(module, exports) {

$parcel$export(module.exports, "isDomElement", function () { return $b0fb182794639188$export$124b2c3e0d3efb2d; });
function $b0fb182794639188$export$124b2c3e0d3efb2d(object) {
    return object instanceof HTMLElement || Boolean(object) && object.nodeType > 0;
}

});



parcelRegister("d5S8e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9885bb6b9bdd7d95$export$2e2bcd8739ae039; });

var $5bown = parcelRequire("5bown");

var $lLkqw = parcelRequire("lLkqw");

var $cJWf4 = parcelRequire("cJWf4");

var $9oCq8 = parcelRequire("9oCq8");

var $1PUnu = parcelRequire("1PUnu");

var $8JLyQ = parcelRequire("8JLyQ");

var $985ic = parcelRequire("985ic");

var $kooa4 = parcelRequire("kooa4");
var $hthTp = parcelRequire("hthTp");

var $73ZoF = parcelRequire("73ZoF");
function $9885bb6b9bdd7d95$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9885bb6b9bdd7d95$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9885bb6b9bdd7d95$var$_typeof(obj);
}
function $9885bb6b9bdd7d95$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9885bb6b9bdd7d95$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9885bb6b9bdd7d95$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9885bb6b9bdd7d95$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9885bb6b9bdd7d95$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9885bb6b9bdd7d95$var$_defineProperty(obj, key, value) {
    key = $9885bb6b9bdd7d95$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9885bb6b9bdd7d95$var$_toPropertyKey(arg) {
    var key = $9885bb6b9bdd7d95$var$_toPrimitive(arg, "string");
    return $9885bb6b9bdd7d95$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9885bb6b9bdd7d95$var$_toPrimitive(input, hint) {
    if ($9885bb6b9bdd7d95$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9885bb6b9bdd7d95$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $9885bb6b9bdd7d95$var$withUsage = (0, $kooa4.createDocumentationMessageGenerator)({
    name: 'infinite-hits'
});
var $9885bb6b9bdd7d95$var$suit = (0, $8JLyQ.component)('InfiniteHits');
var $9885bb6b9bdd7d95$var$renderer = function renderer(_ref) {
    var containerNode = _ref.containerNode, cssClasses = _ref.cssClasses, renderState = _ref.renderState, templates = _ref.templates, hasShowPrevious = _ref.showPrevious;
    return function(_ref2, isFirstRendering) {
        var items = _ref2.items, results = _ref2.results, showMore = _ref2.showMore, showPrevious = _ref2.showPrevious, isFirstPage = _ref2.isFirstPage, isLastPage = _ref2.isLastPage, instantSearchInstance = _ref2.instantSearchInstance, insights = _ref2.insights, bindEvent = _ref2.bindEvent, sendEvent = _ref2.sendEvent, banner = _ref2.banner;
        if (isFirstRendering) {
            renderState.templateProps = (0, $985ic.prepareTemplateProps)({
                defaultTemplates: (0, $73ZoF.default),
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: templates
            });
            return;
        }
        (0, $lLkqw.render)((0, $lLkqw.h)((0, $cJWf4.default), {
            cssClasses: cssClasses,
            hits: items,
            results: results,
            hasShowPrevious: hasShowPrevious,
            showPrevious: showPrevious,
            showMore: showMore,
            templateProps: renderState.templateProps,
            isFirstPage: isFirstPage,
            isLastPage: isLastPage,
            insights: insights,
            sendEvent: sendEvent,
            bindEvent: bindEvent,
            banner: banner
        }), containerNode);
    };
};
var $9885bb6b9bdd7d95$export$2e2bcd8739ae039 = function infiniteHits(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, escapeHTML = _ref3.escapeHTML, transformItems = _ref3.transformItems, _ref3$templates = _ref3.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, showPrevious = _ref3.showPrevious, cache = _ref3.cache;
    if (!container) throw new Error($9885bb6b9bdd7d95$var$withUsage('The `container` option is required.'));
    var containerNode = (0, $hthTp.getContainerNode)(container);
    var cssClasses = {
        root: (0, $5bown.cx)($9885bb6b9bdd7d95$var$suit(), userCssClasses.root),
        emptyRoot: (0, $5bown.cx)($9885bb6b9bdd7d95$var$suit({
            modifierName: 'empty'
        }), userCssClasses.emptyRoot),
        item: (0, $5bown.cx)($9885bb6b9bdd7d95$var$suit({
            descendantName: 'item'
        }), userCssClasses.item),
        list: (0, $5bown.cx)($9885bb6b9bdd7d95$var$suit({
            descendantName: 'list'
        }), userCssClasses.list),
        loadPrevious: (0, $5bown.cx)($9885bb6b9bdd7d95$var$suit({
            descendantName: 'loadPrevious'
        }), userCssClasses.loadPrevious),
        disabledLoadPrevious: (0, $5bown.cx)($9885bb6b9bdd7d95$var$suit({
            descendantName: 'loadPrevious',
            modifierName: 'disabled'
        }), userCssClasses.disabledLoadPrevious),
        loadMore: (0, $5bown.cx)($9885bb6b9bdd7d95$var$suit({
            descendantName: 'loadMore'
        }), userCssClasses.loadMore),
        disabledLoadMore: (0, $5bown.cx)($9885bb6b9bdd7d95$var$suit({
            descendantName: 'loadMore',
            modifierName: 'disabled'
        }), userCssClasses.disabledLoadMore),
        bannerRoot: (0, $5bown.cx)($9885bb6b9bdd7d95$var$suit({
            descendantName: 'banner'
        }), userCssClasses.bannerRoot),
        bannerImage: (0, $5bown.cx)($9885bb6b9bdd7d95$var$suit({
            descendantName: 'banner-image'
        }), userCssClasses.bannerImage),
        bannerLink: (0, $5bown.cx)($9885bb6b9bdd7d95$var$suit({
            descendantName: 'banner-link'
        }), userCssClasses.bannerLink)
    };
    var specializedRenderer = $9885bb6b9bdd7d95$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        templates: templates,
        showPrevious: showPrevious,
        renderState: {}
    });
    var makeWidget = (0, $1PUnu.default)((0, $9oCq8.default))(specializedRenderer, function() {
        return (0, $lLkqw.render)(null, containerNode);
    });
    return $9885bb6b9bdd7d95$var$_objectSpread($9885bb6b9bdd7d95$var$_objectSpread({}, makeWidget({
        escapeHTML: escapeHTML,
        transformItems: transformItems,
        showPrevious: showPrevious,
        cache: cache
    })), {}, {
        $$widgetType: 'ais.infiniteHits'
    });
};

});
parcelRegister("cJWf4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9466dda4c20200d8$export$2e2bcd8739ae039; });

var $5bown = parcelRequire("5bown");

var $lLkqw = parcelRequire("lLkqw");

var $fC4yK = parcelRequire("fC4yK");


var $kNs3K = parcelRequire("kNs3K");
function $9466dda4c20200d8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9466dda4c20200d8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9466dda4c20200d8$var$_typeof(obj);
}
function $9466dda4c20200d8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9466dda4c20200d8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9466dda4c20200d8$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9466dda4c20200d8$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9466dda4c20200d8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9466dda4c20200d8$var$_defineProperty(obj, key, value) {
    key = $9466dda4c20200d8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9466dda4c20200d8$var$_toPropertyKey(arg) {
    var key = $9466dda4c20200d8$var$_toPrimitive(arg, "string");
    return $9466dda4c20200d8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9466dda4c20200d8$var$_toPrimitive(input, hint) {
    if ($9466dda4c20200d8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9466dda4c20200d8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9466dda4c20200d8$var$_extends() {
    $9466dda4c20200d8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9466dda4c20200d8$var$_extends.apply(this, arguments);
}
var $9466dda4c20200d8$var$DefaultBanner = function DefaultBanner(_ref) {
    var banner = _ref.banner, classNames = _ref.classNames;
    if (!banner.image.urls[0].url) return null;
    return (0, $lLkqw.h)("aside", {
        className: (0, $5bown.cx)(classNames.bannerRoot)
    }, banner.link ? (0, $lLkqw.h)("a", {
        className: (0, $5bown.cx)(classNames.bannerLink),
        href: banner.link.url,
        target: banner.link.target
    }, (0, $lLkqw.h)("img", {
        className: (0, $5bown.cx)(classNames.bannerImage),
        src: banner.image.urls[0].url,
        alt: banner.image.title
    })) : (0, $lLkqw.h)("img", {
        className: (0, $5bown.cx)(classNames.bannerImage),
        src: banner.image.urls[0].url,
        alt: banner.image.title
    }));
};
var $9466dda4c20200d8$var$InfiniteHits = function InfiniteHits(_ref2) {
    var results = _ref2.results, hits = _ref2.hits, insights = _ref2.insights, bindEvent = _ref2.bindEvent, sendEvent = _ref2.sendEvent, hasShowPrevious = _ref2.hasShowPrevious, showPrevious = _ref2.showPrevious, showMore = _ref2.showMore, isFirstPage = _ref2.isFirstPage, isLastPage = _ref2.isLastPage, cssClasses = _ref2.cssClasses, templateProps = _ref2.templateProps, banner = _ref2.banner;
    var handleInsightsClick = (0, $fC4yK.createInsightsEventHandler)({
        insights: insights,
        sendEvent: sendEvent
    });
    if (results.hits.length === 0) return (0, $lLkqw.h)("div", {
        className: (0, $5bown.cx)(cssClasses.root, cssClasses.emptyRoot),
        onClick: handleInsightsClick
    }, banner && (templateProps.templates.banner ? (0, $lLkqw.h)((0, $kNs3K.default), $9466dda4c20200d8$var$_extends({}, templateProps, {
        templateKey: "banner",
        rootTagName: "fragment",
        data: {
            banner: banner,
            className: cssClasses.bannerRoot
        }
    })) : (0, $lLkqw.h)($9466dda4c20200d8$var$DefaultBanner, {
        banner: banner,
        classNames: cssClasses
    })), (0, $lLkqw.h)((0, $kNs3K.default), $9466dda4c20200d8$var$_extends({}, templateProps, {
        templateKey: "empty",
        rootTagName: "fragment",
        data: results
    })));
    return (0, $lLkqw.h)("div", {
        className: cssClasses.root
    }, hasShowPrevious && (0, $lLkqw.h)((0, $kNs3K.default), $9466dda4c20200d8$var$_extends({}, templateProps, {
        templateKey: "showPreviousText",
        rootTagName: "button",
        rootProps: {
            className: (0, $5bown.cx)(cssClasses.loadPrevious, isFirstPage && cssClasses.disabledLoadPrevious),
            disabled: isFirstPage,
            onClick: showPrevious
        }
    })), banner && (templateProps.templates.banner ? (0, $lLkqw.h)((0, $kNs3K.default), $9466dda4c20200d8$var$_extends({}, templateProps, {
        templateKey: "banner",
        rootTagName: "fragment",
        data: {
            banner: banner,
            className: cssClasses.bannerRoot
        }
    })) : (0, $lLkqw.h)($9466dda4c20200d8$var$DefaultBanner, {
        banner: banner,
        classNames: cssClasses
    })), (0, $lLkqw.h)("ol", {
        className: cssClasses.list
    }, hits.map(function(hit, index) {
        return (0, $lLkqw.h)((0, $kNs3K.default), $9466dda4c20200d8$var$_extends({}, templateProps, {
            templateKey: "item",
            rootTagName: "li",
            rootProps: {
                className: cssClasses.item,
                onClick: function onClick(event) {
                    handleInsightsClick(event);
                    sendEvent('click:internal', hit, 'Hit Clicked');
                },
                onAuxClick: function onAuxClick(event) {
                    handleInsightsClick(event);
                    sendEvent('click:internal', hit, 'Hit Clicked');
                }
            },
            key: hit.objectID,
            data: $9466dda4c20200d8$var$_objectSpread($9466dda4c20200d8$var$_objectSpread({}, hit), {}, {
                get __hitIndex () {
                    return index;
                }
            }),
            bindEvent: bindEvent,
            sendEvent: sendEvent
        }));
    })), (0, $lLkqw.h)((0, $kNs3K.default), $9466dda4c20200d8$var$_extends({}, templateProps, {
        templateKey: "showMoreText",
        rootTagName: "button",
        rootProps: {
            className: (0, $5bown.cx)(cssClasses.loadMore, isLastPage && cssClasses.disabledLoadMore),
            disabled: isLastPage,
            onClick: showMore
        }
    })));
};
var $9466dda4c20200d8$export$2e2bcd8739ae039 = $9466dda4c20200d8$var$InfiniteHits;

});
parcelRegister("fC4yK", function(module, exports) {

$parcel$export(module.exports, "createInsightsEventHandler", function () { return $b5ddf10bc8ac5584$export$71d036cfbce90975; });

var $lLkqw = parcelRequire("lLkqw");

var $4aHme = parcelRequire("4aHme");

var $1ZS80 = parcelRequire("1ZS80");
var $b5ddf10bc8ac5584$export$71d036cfbce90975 = function createInsightsEventHandler(_ref) {
    var insights = _ref.insights, sendEvent = _ref.sendEvent;
    return function(event) {
        // new way, e.g. bindEvent("click", hit, "Hit clicked")
        var insightsThroughSendEvent = $b5ddf10bc8ac5584$var$findInsightsTarget(event.target, event.currentTarget, function(element) {
            return element.hasAttribute('data-insights-event');
        });
        if (insightsThroughSendEvent) {
            var payload = $b5ddf10bc8ac5584$var$parseInsightsEvent(insightsThroughSendEvent);
            payload.forEach(function(single) {
                return sendEvent(single);
            });
        }
        // old way, e.g. instantsearch.insights("clickedObjectIDsAfterSearch", { .. })
        var insightsThroughFunction = $b5ddf10bc8ac5584$var$findInsightsTarget(event.target, event.currentTarget, function(element) {
            return element.hasAttribute('data-insights-method') && element.hasAttribute('data-insights-payload');
        });
        if (insightsThroughFunction) {
            var _readDataAttributes = (0, $4aHme.readDataAttributes)(insightsThroughFunction), method = _readDataAttributes.method, _payload = _readDataAttributes.payload;
            insights(method, _payload);
        }
    };
};
function $b5ddf10bc8ac5584$var$findInsightsTarget(startElement, endElement, validator) {
    var element = startElement;
    while(element && !validator(element)){
        if (element === endElement) return null;
        element = element.parentElement;
    }
    return element;
}
function $b5ddf10bc8ac5584$var$parseInsightsEvent(element) {
    var serializedPayload = element.getAttribute('data-insights-event');
    if (typeof serializedPayload !== 'string') throw new Error('The insights middleware expects `data-insights-event` to be a base64-encoded JSON string.');
    try {
        return (0, $1ZS80.deserializePayload)(serializedPayload);
    } catch (error) {
        throw new Error('The insights middleware was unable to parse `data-insights-event`.');
    }
}
function $b5ddf10bc8ac5584$export$2e2bcd8739ae039(BaseComponent) {
    return function WithInsightsListener(props) {
        var handleClick = $b5ddf10bc8ac5584$export$71d036cfbce90975(props);
        return (0, $lLkqw.h)("div", {
            onClick: handleClick
        }, (0, $lLkqw.h)(BaseComponent, props));
    };
}

});

parcelRegister("kNs3K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f23e264af7dd74b8$export$2e2bcd8739ae039; });

var $lLkqw = parcelRequire("lLkqw");

var $5lhUZ = parcelRequire("5lhUZ");

var $cg906 = parcelRequire("cg906");
function $f23e264af7dd74b8$var$_extends() {
    $f23e264af7dd74b8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f23e264af7dd74b8$var$_extends.apply(this, arguments);
}
function $f23e264af7dd74b8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f23e264af7dd74b8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f23e264af7dd74b8$var$_typeof(obj);
}
function $f23e264af7dd74b8$var$_toConsumableArray(arr) {
    return $f23e264af7dd74b8$var$_arrayWithoutHoles(arr) || $f23e264af7dd74b8$var$_iterableToArray(arr) || $f23e264af7dd74b8$var$_unsupportedIterableToArray(arr) || $f23e264af7dd74b8$var$_nonIterableSpread();
}
function $f23e264af7dd74b8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f23e264af7dd74b8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f23e264af7dd74b8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f23e264af7dd74b8$var$_arrayLikeToArray(o, minLen);
}
function $f23e264af7dd74b8$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f23e264af7dd74b8$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f23e264af7dd74b8$var$_arrayLikeToArray(arr);
}
function $f23e264af7dd74b8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f23e264af7dd74b8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f23e264af7dd74b8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f23e264af7dd74b8$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f23e264af7dd74b8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f23e264af7dd74b8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f23e264af7dd74b8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f23e264af7dd74b8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f23e264af7dd74b8$var$_setPrototypeOf(subClass, superClass);
}
function $f23e264af7dd74b8$var$_setPrototypeOf(o, p) {
    $f23e264af7dd74b8$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f23e264af7dd74b8$var$_setPrototypeOf(o, p);
}
function $f23e264af7dd74b8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f23e264af7dd74b8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f23e264af7dd74b8$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f23e264af7dd74b8$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f23e264af7dd74b8$var$_possibleConstructorReturn(this, result);
    };
}
function $f23e264af7dd74b8$var$_possibleConstructorReturn(self, call) {
    if (call && ($f23e264af7dd74b8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f23e264af7dd74b8$var$_assertThisInitialized(self);
}
function $f23e264af7dd74b8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f23e264af7dd74b8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f23e264af7dd74b8$var$_getPrototypeOf(o) {
    $f23e264af7dd74b8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f23e264af7dd74b8$var$_getPrototypeOf(o);
}
function $f23e264af7dd74b8$var$_defineProperty(obj, key, value) {
    key = $f23e264af7dd74b8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f23e264af7dd74b8$var$_toPropertyKey(arg) {
    var key = $f23e264af7dd74b8$var$_toPrimitive(arg, "string");
    return $f23e264af7dd74b8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f23e264af7dd74b8$var$_toPrimitive(input, hint) {
    if ($f23e264af7dd74b8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f23e264af7dd74b8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f23e264af7dd74b8$var$RawHtml = /*#__PURE__*/ function(_Component) {
    $f23e264af7dd74b8$var$_inherits(RawHtml, _Component);
    var _super = $f23e264af7dd74b8$var$_createSuper(RawHtml);
    function RawHtml() {
        var _this;
        $f23e264af7dd74b8$var$_classCallCheck(this, RawHtml);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $f23e264af7dd74b8$var$_defineProperty($f23e264af7dd74b8$var$_assertThisInitialized(_this), "ref", (0, $lLkqw.createRef)());
        $f23e264af7dd74b8$var$_defineProperty($f23e264af7dd74b8$var$_assertThisInitialized(_this), "nodes", []);
        return _this;
    }
    $f23e264af7dd74b8$var$_createClass(RawHtml, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var fragment = new DocumentFragment();
                var root = document.createElement('div');
                root.innerHTML = this.props.content;
                this.nodes = $f23e264af7dd74b8$var$_toConsumableArray(root.childNodes);
                this.nodes.forEach(function(node) {
                    return fragment.appendChild(node);
                });
                this.ref.current.replaceWith(fragment);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.nodes.forEach(function(node) {
                    if (node instanceof Element) {
                        node.outerHTML = '';
                        return;
                    }
                    node.nodeValue = '';
                });
                // if there is one TextNode first and one TextNode last, the
                // last one's nodeValue will be assigned to the first.
                if (this.nodes[0].nodeValue) this.nodes[0].nodeValue = '';
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $lLkqw.h)("div", {
                    ref: this.ref
                });
            }
        }
    ]);
    return RawHtml;
}((0, $lLkqw.Component));
var $f23e264af7dd74b8$var$defaultProps = {
    data: {},
    rootTagName: 'div',
    useCustomCompileOptions: {},
    templates: {},
    templatesConfig: {}
};
// @TODO: Template should be a generic and receive TData to pass to Templates (to avoid TTemplateData to be set as `any`)
var $f23e264af7dd74b8$var$Template = /*#__PURE__*/ function(_Component2) {
    $f23e264af7dd74b8$var$_inherits(Template, _Component2);
    var _super2 = $f23e264af7dd74b8$var$_createSuper(Template);
    function Template() {
        $f23e264af7dd74b8$var$_classCallCheck(this, Template);
        return _super2.apply(this, arguments);
    }
    $f23e264af7dd74b8$var$_createClass(Template, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return !(0, $cg906.isEqual)(this.props.data, nextProps.data) || this.props.templateKey !== nextProps.templateKey || !(0, $cg906.isEqual)(this.props.rootProps, nextProps.rootProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var nonFunctionTemplates;
                var RootTagName = this.props.rootTagName === 'fragment' ? (0, $lLkqw.Fragment) : this.props.rootTagName;
                var useCustomCompileOptions = this.props.useCustomCompileOptions[this.props.templateKey];
                var compileOptions = useCustomCompileOptions ? this.props.templatesConfig.compileOptions : {};
                var content = (0, $5lhUZ.renderTemplate)({
                    templates: this.props.templates,
                    templateKey: this.props.templateKey,
                    compileOptions: compileOptions,
                    helpers: this.props.templatesConfig.helpers,
                    data: this.props.data,
                    bindEvent: this.props.bindEvent,
                    sendEvent: this.props.sendEvent
                });
                if (content === null) // Adds a noscript to the DOM but virtual DOM is null
                // See http://facebook.github.io/react/docs/component-specs.html#render
                return null;
                if ($f23e264af7dd74b8$var$_typeof(content) === 'object') return (0, $lLkqw.h)(RootTagName, this.props.rootProps, content);
                // This is to handle Hogan templates with Fragment as rootTagName
                if (RootTagName === (0, $lLkqw.Fragment)) return (0, $lLkqw.h)($f23e264af7dd74b8$var$RawHtml, {
                    content: content,
                    key: Math.random()
                });
                return (0, $lLkqw.h)(RootTagName, $f23e264af7dd74b8$var$_extends({}, this.props.rootProps, {
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                }));
            }
        }
    ]);
    return Template;
}((0, $lLkqw.Component));
$f23e264af7dd74b8$var$_defineProperty($f23e264af7dd74b8$var$Template, "defaultProps", $f23e264af7dd74b8$var$defaultProps);
var $f23e264af7dd74b8$export$2e2bcd8739ae039 = $f23e264af7dd74b8$var$Template;

});
parcelRegister("5lhUZ", function(module, exports) {

$parcel$export(module.exports, "renderTemplate", function () { return $3e3cd01863e1595d$export$b5c363744c17aeab; });

var $5kjGc = parcelRequire("5kjGc");

var $cf9aJ = parcelRequire("cf9aJ");

var $8MXxg = parcelRequire("8MXxg");
var $gkedx = parcelRequire("gkedx");
var $jhbUA = parcelRequire("jhbUA");
var $etXmt = parcelRequire("etXmt");
function $3e3cd01863e1595d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3e3cd01863e1595d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3e3cd01863e1595d$var$_typeof(obj);
}
function $3e3cd01863e1595d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3e3cd01863e1595d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3e3cd01863e1595d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3e3cd01863e1595d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3e3cd01863e1595d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3e3cd01863e1595d$var$_defineProperty(obj, key, value) {
    key = $3e3cd01863e1595d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3e3cd01863e1595d$var$_toPropertyKey(arg) {
    var key = $3e3cd01863e1595d$var$_toPrimitive(arg, "string");
    return $3e3cd01863e1595d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3e3cd01863e1595d$var$_toPrimitive(input, hint) {
    if ($3e3cd01863e1595d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3e3cd01863e1595d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
// We add all our template helper methods to the template as lambdas. Note
// that lambdas in Mustache are supposed to accept a second argument of
// `render` to get the rendered value, not the literal `{{value}}`. But
// this is currently broken (see https://github.com/twitter/hogan.js/issues/222).
function $3e3cd01863e1595d$var$transformHelpersToHogan() {
    var helpers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var compileOptions = arguments.length > 1 ? arguments[1] : undefined;
    var data = arguments.length > 2 ? arguments[2] : undefined;
    return Object.keys(helpers).reduce(function(acc, helperKey) {
        return $3e3cd01863e1595d$var$_objectSpread($3e3cd01863e1595d$var$_objectSpread({}, acc), {}, $3e3cd01863e1595d$var$_defineProperty({}, helperKey, function() {
            var _this = this;
            return function(text) {
                var render = function render(value) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5kjGc))).compile(value, compileOptions).render(_this);
                };
                return helpers[helperKey].call(data, text, render);
            };
        }));
    }, {});
}
function $3e3cd01863e1595d$export$b5c363744c17aeab(_ref) {
    var templates = _ref.templates, templateKey = _ref.templateKey, compileOptions = _ref.compileOptions, helpers = _ref.helpers, data = _ref.data, bindEvent = _ref.bindEvent, sendEvent = _ref.sendEvent;
    var template = templates[templateKey];
    if (typeof template !== 'string' && typeof template !== 'function') throw new Error("Template must be 'string' or 'function', was '".concat($3e3cd01863e1595d$var$_typeof(template), "' (key: ").concat(templateKey, ")"));
    if (typeof template === 'function') {
        // @MAJOR no longer pass bindEvent when string templates are removed
        var params = bindEvent || {};
        params.html = (0, $cf9aJ.html);
        params.sendEvent = sendEvent;
        params.components = {
            Highlight: (0, $8MXxg.Highlight),
            ReverseHighlight: (0, $gkedx.ReverseHighlight),
            Snippet: (0, $etXmt.Snippet),
            ReverseSnippet: (0, $jhbUA.ReverseSnippet)
        };
        // @MAJOR remove the `as any` when string templates are removed
        // needed because not every template receives sendEvent
        return template(data, params);
    }
    var transformedHelpers = $3e3cd01863e1595d$var$transformHelpersToHogan(helpers, compileOptions, data);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5kjGc))).compile(template, compileOptions).render($3e3cd01863e1595d$var$_objectSpread($3e3cd01863e1595d$var$_objectSpread({}, data), {}, {
        helpers: transformedHelpers
    })).replace(/[ \n\r\t\f\xA0]+/g, function(spaces) {
        return spaces.replace(/(^|\xA0+)[^\xA0]+/g, '$1 ');
    }).trim();
}

});
parcelRegister("5kjGc", function(module, exports) {
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ // This file is for use with Node.js. See dist/ for browser files.

var $hIbdi = parcelRequire("hIbdi");

$hIbdi.Template = (parcelRequire("lzxll")).Template;
$hIbdi.template = $hIbdi.Template;
module.exports = $hIbdi;

});
parcelRegister("hIbdi", function(module, exports) {
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ (function(Hogan) {
    // Setup regex  assignments
    // remove whitespace according to Mustache spec
    var rIsWhitespace = /\S/, rQuot = /\"/g, rNewline = /\n/g, rCr = /\r/g, rSlash = /\\/g, rLineSep = /\u2028/, rParagraphSep = /\u2029/;
    Hogan.tags = {
        '#': 1,
        '^': 2,
        '<': 3,
        '$': 4,
        '/': 5,
        '!': 6,
        '>': 7,
        '=': 8,
        '_v': 9,
        '{': 10,
        '&': 11,
        '_t': 12
    };
    Hogan.scan = function scan(text, delimiters) {
        var len = text.length, IN_TEXT = 0, IN_TAG_TYPE = 1, IN_TAG = 2, state = IN_TEXT, tagType = null, tag = null, buf = '', tokens = [], seenTag = false, i = 0, lineStart = 0, otag = '{{', ctag = '}}';
        function addBuf() {
            if (buf.length > 0) {
                tokens.push({
                    tag: '_t',
                    text: new String(buf)
                });
                buf = '';
            }
        }
        function lineIsWhitespace() {
            var isAllWhitespace = true;
            for(var j = lineStart; j < tokens.length; j++){
                isAllWhitespace = Hogan.tags[tokens[j].tag] < Hogan.tags['_v'] || tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null;
                if (!isAllWhitespace) return false;
            }
            return isAllWhitespace;
        }
        function filterLine(haveSeenTag, noNewLine) {
            addBuf();
            if (haveSeenTag && lineIsWhitespace()) {
                for(var j = lineStart, next; j < tokens.length; j++)if (tokens[j].text) {
                    if ((next = tokens[j + 1]) && next.tag == '>') // set indent to token value
                    next.indent = tokens[j].text.toString();
                    tokens.splice(j, 1);
                }
            } else if (!noNewLine) tokens.push({
                tag: '\n'
            });
            seenTag = false;
            lineStart = tokens.length;
        }
        function changeDelimiters(text, index) {
            var close = '=' + ctag, closeIndex = text.indexOf(close, index), delimiters = trim(text.substring(text.indexOf('=', index) + 1, closeIndex)).split(' ');
            otag = delimiters[0];
            ctag = delimiters[delimiters.length - 1];
            return closeIndex + close.length - 1;
        }
        if (delimiters) {
            delimiters = delimiters.split(' ');
            otag = delimiters[0];
            ctag = delimiters[1];
        }
        for(i = 0; i < len; i++){
            if (state == IN_TEXT) {
                if (tagChange(otag, text, i)) {
                    --i;
                    addBuf();
                    state = IN_TAG_TYPE;
                } else if (text.charAt(i) == '\n') filterLine(seenTag);
                else buf += text.charAt(i);
            } else if (state == IN_TAG_TYPE) {
                i += otag.length - 1;
                tag = Hogan.tags[text.charAt(i + 1)];
                tagType = tag ? text.charAt(i + 1) : '_v';
                if (tagType == '=') {
                    i = changeDelimiters(text, i);
                    state = IN_TEXT;
                } else {
                    if (tag) i++;
                    state = IN_TAG;
                }
                seenTag = i;
            } else if (tagChange(ctag, text, i)) {
                tokens.push({
                    tag: tagType,
                    n: trim(buf),
                    otag: otag,
                    ctag: ctag,
                    i: tagType == '/' ? seenTag - otag.length : i + ctag.length
                });
                buf = '';
                i += ctag.length - 1;
                state = IN_TEXT;
                if (tagType == '{') {
                    if (ctag == '}}') i++;
                    else cleanTripleStache(tokens[tokens.length - 1]);
                }
            } else buf += text.charAt(i);
        }
        filterLine(seenTag, true);
        return tokens;
    };
    function cleanTripleStache(token) {
        if (token.n.substr(token.n.length - 1) === '}') token.n = token.n.substring(0, token.n.length - 1);
    }
    function trim(s) {
        if (s.trim) return s.trim();
        return s.replace(/^\s*|\s*$/g, '');
    }
    function tagChange(tag, text, index) {
        if (text.charAt(index) != tag.charAt(0)) return false;
        for(var i = 1, l = tag.length; i < l; i++){
            if (text.charAt(index + i) != tag.charAt(i)) return false;
        }
        return true;
    }
    // the tags allowed inside super templates
    var allowedInSuper = {
        '_t': true,
        '\n': true,
        '$': true,
        '/': true
    };
    function buildTree(tokens, kind, stack, customTags) {
        var instructions = [], opener = null, tail = null, token = null;
        tail = stack[stack.length - 1];
        while(tokens.length > 0){
            token = tokens.shift();
            if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) throw new Error('Illegal content in < super tag.');
            if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
                stack.push(token);
                token.nodes = buildTree(tokens, token.tag, stack, customTags);
            } else if (token.tag == '/') {
                if (stack.length === 0) throw new Error('Closing tag without opener: /' + token.n);
                opener = stack.pop();
                if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
                opener.end = token.i;
                return instructions;
            } else if (token.tag == '\n') token.last = tokens.length == 0 || tokens[0].tag == '\n';
            instructions.push(token);
        }
        if (stack.length > 0) throw new Error('missing closing tag: ' + stack.pop().n);
        return instructions;
    }
    function isOpener(token, tags) {
        for(var i = 0, l = tags.length; i < l; i++)if (tags[i].o == token.n) {
            token.tag = '#';
            return true;
        }
    }
    function isCloser(close, open, tags) {
        for(var i = 0, l = tags.length; i < l; i++){
            if (tags[i].c == close && tags[i].o == open) return true;
        }
    }
    function stringifySubstitutions(obj) {
        var items = [];
        for(var key in obj)items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
        return "{ " + items.join(",") + " }";
    }
    function stringifyPartials(codeObj) {
        var partials = [];
        for(var key in codeObj.partials)partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
        return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
    }
    Hogan.stringify = function(codeObj, text, options) {
        return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) + "}";
    };
    var serialNo = 0;
    Hogan.generate = function(tree, text, options) {
        serialNo = 0;
        var context = {
            code: '',
            subs: {},
            partials: {}
        };
        Hogan.walk(tree, context);
        if (options.asString) return this.stringify(context, text, options);
        return this.makeTemplate(context, text, options);
    };
    Hogan.wrapMain = function(code) {
        return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
    };
    Hogan.template = Hogan.Template;
    Hogan.makeTemplate = function(codeObj, text, options) {
        var template = this.makePartials(codeObj);
        template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
        return new this.template(template, text, this, options);
    };
    Hogan.makePartials = function(codeObj) {
        var key, template = {
            subs: {},
            partials: codeObj.partials,
            name: codeObj.name
        };
        for(key in template.partials)template.partials[key] = this.makePartials(template.partials[key]);
        for(key in codeObj.subs)template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
        return template;
    };
    function esc(s) {
        return s.replace(rSlash, '\\\\').replace(rQuot, '\\\"').replace(rNewline, '\\n').replace(rCr, '\\r').replace(rLineSep, '\\u2028').replace(rParagraphSep, '\\u2029');
    }
    function chooseMethod(s) {
        return ~s.indexOf('.') ? 'd' : 'f';
    }
    function createPartial(node, context) {
        var prefix = "<" + (context.prefix || "");
        var sym = prefix + node.n + serialNo++;
        context.partials[sym] = {
            name: node.n,
            partials: {}
        };
        context.code += 't.b(t.rp("' + esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
        return sym;
    }
    Hogan.codegen = {
        '#': function(node, context) {
            context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' + 'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' + 't.rs(c,p,' + 'function(c,p,t){';
            Hogan.walk(node.nodes, context);
            context.code += '});c.pop();}';
        },
        '^': function(node, context) {
            context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
            Hogan.walk(node.nodes, context);
            context.code += '};';
        },
        '>': createPartial,
        '<': function(node, context) {
            var ctx = {
                partials: {},
                code: '',
                subs: {},
                inPartial: true
            };
            Hogan.walk(node.nodes, ctx);
            var template = context.partials[createPartial(node, context)];
            template.subs = ctx.subs;
            template.partials = ctx.partials;
        },
        '$': function(node, context) {
            var ctx = {
                subs: {},
                code: '',
                partials: context.partials,
                prefix: node.n
            };
            Hogan.walk(node.nodes, ctx);
            context.subs[node.n] = ctx.code;
            if (!context.inPartial) context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
        },
        '\n': function(node, context) {
            context.code += write('"\\n"' + (node.last ? '' : ' + i'));
        },
        '_v': function(node, context) {
            context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
        },
        '_t': function(node, context) {
            context.code += write('"' + esc(node.text) + '"');
        },
        '{': tripleStache,
        '&': tripleStache
    };
    function tripleStache(node, context) {
        context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    }
    function write(s) {
        return 't.b(' + s + ');';
    }
    Hogan.walk = function(nodelist, context) {
        var func;
        for(var i = 0, l = nodelist.length; i < l; i++){
            func = Hogan.codegen[nodelist[i].tag];
            func && func(nodelist[i], context);
        }
        return context;
    };
    Hogan.parse = function(tokens, text, options) {
        options = options || {};
        return buildTree(tokens, '', [], options.sectionTags || []);
    };
    Hogan.cache = {};
    Hogan.cacheKey = function(text, options) {
        return [
            text,
            !!options.asString,
            !!options.disableLambda,
            options.delimiters,
            !!options.modelGet
        ].join('||');
    };
    Hogan.compile = function(text, options) {
        options = options || {};
        var key = Hogan.cacheKey(text, options);
        var template = this.cache[key];
        if (template) {
            var partials = template.partials;
            for(var name in partials)delete partials[name].instance;
            return template;
        }
        template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
        return this.cache[key] = template;
    };
})(module.exports);

});

parcelRegister("lzxll", function(module, exports) {
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ var $fb46bb264166effc$var$Hogan = {};
(function(Hogan) {
    Hogan.Template = function(codeObj, text, compiler, options) {
        codeObj = codeObj || {};
        this.r = codeObj.code || this.r;
        this.c = compiler;
        this.options = options || {};
        this.text = text || '';
        this.partials = codeObj.partials || {};
        this.subs = codeObj.subs || {};
        this.buf = '';
    };
    Hogan.Template.prototype = {
        // render: replaced by generated code.
        r: function(context, partials, indent) {
            return '';
        },
        // variable escaping
        v: hoganEscape,
        // triple stache
        t: coerceToString,
        render: function render(context, partials, indent) {
            return this.ri([
                context
            ], partials || {}, indent);
        },
        // render internal -- a hook for overrides that catches partials too
        ri: function(context, partials, indent) {
            return this.r(context, partials, indent);
        },
        // ensurePartial
        ep: function(symbol, partials) {
            var partial = this.partials[symbol];
            // check to see that if we've instantiated this partial before
            var template = partials[partial.name];
            if (partial.instance && partial.base == template) return partial.instance;
            if (typeof template == 'string') {
                if (!this.c) throw new Error("No compiler available.");
                template = this.c.compile(template, this.options);
            }
            if (!template) return null;
            // We use this to check whether the partials dictionary has changed
            this.partials[symbol].base = template;
            if (partial.subs) {
                // Make sure we consider parent template now
                if (!partials.stackText) partials.stackText = {};
                for(key in partial.subs)if (!partials.stackText[key]) partials.stackText[key] = this.activeSub !== undefined && partials.stackText[this.activeSub] ? partials.stackText[this.activeSub] : this.text;
                template = createSpecializedPartial(template, partial.subs, partial.partials, this.stackSubs, this.stackPartials, partials.stackText);
            }
            this.partials[symbol].instance = template;
            return template;
        },
        // tries to find a partial in the current scope and render it
        rp: function(symbol, context, partials, indent) {
            var partial = this.ep(symbol, partials);
            if (!partial) return '';
            return partial.ri(context, partials, indent);
        },
        // render a section
        rs: function(context, partials, section) {
            var tail = context[context.length - 1];
            if (!isArray(tail)) {
                section(context, partials, this);
                return;
            }
            for(var i = 0; i < tail.length; i++){
                context.push(tail[i]);
                section(context, partials, this);
                context.pop();
            }
        },
        // maybe start a section
        s: function(val, ctx, partials, inverted, start, end, tags) {
            var pass;
            if (isArray(val) && val.length === 0) return false;
            if (typeof val == 'function') val = this.ms(val, ctx, partials, inverted, start, end, tags);
            pass = !!val;
            if (!inverted && pass && ctx) ctx.push(typeof val == 'object' ? val : ctx[ctx.length - 1]);
            return pass;
        },
        // find values with dotted names
        d: function(key1, ctx, partials, returnFound) {
            var found, names = key1.split('.'), val = this.f(names[0], ctx, partials, returnFound), doModelGet = this.options.modelGet, cx = null;
            if (key1 === '.' && isArray(ctx[ctx.length - 2])) val = ctx[ctx.length - 1];
            else for(var i = 1; i < names.length; i++){
                found = findInScope(names[i], val, doModelGet);
                if (found !== undefined) {
                    cx = val;
                    val = found;
                } else val = '';
            }
            if (returnFound && !val) return false;
            if (!returnFound && typeof val == 'function') {
                ctx.push(cx);
                val = this.mv(val, ctx, partials);
                ctx.pop();
            }
            return val;
        },
        // find values with normal names
        f: function(key1, ctx, partials, returnFound) {
            var val = false, v = null, found = false, doModelGet = this.options.modelGet;
            for(var i = ctx.length - 1; i >= 0; i--){
                v = ctx[i];
                val = findInScope(key1, v, doModelGet);
                if (val !== undefined) {
                    found = true;
                    break;
                }
            }
            if (!found) return returnFound ? false : "";
            if (!returnFound && typeof val == 'function') val = this.mv(val, ctx, partials);
            return val;
        },
        // higher order templates
        ls: function(func, cx, partials, text, tags) {
            var oldTags = this.options.delimiters;
            this.options.delimiters = tags;
            this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
            this.options.delimiters = oldTags;
            return false;
        },
        // compile text
        ct: function(text, cx, partials) {
            if (this.options.disableLambda) throw new Error('Lambda features disabled.');
            return this.c.compile(text, this.options).render(cx, partials);
        },
        // template result buffering
        b: function(s) {
            this.buf += s;
        },
        fl: function() {
            var r = this.buf;
            this.buf = '';
            return r;
        },
        // method replace section
        ms: function(func, ctx, partials, inverted, start, end, tags) {
            var textSource, cx = ctx[ctx.length - 1], result = func.call(cx);
            if (typeof result == 'function') {
                if (inverted) return true;
                else {
                    textSource = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text;
                    return this.ls(result, cx, partials, textSource.substring(start, end), tags);
                }
            }
            return result;
        },
        // method replace variable
        mv: function(func, ctx, partials) {
            var cx = ctx[ctx.length - 1];
            var result = func.call(cx);
            if (typeof result == 'function') return this.ct(coerceToString(result.call(cx)), cx, partials);
            return result;
        },
        sub: function(name, context, partials, indent) {
            var f = this.subs[name];
            if (f) {
                this.activeSub = name;
                f(context, partials, this, indent);
                this.activeSub = false;
            }
        }
    };
    //Find a key in an object
    function findInScope(key1, scope, doModelGet) {
        var val;
        if (scope && typeof scope == 'object') {
            if (scope[key1] !== undefined) val = scope[key1];
            else if (doModelGet && scope.get && typeof scope.get == 'function') val = scope.get(key1);
        }
        return val;
    }
    function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
        function PartialTemplate() {}
        PartialTemplate.prototype = instance;
        function Substitutions() {}
        Substitutions.prototype = instance.subs;
        var key1;
        var partial = new PartialTemplate();
        partial.subs = new Substitutions();
        partial.subsText = {}; //hehe. substext.
        partial.buf = '';
        stackSubs = stackSubs || {};
        partial.stackSubs = stackSubs;
        partial.subsText = stackText;
        for(key1 in subs)if (!stackSubs[key1]) stackSubs[key1] = subs[key1];
        for(key1 in stackSubs)partial.subs[key1] = stackSubs[key1];
        stackPartials = stackPartials || {};
        partial.stackPartials = stackPartials;
        for(key1 in partials)if (!stackPartials[key1]) stackPartials[key1] = partials[key1];
        for(key1 in stackPartials)partial.partials[key1] = stackPartials[key1];
        return partial;
    }
    var rAmp = /&/g, rLt = /</g, rGt = />/g, rApos = /\'/g, rQuot = /\"/g, hChars = /[&<>\"\']/;
    function coerceToString(val) {
        return String(val === null || val === undefined ? '' : val);
    }
    function hoganEscape(str) {
        str = coerceToString(str);
        return hChars.test(str) ? str.replace(rAmp, '&amp;').replace(rLt, '&lt;').replace(rGt, '&gt;').replace(rApos, '&#39;').replace(rQuot, '&quot;') : str;
    }
    var isArray = Array.isArray || function(a) {
        return Object.prototype.toString.call(a) === '[object Array]';
    };
})(module.exports);

});


parcelRegister("cf9aJ", function(module, exports) {

$parcel$export(module.exports, "html", function () { return $8e9e001f6d0682dc$export$c0bb0b647f701bb5; });

var $lLkqw = parcelRequire("lLkqw");

var $1QkQc = parcelRequire("1QkQc");
var $8e9e001f6d0682dc$export$c0bb0b647f701bb5 = (0, $1QkQc.default).bind((0, $lLkqw.h));

});
parcelRegister("1QkQc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $157ad057cfb614b8$export$2e2bcd8739ae039; });
var $157ad057cfb614b8$var$n = function(t, s, r, e) {
    var u;
    s[0] = 0;
    for(var h = 1; h < s.length; h++){
        var p = s[h++], a = s[h] ? (s[0] |= p ? 1 : 2, r[s[h++]]) : s[++h];
        3 === p ? e[0] = a : 4 === p ? e[1] = Object.assign(e[1] || {}, a) : 5 === p ? (e[1] = e[1] || {})[s[++h]] = a : 6 === p ? e[1][s[++h]] += a + "" : p ? (u = t.apply(a, $157ad057cfb614b8$var$n(t, a, r, [
            "",
            null
        ])), e.push(u), a[0] ? s[0] |= 2 : (s[h - 2] = 0, s[h] = u)) : e.push(a);
    }
    return e;
}, $157ad057cfb614b8$var$t = new Map;
function $157ad057cfb614b8$export$2e2bcd8739ae039(s) {
    var r = $157ad057cfb614b8$var$t.get(this);
    return r || (r = new Map, $157ad057cfb614b8$var$t.set(this, r)), (r = $157ad057cfb614b8$var$n(this, r.get(s) || (r.set(s, r = function(n) {
        for(var t, s, r = 1, e = "", u = "", h = [
            0
        ], p = function(n) {
            1 === r && (n || (e = e.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? h.push(0, n, e) : 3 === r && (n || e) ? (h.push(3, n, e), r = 2) : 2 === r && "..." === e && n ? h.push(4, n, 0) : 2 === r && e && !n ? h.push(5, 0, !0, e) : r >= 5 && ((e || !n && 5 === r) && (h.push(r, 0, e, s), r = 6), n && (h.push(r, n, 0, s), r = 6)), e = "";
        }, a = 0; a < n.length; a++){
            a && (1 === r && p(), p(a));
            for(var l = 0; l < n[a].length; l++)t = n[a][l], 1 === r ? "<" === t ? (p(), h = [
                h
            ], r = 3) : e += t : 4 === r ? "--" === e && ">" === t ? (r = 1, e = "") : e = t + e[0] : u ? t === u ? u = "" : e += t : '"' === t || "'" === t ? u = t : ">" === t ? (p(), r = 1) : r && ("=" === t ? (r = 5, s = e, e = "") : "/" === t && (r < 5 || ">" === n[a][l + 1]) ? (p(), 3 === r && (h = h[0]), r = h, (h = h[0]).push(2, 0, r), r = 0) : " " === t || "\t" === t || "\n" === t || "\r" === t ? (p(), r = 2) : e += t), 3 === r && "!--" === e && (r = 4, h = h[0]);
        }
        return p(), h;
    }(s)), r), arguments, [])).length > 1 ? r : r[0];
}

});


parcelRegister("8MXxg", function(module, exports) {

$parcel$export(module.exports, "Highlight", function () { return $6660fceebee62fdd$export$39dbc3f558091353; });

var $lLkqw = parcelRequire("lLkqw");

var $hzJtF = parcelRequire("hzJtF");

var $Vh0Bs = parcelRequire("Vh0Bs");
var $jVXiW = parcelRequire("jVXiW");
var $4vPeB = parcelRequire("4vPeB");
var $lxPA4 = parcelRequire("lxPA4");
var $6660fceebee62fdd$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
];
function $6660fceebee62fdd$var$_extends() {
    $6660fceebee62fdd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6660fceebee62fdd$var$_extends.apply(this, arguments);
}
function $6660fceebee62fdd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6660fceebee62fdd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6660fceebee62fdd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6660fceebee62fdd$export$39dbc3f558091353(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $6660fceebee62fdd$var$_objectWithoutProperties(_ref, $6660fceebee62fdd$var$_excluded);
    var property = (0, $jVXiW.getPropertyByPath)(hit._highlightResult, attribute) || [];
    var properties = (0, $4vPeB.toArray)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $Vh0Bs.getHighlightedParts)((0, $lxPA4.unescape)(value || ''));
    });
    return (0, $lLkqw.h)((0, $hzJtF.Highlight), $6660fceebee62fdd$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}

});
parcelRegister("hzJtF", function(module, exports) {

$parcel$export(module.exports, "Highlight", function () { return $ccb8fb709b03746d$export$39dbc3f558091353; });

var $5bown = parcelRequire("5bown");

var $lLkqw = parcelRequire("lLkqw");

var $5E6yU = parcelRequire("5E6yU");
var $ccb8fb709b03746d$var$_excluded = [
    "classNames"
];
function $ccb8fb709b03746d$var$_extends() {
    $ccb8fb709b03746d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ccb8fb709b03746d$var$_extends.apply(this, arguments);
}
function $ccb8fb709b03746d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ccb8fb709b03746d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ccb8fb709b03746d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ccb8fb709b03746d$export$39dbc3f558091353(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $ccb8fb709b03746d$var$_objectWithoutProperties(_ref, $ccb8fb709b03746d$var$_excluded);
    return (0, $lLkqw.h)((0, $5E6yU.InternalHighlight), $ccb8fb709b03746d$var$_extends({
        classNames: {
            root: (0, $5bown.cx)('ais-Highlight', classNames.root),
            highlighted: (0, $5bown.cx)('ais-Highlight-highlighted', classNames.highlighted),
            nonHighlighted: (0, $5bown.cx)('ais-Highlight-nonHighlighted', classNames.nonHighlighted),
            separator: (0, $5bown.cx)('ais-Highlight-separator', classNames.separator)
        }
    }, props));
}

});
parcelRegister("5E6yU", function(module, exports) {

$parcel$export(module.exports, "InternalHighlight", function () { return $41c5c7414ee04c2b$export$57a0c6fc80bec05c; });

var $sJqhZ = parcelRequire("sJqhZ");

var $lLkqw = parcelRequire("lLkqw");
var $41c5c7414ee04c2b$export$57a0c6fc80bec05c = (0, $sJqhZ.createHighlightComponent)({
    createElement: (0, $lLkqw.createElement),
    Fragment: (0, $lLkqw.Fragment)
});

});
parcelRegister("sJqhZ", function(module, exports) {

$parcel$export(module.exports, "createHighlightComponent", function () { return $0565d9b48d4b408c$export$c8682df1c852a966; });

var $cdZIk = parcelRequire("cdZIk");

var $446jn = parcelRequire("446jn");

var $5bown = parcelRequire("5bown");
var $0565d9b48d4b408c$var$_excluded = [
    "parts",
    "highlightedTagName",
    "nonHighlightedTagName",
    "separator",
    "className",
    "classNames"
];
function $0565d9b48d4b408c$var$createHighlightPartComponent(_ref) {
    var createElement = _ref.createElement;
    return function HighlightPart(_ref2) {
        var classNames = _ref2.classNames, children = _ref2.children, highlightedTagName = _ref2.highlightedTagName, isHighlighted = _ref2.isHighlighted, nonHighlightedTagName = _ref2.nonHighlightedTagName;
        var TagName = isHighlighted ? highlightedTagName : nonHighlightedTagName;
        return createElement(TagName, {
            className: isHighlighted ? classNames.highlighted : classNames.nonHighlighted
        }, children);
    };
}
function $0565d9b48d4b408c$export$c8682df1c852a966(_ref3) {
    var createElement = _ref3.createElement, Fragment = _ref3.Fragment;
    var HighlightPart = $0565d9b48d4b408c$var$createHighlightPartComponent({
        createElement: createElement,
        Fragment: Fragment
    });
    return function Highlight(userProps) {
        var parts = userProps.parts, _userProps$highlighte = userProps.highlightedTagName, highlightedTagName = _userProps$highlighte === void 0 ? 'mark' : _userProps$highlighte, _userProps$nonHighlig = userProps.nonHighlightedTagName, nonHighlightedTagName = _userProps$nonHighlig === void 0 ? 'span' : _userProps$nonHighlig, _userProps$separator = userProps.separator, separator = _userProps$separator === void 0 ? ', ' : _userProps$separator, className = userProps.className, _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, props = (0, (/*@__PURE__*/$parcel$interopDefault($446jn)))(userProps, $0565d9b48d4b408c$var$_excluded);
        return createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($cdZIk)))({}, props, {
            className: (0, $5bown.cx)(classNames.root, className)
        }), parts.map(function(part, partIndex) {
            var isLastPart = partIndex === parts.length - 1;
            return createElement(Fragment, {
                key: partIndex
            }, part.map(function(subPart, subPartIndex) {
                return createElement(HighlightPart, {
                    key: subPartIndex,
                    classNames: classNames,
                    highlightedTagName: highlightedTagName,
                    nonHighlightedTagName: nonHighlightedTagName,
                    isHighlighted: subPart.isHighlighted
                }, subPart.value);
            }), !isLastPart && createElement("span", {
                className: classNames.separator
            }, separator));
        }));
    };
}

});
parcelRegister("cdZIk", function(module, exports) {
function $8e669211069449a2$var$_extends() {
    module.exports = $8e669211069449a2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $8e669211069449a2$var$_extends.apply(this, arguments);
}
module.exports = $8e669211069449a2$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("446jn", function(module, exports) {

var $bs2Nw = parcelRequire("bs2Nw");
function $2f5c6e75d911a5a4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bs2Nw(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = $2f5c6e75d911a5a4$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bs2Nw", function(module, exports) {
function $85647ad061544123$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $85647ad061544123$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("4vPeB", function(module, exports) {

$parcel$export(module.exports, "toArray", function () { return $3491ccc71ef394eb$export$45b10814cc054894; });
function $3491ccc71ef394eb$export$45b10814cc054894(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}

});


parcelRegister("gkedx", function(module, exports) {

$parcel$export(module.exports, "ReverseHighlight", function () { return $be298ad94c6a1da1$export$f346643e8570b662; });

var $lLkqw = parcelRequire("lLkqw");

var $37OBo = parcelRequire("37OBo");

var $Vh0Bs = parcelRequire("Vh0Bs");
var $jVXiW = parcelRequire("jVXiW");
var $4vPeB = parcelRequire("4vPeB");
var $lxPA4 = parcelRequire("lxPA4");
function $be298ad94c6a1da1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $be298ad94c6a1da1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $be298ad94c6a1da1$var$_typeof(obj);
}
var $be298ad94c6a1da1$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
], $be298ad94c6a1da1$var$_excluded2 = [
    "isHighlighted"
];
function $be298ad94c6a1da1$var$_extends() {
    $be298ad94c6a1da1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $be298ad94c6a1da1$var$_extends.apply(this, arguments);
}
function $be298ad94c6a1da1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $be298ad94c6a1da1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $be298ad94c6a1da1$var$ownKeys(Object(source), !0).forEach(function(key) {
            $be298ad94c6a1da1$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $be298ad94c6a1da1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $be298ad94c6a1da1$var$_defineProperty(obj, key, value) {
    key = $be298ad94c6a1da1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $be298ad94c6a1da1$var$_toPropertyKey(arg) {
    var key = $be298ad94c6a1da1$var$_toPrimitive(arg, "string");
    return $be298ad94c6a1da1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $be298ad94c6a1da1$var$_toPrimitive(input, hint) {
    if ($be298ad94c6a1da1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($be298ad94c6a1da1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $be298ad94c6a1da1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $be298ad94c6a1da1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $be298ad94c6a1da1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $be298ad94c6a1da1$export$f346643e8570b662(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $be298ad94c6a1da1$var$_objectWithoutProperties(_ref, $be298ad94c6a1da1$var$_excluded);
    var property = (0, $jVXiW.getPropertyByPath)(hit._highlightResult, attribute) || [];
    var properties = (0, $4vPeB.toArray)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $Vh0Bs.getHighlightedParts)((0, $lxPA4.unescape)(value || '')).map(function(_ref3) {
            var isHighlighted = _ref3.isHighlighted, rest = $be298ad94c6a1da1$var$_objectWithoutProperties(_ref3, $be298ad94c6a1da1$var$_excluded2);
            return $be298ad94c6a1da1$var$_objectSpread($be298ad94c6a1da1$var$_objectSpread({}, rest), {}, {
                isHighlighted: !isHighlighted
            });
        });
    });
    return (0, $lLkqw.h)((0, $37OBo.ReverseHighlight), $be298ad94c6a1da1$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}

});
parcelRegister("37OBo", function(module, exports) {

$parcel$export(module.exports, "ReverseHighlight", function () { return $2469470ec5900538$export$f346643e8570b662; });

var $5bown = parcelRequire("5bown");

var $lLkqw = parcelRequire("lLkqw");

var $5E6yU = parcelRequire("5E6yU");
var $2469470ec5900538$var$_excluded = [
    "classNames"
];
function $2469470ec5900538$var$_extends() {
    $2469470ec5900538$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2469470ec5900538$var$_extends.apply(this, arguments);
}
function $2469470ec5900538$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2469470ec5900538$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2469470ec5900538$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2469470ec5900538$export$f346643e8570b662(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $2469470ec5900538$var$_objectWithoutProperties(_ref, $2469470ec5900538$var$_excluded);
    return (0, $lLkqw.h)((0, $5E6yU.InternalHighlight), $2469470ec5900538$var$_extends({
        classNames: {
            root: (0, $5bown.cx)('ais-ReverseHighlight', classNames.root),
            highlighted: (0, $5bown.cx)('ais-ReverseHighlight-highlighted', classNames.highlighted),
            nonHighlighted: (0, $5bown.cx)('ais-ReverseHighlight-nonHighlighted', classNames.nonHighlighted),
            separator: (0, $5bown.cx)('ais-ReverseHighlight-separator', classNames.separator)
        }
    }, props));
}

});


parcelRegister("jhbUA", function(module, exports) {

$parcel$export(module.exports, "ReverseSnippet", function () { return $e088d83d68cb20fd$export$235f9e0721ad46fa; });

var $lLkqw = parcelRequire("lLkqw");

var $cOnZO = parcelRequire("cOnZO");

var $Vh0Bs = parcelRequire("Vh0Bs");
var $jVXiW = parcelRequire("jVXiW");
var $4vPeB = parcelRequire("4vPeB");
var $lxPA4 = parcelRequire("lxPA4");
function $e088d83d68cb20fd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e088d83d68cb20fd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e088d83d68cb20fd$var$_typeof(obj);
}
var $e088d83d68cb20fd$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
], $e088d83d68cb20fd$var$_excluded2 = [
    "isHighlighted"
];
function $e088d83d68cb20fd$var$_extends() {
    $e088d83d68cb20fd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e088d83d68cb20fd$var$_extends.apply(this, arguments);
}
function $e088d83d68cb20fd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e088d83d68cb20fd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e088d83d68cb20fd$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e088d83d68cb20fd$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e088d83d68cb20fd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e088d83d68cb20fd$var$_defineProperty(obj, key, value) {
    key = $e088d83d68cb20fd$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e088d83d68cb20fd$var$_toPropertyKey(arg) {
    var key = $e088d83d68cb20fd$var$_toPrimitive(arg, "string");
    return $e088d83d68cb20fd$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e088d83d68cb20fd$var$_toPrimitive(input, hint) {
    if ($e088d83d68cb20fd$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e088d83d68cb20fd$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e088d83d68cb20fd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e088d83d68cb20fd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e088d83d68cb20fd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e088d83d68cb20fd$export$235f9e0721ad46fa(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $e088d83d68cb20fd$var$_objectWithoutProperties(_ref, $e088d83d68cb20fd$var$_excluded);
    var property = (0, $jVXiW.getPropertyByPath)(hit._snippetResult, attribute) || [];
    var properties = (0, $4vPeB.toArray)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $Vh0Bs.getHighlightedParts)((0, $lxPA4.unescape)(value || '')).map(function(_ref3) {
            var isHighlighted = _ref3.isHighlighted, rest = $e088d83d68cb20fd$var$_objectWithoutProperties(_ref3, $e088d83d68cb20fd$var$_excluded2);
            return $e088d83d68cb20fd$var$_objectSpread($e088d83d68cb20fd$var$_objectSpread({}, rest), {}, {
                isHighlighted: !isHighlighted
            });
        });
    });
    return (0, $lLkqw.h)((0, $cOnZO.ReverseSnippet), $e088d83d68cb20fd$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}

});
parcelRegister("cOnZO", function(module, exports) {

$parcel$export(module.exports, "ReverseSnippet", function () { return $953cc4ac7b073c22$export$235f9e0721ad46fa; });

var $5bown = parcelRequire("5bown");

var $lLkqw = parcelRequire("lLkqw");

var $5E6yU = parcelRequire("5E6yU");
var $953cc4ac7b073c22$var$_excluded = [
    "classNames"
];
function $953cc4ac7b073c22$var$_extends() {
    $953cc4ac7b073c22$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $953cc4ac7b073c22$var$_extends.apply(this, arguments);
}
function $953cc4ac7b073c22$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $953cc4ac7b073c22$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $953cc4ac7b073c22$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $953cc4ac7b073c22$export$235f9e0721ad46fa(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $953cc4ac7b073c22$var$_objectWithoutProperties(_ref, $953cc4ac7b073c22$var$_excluded);
    return (0, $lLkqw.h)((0, $5E6yU.InternalHighlight), $953cc4ac7b073c22$var$_extends({
        classNames: {
            root: (0, $5bown.cx)('ais-ReverseSnippet', classNames.root),
            highlighted: (0, $5bown.cx)('ais-ReverseSnippet-highlighted', classNames.highlighted),
            nonHighlighted: (0, $5bown.cx)('ais-ReverseSnippet-nonHighlighted', classNames.nonHighlighted),
            separator: (0, $5bown.cx)('ais-ReverseSnippet-separator', classNames.separator)
        }
    }, props));
}

});


parcelRegister("etXmt", function(module, exports) {

$parcel$export(module.exports, "Snippet", function () { return $a8b1d216499a4f88$export$10c56fa12fda26f9; });

var $lLkqw = parcelRequire("lLkqw");

var $eDpEy = parcelRequire("eDpEy");

var $Vh0Bs = parcelRequire("Vh0Bs");
var $jVXiW = parcelRequire("jVXiW");
var $4vPeB = parcelRequire("4vPeB");
var $lxPA4 = parcelRequire("lxPA4");
var $a8b1d216499a4f88$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
];
function $a8b1d216499a4f88$var$_extends() {
    $a8b1d216499a4f88$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a8b1d216499a4f88$var$_extends.apply(this, arguments);
}
function $a8b1d216499a4f88$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a8b1d216499a4f88$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a8b1d216499a4f88$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a8b1d216499a4f88$export$10c56fa12fda26f9(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $a8b1d216499a4f88$var$_objectWithoutProperties(_ref, $a8b1d216499a4f88$var$_excluded);
    var property = (0, $jVXiW.getPropertyByPath)(hit._snippetResult, attribute) || [];
    var properties = (0, $4vPeB.toArray)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $Vh0Bs.getHighlightedParts)((0, $lxPA4.unescape)(value || ''));
    });
    return (0, $lLkqw.h)((0, $eDpEy.Snippet), $a8b1d216499a4f88$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}

});
parcelRegister("eDpEy", function(module, exports) {

$parcel$export(module.exports, "Snippet", function () { return $aa789b60b57ed382$export$10c56fa12fda26f9; });

var $5bown = parcelRequire("5bown");

var $lLkqw = parcelRequire("lLkqw");

var $5E6yU = parcelRequire("5E6yU");
var $aa789b60b57ed382$var$_excluded = [
    "classNames"
];
function $aa789b60b57ed382$var$_extends() {
    $aa789b60b57ed382$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aa789b60b57ed382$var$_extends.apply(this, arguments);
}
function $aa789b60b57ed382$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $aa789b60b57ed382$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $aa789b60b57ed382$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $aa789b60b57ed382$export$10c56fa12fda26f9(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $aa789b60b57ed382$var$_objectWithoutProperties(_ref, $aa789b60b57ed382$var$_excluded);
    return (0, $lLkqw.h)((0, $5E6yU.InternalHighlight), $aa789b60b57ed382$var$_extends({
        classNames: {
            root: (0, $5bown.cx)('ais-Snippet', classNames.root),
            highlighted: (0, $5bown.cx)('ais-Snippet-highlighted', classNames.highlighted),
            nonHighlighted: (0, $5bown.cx)('ais-Snippet-nonHighlighted', classNames.nonHighlighted),
            separator: (0, $5bown.cx)('ais-Snippet-separator', classNames.separator)
        }
    }, props));
}

});





parcelRegister("9oCq8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d74287a4e18bc0f$export$2e2bcd8739ae039; });

var $eYjvp = parcelRequire("eYjvp");
var $lkA4u = parcelRequire("lkA4u");
var $6YH5z = parcelRequire("6YH5z");
var $4Tow4 = parcelRequire("4Tow4");
var $kooa4 = parcelRequire("kooa4");
var $jF7w3 = parcelRequire("jF7w3");
var $cg906 = parcelRequire("cg906");
var $fMELL = parcelRequire("fMELL");
var $jDJSV = parcelRequire("jDJSV");
function $6d74287a4e18bc0f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6d74287a4e18bc0f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6d74287a4e18bc0f$var$_typeof(obj);
}
var $6d74287a4e18bc0f$var$_excluded = [
    "page"
], $6d74287a4e18bc0f$var$_excluded2 = [
    "clickAnalytics",
    "userToken"
];
function $6d74287a4e18bc0f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6d74287a4e18bc0f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6d74287a4e18bc0f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6d74287a4e18bc0f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6d74287a4e18bc0f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6d74287a4e18bc0f$var$_defineProperty(obj, key, value) {
    key = $6d74287a4e18bc0f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6d74287a4e18bc0f$var$_toPropertyKey(arg) {
    var key = $6d74287a4e18bc0f$var$_toPrimitive(arg, "string");
    return $6d74287a4e18bc0f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6d74287a4e18bc0f$var$_toPrimitive(input, hint) {
    if ($6d74287a4e18bc0f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6d74287a4e18bc0f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6d74287a4e18bc0f$var$_toConsumableArray(arr) {
    return $6d74287a4e18bc0f$var$_arrayWithoutHoles(arr) || $6d74287a4e18bc0f$var$_iterableToArray(arr) || $6d74287a4e18bc0f$var$_unsupportedIterableToArray(arr) || $6d74287a4e18bc0f$var$_nonIterableSpread();
}
function $6d74287a4e18bc0f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6d74287a4e18bc0f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6d74287a4e18bc0f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6d74287a4e18bc0f$var$_arrayLikeToArray(o, minLen);
}
function $6d74287a4e18bc0f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $6d74287a4e18bc0f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6d74287a4e18bc0f$var$_arrayLikeToArray(arr);
}
function $6d74287a4e18bc0f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6d74287a4e18bc0f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6d74287a4e18bc0f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6d74287a4e18bc0f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $6d74287a4e18bc0f$var$withUsage = (0, $kooa4.createDocumentationMessageGenerator)({
    name: 'infinite-hits',
    connector: true
});
function $6d74287a4e18bc0f$var$getStateWithoutPage(state) {
    var _ref = state || {}, page = _ref.page, rest = $6d74287a4e18bc0f$var$_objectWithoutProperties(_ref, $6d74287a4e18bc0f$var$_excluded);
    return rest;
}
function $6d74287a4e18bc0f$var$normalizeState(state) {
    var _ref2 = state || {}, clickAnalytics = _ref2.clickAnalytics, userToken = _ref2.userToken, rest = $6d74287a4e18bc0f$var$_objectWithoutProperties(_ref2, $6d74287a4e18bc0f$var$_excluded2);
    return rest;
}
function $6d74287a4e18bc0f$var$getInMemoryCache() {
    var cachedHits = null;
    var cachedState = null;
    return {
        read: function read(_ref3) {
            var state = _ref3.state;
            return (0, $cg906.isEqual)(cachedState, $6d74287a4e18bc0f$var$getStateWithoutPage(state)) ? cachedHits : null;
        },
        write: function write(_ref4) {
            var state = _ref4.state, hits = _ref4.hits;
            cachedState = $6d74287a4e18bc0f$var$getStateWithoutPage(state);
            cachedHits = hits;
        }
    };
}
function $6d74287a4e18bc0f$var$extractHitsFromCachedHits(cachedHits) {
    return Object.keys(cachedHits).map(Number).sort(function(a, b) {
        return a - b;
    }).reduce(function(acc, page) {
        return acc.concat(cachedHits[page]);
    }, []);
}
var $6d74287a4e18bc0f$export$2e2bcd8739ae039 = function connectInfiniteHits(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $fMELL.noop);
    (0, $6YH5z.checkRendering)(renderFn, $6d74287a4e18bc0f$var$withUsage());
    return function(widgetParams) {
        var _ref5 = widgetParams || {}, _ref5$escapeHTML = _ref5.escapeHTML, escapeHTML = _ref5$escapeHTML === void 0 ? true : _ref5$escapeHTML, _ref5$transformItems = _ref5.transformItems, transformItems = _ref5$transformItems === void 0 ? function(items) {
            return items;
        } : _ref5$transformItems, _ref5$cache = _ref5.cache, cache = _ref5$cache === void 0 ? $6d74287a4e18bc0f$var$getInMemoryCache() : _ref5$cache;
        var showPrevious;
        var showMore;
        var sendEvent;
        var bindEvent;
        var getFirstReceivedPage = function getFirstReceivedPage(state, cachedHits) {
            var _state$page = state.page, page = _state$page === void 0 ? 0 : _state$page;
            var pages = Object.keys(cachedHits).map(Number);
            if (pages.length === 0) return page;
            else return Math.min.apply(Math, [
                page
            ].concat($6d74287a4e18bc0f$var$_toConsumableArray(pages)));
        };
        var getLastReceivedPage = function getLastReceivedPage(state, cachedHits) {
            var _state$page2 = state.page, page = _state$page2 === void 0 ? 0 : _state$page2;
            var pages = Object.keys(cachedHits).map(Number);
            if (pages.length === 0) return page;
            else return Math.max.apply(Math, [
                page
            ].concat($6d74287a4e18bc0f$var$_toConsumableArray(pages)));
        };
        var getShowPrevious = function getShowPrevious(helper) {
            return function() {
                // Using the helper's `overrideStateWithoutTriggeringChangeEvent` method
                // avoid updating the browser URL when the user displays the previous page.
                helper.overrideStateWithoutTriggeringChangeEvent($6d74287a4e18bc0f$var$_objectSpread($6d74287a4e18bc0f$var$_objectSpread({}, helper.state), {}, {
                    page: getFirstReceivedPage(helper.state, cache.read({
                        state: $6d74287a4e18bc0f$var$normalizeState(helper.state)
                    }) || {}) - 1
                })).searchWithoutTriggeringOnStateChange();
            };
        };
        var getShowMore = function getShowMore(helper) {
            return function() {
                helper.setPage(getLastReceivedPage(helper.state, cache.read({
                    state: $6d74287a4e18bc0f$var$normalizeState(helper.state)
                }) || {}) + 1).search();
            };
        };
        return {
            $$type: 'ais.infiniteHits',
            init: function init(initOptions) {
                renderFn($6d74287a4e18bc0f$var$_objectSpread($6d74287a4e18bc0f$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                var widgetRenderState = this.getWidgetRenderState(renderOptions);
                renderFn($6d74287a4e18bc0f$var$_objectSpread($6d74287a4e18bc0f$var$_objectSpread({}, widgetRenderState), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
                sendEvent('view:internal', widgetRenderState.currentPageHits);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $6d74287a4e18bc0f$var$_objectSpread($6d74287a4e18bc0f$var$_objectSpread({}, renderState), {}, {
                    infiniteHits: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref6) {
                var _results$renderingCon, _results$renderingCon2, _results$renderingCon3;
                var results = _ref6.results, helper = _ref6.helper, parent = _ref6.parent, existingState = _ref6.state, instantSearchInstance = _ref6.instantSearchInstance;
                var isFirstPage;
                var currentPageHits = [];
                /**
         * We bail out of optimistic UI here, as the cache is based on search
         * parameters, and we don't want to invalidate the cache when the search
         * is loading.
         */ var state = parent.getPreviousState() || existingState;
                var cachedHits = cache.read({
                    state: $6d74287a4e18bc0f$var$normalizeState(state)
                }) || {};
                var banner = results === null || results === void 0 ? void 0 : (_results$renderingCon = results.renderingContent) === null || _results$renderingCon === void 0 ? void 0 : (_results$renderingCon2 = _results$renderingCon.widgets) === null || _results$renderingCon2 === void 0 ? void 0 : (_results$renderingCon3 = _results$renderingCon2.banners) === null || _results$renderingCon3 === void 0 ? void 0 : _results$renderingCon3[0];
                if (!results) {
                    showPrevious = getShowPrevious(helper);
                    showMore = getShowMore(helper);
                    sendEvent = (0, $4Tow4.createSendEventForHits)({
                        instantSearchInstance: instantSearchInstance,
                        getIndex: function getIndex() {
                            return helper.getIndex();
                        },
                        widgetType: this.$$type
                    });
                    bindEvent = (0, $4Tow4.createBindEventForHits)({
                        getIndex: function getIndex() {
                            return helper.getIndex();
                        },
                        widgetType: this.$$type,
                        instantSearchInstance: instantSearchInstance
                    });
                    isFirstPage = state.page === undefined || getFirstReceivedPage(state, cachedHits) === 0;
                } else {
                    var _state$disjunctiveFac, _state$hierarchicalFa;
                    var _state$page3 = state.page, _page = _state$page3 === void 0 ? 0 : _state$page3;
                    if (escapeHTML && results.hits.length > 0) results.hits = (0, $jF7w3.escapeHits)(results.hits);
                    var hitsWithAbsolutePosition = (0, $eYjvp.addAbsolutePosition)(results.hits, results.page, results.hitsPerPage);
                    var hitsWithAbsolutePositionAndQueryID = (0, $lkA4u.addQueryID)(hitsWithAbsolutePosition, results.queryID);
                    var transformedHits = transformItems(hitsWithAbsolutePositionAndQueryID, {
                        results: results
                    });
                    /*
            With dynamic widgets, facets are not included in the state before their relevant widgets are mounted. Until then, we need to bail out of writing this incomplete state representation in cache.
          */ var hasDynamicWidgets = false;
                    (0, $jDJSV.walkIndex)(instantSearchInstance.mainIndex, function(indexWidget) {
                        if (!hasDynamicWidgets && indexWidget.getWidgets().some(function(_ref7) {
                            var $$type = _ref7.$$type;
                            return $$type === 'ais.dynamicWidgets';
                        })) hasDynamicWidgets = true;
                    });
                    var hasNoFacets = !((_state$disjunctiveFac = state.disjunctiveFacets) !== null && _state$disjunctiveFac !== void 0 && _state$disjunctiveFac.length) && !(state.facets || []).filter(function(f) {
                        return f !== '*';
                    }).length && !((_state$hierarchicalFa = state.hierarchicalFacets) !== null && _state$hierarchicalFa !== void 0 && _state$hierarchicalFa.length);
                    if (cachedHits[_page] === undefined && !results.__isArtificial && instantSearchInstance.status === 'idle' && !(hasDynamicWidgets && hasNoFacets)) {
                        cachedHits[_page] = transformedHits;
                        cache.write({
                            state: $6d74287a4e18bc0f$var$normalizeState(state),
                            hits: cachedHits
                        });
                    }
                    currentPageHits = transformedHits;
                    isFirstPage = getFirstReceivedPage(state, cachedHits) === 0;
                }
                var items = $6d74287a4e18bc0f$var$extractHitsFromCachedHits(cachedHits);
                var isLastPage = results ? results.nbPages <= getLastReceivedPage(state, cachedHits) + 1 : true;
                return {
                    hits: items,
                    items: items,
                    currentPageHits: currentPageHits,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    banner: banner,
                    results: results || undefined,
                    showPrevious: showPrevious,
                    showMore: showMore,
                    isFirstPage: isFirstPage,
                    isLastPage: isLastPage,
                    widgetParams: widgetParams
                };
            },
            dispose: function dispose(_ref8) {
                var state = _ref8.state;
                unmountFn();
                var stateWithoutPage = state.setQueryParameter('page', undefined);
                if (!escapeHTML) return stateWithoutPage;
                return stateWithoutPage.setQueryParameters(Object.keys((0, $jF7w3.TAG_PLACEHOLDER)).reduce(function(acc, key) {
                    return $6d74287a4e18bc0f$var$_objectSpread($6d74287a4e18bc0f$var$_objectSpread({}, acc), {}, $6d74287a4e18bc0f$var$_defineProperty({}, key, undefined));
                }, {}));
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref9) {
                var searchParameters = _ref9.searchParameters;
                var page = searchParameters.page || 0;
                if (!page) // return without adding `page` to uiState
                // because we don't want `page=1` in the URL
                return uiState;
                return $6d74287a4e18bc0f$var$_objectSpread($6d74287a4e18bc0f$var$_objectSpread({}, uiState), {}, {
                    // The page in the UI state is incremented by one
                    // to expose the user value (not `0`).
                    page: page + 1
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref10) {
                var uiState = _ref10.uiState;
                var widgetSearchParameters = searchParameters;
                if (escapeHTML) // @MAJOR: set this globally, not in the InfiniteHits widget to allow InfiniteHits to be conditionally used
                widgetSearchParameters = searchParameters.setQueryParameters((0, $jF7w3.TAG_PLACEHOLDER));
                // The page in the search parameters is decremented by one
                // to get to the actual parameter value from the UI state.
                var page = uiState.page ? uiState.page - 1 : 0;
                return widgetSearchParameters.setQueryParameter('page', page);
            }
        };
    };
};

});
parcelRegister("eYjvp", function(module, exports) {

$parcel$export(module.exports, "addAbsolutePosition", function () { return $ae65ccb446b970d4$export$33d742d8ee5a4609; });
function $ae65ccb446b970d4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ae65ccb446b970d4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ae65ccb446b970d4$var$_typeof(obj);
}
function $ae65ccb446b970d4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ae65ccb446b970d4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ae65ccb446b970d4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ae65ccb446b970d4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ae65ccb446b970d4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ae65ccb446b970d4$var$_defineProperty(obj, key, value) {
    key = $ae65ccb446b970d4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ae65ccb446b970d4$var$_toPropertyKey(arg) {
    var key = $ae65ccb446b970d4$var$_toPrimitive(arg, "string");
    return $ae65ccb446b970d4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ae65ccb446b970d4$var$_toPrimitive(input, hint) {
    if ($ae65ccb446b970d4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ae65ccb446b970d4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ae65ccb446b970d4$export$33d742d8ee5a4609(hits, page, hitsPerPage) {
    return hits.map(function(hit, idx) {
        return $ae65ccb446b970d4$var$_objectSpread($ae65ccb446b970d4$var$_objectSpread({}, hit), {}, {
            __position: hitsPerPage * page + idx + 1
        });
    });
}

});

parcelRegister("lkA4u", function(module, exports) {

$parcel$export(module.exports, "addQueryID", function () { return $f877723d9b9bf320$export$b8f834386ea30952; });
function $f877723d9b9bf320$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f877723d9b9bf320$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f877723d9b9bf320$var$_typeof(obj);
}
function $f877723d9b9bf320$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f877723d9b9bf320$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f877723d9b9bf320$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f877723d9b9bf320$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f877723d9b9bf320$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f877723d9b9bf320$var$_defineProperty(obj, key, value) {
    key = $f877723d9b9bf320$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f877723d9b9bf320$var$_toPropertyKey(arg) {
    var key = $f877723d9b9bf320$var$_toPrimitive(arg, "string");
    return $f877723d9b9bf320$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f877723d9b9bf320$var$_toPrimitive(input, hint) {
    if ($f877723d9b9bf320$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f877723d9b9bf320$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f877723d9b9bf320$export$b8f834386ea30952(hits, queryID) {
    if (!queryID) return hits;
    return hits.map(function(hit) {
        return $f877723d9b9bf320$var$_objectSpread($f877723d9b9bf320$var$_objectSpread({}, hit), {}, {
            __queryID: queryID
        });
    });
}

});

parcelRegister("4Tow4", function(module, exports) {

$parcel$export(module.exports, "createSendEventForHits", function () { return $38ff50e6e26da9a2$export$4139f3a7130239e3; });
$parcel$export(module.exports, "createBindEventForHits", function () { return $38ff50e6e26da9a2$export$5a3d9973824d9b76; });

var $1ZS80 = parcelRequire("1ZS80");
function $38ff50e6e26da9a2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $38ff50e6e26da9a2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $38ff50e6e26da9a2$var$ownKeys(Object(source), !0).forEach(function(key) {
            $38ff50e6e26da9a2$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $38ff50e6e26da9a2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $38ff50e6e26da9a2$var$_defineProperty(obj, key, value) {
    key = $38ff50e6e26da9a2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $38ff50e6e26da9a2$var$_toPropertyKey(arg) {
    var key = $38ff50e6e26da9a2$var$_toPrimitive(arg, "string");
    return $38ff50e6e26da9a2$var$_typeof(key) === "symbol" ? key : String(key);
}
function $38ff50e6e26da9a2$var$_toPrimitive(input, hint) {
    if ($38ff50e6e26da9a2$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($38ff50e6e26da9a2$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $38ff50e6e26da9a2$var$_slicedToArray(arr, i) {
    return $38ff50e6e26da9a2$var$_arrayWithHoles(arr) || $38ff50e6e26da9a2$var$_iterableToArrayLimit(arr, i) || $38ff50e6e26da9a2$var$_unsupportedIterableToArray(arr, i) || $38ff50e6e26da9a2$var$_nonIterableRest();
}
function $38ff50e6e26da9a2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $38ff50e6e26da9a2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $38ff50e6e26da9a2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $38ff50e6e26da9a2$var$_arrayLikeToArray(o, minLen);
}
function $38ff50e6e26da9a2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $38ff50e6e26da9a2$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $38ff50e6e26da9a2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $38ff50e6e26da9a2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $38ff50e6e26da9a2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $38ff50e6e26da9a2$var$_typeof(obj);
}
function $38ff50e6e26da9a2$var$chunk(arr) {
    var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var chunks = [];
    for(var i = 0; i < Math.ceil(arr.length / chunkSize); i++)chunks.push(arr.slice(i * chunkSize, (i + 1) * chunkSize));
    return chunks;
}
function $38ff50e6e26da9a2$export$2f82a8f6391c6db9(_ref) {
    var getIndex = _ref.getIndex, widgetType = _ref.widgetType, methodName = _ref.methodName, args = _ref.args, instantSearchInstance = _ref.instantSearchInstance;
    // when there's only one argument, that means it's custom
    if (args.length === 1 && $38ff50e6e26da9a2$var$_typeof(args[0]) === 'object') return [
        args[0]
    ];
    var _args$0$split = args[0].split(':'), _args$0$split2 = $38ff50e6e26da9a2$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
    var hits = args[1];
    var eventName = args[2];
    var additionalData = args[3] || {};
    if (!hits) return [];
    if ((eventType === 'click' || eventType === 'conversion') && !eventName) return [];
    var hitsArray = Array.isArray(hits) ? hits : [
        hits
    ];
    if (hitsArray.length === 0) return [];
    var queryID = hitsArray[0].__queryID;
    var hitsChunks = $38ff50e6e26da9a2$var$chunk(hitsArray);
    var objectIDsByChunk = hitsChunks.map(function(batch) {
        return batch.map(function(hit) {
            return hit.objectID;
        });
    });
    var positionsByChunk = hitsChunks.map(function(batch) {
        return batch.map(function(hit) {
            return hit.__position;
        });
    });
    if (eventType === 'view') {
        if (instantSearchInstance.status !== 'idle') return [];
        return hitsChunks.map(function(batch, i) {
            return {
                insightsMethod: 'viewedObjectIDs',
                widgetType: widgetType,
                eventType: eventType,
                payload: $38ff50e6e26da9a2$var$_objectSpread({
                    eventName: eventName || 'Hits Viewed',
                    index: getIndex(),
                    objectIDs: objectIDsByChunk[i]
                }, additionalData),
                hits: batch,
                eventModifier: eventModifier
            };
        });
    } else if (eventType === 'click') return hitsChunks.map(function(batch, i) {
        return {
            insightsMethod: 'clickedObjectIDsAfterSearch',
            widgetType: widgetType,
            eventType: eventType,
            payload: $38ff50e6e26da9a2$var$_objectSpread({
                eventName: eventName || 'Hit Clicked',
                index: getIndex(),
                queryID: queryID,
                objectIDs: objectIDsByChunk[i],
                positions: positionsByChunk[i]
            }, additionalData),
            hits: batch,
            eventModifier: eventModifier
        };
    });
    else if (eventType === 'conversion') return hitsChunks.map(function(batch, i) {
        return {
            insightsMethod: 'convertedObjectIDsAfterSearch',
            widgetType: widgetType,
            eventType: eventType,
            payload: $38ff50e6e26da9a2$var$_objectSpread({
                eventName: eventName || 'Hit Converted',
                index: getIndex(),
                queryID: queryID,
                objectIDs: objectIDsByChunk[i]
            }, additionalData),
            hits: batch,
            eventModifier: eventModifier
        };
    });
    else return [];
}
function $38ff50e6e26da9a2$export$4139f3a7130239e3(_ref2) {
    var instantSearchInstance = _ref2.instantSearchInstance, getIndex = _ref2.getIndex, widgetType = _ref2.widgetType;
    var sentEvents = {};
    var timer = undefined;
    var sendEventForHits = function sendEventForHits() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var payloads = $38ff50e6e26da9a2$export$2f82a8f6391c6db9({
            widgetType: widgetType,
            getIndex: getIndex,
            methodName: 'sendEvent',
            args: args,
            instantSearchInstance: instantSearchInstance
        });
        payloads.forEach(function(payload) {
            if (payload.eventType === 'click' && payload.eventModifier === 'internal' && sentEvents[payload.eventType]) return;
            sentEvents[payload.eventType] = true;
            instantSearchInstance.sendEventToInsights(payload);
        });
        clearTimeout(timer);
        timer = setTimeout(function() {
            sentEvents = {};
        }, 0);
    };
    return sendEventForHits;
}
function $38ff50e6e26da9a2$export$5a3d9973824d9b76(_ref3) {
    var getIndex = _ref3.getIndex, widgetType = _ref3.widgetType, instantSearchInstance = _ref3.instantSearchInstance;
    var bindEventForHits = function bindEventForHits() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var payloads = $38ff50e6e26da9a2$export$2f82a8f6391c6db9({
            widgetType: widgetType,
            getIndex: getIndex,
            methodName: 'bindEvent',
            args: args,
            instantSearchInstance: instantSearchInstance
        });
        return payloads.length ? "data-insights-event=".concat((0, $1ZS80.serializePayload)(payloads)) : '';
    };
    return bindEventForHits;
}

});

parcelRegister("jDJSV", function(module, exports) {

$parcel$export(module.exports, "walkIndex", function () { return $e4c540a1ee35b14d$export$85118a9141ea2b78; });

var $eRloN = parcelRequire("eRloN");
function $e4c540a1ee35b14d$export$85118a9141ea2b78(indexWidget, callback) {
    callback(indexWidget);
    indexWidget.getWidgets().forEach(function(widget) {
        if ((0, $eRloN.isIndexWidget)(widget)) $e4c540a1ee35b14d$export$85118a9141ea2b78(widget, callback);
    });
}

});


parcelRegister("1PUnu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $156649581964764c$export$2e2bcd8739ae039; });

var $kooa4 = parcelRequire("kooa4");
var $eHfFT = parcelRequire("eHfFT");
var $7DrFa = parcelRequire("7DrFa");
function $156649581964764c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $156649581964764c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $156649581964764c$var$_typeof(obj);
}
function $156649581964764c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $156649581964764c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $156649581964764c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $156649581964764c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $156649581964764c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $156649581964764c$var$_defineProperty(obj, key, value) {
    key = $156649581964764c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $156649581964764c$var$_toPropertyKey(arg) {
    var key = $156649581964764c$var$_toPrimitive(arg, "string");
    return $156649581964764c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $156649581964764c$var$_toPrimitive(input, hint) {
    if ($156649581964764c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($156649581964764c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $156649581964764c$var$getSelectedHits = function getSelectedHits(hits, selectedObjectIDs) {
    return selectedObjectIDs.map(function(objectID) {
        var hit = (0, $eHfFT.find)(hits, function(h) {
            return h.objectID === objectID;
        });
        if (typeof hit === 'undefined') throw new Error("Could not find objectID \"".concat(objectID, "\" passed to `clickedObjectIDsAfterSearch` in the returned hits. This is necessary to infer the absolute position and the query ID."));
        return hit;
    });
};
var $156649581964764c$var$getQueryID = function getQueryID(selectedHits) {
    var queryIDs = (0, $7DrFa.uniq)(selectedHits.map(function(hit) {
        return hit.__queryID;
    }));
    if (queryIDs.length > 1) throw new Error('Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s.');
    var queryID = queryIDs[0];
    if (typeof queryID !== 'string') throw new Error("Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7");
    return queryID;
};
var $156649581964764c$var$getPositions = function getPositions(selectedHits) {
    return selectedHits.map(function(hit) {
        return hit.__position;
    });
};
var $156649581964764c$export$24bd91850d68b36c = function inferPayload(_ref) {
    var method = _ref.method, results = _ref.results, hits = _ref.hits, objectIDs = _ref.objectIDs;
    var index = results.index;
    var selectedHits = $156649581964764c$var$getSelectedHits(hits, objectIDs);
    var queryID = $156649581964764c$var$getQueryID(selectedHits);
    switch(method){
        case 'clickedObjectIDsAfterSearch':
            var positions = $156649581964764c$var$getPositions(selectedHits);
            return {
                index: index,
                queryID: queryID,
                objectIDs: objectIDs,
                positions: positions
            };
        case 'convertedObjectIDsAfterSearch':
            return {
                index: index,
                queryID: queryID,
                objectIDs: objectIDs
            };
        default:
            throw new Error("Unsupported method passed to insights: \"".concat(method, "\"."));
    }
};
var $156649581964764c$var$wrapInsightsClient = function wrapInsightsClient(aa, results, hits) {
    return function(method) {
        for(var _len = arguments.length, payloads = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)payloads[_key - 1] = arguments[_key];
        var payload = payloads[0];
        if (!aa) {
            var withInstantSearchUsage = (0, $kooa4.createDocumentationMessageGenerator)({
                name: 'instantsearch'
            });
            throw new Error(withInstantSearchUsage('The `insightsClient` option has not been provided to `instantsearch`.'));
        }
        if (!Array.isArray(payload.objectIDs)) throw new TypeError('Expected `objectIDs` to be an array.');
        var inferredPayload = $156649581964764c$export$24bd91850d68b36c({
            method: method,
            results: results,
            hits: hits,
            objectIDs: payload.objectIDs
        });
        aa(method, $156649581964764c$var$_objectSpread($156649581964764c$var$_objectSpread({}, inferredPayload), payload));
    };
};
function $156649581964764c$export$2e2bcd8739ae039(connector) {
    return function(renderFn, unmountFn) {
        return connector(function(renderOptions, isFirstRender) {
            var results = renderOptions.results, hits = renderOptions.hits, instantSearchInstance = renderOptions.instantSearchInstance;
            if (results && hits && instantSearchInstance) {
                var insights = $156649581964764c$var$wrapInsightsClient(instantSearchInstance.insightsClient, results, hits);
                return renderFn($156649581964764c$var$_objectSpread($156649581964764c$var$_objectSpread({}, renderOptions), {}, {
                    insights: insights
                }), isFirstRender);
            }
            return renderFn(renderOptions, isFirstRender);
        }, unmountFn);
    };
}

});

parcelRegister("985ic", function(module, exports) {

$parcel$export(module.exports, "prepareTemplateProps", function () { return $6a58f76ad81c2115$export$2938ff6a58d41f25; });

var $7DrFa = parcelRequire("7DrFa");
function $6a58f76ad81c2115$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6a58f76ad81c2115$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6a58f76ad81c2115$var$_typeof(obj);
}
function $6a58f76ad81c2115$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6a58f76ad81c2115$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6a58f76ad81c2115$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6a58f76ad81c2115$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6a58f76ad81c2115$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6a58f76ad81c2115$var$_defineProperty(obj, key, value) {
    key = $6a58f76ad81c2115$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6a58f76ad81c2115$var$_toPropertyKey(arg) {
    var key = $6a58f76ad81c2115$var$_toPrimitive(arg, "string");
    return $6a58f76ad81c2115$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6a58f76ad81c2115$var$_toPrimitive(input, hint) {
    if ($6a58f76ad81c2115$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6a58f76ad81c2115$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6a58f76ad81c2115$var$_toConsumableArray(arr) {
    return $6a58f76ad81c2115$var$_arrayWithoutHoles(arr) || $6a58f76ad81c2115$var$_iterableToArray(arr) || $6a58f76ad81c2115$var$_unsupportedIterableToArray(arr) || $6a58f76ad81c2115$var$_nonIterableSpread();
}
function $6a58f76ad81c2115$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6a58f76ad81c2115$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6a58f76ad81c2115$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6a58f76ad81c2115$var$_arrayLikeToArray(o, minLen);
}
function $6a58f76ad81c2115$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $6a58f76ad81c2115$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6a58f76ad81c2115$var$_arrayLikeToArray(arr);
}
function $6a58f76ad81c2115$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6a58f76ad81c2115$var$prepareTemplates(// can not use = {} here, since the template could have different constraints
defaultTemplates) {
    var templates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var allKeys = (0, $7DrFa.uniq)([].concat($6a58f76ad81c2115$var$_toConsumableArray(Object.keys(defaultTemplates || {})), $6a58f76ad81c2115$var$_toConsumableArray(Object.keys(templates))));
    return allKeys.reduce(function(config, key) {
        var defaultTemplate = defaultTemplates ? defaultTemplates[key] : undefined;
        var customTemplate = templates[key];
        var isCustomTemplate = customTemplate !== undefined && customTemplate !== defaultTemplate;
        config.templates[key] = isCustomTemplate ? customTemplate : defaultTemplate;
        config.useCustomCompileOptions[key] = isCustomTemplate;
        return config;
    }, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        templates: {},
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        useCustomCompileOptions: {}
    });
}
function $6a58f76ad81c2115$export$2938ff6a58d41f25(_ref) {
    var defaultTemplates = _ref.defaultTemplates, templates = _ref.templates, templatesConfig = _ref.templatesConfig;
    var preparedTemplates = $6a58f76ad81c2115$var$prepareTemplates(defaultTemplates, templates);
    return $6a58f76ad81c2115$var$_objectSpread({
        templatesConfig: templatesConfig
    }, preparedTemplates);
}

});

parcelRegister("73ZoF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $524870565b01ae23$export$2e2bcd8739ae039; });

var $57T2D = parcelRequire("57T2D");
var $524870565b01ae23$var$defaultTemplates = {
    empty: function empty() {
        return 'No results';
    },
    showPreviousText: function showPreviousText() {
        return 'Show previous results';
    },
    showMoreText: function showMoreText() {
        return 'Show more results';
    },
    item: function item(data) {
        return JSON.stringify((0, $57T2D.omit)(data, [
            '__hitIndex'
        ]), null, 2);
    }
};
var $524870565b01ae23$export$2e2bcd8739ae039 = $524870565b01ae23$var$defaultTemplates;

});
parcelRegister("57T2D", function(module, exports) {

$parcel$export(module.exports, "omit", function () { return $3bb84d4f4cc5f14b$export$30a06c8d3562193f; });
/**
 * Creates a new object with the same keys as the original object, but without the excluded keys.
 * @param source original object
 * @param excluded keys to remove from the original object
 * @returns the new object
 */ function $3bb84d4f4cc5f14b$export$30a06c8d3562193f(source, excluded) {
    if (source === null || source === undefined) return source;
    return Object.keys(source).reduce(function(target, key) {
        if (excluded.indexOf(key) >= 0) return target;
        var validKey = key;
        target[validKey] = source[validKey];
        return target;
    }, {});
}

});



parcelRegister("2wrqp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d63d7edc87da378$export$2e2bcd8739ae039; });

var $5bown = parcelRequire("5bown");

var $lLkqw = parcelRequire("lLkqw");

var $apjZY = parcelRequire("apjZY");

var $3EjUd = parcelRequire("3EjUd");

var $8JLyQ = parcelRequire("8JLyQ");

var $985ic = parcelRequire("985ic");

var $kooa4 = parcelRequire("kooa4");
var $hthTp = parcelRequire("hthTp");

var $gl0jp = parcelRequire("gl0jp");

var $7QzLi = parcelRequire("7QzLi");
function $1d63d7edc87da378$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1d63d7edc87da378$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1d63d7edc87da378$var$_typeof(obj);
}
function $1d63d7edc87da378$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1d63d7edc87da378$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1d63d7edc87da378$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1d63d7edc87da378$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1d63d7edc87da378$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1d63d7edc87da378$var$_defineProperty(obj, key, value) {
    key = $1d63d7edc87da378$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1d63d7edc87da378$var$_toPropertyKey(arg) {
    var key = $1d63d7edc87da378$var$_toPrimitive(arg, "string");
    return $1d63d7edc87da378$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1d63d7edc87da378$var$_toPrimitive(input, hint) {
    if ($1d63d7edc87da378$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1d63d7edc87da378$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $1d63d7edc87da378$var$withUsage = (0, $kooa4.createDocumentationMessageGenerator)({
    name: 'refinement-list'
});
var $1d63d7edc87da378$var$suit = (0, $8JLyQ.component)('RefinementList');
var $1d63d7edc87da378$var$searchBoxSuit = (0, $8JLyQ.component)('SearchBox');
var $1d63d7edc87da378$var$renderer = function renderer(_ref) {
    var containerNode = _ref.containerNode, cssClasses = _ref.cssClasses, templates = _ref.templates, searchBoxTemplates = _ref.searchBoxTemplates, renderState = _ref.renderState, showMore = _ref.showMore, searchable = _ref.searchable, searchablePlaceholder = _ref.searchablePlaceholder, searchableIsAlwaysActive = _ref.searchableIsAlwaysActive;
    return function(_ref2, isFirstRendering) {
        var refine = _ref2.refine, items = _ref2.items, createURL = _ref2.createURL, searchForItems = _ref2.searchForItems, isFromSearch = _ref2.isFromSearch, instantSearchInstance = _ref2.instantSearchInstance, toggleShowMore = _ref2.toggleShowMore, isShowingMore = _ref2.isShowingMore, hasExhaustiveItems = _ref2.hasExhaustiveItems, canToggleShowMore = _ref2.canToggleShowMore;
        if (isFirstRendering) {
            renderState.templateProps = (0, $985ic.prepareTemplateProps)({
                defaultTemplates: (0, $7QzLi.default),
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: templates
            });
            renderState.searchBoxTemplateProps = (0, $985ic.prepareTemplateProps)({
                defaultTemplates: (0, $gl0jp.default),
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: searchBoxTemplates
            });
            return;
        }
        (0, $lLkqw.render)((0, $lLkqw.h)((0, $apjZY.default), {
            createURL: createURL,
            cssClasses: cssClasses,
            facetValues: items,
            templateProps: renderState.templateProps,
            searchBoxTemplateProps: renderState.searchBoxTemplateProps,
            toggleRefinement: refine,
            searchFacetValues: searchable ? searchForItems : undefined,
            searchPlaceholder: searchablePlaceholder,
            searchIsAlwaysActive: searchableIsAlwaysActive,
            isFromSearch: isFromSearch,
            showMore: showMore && !isFromSearch && items.length > 0,
            toggleShowMore: toggleShowMore,
            isShowingMore: isShowingMore,
            hasExhaustiveItems: hasExhaustiveItems,
            canToggleShowMore: canToggleShowMore
        }), containerNode);
    };
};
/**
 * The refinement list widget is one of the most common widget that you can find
 * in a search UI. With this widget, the user can filter the dataset based on facets.
 *
 * The refinement list displays only the most relevant facets for the current search
 * context. The sort option only affects the facet that are returned by the engine,
 * not which facets are returned.
 *
 * This widget also implements search for facet values, which is a mini search inside the
 * values of the facets. This makes easy to deal with uncommon facet values.
 *
 * @requirements
 *
 * The attribute passed to `attribute` must be declared as an
 * [attribute for faceting](https://www.algolia.com/doc/guides/searching/faceting/#declaring-attributes-for-faceting)
 * in your Algolia settings.
 *
 * If you also want to use search for facet values on this attribute, you need to make it searchable using the [dashboard](https://www.algolia.com/explorer/display/) or using the [API](https://www.algolia.com/doc/guides/searching/faceting/#search-for-facet-values).
 */ var $1d63d7edc87da378$var$refinementList = function refinementList(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, attribute = _ref3.attribute, operator = _ref3.operator, sortBy = _ref3.sortBy, limit = _ref3.limit, showMore = _ref3.showMore, showMoreLimit = _ref3.showMoreLimit, _ref3$searchable = _ref3.searchable, searchable = _ref3$searchable === void 0 ? false : _ref3$searchable, _ref3$searchablePlace = _ref3.searchablePlaceholder, searchablePlaceholder = _ref3$searchablePlace === void 0 ? 'Search...' : _ref3$searchablePlace, _ref3$searchableEscap = _ref3.searchableEscapeFacetValues, searchableEscapeFacetValues = _ref3$searchableEscap === void 0 ? true : _ref3$searchableEscap, _ref3$searchableIsAlw = _ref3.searchableIsAlwaysActive, searchableIsAlwaysActive = _ref3$searchableIsAlw === void 0 ? true : _ref3$searchableIsAlw, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$templates = _ref3.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, transformItems = _ref3.transformItems;
    if (!container) throw new Error($1d63d7edc87da378$var$withUsage('The `container` option is required.'));
    var escapeFacetValues = searchable ? Boolean(searchableEscapeFacetValues) : false;
    var containerNode = (0, $hthTp.getContainerNode)(container);
    var cssClasses = {
        root: (0, $5bown.cx)($1d63d7edc87da378$var$suit(), userCssClasses.root),
        noRefinementRoot: (0, $5bown.cx)($1d63d7edc87da378$var$suit({
            modifierName: 'noRefinement'
        }), userCssClasses.noRefinementRoot),
        list: (0, $5bown.cx)($1d63d7edc87da378$var$suit({
            descendantName: 'list'
        }), userCssClasses.list),
        item: (0, $5bown.cx)($1d63d7edc87da378$var$suit({
            descendantName: 'item'
        }), userCssClasses.item),
        selectedItem: (0, $5bown.cx)($1d63d7edc87da378$var$suit({
            descendantName: 'item',
            modifierName: 'selected'
        }), userCssClasses.selectedItem),
        searchBox: (0, $5bown.cx)($1d63d7edc87da378$var$suit({
            descendantName: 'searchBox'
        }), userCssClasses.searchBox),
        label: (0, $5bown.cx)($1d63d7edc87da378$var$suit({
            descendantName: 'label'
        }), userCssClasses.label),
        checkbox: (0, $5bown.cx)($1d63d7edc87da378$var$suit({
            descendantName: 'checkbox'
        }), userCssClasses.checkbox),
        labelText: (0, $5bown.cx)($1d63d7edc87da378$var$suit({
            descendantName: 'labelText'
        }), userCssClasses.labelText),
        count: (0, $5bown.cx)($1d63d7edc87da378$var$suit({
            descendantName: 'count'
        }), userCssClasses.count),
        noResults: (0, $5bown.cx)($1d63d7edc87da378$var$suit({
            descendantName: 'noResults'
        }), userCssClasses.noResults),
        showMore: (0, $5bown.cx)($1d63d7edc87da378$var$suit({
            descendantName: 'showMore'
        }), userCssClasses.showMore),
        disabledShowMore: (0, $5bown.cx)($1d63d7edc87da378$var$suit({
            descendantName: 'showMore',
            modifierName: 'disabled'
        }), userCssClasses.disabledShowMore),
        searchable: {
            root: (0, $5bown.cx)($1d63d7edc87da378$var$searchBoxSuit(), userCssClasses.searchableRoot),
            form: (0, $5bown.cx)($1d63d7edc87da378$var$searchBoxSuit({
                descendantName: 'form'
            }), userCssClasses.searchableForm),
            input: (0, $5bown.cx)($1d63d7edc87da378$var$searchBoxSuit({
                descendantName: 'input'
            }), userCssClasses.searchableInput),
            submit: (0, $5bown.cx)($1d63d7edc87da378$var$searchBoxSuit({
                descendantName: 'submit'
            }), userCssClasses.searchableSubmit),
            submitIcon: (0, $5bown.cx)($1d63d7edc87da378$var$searchBoxSuit({
                descendantName: 'submitIcon'
            }), userCssClasses.searchableSubmitIcon),
            reset: (0, $5bown.cx)($1d63d7edc87da378$var$searchBoxSuit({
                descendantName: 'reset'
            }), userCssClasses.searchableReset),
            resetIcon: (0, $5bown.cx)($1d63d7edc87da378$var$searchBoxSuit({
                descendantName: 'resetIcon'
            }), userCssClasses.searchableResetIcon),
            loadingIndicator: (0, $5bown.cx)($1d63d7edc87da378$var$searchBoxSuit({
                descendantName: 'loadingIndicator'
            }), userCssClasses.searchableLoadingIndicator),
            loadingIcon: (0, $5bown.cx)($1d63d7edc87da378$var$searchBoxSuit({
                descendantName: 'loadingIcon'
            }), userCssClasses.searchableLoadingIcon)
        }
    };
    var specializedRenderer = $1d63d7edc87da378$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        templates: templates,
        searchBoxTemplates: {
            submit: templates.searchableSubmit,
            reset: templates.searchableReset,
            loadingIndicator: templates.searchableLoadingIndicator
        },
        renderState: {},
        searchable: searchable,
        searchablePlaceholder: searchablePlaceholder,
        searchableIsAlwaysActive: searchableIsAlwaysActive,
        showMore: showMore
    });
    var makeWidget = (0, $3EjUd.default)(specializedRenderer, function() {
        return (0, $lLkqw.render)(null, containerNode);
    });
    return $1d63d7edc87da378$var$_objectSpread($1d63d7edc87da378$var$_objectSpread({}, makeWidget({
        attribute: attribute,
        operator: operator,
        limit: limit,
        showMore: showMore,
        showMoreLimit: showMoreLimit,
        sortBy: sortBy,
        escapeFacetValues: escapeFacetValues,
        transformItems: transformItems
    })), {}, {
        $$widgetType: 'ais.refinementList'
    });
};
var $1d63d7edc87da378$export$2e2bcd8739ae039 = $1d63d7edc87da378$var$refinementList;

});
parcelRegister("apjZY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $793bc0815022b7e2$export$2e2bcd8739ae039; });

var $5bown = parcelRequire("5bown");

var $lLkqw = parcelRequire("lLkqw");

var $cg906 = parcelRequire("cg906");
var $1OF97 = parcelRequire("1OF97");

var $jv2Ed = parcelRequire("jv2Ed");

var $kNs3K = parcelRequire("kNs3K");

var $aezJK = parcelRequire("aezJK");
var $793bc0815022b7e2$var$_excluded = [
    "root"
];
function $793bc0815022b7e2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $793bc0815022b7e2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $793bc0815022b7e2$var$_typeof(obj);
}
function $793bc0815022b7e2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $793bc0815022b7e2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $793bc0815022b7e2$var$ownKeys(Object(source), !0).forEach(function(key) {
            $793bc0815022b7e2$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $793bc0815022b7e2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $793bc0815022b7e2$var$_extends() {
    $793bc0815022b7e2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $793bc0815022b7e2$var$_extends.apply(this, arguments);
}
function $793bc0815022b7e2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $793bc0815022b7e2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $793bc0815022b7e2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $793bc0815022b7e2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $793bc0815022b7e2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $793bc0815022b7e2$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $793bc0815022b7e2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $793bc0815022b7e2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $793bc0815022b7e2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $793bc0815022b7e2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $793bc0815022b7e2$var$_setPrototypeOf(subClass, superClass);
}
function $793bc0815022b7e2$var$_setPrototypeOf(o, p) {
    $793bc0815022b7e2$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $793bc0815022b7e2$var$_setPrototypeOf(o, p);
}
function $793bc0815022b7e2$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $793bc0815022b7e2$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $793bc0815022b7e2$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $793bc0815022b7e2$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $793bc0815022b7e2$var$_possibleConstructorReturn(this, result);
    };
}
function $793bc0815022b7e2$var$_possibleConstructorReturn(self, call) {
    if (call && ($793bc0815022b7e2$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $793bc0815022b7e2$var$_assertThisInitialized(self);
}
function $793bc0815022b7e2$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $793bc0815022b7e2$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $793bc0815022b7e2$var$_getPrototypeOf(o) {
    $793bc0815022b7e2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $793bc0815022b7e2$var$_getPrototypeOf(o);
}
function $793bc0815022b7e2$var$_defineProperty(obj, key, value) {
    key = $793bc0815022b7e2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $793bc0815022b7e2$var$_toPropertyKey(arg) {
    var key = $793bc0815022b7e2$var$_toPrimitive(arg, "string");
    return $793bc0815022b7e2$var$_typeof(key) === "symbol" ? key : String(key);
}
function $793bc0815022b7e2$var$_toPrimitive(input, hint) {
    if ($793bc0815022b7e2$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($793bc0815022b7e2$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
// CSS types
var $793bc0815022b7e2$var$defaultProps = {
    cssClasses: {},
    depth: 0
};
function $793bc0815022b7e2$var$isHierarchicalMenuItem(facetValue) {
    return facetValue.data !== undefined;
}
var $793bc0815022b7e2$var$RefinementList = /*#__PURE__*/ function(_Component) {
    $793bc0815022b7e2$var$_inherits(RefinementList, _Component);
    var _super = $793bc0815022b7e2$var$_createSuper(RefinementList);
    function RefinementList() {
        var _this;
        $793bc0815022b7e2$var$_classCallCheck(this, RefinementList);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $793bc0815022b7e2$var$_defineProperty($793bc0815022b7e2$var$_assertThisInitialized(_this), "listRef", (0, $lLkqw.createRef)());
        $793bc0815022b7e2$var$_defineProperty($793bc0815022b7e2$var$_assertThisInitialized(_this), "searchBox", (0, $lLkqw.createRef)());
        $793bc0815022b7e2$var$_defineProperty($793bc0815022b7e2$var$_assertThisInitialized(_this), "lastRefinedValue", undefined);
        $793bc0815022b7e2$var$_defineProperty($793bc0815022b7e2$var$_assertThisInitialized(_this), "_generateFacetItem", function(facetValue) {
            var subItems;
            if ($793bc0815022b7e2$var$isHierarchicalMenuItem(facetValue) && Array.isArray(facetValue.data) && facetValue.data.length > 0) {
                var _this$props$cssClasse = _this.props.cssClasses, root = _this$props$cssClasse.root, cssClasses = $793bc0815022b7e2$var$_objectWithoutProperties(_this$props$cssClasse, $793bc0815022b7e2$var$_excluded);
                subItems = (0, $lLkqw.h)(RefinementList, $793bc0815022b7e2$var$_extends({}, _this.props, {
                    // We want to keep `root` required for external usage but not for the
                    // sub items.
                    cssClasses: cssClasses,
                    depth: _this.props.depth + 1,
                    facetValues: facetValue.data,
                    showMore: false,
                    className: _this.props.cssClasses.childList
                }));
            }
            var url = _this.props.createURL(facetValue.value);
            var templateData = $793bc0815022b7e2$var$_objectSpread($793bc0815022b7e2$var$_objectSpread({}, facetValue), {}, {
                url: url,
                attribute: _this.props.attribute,
                cssClasses: _this.props.cssClasses,
                isFromSearch: _this.props.isFromSearch
            });
            var key = facetValue.value;
            if (facetValue.isRefined !== undefined) key += "/".concat(facetValue.isRefined);
            if (facetValue.count !== undefined) key += "/".concat(facetValue.count);
            var refinementListItemClassName = (0, $5bown.cx)(_this.props.cssClasses.item, facetValue.isRefined && _this.props.cssClasses.selectedItem, !facetValue.count && _this.props.cssClasses.disabledItem, Boolean($793bc0815022b7e2$var$isHierarchicalMenuItem(facetValue) && Array.isArray(facetValue.data) && facetValue.data.length > 0) && _this.props.cssClasses.parentItem);
            return (0, $lLkqw.h)((0, $aezJK.default), {
                templateKey: "item",
                key: key,
                facetValueToRefine: facetValue.value,
                handleClick: _this.handleItemClick,
                isRefined: facetValue.isRefined,
                className: refinementListItemClassName,
                subItems: subItems,
                templateData: templateData,
                templateProps: _this.props.templateProps
            });
        });
        // Click events on DOM tree like LABEL > INPUT will result in two click events
        // instead of one.
        // No matter the framework, see https://www.google.com/search?q=click+label+twice
        //
        // Thus making it hard to distinguish activation from deactivation because both click events
        // are very close. Debounce is a solution but hacky.
        //
        // So the code here checks if the click was done on or in a LABEL. If this LABEL
        // has a checkbox inside, we ignore the first click event because we will get another one.
        //
        // We also check if the click was done inside a link and then e.preventDefault() because we already
        // handle the url
        //
        // Finally, we always stop propagation of the event to avoid multiple levels RefinementLists to fail: click
        // on child would click on parent also
        $793bc0815022b7e2$var$_defineProperty($793bc0815022b7e2$var$_assertThisInitialized(_this), "handleItemClick", function(_ref) {
            var facetValueToRefine = _ref.facetValueToRefine, isRefined = _ref.isRefined, originalEvent = _ref.originalEvent;
            if ((0, $1OF97.isSpecialClick)(originalEvent)) // do not alter the default browser behavior
            // if one special key is down
            return;
            var parent = originalEvent.target;
            if (parent === null || parent.parentNode === null) return;
            if (isRefined && parent.parentNode.querySelector('input[type="radio"]:checked')) // Prevent refinement for being reset if the user clicks on an already checked radio button
            return;
            if (parent.tagName === 'INPUT') {
                _this.refine(facetValueToRefine);
                return;
            }
            while(parent !== originalEvent.currentTarget){
                if (parent.tagName === 'LABEL' && (parent.querySelector('input[type="checkbox"]') || parent.querySelector('input[type="radio"]'))) return;
                if (parent.tagName === 'A' && parent.href) originalEvent.preventDefault();
                parent = parent.parentNode;
            }
            originalEvent.stopPropagation();
            _this.refine(facetValueToRefine);
        });
        return _this;
    }
    $793bc0815022b7e2$var$_createClass(RefinementList, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var areFacetValuesDifferent = !(0, $cg906.isEqual)(this.props.facetValues, nextProps.facetValues);
                return areFacetValuesDifferent;
            }
        },
        {
            key: "refine",
            value: function refine(facetValueToRefine) {
                this.lastRefinedValue = facetValueToRefine;
                this.props.toggleRefinement(facetValueToRefine);
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                if (this.searchBox.current && !nextProps.isFromSearch) this.searchBox.current.resetInput();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$listRef$current, _this$listRef$current2;
                (_this$listRef$current = this.listRef.current) === null || _this$listRef$current === void 0 || (_this$listRef$current2 = _this$listRef$current.querySelector("input[value=\"".concat(this.lastRefinedValue, "\"]"))) === null || _this$listRef$current2 === void 0 || _this$listRef$current2.focus();
                this.lastRefinedValue = undefined;
            }
        },
        {
            key: "refineFirstValue",
            value: function refineFirstValue() {
                var firstValue = this.props.facetValues && this.props.facetValues[0];
                if (firstValue) {
                    var actualValue = firstValue.value;
                    this.props.toggleRefinement(actualValue);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var showMoreButtonClassName = (0, $5bown.cx)(this.props.cssClasses.showMore, !(this.props.showMore === true && this.props.canToggleShowMore) && this.props.cssClasses.disabledShowMore);
                var showMoreButton = this.props.showMore === true && (0, $lLkqw.h)((0, $kNs3K.default), $793bc0815022b7e2$var$_extends({}, this.props.templateProps, {
                    templateKey: "showMoreText",
                    rootTagName: "button",
                    rootProps: {
                        className: showMoreButtonClassName,
                        disabled: !this.props.canToggleShowMore,
                        onClick: this.props.toggleShowMore
                    },
                    data: {
                        isShowingMore: this.props.isShowingMore
                    }
                }));
                var shouldDisableSearchBox = this.props.searchIsAlwaysActive !== true && !(this.props.isFromSearch || !this.props.hasExhaustiveItems);
                var searchBox = this.props.searchFacetValues && (0, $lLkqw.h)("div", {
                    className: this.props.cssClasses.searchBox
                }, (0, $lLkqw.h)((0, $jv2Ed.default), {
                    ref: this.searchBox,
                    placeholder: this.props.searchPlaceholder,
                    disabled: shouldDisableSearchBox,
                    cssClasses: this.props.cssClasses.searchable,
                    templates: this.props.searchBoxTemplateProps.templates,
                    onChange: function onChange(event) {
                        return _this2.props.searchFacetValues(event.target.value);
                    },
                    onReset: function onReset() {
                        return _this2.props.searchFacetValues('');
                    },
                    onSubmit: function onSubmit() {
                        return _this2.refineFirstValue();
                    },
                    searchAsYouType: false,
                    ariaLabel: "Search for filters"
                }));
                var facetValues = this.props.facetValues && this.props.facetValues.length > 0 && (0, $lLkqw.h)("ul", {
                    ref: this.listRef,
                    className: this.props.cssClasses.list
                }, this.props.facetValues.map(this._generateFacetItem, this));
                var noResults = this.props.searchFacetValues && this.props.isFromSearch && (!this.props.facetValues || this.props.facetValues.length === 0) && (0, $lLkqw.h)((0, $kNs3K.default), $793bc0815022b7e2$var$_extends({}, this.props.templateProps, {
                    templateKey: "searchableNoResults",
                    rootProps: {
                        className: this.props.cssClasses.noResults
                    }
                }));
                var rootClassName = (0, $5bown.cx)(this.props.cssClasses.root, (!this.props.facetValues || this.props.facetValues.length === 0) && this.props.cssClasses.noRefinementRoot, this.props.className);
                return (0, $lLkqw.h)("div", {
                    className: rootClassName
                }, this.props.children, searchBox, facetValues, noResults, showMoreButton);
            }
        }
    ]);
    return RefinementList;
}((0, $lLkqw.Component));
$793bc0815022b7e2$var$_defineProperty($793bc0815022b7e2$var$RefinementList, "defaultProps", $793bc0815022b7e2$var$defaultProps);
var $793bc0815022b7e2$export$2e2bcd8739ae039 = $793bc0815022b7e2$var$RefinementList;

});
parcelRegister("jv2Ed", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e322f75a4dd1ce90$export$2e2bcd8739ae039; });

var $lLkqw = parcelRequire("lLkqw");

var $fMELL = parcelRequire("fMELL");

var $kNs3K = parcelRequire("kNs3K");
function $e322f75a4dd1ce90$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e322f75a4dd1ce90$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e322f75a4dd1ce90$var$_typeof(obj);
}
function $e322f75a4dd1ce90$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e322f75a4dd1ce90$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e322f75a4dd1ce90$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e322f75a4dd1ce90$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e322f75a4dd1ce90$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e322f75a4dd1ce90$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e322f75a4dd1ce90$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e322f75a4dd1ce90$var$_setPrototypeOf(subClass, superClass);
}
function $e322f75a4dd1ce90$var$_setPrototypeOf(o, p) {
    $e322f75a4dd1ce90$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e322f75a4dd1ce90$var$_setPrototypeOf(o, p);
}
function $e322f75a4dd1ce90$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e322f75a4dd1ce90$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e322f75a4dd1ce90$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e322f75a4dd1ce90$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e322f75a4dd1ce90$var$_possibleConstructorReturn(this, result);
    };
}
function $e322f75a4dd1ce90$var$_possibleConstructorReturn(self, call) {
    if (call && ($e322f75a4dd1ce90$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e322f75a4dd1ce90$var$_assertThisInitialized(self);
}
function $e322f75a4dd1ce90$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e322f75a4dd1ce90$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e322f75a4dd1ce90$var$_getPrototypeOf(o) {
    $e322f75a4dd1ce90$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e322f75a4dd1ce90$var$_getPrototypeOf(o);
}
function $e322f75a4dd1ce90$var$_defineProperty(obj, key, value) {
    key = $e322f75a4dd1ce90$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e322f75a4dd1ce90$var$_toPropertyKey(arg) {
    var key = $e322f75a4dd1ce90$var$_toPrimitive(arg, "string");
    return $e322f75a4dd1ce90$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e322f75a4dd1ce90$var$_toPrimitive(input, hint) {
    if ($e322f75a4dd1ce90$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e322f75a4dd1ce90$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $e322f75a4dd1ce90$var$defaultProps = {
    query: '',
    showSubmit: true,
    showReset: true,
    showLoadingIndicator: true,
    autofocus: false,
    searchAsYouType: true,
    ignoreCompositionEvents: false,
    isSearchStalled: false,
    disabled: false,
    ariaLabel: 'Search',
    onChange: (0, $fMELL.noop),
    onSubmit: (0, $fMELL.noop),
    onReset: (0, $fMELL.noop),
    refine: (0, $fMELL.noop)
};
var $e322f75a4dd1ce90$var$SearchBox = /*#__PURE__*/ function(_Component) {
    $e322f75a4dd1ce90$var$_inherits(SearchBox, _Component);
    var _super = $e322f75a4dd1ce90$var$_createSuper(SearchBox);
    function SearchBox() {
        var _this;
        $e322f75a4dd1ce90$var$_classCallCheck(this, SearchBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $e322f75a4dd1ce90$var$_defineProperty($e322f75a4dd1ce90$var$_assertThisInitialized(_this), "state", {
            query: _this.props.query,
            focused: false
        });
        $e322f75a4dd1ce90$var$_defineProperty($e322f75a4dd1ce90$var$_assertThisInitialized(_this), "input", (0, $lLkqw.createRef)());
        $e322f75a4dd1ce90$var$_defineProperty($e322f75a4dd1ce90$var$_assertThisInitialized(_this), "onInput", function(event) {
            var _this$props = _this.props, searchAsYouType = _this$props.searchAsYouType, refine = _this$props.refine, onChange = _this$props.onChange;
            var query = event.target.value;
            if (!(_this.props.ignoreCompositionEvents && event.isComposing)) {
                if (searchAsYouType) refine(query);
                _this.setState({
                    query: query
                });
                onChange(event);
            }
        });
        $e322f75a4dd1ce90$var$_defineProperty($e322f75a4dd1ce90$var$_assertThisInitialized(_this), "onSubmit", function(event) {
            var _this$props2 = _this.props, searchAsYouType = _this$props2.searchAsYouType, refine = _this$props2.refine, onSubmit = _this$props2.onSubmit;
            event.preventDefault();
            event.stopPropagation();
            if (_this.input.current) _this.input.current.blur();
            if (!searchAsYouType) refine(_this.state.query);
            onSubmit(event);
            return false;
        });
        $e322f75a4dd1ce90$var$_defineProperty($e322f75a4dd1ce90$var$_assertThisInitialized(_this), "onReset", function(event) {
            var _this$props3 = _this.props, refine = _this$props3.refine, onReset = _this$props3.onReset;
            var query = '';
            if (_this.input.current) _this.input.current.focus();
            refine(query);
            _this.setState({
                query: query
            });
            onReset(event);
        });
        $e322f75a4dd1ce90$var$_defineProperty($e322f75a4dd1ce90$var$_assertThisInitialized(_this), "onBlur", function() {
            _this.setState({
                focused: false
            });
        });
        $e322f75a4dd1ce90$var$_defineProperty($e322f75a4dd1ce90$var$_assertThisInitialized(_this), "onFocus", function() {
            _this.setState({
                focused: true
            });
        });
        return _this;
    }
    $e322f75a4dd1ce90$var$_createClass(SearchBox, [
        {
            key: "resetInput",
            value: /**
     * This public method is used in the RefinementList SFFV search box
     * to reset the input state when an item is selected.
     *
     * @see RefinementList#componentWillReceiveProps
     * @return {undefined}
     */ function resetInput() {
                this.setState({
                    query: ''
                });
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                /**
       * when the user is typing, we don't want to replace the query typed
       * by the user (state.query) with the query exposed by the connector (props.query)
       * see: https://github.com/algolia/instantsearch/issues/4141
       */ if (!this.state.focused && nextProps.query !== this.state.query) this.setState({
                    query: nextProps.query
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, cssClasses = _this$props4.cssClasses, placeholder = _this$props4.placeholder, autofocus = _this$props4.autofocus, showSubmit = _this$props4.showSubmit, showReset = _this$props4.showReset, showLoadingIndicator = _this$props4.showLoadingIndicator, templates = _this$props4.templates, isSearchStalled = _this$props4.isSearchStalled, ariaLabel = _this$props4.ariaLabel;
                return (0, $lLkqw.h)("div", {
                    className: cssClasses.root
                }, (0, $lLkqw.h)("form", {
                    action: "",
                    role: "search",
                    className: cssClasses.form,
                    noValidate: true,
                    onSubmit: this.onSubmit,
                    onReset: this.onReset
                }, (0, $lLkqw.h)("input", {
                    ref: this.input,
                    value: this.state.query,
                    disabled: this.props.disabled,
                    className: cssClasses.input,
                    type: "search",
                    placeholder: placeholder,
                    autoFocus: autofocus,
                    autoComplete: "off",
                    autoCorrect: "off",
                    autoCapitalize: "off",
                    spellCheck: "false",
                    maxLength: 512,
                    onInput: this.onInput,
                    oncompositionend: this.onInput,
                    onBlur: this.onBlur,
                    onFocus: this.onFocus,
                    "aria-label": ariaLabel
                }), (0, $lLkqw.h)((0, $kNs3K.default), {
                    templateKey: "submit",
                    rootTagName: "button",
                    rootProps: {
                        className: cssClasses.submit,
                        type: 'submit',
                        title: 'Submit the search query',
                        hidden: !showSubmit
                    },
                    templates: templates,
                    data: {
                        cssClasses: cssClasses
                    }
                }), (0, $lLkqw.h)((0, $kNs3K.default), {
                    templateKey: "reset",
                    rootTagName: "button",
                    rootProps: {
                        className: cssClasses.reset,
                        type: 'reset',
                        title: 'Clear the search query',
                        hidden: !(showReset && this.state.query.trim() && !isSearchStalled)
                    },
                    templates: templates,
                    data: {
                        cssClasses: cssClasses
                    }
                }), showLoadingIndicator && (0, $lLkqw.h)((0, $kNs3K.default), {
                    templateKey: "loadingIndicator",
                    rootTagName: "span",
                    rootProps: {
                        className: cssClasses.loadingIndicator,
                        hidden: !isSearchStalled
                    },
                    templates: templates,
                    data: {
                        cssClasses: cssClasses
                    }
                })));
            }
        }
    ]);
    return SearchBox;
}((0, $lLkqw.Component));
$e322f75a4dd1ce90$var$_defineProperty($e322f75a4dd1ce90$var$SearchBox, "defaultProps", $e322f75a4dd1ce90$var$defaultProps);
var $e322f75a4dd1ce90$export$2e2bcd8739ae039 = $e322f75a4dd1ce90$var$SearchBox;

});

parcelRegister("aezJK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7736eecd114f3f41$export$2e2bcd8739ae039; });

var $lLkqw = parcelRequire("lLkqw");

var $kNs3K = parcelRequire("kNs3K");
function $7736eecd114f3f41$var$_extends() {
    $7736eecd114f3f41$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7736eecd114f3f41$var$_extends.apply(this, arguments);
}
function $7736eecd114f3f41$var$RefinementListItem(_ref) {
    var className = _ref.className, handleClick = _ref.handleClick, facetValueToRefine = _ref.facetValueToRefine, isRefined = _ref.isRefined, templateProps = _ref.templateProps, templateKey = _ref.templateKey, templateData = _ref.templateData, subItems = _ref.subItems;
    return (0, $lLkqw.h)("li", {
        className: className,
        onClick: function onClick(originalEvent) {
            handleClick({
                facetValueToRefine: facetValueToRefine,
                isRefined: isRefined,
                originalEvent: originalEvent
            });
        }
    }, (0, $lLkqw.h)((0, $kNs3K.default), $7736eecd114f3f41$var$_extends({}, templateProps, {
        templateKey: templateKey,
        data: templateData
    })), subItems);
}
var $7736eecd114f3f41$export$2e2bcd8739ae039 = $7736eecd114f3f41$var$RefinementListItem;

});


parcelRegister("3EjUd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a848c5d08d17597$export$2e2bcd8739ae039; });

var $6YH5z = parcelRequire("6YH5z");
var $kooa4 = parcelRequire("kooa4");
var $bKsNy = parcelRequire("bKsNy");
var $jF7w3 = parcelRequire("jF7w3");
var $fMELL = parcelRequire("fMELL");
function $2a848c5d08d17597$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2a848c5d08d17597$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2a848c5d08d17597$var$_typeof(obj);
}
var $2a848c5d08d17597$var$_excluded = [
    "name",
    "escapedValue"
], $2a848c5d08d17597$var$_excluded2 = [
    "escapedValue",
    "value"
];
function $2a848c5d08d17597$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2a848c5d08d17597$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2a848c5d08d17597$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2a848c5d08d17597$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2a848c5d08d17597$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2a848c5d08d17597$var$_defineProperty(obj, key, value) {
    key = $2a848c5d08d17597$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2a848c5d08d17597$var$_toPropertyKey(arg) {
    var key = $2a848c5d08d17597$var$_toPrimitive(arg, "string");
    return $2a848c5d08d17597$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2a848c5d08d17597$var$_toPrimitive(input, hint) {
    if ($2a848c5d08d17597$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2a848c5d08d17597$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $2a848c5d08d17597$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2a848c5d08d17597$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2a848c5d08d17597$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2a848c5d08d17597$var$withUsage = (0, $kooa4.createDocumentationMessageGenerator)({
    name: 'refinement-list',
    connector: true
});
var $2a848c5d08d17597$var$DEFAULT_SORT = [
    'isRefined',
    'count:desc',
    'name:asc'
];
/**
 * **RefinementList** connector provides the logic to build a custom widget that
 * will let the user filter the results based on the values of a specific facet.
 *
 * **Requirement:** the attribute passed as `attribute` must be present in
 * attributesForFaceting of the searched index.
 *
 * This connector provides:
 * - a `refine()` function to select an item.
 * - a `toggleShowMore()` function to display more or less items
 * - a `searchForItems()` function to search within the items.
 */ var $2a848c5d08d17597$var$connectRefinementList = function connectRefinementList(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $fMELL.noop);
    (0, $6YH5z.checkRendering)(renderFn, $2a848c5d08d17597$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, attribute = _ref.attribute, _ref$operator = _ref.operator, operator = _ref$operator === void 0 ? 'or' : _ref$operator, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 10 : _ref$limit, _ref$showMore = _ref.showMore, showMore = _ref$showMore === void 0 ? false : _ref$showMore, _ref$showMoreLimit = _ref.showMoreLimit, showMoreLimit = _ref$showMoreLimit === void 0 ? 20 : _ref$showMoreLimit, _ref$sortBy = _ref.sortBy, sortBy = _ref$sortBy === void 0 ? $2a848c5d08d17597$var$DEFAULT_SORT : _ref$sortBy, _ref$escapeFacetValue = _ref.escapeFacetValues, escapeFacetValues = _ref$escapeFacetValue === void 0 ? true : _ref$escapeFacetValue, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        if (!attribute) throw new Error($2a848c5d08d17597$var$withUsage('The `attribute` option is required.'));
        if (!/^(and|or)$/.test(operator)) throw new Error($2a848c5d08d17597$var$withUsage("The `operator` must one of: `\"and\"`, `\"or\"` (got \"".concat(operator, "\").")));
        if (showMore === true && showMoreLimit <= limit) throw new Error($2a848c5d08d17597$var$withUsage('`showMoreLimit` should be greater than `limit`.'));
        var formatItems = function formatItems(_ref2) {
            var label = _ref2.name, value = _ref2.escapedValue, item = $2a848c5d08d17597$var$_objectWithoutProperties(_ref2, $2a848c5d08d17597$var$_excluded);
            return $2a848c5d08d17597$var$_objectSpread($2a848c5d08d17597$var$_objectSpread({}, item), {}, {
                value: value,
                label: label,
                highlighted: label
            });
        };
        var lastResultsFromMainSearch;
        var lastItemsFromMainSearch = [];
        var hasExhaustiveItems = true;
        var triggerRefine;
        var sendEvent;
        var isShowingMore = false;
        // Provide the same function to the `renderFn` so that way the user
        // has to only bind it once when `isFirstRendering` for instance
        var toggleShowMore = function toggleShowMore() {};
        function cachedToggleShowMore() {
            toggleShowMore();
        }
        function createToggleShowMore(renderOptions, widget) {
            return function() {
                isShowingMore = !isShowingMore;
                widget.render(renderOptions);
            };
        }
        function getLimit() {
            return isShowingMore ? showMoreLimit : limit;
        }
        var searchForFacetValues = function searchForFacetValues() {
            return function() {};
        };
        var createSearchForFacetValues = function createSearchForFacetValues(helper, widget) {
            return function(renderOptions) {
                return function(query) {
                    var instantSearchInstance = renderOptions.instantSearchInstance, searchResults = renderOptions.results;
                    if (query === '' && lastItemsFromMainSearch) // render with previous data from the helper.
                    renderFn($2a848c5d08d17597$var$_objectSpread($2a848c5d08d17597$var$_objectSpread({}, widget.getWidgetRenderState($2a848c5d08d17597$var$_objectSpread($2a848c5d08d17597$var$_objectSpread({}, renderOptions), {}, {
                        results: lastResultsFromMainSearch
                    }))), {}, {
                        instantSearchInstance: instantSearchInstance
                    }), false);
                    else {
                        var tags = {
                            highlightPreTag: escapeFacetValues ? (0, $jF7w3.TAG_PLACEHOLDER).highlightPreTag : (0, $jF7w3.TAG_REPLACEMENT).highlightPreTag,
                            highlightPostTag: escapeFacetValues ? (0, $jF7w3.TAG_PLACEHOLDER).highlightPostTag : (0, $jF7w3.TAG_REPLACEMENT).highlightPostTag
                        };
                        helper.searchForFacetValues(attribute, query, // We cap the `maxFacetHits` value to 100 because the Algolia API
                        // doesn't support a greater number.
                        // See https://www.algolia.com/doc/api-reference/api-parameters/maxFacetHits/
                        Math.min(getLimit(), 100), tags).then(function(results) {
                            var facetValues = escapeFacetValues ? (0, $jF7w3.escapeFacets)(results.facetHits) : results.facetHits;
                            var normalizedFacetValues = transformItems(facetValues.map(function(_ref3) {
                                var escapedValue = _ref3.escapedValue, value = _ref3.value, item = $2a848c5d08d17597$var$_objectWithoutProperties(_ref3, $2a848c5d08d17597$var$_excluded2);
                                return $2a848c5d08d17597$var$_objectSpread($2a848c5d08d17597$var$_objectSpread({}, item), {}, {
                                    value: escapedValue,
                                    label: value
                                });
                            }), {
                                results: searchResults
                            });
                            renderFn($2a848c5d08d17597$var$_objectSpread($2a848c5d08d17597$var$_objectSpread({}, widget.getWidgetRenderState($2a848c5d08d17597$var$_objectSpread($2a848c5d08d17597$var$_objectSpread({}, renderOptions), {}, {
                                results: lastResultsFromMainSearch
                            }))), {}, {
                                items: normalizedFacetValues,
                                canToggleShowMore: false,
                                canRefine: true,
                                isFromSearch: true,
                                instantSearchInstance: instantSearchInstance
                            }), false);
                        });
                    }
                };
            };
        };
        return {
            $$type: 'ais.refinementList',
            init: function init(initOptions) {
                renderFn($2a848c5d08d17597$var$_objectSpread($2a848c5d08d17597$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                renderFn($2a848c5d08d17597$var$_objectSpread($2a848c5d08d17597$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $2a848c5d08d17597$var$_objectSpread($2a848c5d08d17597$var$_objectSpread({}, renderState), {}, {
                    refinementList: $2a848c5d08d17597$var$_objectSpread($2a848c5d08d17597$var$_objectSpread({}, renderState.refinementList), {}, $2a848c5d08d17597$var$_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
                });
            },
            getWidgetRenderState: function getWidgetRenderState(renderOptions) {
                var _this = this;
                var results = renderOptions.results, state = renderOptions.state, _createURL = renderOptions.createURL, instantSearchInstance = renderOptions.instantSearchInstance, helper = renderOptions.helper;
                var items = [];
                var facetValues = [];
                if (!sendEvent || !triggerRefine || !searchForFacetValues) {
                    sendEvent = (0, $bKsNy.createSendEventForFacet)({
                        instantSearchInstance: instantSearchInstance,
                        helper: helper,
                        attribute: attribute,
                        widgetType: this.$$type
                    });
                    triggerRefine = function triggerRefine(facetValue) {
                        sendEvent('click:internal', facetValue);
                        helper.toggleFacetRefinement(attribute, facetValue).search();
                    };
                    searchForFacetValues = createSearchForFacetValues(helper, this);
                }
                if (results) {
                    var values = results.getFacetValues(attribute, {
                        sortBy: sortBy,
                        facetOrdering: sortBy === $2a848c5d08d17597$var$DEFAULT_SORT
                    });
                    facetValues = values && Array.isArray(values) ? values : [];
                    items = transformItems(facetValues.slice(0, getLimit()).map(formatItems), {
                        results: results
                    });
                    var maxValuesPerFacetConfig = state.maxValuesPerFacet;
                    var currentLimit = getLimit();
                    // If the limit is the max number of facet retrieved it is impossible to know
                    // if the facets are exhaustive. The only moment we are sure it is exhaustive
                    // is when it is strictly under the number requested unless we know that another
                    // widget has requested more values (maxValuesPerFacet > getLimit()).
                    // Because this is used for making the search of facets unable or not, it is important
                    // to be conservative here.
                    hasExhaustiveItems = maxValuesPerFacetConfig > currentLimit ? facetValues.length <= currentLimit : facetValues.length < currentLimit;
                    lastResultsFromMainSearch = results;
                    lastItemsFromMainSearch = items;
                    if (renderOptions.results) toggleShowMore = createToggleShowMore(renderOptions, this);
                }
                // Do not mistake searchForFacetValues and searchFacetValues which is the actual search
                // function
                var searchFacetValues = searchForFacetValues && searchForFacetValues(renderOptions);
                var canShowLess = isShowingMore && lastItemsFromMainSearch.length > limit;
                var canShowMore = showMore && !hasExhaustiveItems;
                var canToggleShowMore = canShowLess || canShowMore;
                return {
                    createURL: function createURL(facetValue) {
                        return _createURL(function(uiState) {
                            return _this.getWidgetUiState(uiState, {
                                searchParameters: state.resetPage().toggleFacetRefinement(attribute, facetValue),
                                helper: helper
                            });
                        });
                    },
                    items: items,
                    refine: triggerRefine,
                    searchForItems: searchFacetValues,
                    isFromSearch: false,
                    canRefine: items.length > 0,
                    widgetParams: widgetParams,
                    isShowingMore: isShowingMore,
                    canToggleShowMore: canToggleShowMore,
                    toggleShowMore: cachedToggleShowMore,
                    sendEvent: sendEvent,
                    hasExhaustiveItems: hasExhaustiveItems
                };
            },
            dispose: function dispose(_ref4) {
                var state = _ref4.state;
                unmountFn();
                var withoutMaxValuesPerFacet = state.setQueryParameter('maxValuesPerFacet', undefined);
                if (operator === 'and') return withoutMaxValuesPerFacet.removeFacet(attribute);
                return withoutMaxValuesPerFacet.removeDisjunctiveFacet(attribute);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref5) {
                var searchParameters = _ref5.searchParameters;
                var values = operator === 'or' ? searchParameters.getDisjunctiveRefinements(attribute) : searchParameters.getConjunctiveRefinements(attribute);
                return $2a848c5d08d17597$var$removeEmptyRefinementsFromUiState($2a848c5d08d17597$var$_objectSpread($2a848c5d08d17597$var$_objectSpread({}, uiState), {}, {
                    refinementList: $2a848c5d08d17597$var$_objectSpread($2a848c5d08d17597$var$_objectSpread({}, uiState.refinementList), {}, $2a848c5d08d17597$var$_defineProperty({}, attribute, values))
                }), attribute);
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref6) {
                var uiState = _ref6.uiState;
                var isDisjunctive = operator === 'or';
                if (searchParameters.isHierarchicalFacet(attribute)) return searchParameters;
                if (isDisjunctive && searchParameters.isConjunctiveFacet(attribute) || !isDisjunctive && searchParameters.isDisjunctiveFacet(attribute)) return searchParameters;
                var values = uiState.refinementList && uiState.refinementList[attribute];
                var withFacetConfiguration = isDisjunctive ? searchParameters.addDisjunctiveFacet(attribute).removeDisjunctiveFacetRefinement(attribute) : searchParameters.addFacet(attribute).removeFacetRefinement(attribute);
                var currentMaxValuesPerFacet = withFacetConfiguration.maxValuesPerFacet || 0;
                var nextMaxValuesPerFacet = Math.max(currentMaxValuesPerFacet, showMore ? showMoreLimit : limit);
                var withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter('maxValuesPerFacet', nextMaxValuesPerFacet);
                if (!values) {
                    var key = isDisjunctive ? 'disjunctiveFacetsRefinements' : 'facetsRefinements';
                    return withMaxValuesPerFacet.setQueryParameters($2a848c5d08d17597$var$_defineProperty({}, key, $2a848c5d08d17597$var$_objectSpread($2a848c5d08d17597$var$_objectSpread({}, withMaxValuesPerFacet[key]), {}, $2a848c5d08d17597$var$_defineProperty({}, attribute, []))));
                }
                return values.reduce(function(parameters, value) {
                    return isDisjunctive ? parameters.addDisjunctiveFacetRefinement(attribute, value) : parameters.addFacetRefinement(attribute, value);
                }, withMaxValuesPerFacet);
            }
        };
    };
};
function $2a848c5d08d17597$var$removeEmptyRefinementsFromUiState(indexUiState, attribute) {
    if (!indexUiState.refinementList) return indexUiState;
    if (!indexUiState.refinementList[attribute] || indexUiState.refinementList[attribute].length === 0) delete indexUiState.refinementList[attribute];
    if (Object.keys(indexUiState.refinementList).length === 0) delete indexUiState.refinementList;
    return indexUiState;
}
var $2a848c5d08d17597$export$2e2bcd8739ae039 = $2a848c5d08d17597$var$connectRefinementList;

});
parcelRegister("bKsNy", function(module, exports) {

$parcel$export(module.exports, "createSendEventForFacet", function () { return $88da544f1101d9e3$export$75bfa3473d01f29f; });

var $5sfwA = parcelRequire("5sfwA");
function $88da544f1101d9e3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $88da544f1101d9e3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $88da544f1101d9e3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $88da544f1101d9e3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $88da544f1101d9e3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $88da544f1101d9e3$var$_defineProperty(obj, key, value) {
    key = $88da544f1101d9e3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $88da544f1101d9e3$var$_toPropertyKey(arg) {
    var key = $88da544f1101d9e3$var$_toPrimitive(arg, "string");
    return $88da544f1101d9e3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $88da544f1101d9e3$var$_toPrimitive(input, hint) {
    if ($88da544f1101d9e3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($88da544f1101d9e3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $88da544f1101d9e3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $88da544f1101d9e3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $88da544f1101d9e3$var$_typeof(obj);
}
function $88da544f1101d9e3$var$_slicedToArray(arr, i) {
    return $88da544f1101d9e3$var$_arrayWithHoles(arr) || $88da544f1101d9e3$var$_iterableToArrayLimit(arr, i) || $88da544f1101d9e3$var$_unsupportedIterableToArray(arr, i) || $88da544f1101d9e3$var$_nonIterableRest();
}
function $88da544f1101d9e3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $88da544f1101d9e3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $88da544f1101d9e3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $88da544f1101d9e3$var$_arrayLikeToArray(o, minLen);
}
function $88da544f1101d9e3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $88da544f1101d9e3$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $88da544f1101d9e3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $88da544f1101d9e3$export$75bfa3473d01f29f(_ref) {
    var instantSearchInstance = _ref.instantSearchInstance, helper = _ref.helper, attr = _ref.attribute, widgetType = _ref.widgetType;
    var sendEventForFacet = function sendEventForFacet() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var facetValue = args[1], _args$ = args[2], eventName = _args$ === void 0 ? 'Filter Applied' : _args$, _args$2 = args[3], additionalData = _args$2 === void 0 ? {} : _args$2;
        var _args$0$split = args[0].split(':'), _args$0$split2 = $88da544f1101d9e3$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
        var attribute = typeof attr === 'string' ? attr : attr(facetValue);
        if (args.length === 1 && $88da544f1101d9e3$var$_typeof(args[0]) === 'object') instantSearchInstance.sendEventToInsights(args[0]);
        else if (eventType === 'click' && args.length >= 2 && args.length <= 4) {
            if (!(0, $5sfwA.isFacetRefined)(helper, attribute, facetValue)) // send event only when the facet is being checked "ON"
            instantSearchInstance.sendEventToInsights({
                insightsMethod: 'clickedFilters',
                widgetType: widgetType,
                eventType: eventType,
                eventModifier: eventModifier,
                payload: $88da544f1101d9e3$var$_objectSpread({
                    eventName: eventName,
                    index: helper.getIndex(),
                    filters: [
                        "".concat(attribute, ":").concat(facetValue)
                    ]
                }, additionalData),
                attribute: attribute
            });
        }
    };
    return sendEventForFacet;
}

});
parcelRegister("5sfwA", function(module, exports) {

$parcel$export(module.exports, "isFacetRefined", function () { return $3f8b9c1c3c3139d1$export$12368a7050a31bdd; });
function $3f8b9c1c3c3139d1$export$12368a7050a31bdd(helper, facet, value) {
    if (helper.state.isHierarchicalFacet(facet)) return helper.state.isHierarchicalFacetRefined(facet, value);
    else if (helper.state.isConjunctiveFacet(facet)) return helper.state.isFacetRefined(facet, value);
    else return helper.state.isDisjunctiveFacetRefined(facet, value);
}

});



parcelRegister("gl0jp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be4ed974494fa981$export$2e2bcd8739ae039; });

var $lLkqw = parcelRequire("lLkqw");
var $be4ed974494fa981$var$_ref2 = (0, $lLkqw.h)("path", {
    d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
});
var $be4ed974494fa981$var$_ref4 = (0, $lLkqw.h)("path", {
    d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
});
var $be4ed974494fa981$var$_ref6 = (0, $lLkqw.h)("g", {
    fill: "none",
    "fill-rule": "evenodd"
}, (0, $lLkqw.h)("g", {
    transform: "translate(1 1)",
    "stroke-width": "2"
}, (0, $lLkqw.h)("circle", {
    "stroke-opacity": ".5",
    cx: "18",
    cy: "18",
    r: "18"
}), (0, $lLkqw.h)("path", {
    d: "M36 18c0-9.94-8.06-18-18-18"
}, (0, $lLkqw.h)("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "1s",
    repeatCount: "indefinite"
}))));
var $be4ed974494fa981$var$defaultTemplate = {
    reset: function reset(_ref) {
        var cssClasses = _ref.cssClasses;
        return (0, $lLkqw.h)("svg", {
            className: cssClasses.resetIcon,
            viewBox: "0 0 20 20",
            width: "10",
            height: "10",
            "aria-hidden": "true"
        }, $be4ed974494fa981$var$_ref2);
    },
    submit: function submit(_ref3) {
        var cssClasses = _ref3.cssClasses;
        return (0, $lLkqw.h)("svg", {
            className: cssClasses.submitIcon,
            width: "10",
            height: "10",
            viewBox: "0 0 40 40",
            "aria-hidden": "true"
        }, $be4ed974494fa981$var$_ref4);
    },
    loadingIndicator: function loadingIndicator(_ref5) {
        var cssClasses = _ref5.cssClasses;
        /* eslint-disable react/no-unknown-property */ // Preact supports kebab case attributes, and using camel case would
        // require using `preact/compat`.
        // @TODO: reconsider using the `react` ESLint preset
        return (0, $lLkqw.h)("svg", {
            "aria-label": "Results are loading",
            className: cssClasses.loadingIcon,
            width: "16",
            height: "16",
            viewBox: "0 0 38 38",
            stroke: "#444",
            "aria-hidden": "true"
        }, $be4ed974494fa981$var$_ref6);
    /* eslint-enable react/no-unknown-property */ }
};
var $be4ed974494fa981$export$2e2bcd8739ae039 = $be4ed974494fa981$var$defaultTemplate;

});

parcelRegister("7QzLi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b69214d15523b07$export$2e2bcd8739ae039; });

var $5bown = parcelRequire("5bown");

var $lLkqw = parcelRequire("lLkqw");

var $fxVpM = parcelRequire("fxVpM");
var $5b69214d15523b07$var$defaultTemplates = {
    item: function item(_ref) {
        var cssClasses = _ref.cssClasses, count = _ref.count, value = _ref.value, highlighted = _ref.highlighted, isRefined = _ref.isRefined, isFromSearch = _ref.isFromSearch;
        return (0, $lLkqw.h)("label", {
            className: (0, $5bown.cx)(cssClasses.label)
        }, (0, $lLkqw.h)("input", {
            type: "checkbox",
            className: (0, $5bown.cx)(cssClasses.checkbox),
            value: value,
            defaultChecked: isRefined
        }), (0, $lLkqw.h)("span", {
            className: (0, $5bown.cx)(cssClasses.labelText),
            dangerouslySetInnerHTML: isFromSearch ? {
                __html: highlighted
            } : undefined
        }, !isFromSearch && highlighted), (0, $lLkqw.h)("span", {
            className: (0, $5bown.cx)(cssClasses.count)
        }, (0, $fxVpM.formatNumber)(count)));
    },
    showMoreText: function showMoreText(_ref2) {
        var isShowingMore = _ref2.isShowingMore;
        return isShowingMore ? 'Show less' : 'Show more';
    },
    searchableNoResults: function searchableNoResults() {
        return 'No results';
    }
};
var $5b69214d15523b07$export$2e2bcd8739ae039 = $5b69214d15523b07$var$defaultTemplates;

});


parcelRegister("9MfiC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71e476daa32f861b$export$2e2bcd8739ae039; });

var $5bown = parcelRequire("5bown");

var $lLkqw = parcelRequire("lLkqw");

var $6xz1z = parcelRequire("6xz1z");

var $gzfYY = parcelRequire("gzfYY");

var $fxVpM = parcelRequire("fxVpM");

var $8JLyQ = parcelRequire("8JLyQ");

var $985ic = parcelRequire("985ic");

var $kooa4 = parcelRequire("kooa4");
var $hthTp = parcelRequire("hthTp");
function $71e476daa32f861b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $71e476daa32f861b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $71e476daa32f861b$var$_typeof(obj);
}
function $71e476daa32f861b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $71e476daa32f861b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $71e476daa32f861b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $71e476daa32f861b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $71e476daa32f861b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $71e476daa32f861b$var$_defineProperty(obj, key, value) {
    key = $71e476daa32f861b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $71e476daa32f861b$var$_toPropertyKey(arg) {
    var key = $71e476daa32f861b$var$_toPrimitive(arg, "string");
    return $71e476daa32f861b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $71e476daa32f861b$var$_toPrimitive(input, hint) {
    if ($71e476daa32f861b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($71e476daa32f861b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $71e476daa32f861b$var$withUsage = (0, $kooa4.createDocumentationMessageGenerator)({
    name: 'stats'
});
var $71e476daa32f861b$var$suit = (0, $8JLyQ.component)('Stats');
var $71e476daa32f861b$export$952bbd6b1defadc7 = {
    text: function text(props) {
        return "".concat(props.areHitsSorted ? $71e476daa32f861b$var$getSortedResultsSentence(props) : $71e476daa32f861b$var$getResultsSentence(props), " found in ").concat(props.processingTimeMS, "ms");
    }
};
function $71e476daa32f861b$var$getSortedResultsSentence(_ref) {
    var nbHits = _ref.nbHits, hasNoSortedResults = _ref.hasNoSortedResults, hasOneSortedResults = _ref.hasOneSortedResults, hasManySortedResults = _ref.hasManySortedResults, nbSortedHits = _ref.nbSortedHits;
    var suffix = "sorted out of ".concat((0, $fxVpM.formatNumber)(nbHits));
    if (hasNoSortedResults) return "No relevant results ".concat(suffix);
    if (hasOneSortedResults) return "1 relevant result ".concat(suffix);
    if (hasManySortedResults) return "".concat((0, $fxVpM.formatNumber)(nbSortedHits || 0), " relevant results ").concat(suffix);
    return '';
}
function $71e476daa32f861b$var$getResultsSentence(_ref2) {
    var nbHits = _ref2.nbHits, hasNoResults = _ref2.hasNoResults, hasOneResult = _ref2.hasOneResult, hasManyResults = _ref2.hasManyResults;
    if (hasNoResults) return 'No results';
    if (hasOneResult) return '1 result';
    if (hasManyResults) return "".concat((0, $fxVpM.formatNumber)(nbHits), " results");
    return '';
}
var $71e476daa32f861b$var$renderer = function renderer(_ref3) {
    var renderState = _ref3.renderState, cssClasses = _ref3.cssClasses, containerNode = _ref3.containerNode, templates = _ref3.templates;
    return function(_ref4, isFirstRendering) {
        var hitsPerPage = _ref4.hitsPerPage, nbHits = _ref4.nbHits, nbSortedHits = _ref4.nbSortedHits, areHitsSorted = _ref4.areHitsSorted, nbPages = _ref4.nbPages, page = _ref4.page, processingTimeMS = _ref4.processingTimeMS, query = _ref4.query, instantSearchInstance = _ref4.instantSearchInstance;
        if (isFirstRendering) {
            renderState.templateProps = (0, $985ic.prepareTemplateProps)({
                defaultTemplates: $71e476daa32f861b$export$952bbd6b1defadc7,
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: templates
            });
            return;
        }
        (0, $lLkqw.render)((0, $lLkqw.h)((0, $6xz1z.default), {
            cssClasses: cssClasses,
            hitsPerPage: hitsPerPage,
            nbHits: nbHits,
            nbSortedHits: nbSortedHits,
            areHitsSorted: areHitsSorted,
            nbPages: nbPages,
            page: page,
            processingTimeMS: processingTimeMS,
            query: query,
            templateProps: renderState.templateProps
        }), containerNode);
    };
};
/**
 * The `stats` widget is used to display useful insights about the current results.
 *
 * By default, it will display the **number of hits** and the time taken to compute the
 * results inside the engine.
 */ var $71e476daa32f861b$var$stats = function stats(widgetParams) {
    var _ref5 = widgetParams || {}, container = _ref5.container, _ref5$cssClasses = _ref5.cssClasses, userCssClasses = _ref5$cssClasses === void 0 ? {} : _ref5$cssClasses, _ref5$templates = _ref5.templates, templates = _ref5$templates === void 0 ? {} : _ref5$templates;
    if (!container) throw new Error($71e476daa32f861b$var$withUsage('The `container` option is required.'));
    var containerNode = (0, $hthTp.getContainerNode)(container);
    var cssClasses = {
        root: (0, $5bown.cx)($71e476daa32f861b$var$suit(), userCssClasses.root),
        text: (0, $5bown.cx)($71e476daa32f861b$var$suit({
            descendantName: 'text'
        }), userCssClasses.text)
    };
    var specializedRenderer = $71e476daa32f861b$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        templates: templates,
        renderState: {}
    });
    var makeWidget = (0, $gzfYY.default)(specializedRenderer, function() {
        return (0, $lLkqw.render)(null, containerNode);
    });
    return $71e476daa32f861b$var$_objectSpread($71e476daa32f861b$var$_objectSpread({}, makeWidget({})), {}, {
        $$widgetType: 'ais.stats'
    });
};
var $71e476daa32f861b$export$2e2bcd8739ae039 = $71e476daa32f861b$var$stats;

});
parcelRegister("6xz1z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c30fe3910161c6f$export$2e2bcd8739ae039; });

var $5bown = parcelRequire("5bown");

var $lLkqw = parcelRequire("lLkqw");

var $kNs3K = parcelRequire("kNs3K");
function $4c30fe3910161c6f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $4c30fe3910161c6f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4c30fe3910161c6f$var$_typeof(obj);
}
var $4c30fe3910161c6f$var$_excluded = [
    "nbHits",
    "nbSortedHits",
    "cssClasses",
    "templateProps"
];
function $4c30fe3910161c6f$var$_extends() {
    $4c30fe3910161c6f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4c30fe3910161c6f$var$_extends.apply(this, arguments);
}
function $4c30fe3910161c6f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4c30fe3910161c6f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4c30fe3910161c6f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4c30fe3910161c6f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4c30fe3910161c6f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4c30fe3910161c6f$var$_defineProperty(obj, key, value) {
    key = $4c30fe3910161c6f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4c30fe3910161c6f$var$_toPropertyKey(arg) {
    var key = $4c30fe3910161c6f$var$_toPrimitive(arg, "string");
    return $4c30fe3910161c6f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4c30fe3910161c6f$var$_toPrimitive(input, hint) {
    if ($4c30fe3910161c6f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4c30fe3910161c6f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $4c30fe3910161c6f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4c30fe3910161c6f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4c30fe3910161c6f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $4c30fe3910161c6f$var$Stats = function Stats(_ref) {
    var nbHits = _ref.nbHits, nbSortedHits = _ref.nbSortedHits, cssClasses = _ref.cssClasses, templateProps = _ref.templateProps, rest = $4c30fe3910161c6f$var$_objectWithoutProperties(_ref, $4c30fe3910161c6f$var$_excluded);
    return (0, $lLkqw.h)("div", {
        className: (0, $5bown.cx)(cssClasses.root)
    }, (0, $lLkqw.h)((0, $kNs3K.default), $4c30fe3910161c6f$var$_extends({}, templateProps, {
        templateKey: "text",
        rootTagName: "span",
        rootProps: {
            className: cssClasses.text
        },
        data: $4c30fe3910161c6f$var$_objectSpread({
            hasManySortedResults: nbSortedHits && nbSortedHits > 1,
            hasNoSortedResults: nbSortedHits === 0,
            hasOneSortedResults: nbSortedHits === 1,
            hasManyResults: nbHits > 1,
            hasNoResults: nbHits === 0,
            hasOneResult: nbHits === 1,
            nbHits: nbHits,
            nbSortedHits: nbSortedHits,
            cssClasses: cssClasses
        }, rest)
    })));
};
var $4c30fe3910161c6f$export$2e2bcd8739ae039 = $4c30fe3910161c6f$var$Stats;

});

parcelRegister("gzfYY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0fc50012c6ba4a0$export$2e2bcd8739ae039; });

var $6YH5z = parcelRequire("6YH5z");
var $kooa4 = parcelRequire("kooa4");
var $fMELL = parcelRequire("fMELL");
function $c0fc50012c6ba4a0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c0fc50012c6ba4a0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c0fc50012c6ba4a0$var$_typeof(obj);
}
function $c0fc50012c6ba4a0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c0fc50012c6ba4a0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c0fc50012c6ba4a0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c0fc50012c6ba4a0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c0fc50012c6ba4a0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c0fc50012c6ba4a0$var$_defineProperty(obj, key, value) {
    key = $c0fc50012c6ba4a0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c0fc50012c6ba4a0$var$_toPropertyKey(arg) {
    var key = $c0fc50012c6ba4a0$var$_toPrimitive(arg, "string");
    return $c0fc50012c6ba4a0$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c0fc50012c6ba4a0$var$_toPrimitive(input, hint) {
    if ($c0fc50012c6ba4a0$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c0fc50012c6ba4a0$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $c0fc50012c6ba4a0$var$withUsage = (0, $kooa4.createDocumentationMessageGenerator)({
    name: 'stats',
    connector: true
});
/**
 * **Stats** connector provides the logic to build a custom widget that will displays
 * search statistics (hits number and processing time).
 */ var $c0fc50012c6ba4a0$var$connectStats = function connectStats(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $fMELL.noop);
    (0, $6YH5z.checkRendering)(renderFn, $c0fc50012c6ba4a0$var$withUsage());
    return function(widgetParams) {
        return {
            $$type: 'ais.stats',
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($c0fc50012c6ba4a0$var$_objectSpread($c0fc50012c6ba4a0$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($c0fc50012c6ba4a0$var$_objectSpread($c0fc50012c6ba4a0$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose() {
                unmountFn();
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $c0fc50012c6ba4a0$var$_objectSpread($c0fc50012c6ba4a0$var$_objectSpread({}, renderState), {}, {
                    stats: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref) {
                var results = _ref.results, state = _ref.state;
                if (!results) return {
                    hitsPerPage: state.hitsPerPage,
                    nbHits: 0,
                    nbSortedHits: undefined,
                    areHitsSorted: false,
                    nbPages: 0,
                    page: state.page || 0,
                    processingTimeMS: -1,
                    query: state.query || '',
                    widgetParams: widgetParams
                };
                return {
                    hitsPerPage: results.hitsPerPage,
                    nbHits: results.nbHits,
                    nbSortedHits: results.nbSortedHits,
                    areHitsSorted: typeof results.appliedRelevancyStrictness !== 'undefined' && results.appliedRelevancyStrictness > 0 && results.nbSortedHits !== results.nbHits,
                    nbPages: results.nbPages,
                    page: results.page,
                    processingTimeMS: results.processingTimeMS,
                    query: results.query,
                    widgetParams: widgetParams
                };
            }
        };
    };
};
var $c0fc50012c6ba4a0$export$2e2bcd8739ae039 = $c0fc50012c6ba4a0$var$connectStats;

});


parcelRegister("6ACgD", function(module, exports) {
"use strict";

var $9suN4 = parcelRequire("9suN4");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4cc3c9f342c89ba6$var$_regenerator = $9suN4((parcelRequire("iQvf5")));

var $4cc3c9f342c89ba6$var$_asyncToGenerator2 = $9suN4((parcelRequire("H0Kw6")));

var $4cc3c9f342c89ba6$var$_classCallCheck2 = $9suN4((parcelRequire("6RERu")));

var $4cc3c9f342c89ba6$var$_createClass2 = $9suN4((parcelRequire("1XdEY")));

var $7fN16 = parcelRequire("7fN16");

var $eomKw = parcelRequire("eomKw");

var $0gOMs = parcelRequire("0gOMs");

var $aFsEy = parcelRequire("aFsEy");

var $eXaZk = parcelRequire("eXaZk");
var $4cc3c9f342c89ba6$var$TypesenseInstantsearchAdapter = /*#__PURE__*/ function() {
    function TypesenseInstantsearchAdapter(options) {
        var _this = this;
        (0, $4cc3c9f342c89ba6$var$_classCallCheck2["default"])(this, TypesenseInstantsearchAdapter);
        this.updateConfiguration(options);
        this.searchClient = {
            clearCache: function clearCache() {
                return _this.clearCache();
            },
            search: function search(instantsearchRequests) {
                return _this.searchTypesenseAndAdapt(instantsearchRequests);
            },
            searchForFacetValues: function searchForFacetValues(instantsearchRequests) {
                return _this.searchTypesenseForFacetValuesAndAdapt(instantsearchRequests);
            }
        };
    }
    (0, $4cc3c9f342c89ba6$var$_createClass2["default"])(TypesenseInstantsearchAdapter, [
        {
            key: "searchTypesenseAndAdapt",
            value: function() {
                var _searchTypesenseAndAdapt = (0, $4cc3c9f342c89ba6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4cc3c9f342c89ba6$var$_regenerator["default"].mark(function _callee(instantsearchRequests) {
                    var _this2 = this;
                    var typesenseResponse, adaptedResponses;
                    return $4cc3c9f342c89ba6$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return this._adaptAndPerformTypesenseRequest(instantsearchRequests);
                            case 3:
                                typesenseResponse = _context.sent;
                                adaptedResponses = typesenseResponse.results.map(function(typesenseResult, index) {
                                    _this2._validateTypesenseResult(typesenseResult);
                                    var responseAdapter = new $aFsEy.SearchResponseAdapter(typesenseResult, instantsearchRequests[index], _this2.configuration, typesenseResponse.results);
                                    return responseAdapter.adapt();
                                });
                                return _context.abrupt("return", {
                                    results: adaptedResponses
                                });
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](0);
                                console.error(_context.t0);
                                throw _context.t0;
                            case 12:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            0,
                            8
                        ]
                    ]);
                }));
                function searchTypesenseAndAdapt(_x) {
                    return _searchTypesenseAndAdapt.apply(this, arguments);
                }
                return searchTypesenseAndAdapt;
            }()
        },
        {
            key: "searchTypesenseForFacetValuesAndAdapt",
            value: function() {
                var _searchTypesenseForFacetValuesAndAdapt = (0, $4cc3c9f342c89ba6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4cc3c9f342c89ba6$var$_regenerator["default"].mark(function _callee2(instantsearchRequests) {
                    var _this3 = this;
                    var typesenseResponse, adaptedResponses;
                    return $4cc3c9f342c89ba6$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return this._adaptAndPerformTypesenseRequest(instantsearchRequests);
                            case 3:
                                typesenseResponse = _context2.sent;
                                adaptedResponses = typesenseResponse.results.map(function(typesenseResult, index) {
                                    _this3._validateTypesenseResult(typesenseResult);
                                    var responseAdapter = new $eXaZk.FacetSearchResponseAdapter(typesenseResult, instantsearchRequests[index], _this3.configuration);
                                    return responseAdapter.adapt();
                                });
                                return _context2.abrupt("return", adaptedResponses);
                            case 8:
                                _context2.prev = 8;
                                _context2.t0 = _context2["catch"](0);
                                console.error(_context2.t0);
                                throw _context2.t0;
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            0,
                            8
                        ]
                    ]);
                }));
                function searchTypesenseForFacetValuesAndAdapt(_x2) {
                    return _searchTypesenseForFacetValuesAndAdapt.apply(this, arguments);
                }
                return searchTypesenseForFacetValuesAndAdapt;
            }()
        },
        {
            key: "_adaptAndPerformTypesenseRequest",
            value: function() {
                var _adaptAndPerformTypesenseRequest2 = (0, $4cc3c9f342c89ba6$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4cc3c9f342c89ba6$var$_regenerator["default"].mark(function _callee3(instantsearchRequests) {
                    var requestAdapter, typesenseResponse;
                    return $4cc3c9f342c89ba6$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                requestAdapter = new $0gOMs.SearchRequestAdapter(instantsearchRequests, this.typesenseClient, this.configuration);
                                _context3.next = 3;
                                return requestAdapter.request();
                            case 3:
                                typesenseResponse = _context3.sent;
                                return _context3.abrupt("return", typesenseResponse);
                            case 5:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function _adaptAndPerformTypesenseRequest(_x3) {
                    return _adaptAndPerformTypesenseRequest2.apply(this, arguments);
                }
                return _adaptAndPerformTypesenseRequest;
            }()
        },
        {
            key: "clearCache",
            value: function clearCache() {
                this.typesenseClient = new $eomKw.SearchClient(this.configuration.server);
                return this.searchClient;
            }
        },
        {
            key: "updateConfiguration",
            value: function updateConfiguration(options) {
                this.configuration = new $7fN16.Configuration(options);
                this.configuration.validate();
                this.typesenseClient = new $eomKw.SearchClient(this.configuration.server);
                return true;
            }
        },
        {
            key: "_validateTypesenseResult",
            value: function _validateTypesenseResult(typesenseResult) {
                if (typesenseResult.error) throw new Error("".concat(typesenseResult.code, " - ").concat(typesenseResult.error));
                if (!typesenseResult.hits && !typesenseResult.grouped_hits) throw new Error("Did not find any hits. ".concat(typesenseResult.code, " - ").concat(typesenseResult.error));
            }
        }
    ]);
    return TypesenseInstantsearchAdapter;
}();
module.exports["default"] = $4cc3c9f342c89ba6$var$TypesenseInstantsearchAdapter;

});
parcelRegister("9suN4", function(module, exports) {
function $6e2e9cf125fabe14$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $6e2e9cf125fabe14$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iQvf5", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $db855163d114dc65$var$runtime = (parcelRequire("k4cXH"))();
module.exports = $db855163d114dc65$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $db855163d114dc65$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $db855163d114dc65$var$runtime;
    else Function("r", "regeneratorRuntime = r")($db855163d114dc65$var$runtime);
}

});
parcelRegister("k4cXH", function(module, exports) {

var $lyHQD = parcelRequire("lyHQD");
var $e9be3c4e444de2b8$var$_typeof = $lyHQD.default;
function $e9be3c4e444de2b8$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $e9be3c4e444de2b8$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $e9be3c4e444de2b8$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($e9be3c4e444de2b8$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $e9be3c4e444de2b8$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lyHQD", function(module, exports) {
function $fb1ec93ed73f93f1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $fb1ec93ed73f93f1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $fb1ec93ed73f93f1$var$_typeof(o);
}
module.exports = $fb1ec93ed73f93f1$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("H0Kw6", function(module, exports) {
function $0814990e8b155835$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $0814990e8b155835$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $0814990e8b155835$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $0814990e8b155835$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $0814990e8b155835$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6RERu", function(module, exports) {
function $4ff763a0d172a334$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $4ff763a0d172a334$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1XdEY", function(module, exports) {

var $hGj3F = parcelRequire("hGj3F");
function $16c5e5ae47e6be17$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $hGj3F(o.key), o);
    }
}
function $16c5e5ae47e6be17$var$_createClass(e, r, t) {
    return r && $16c5e5ae47e6be17$var$_defineProperties(e.prototype, r), t && $16c5e5ae47e6be17$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $16c5e5ae47e6be17$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hGj3F", function(module, exports) {

var $lyHQD = parcelRequire("lyHQD");
var $035267d04eaad453$var$_typeof = $lyHQD.default;

var $cZPxD = parcelRequire("cZPxD");
function $035267d04eaad453$var$toPropertyKey(t) {
    var i = $cZPxD(t, "string");
    return "symbol" == $035267d04eaad453$var$_typeof(i) ? i : i + "";
}
module.exports = $035267d04eaad453$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cZPxD", function(module, exports) {

var $lyHQD = parcelRequire("lyHQD");
var $9763299f59c38712$var$_typeof = $lyHQD.default;
function $9763299f59c38712$var$toPrimitive(t, r) {
    if ("object" != $9763299f59c38712$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9763299f59c38712$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $9763299f59c38712$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("7fN16", function(module, exports) {
"use strict";

var $9suN4 = parcelRequire("9suN4");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Configuration = void 0;

var $547ff4d9be9317cd$var$_classCallCheck2 = $9suN4((parcelRequire("6RERu")));

var $547ff4d9be9317cd$var$_createClass2 = $9suN4((parcelRequire("1XdEY")));
var $547ff4d9be9317cd$var$Configuration = /*#__PURE__*/ function() {
    function Configuration() {
        var _this$server$cacheSea, _options$additionalSe, _ref, _this$additionalSearc, _ref2, _this$additionalSearc2, _ref3, _this$additionalSearc3, _ref4, _this$additionalSearc4, _options$geoLocationF, _options$facetableFie, _options$collectionSp, _this = this, _options$flattenGroup, _options$facetByOptio, _options$filterByOpti, _options$collectionSp2, _options$collectionSp3;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $547ff4d9be9317cd$var$_classCallCheck2["default"])(this, Configuration);
        this.server = options.server || {
            nodes: [
                {
                    host: "localhost",
                    port: "8108",
                    path: "",
                    protocol: "http"
                }
            ]
        };
        this.server.cacheSearchResultsForSeconds = (_this$server$cacheSea = this.server.cacheSearchResultsForSeconds) !== null && _this$server$cacheSea !== void 0 ? _this$server$cacheSea : 120;
        this.additionalSearchParameters = (_options$additionalSe = options.additionalSearchParameters) !== null && _options$additionalSe !== void 0 ? _options$additionalSe : {};
        this.additionalSearchParameters.query_by = (_ref = (_this$additionalSearc = this.additionalSearchParameters.queryBy) !== null && _this$additionalSearc !== void 0 ? _this$additionalSearc : this.additionalSearchParameters.query_by) !== null && _ref !== void 0 ? _ref : "";
        this.additionalSearchParameters.preset = (_ref2 = (_this$additionalSearc2 = this.additionalSearchParameters.preset) !== null && _this$additionalSearc2 !== void 0 ? _this$additionalSearc2 : this.additionalSearchParameters.preset) !== null && _ref2 !== void 0 ? _ref2 : "";
        this.additionalSearchParameters.sort_by = (_ref3 = (_this$additionalSearc3 = this.additionalSearchParameters.sortBy) !== null && _this$additionalSearc3 !== void 0 ? _this$additionalSearc3 : this.additionalSearchParameters.sort_by) !== null && _ref3 !== void 0 ? _ref3 : "";
        this.additionalSearchParameters.highlight_full_fields = (_ref4 = (_this$additionalSearc4 = this.additionalSearchParameters.highlightFullFields) !== null && _this$additionalSearc4 !== void 0 ? _this$additionalSearc4 : this.additionalSearchParameters.highlight_full_fields) !== null && _ref4 !== void 0 ? _ref4 : this.additionalSearchParameters.query_by;
        this.geoLocationField = (_options$geoLocationF = options.geoLocationField) !== null && _options$geoLocationF !== void 0 ? _options$geoLocationF : "_geoloc";
        this.facetableFieldsWithSpecialCharacters = (_options$facetableFie = options.facetableFieldsWithSpecialCharacters) !== null && _options$facetableFie !== void 0 ? _options$facetableFie : [];
        this.collectionSpecificSearchParameters = (_options$collectionSp = options.collectionSpecificSearchParameters) !== null && _options$collectionSp !== void 0 ? _options$collectionSp : {};
        Object.keys(this.collectionSpecificSearchParameters).forEach(function(collection) {
            var _params$queryBy, _params$preset, _params$sortBy, _ref5, _ref6, _params$highlightFull;
            var params = _this.collectionSpecificSearchParameters[collection];
            params.query_by = (_params$queryBy = params.queryBy) !== null && _params$queryBy !== void 0 ? _params$queryBy : params.query_by;
            params.preset = (_params$preset = params.preset) !== null && _params$preset !== void 0 ? _params$preset : params.preset;
            params.sort_by = (_params$sortBy = params.sortBy) !== null && _params$sortBy !== void 0 ? _params$sortBy : params.sort_by;
            params.highlight_full_fields = (_ref5 = (_ref6 = (_params$highlightFull = params.highlightFullFields) !== null && _params$highlightFull !== void 0 ? _params$highlightFull : params.highlight_full_fields) !== null && _ref6 !== void 0 ? _ref6 : _this.additionalSearchParameters.highlight_full_fields) !== null && _ref5 !== void 0 ? _ref5 : params.query_by; // Remove undefined values
            Object.keys(params).forEach(function(key) {
                return params[key] === undefined ? delete params[key] : {};
            });
        });
        this.renderingContent = options.renderingContent;
        this.flattenGroupedHits = (_options$flattenGroup = options.flattenGroupedHits) !== null && _options$flattenGroup !== void 0 ? _options$flattenGroup : true;
        this.facetByOptions = (_options$facetByOptio = options.facetByOptions) !== null && _options$facetByOptio !== void 0 ? _options$facetByOptio : {};
        this.filterByOptions = (_options$filterByOpti = options.filterByOptions) !== null && _options$filterByOpti !== void 0 ? _options$filterByOpti : {};
        this.collectionSpecificFacetByOptions = (_options$collectionSp2 = options.collectionSpecificFacetByOptions) !== null && _options$collectionSp2 !== void 0 ? _options$collectionSp2 : {};
        this.collectionSpecificFilterByOptions = (_options$collectionSp3 = options.collectionSpecificFilterByOptions) !== null && _options$collectionSp3 !== void 0 ? _options$collectionSp3 : {};
    }
    (0, $547ff4d9be9317cd$var$_createClass2["default"])(Configuration, [
        {
            key: "validate",
            value: function validate() {
                // Warn if camelCased parameters are used, suggest using snake_cased parameters instead
                if (this.additionalSearchParameters.queryBy || Object.values(this.collectionSpecificSearchParameters).some(function(c) {
                    return c.queryBy;
                })) console.warn("[typesense-instantsearch-adapter] Please use snake_cased versions of parameters in additionalSearchParameters instead of camelCased parameters. For example: Use query_by instead of queryBy. camelCased parameters will be deprecated in a future version. We're making this change so that parameter names are identical to the ones sent to Typesense (which are all snake_cased), and to also keep the types for these parameters in sync with the types defined in typesense-js.");
                /*
       * Either additionalSearchParameters.query_by or additionalSearchParameters.preset needs to be set, or
       *   All collectionSpecificSearchParameters need to have query_by or preset
       *
       * */ if (this.additionalSearchParameters.query_by.length === 0 && this.additionalSearchParameters.preset.length === 0 && (Object.keys(this.collectionSpecificSearchParameters).length === 0 || Object.values(this.collectionSpecificSearchParameters).some(function(c) {
                    return (c.query_by || "").length === 0 && (c.preset || "").length === 0;
                }))) throw new Error("[typesense-instantsearch-adapter] Missing parameter: One of additionalSearchParameters.query_by or additionalSearchParameters.preset needs to be set, or all collectionSpecificSearchParameters need to have either .query_by or .preset set.");
            }
        }
    ]);
    return Configuration;
}();
module.exports.Configuration = $547ff4d9be9317cd$var$Configuration;

});

parcelRegister("eomKw", function(module, exports) {
"use strict";
var $a7a4f41d9881ccba$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a7a4f41d9881ccba$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a7a4f41d9881ccba$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a7a4f41d9881ccba$var$__createBinding(result, mod, k);
    }
    $a7a4f41d9881ccba$var$__setModuleDefault(result, mod);
    return result;
};
var $a7a4f41d9881ccba$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Errors = module.exports.SearchClient = module.exports.Client = void 0;

var $a7a4f41d9881ccba$var$Client_1 = $a7a4f41d9881ccba$var$__importDefault((parcelRequire("e9W8r")));
module.exports.Client = $a7a4f41d9881ccba$var$Client_1.default;

var $a7a4f41d9881ccba$var$SearchClient_1 = $a7a4f41d9881ccba$var$__importDefault((parcelRequire("6EHhb")));
module.exports.SearchClient = $a7a4f41d9881ccba$var$SearchClient_1.default;

var $a7a4f41d9881ccba$var$Errors = $a7a4f41d9881ccba$var$__importStar((parcelRequire("f6qFb")));
module.exports.Errors = $a7a4f41d9881ccba$var$Errors;
module.exports.default = {
    Client: $a7a4f41d9881ccba$var$Client_1.default,
    SearchClient: $a7a4f41d9881ccba$var$SearchClient_1.default,
    Errors: $a7a4f41d9881ccba$var$Errors
};

});
parcelRegister("e9W8r", function(module, exports) {
"use strict";
/* eslint-disable no-dupe-class-members */ var $a4ef00600366d32c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $a4ef00600366d32c$var$Configuration_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("1B9yQ")));

var $a4ef00600366d32c$var$ApiCall_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("4g7eM")));

var $a4ef00600366d32c$var$Collections_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("cbDml")));

var $a4ef00600366d32c$var$Collection_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("9dH5k")));

var $a4ef00600366d32c$var$Aliases_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("aHzj0")));

var $a4ef00600366d32c$var$Alias_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("idxV3")));

var $a4ef00600366d32c$var$Keys_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("ktyOU")));

var $a4ef00600366d32c$var$Key_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("6REhn")));

var $a4ef00600366d32c$var$Debug_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("ejoAV")));

var $a4ef00600366d32c$var$Metrics_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("5rAEm")));

var $a4ef00600366d32c$var$Health_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("dFdQs")));

var $a4ef00600366d32c$var$Operations_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("bU3XR")));

var $a4ef00600366d32c$var$MultiSearch_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("8wz0y")));

var $a4ef00600366d32c$var$Presets_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("54pLW")));

var $a4ef00600366d32c$var$Preset_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("fW5Co")));

var $a4ef00600366d32c$var$Analytics_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("gYmIV")));

var $a4ef00600366d32c$var$Stopwords_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("kpYim")));

var $a4ef00600366d32c$var$Stopword_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("aqI62")));

var $a4ef00600366d32c$var$Conversations_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("3oWtD")));

var $a4ef00600366d32c$var$Conversation_1 = $a4ef00600366d32c$var$__importDefault((parcelRequire("2CfIE")));
var $a4ef00600366d32c$var$Client = /** @class */ function() {
    function Client(options) {
        var _a;
        options.sendApiKeyAsQueryParam = (_a = options.sendApiKeyAsQueryParam) !== null && _a !== void 0 ? _a : false;
        this.configuration = new $a4ef00600366d32c$var$Configuration_1.default(options);
        this.apiCall = new $a4ef00600366d32c$var$ApiCall_1.default(this.configuration);
        this.debug = new $a4ef00600366d32c$var$Debug_1.default(this.apiCall);
        this.metrics = new $a4ef00600366d32c$var$Metrics_1.default(this.apiCall);
        this.health = new $a4ef00600366d32c$var$Health_1.default(this.apiCall);
        this.operations = new $a4ef00600366d32c$var$Operations_1.default(this.apiCall);
        this.multiSearch = new $a4ef00600366d32c$var$MultiSearch_1.default(this.apiCall, this.configuration);
        this._collections = new $a4ef00600366d32c$var$Collections_1.default(this.apiCall);
        this.individualCollections = {};
        this._aliases = new $a4ef00600366d32c$var$Aliases_1.default(this.apiCall);
        this.individualAliases = {};
        this._keys = new $a4ef00600366d32c$var$Keys_1.default(this.apiCall);
        this.individualKeys = {};
        this._presets = new $a4ef00600366d32c$var$Presets_1.default(this.apiCall);
        this.individualPresets = {};
        this._stopwords = new $a4ef00600366d32c$var$Stopwords_1.default(this.apiCall);
        this.individualStopwords = {};
        this.analytics = new $a4ef00600366d32c$var$Analytics_1.default(this.apiCall);
        this._conversations = new $a4ef00600366d32c$var$Conversations_1.default(this.apiCall);
        this.individualConversations = {};
    }
    Client.prototype.collections = function(collectionName) {
        if (collectionName === undefined) return this._collections;
        else {
            if (this.individualCollections[collectionName] === undefined) this.individualCollections[collectionName] = new $a4ef00600366d32c$var$Collection_1.default(collectionName, this.apiCall, this.configuration);
            return this.individualCollections[collectionName];
        }
    };
    Client.prototype.aliases = function(aliasName) {
        if (aliasName === undefined) return this._aliases;
        else {
            if (this.individualAliases[aliasName] === undefined) this.individualAliases[aliasName] = new $a4ef00600366d32c$var$Alias_1.default(aliasName, this.apiCall);
            return this.individualAliases[aliasName];
        }
    };
    Client.prototype.keys = function(id) {
        if (id === undefined) return this._keys;
        else {
            if (this.individualKeys[id] === undefined) this.individualKeys[id] = new $a4ef00600366d32c$var$Key_1.default(id, this.apiCall);
            return this.individualKeys[id];
        }
    };
    Client.prototype.presets = function(id) {
        if (id === undefined) return this._presets;
        else {
            if (this.individualPresets[id] === undefined) this.individualPresets[id] = new $a4ef00600366d32c$var$Preset_1.default(id, this.apiCall);
            return this.individualPresets[id];
        }
    };
    Client.prototype.stopwords = function(id) {
        if (id === undefined) return this._stopwords;
        else {
            if (this.individualStopwords[id] === undefined) this.individualStopwords[id] = new $a4ef00600366d32c$var$Stopword_1.default(id, this.apiCall);
            return this.individualStopwords[id];
        }
    };
    Client.prototype.conversations = function(id) {
        if (id === undefined) return this._conversations;
        else {
            if (this.individualConversations[id] === undefined) this.individualConversations[id] = new $a4ef00600366d32c$var$Conversation_1.default(id, this.apiCall);
            return this.individualConversations[id];
        }
    };
    return Client;
}();
module.exports.default = $a4ef00600366d32c$var$Client;

});
parcelRegister("1B9yQ", function(module, exports) {
"use strict";
var $12a0a9c6f1b1d712$var$__assign = module.exports && module.exports.__assign || function() {
    $12a0a9c6f1b1d712$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $12a0a9c6f1b1d712$var$__assign.apply(this, arguments);
};
var $12a0a9c6f1b1d712$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $12a0a9c6f1b1d712$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $12a0a9c6f1b1d712$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $12a0a9c6f1b1d712$var$__createBinding(result, mod, k);
    }
    $12a0a9c6f1b1d712$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $12a0a9c6f1b1d712$var$logger = $12a0a9c6f1b1d712$var$__importStar((parcelRequire("hrNpa")));

var $f6qFb = parcelRequire("f6qFb");
var $12a0a9c6f1b1d712$var$Configuration = /** @class */ function() {
    function Configuration(options) {
        var _this = this;
        this.nodes = options.nodes || [];
        this.nodes = this.nodes.map(function(node) {
            return _this.setDefaultPathInNode(node);
        }).map(function(node) {
            return _this.setDefaultPortInNode(node);
        }).map(function(node) {
            return $12a0a9c6f1b1d712$var$__assign({}, node);
        }); // Make a deep copy
        if (options.randomizeNodes == null) options.randomizeNodes = true;
        if (options.randomizeNodes === true) this.shuffleArray(this.nodes);
        this.nearestNode = options.nearestNode;
        this.nearestNode = this.setDefaultPathInNode(this.nearestNode);
        this.nearestNode = this.setDefaultPortInNode(this.nearestNode);
        this.connectionTimeoutSeconds = options.connectionTimeoutSeconds || options.timeoutSeconds || 5;
        this.healthcheckIntervalSeconds = options.healthcheckIntervalSeconds || 60;
        this.numRetries = options.numRetries || this.nodes.length + (this.nearestNode == null ? 0 : 1) || 3;
        this.retryIntervalSeconds = options.retryIntervalSeconds || 0.1;
        this.apiKey = options.apiKey;
        this.sendApiKeyAsQueryParam = options.sendApiKeyAsQueryParam; // We will set a default for this in Client and SearchClient
        this.cacheSearchResultsForSeconds = options.cacheSearchResultsForSeconds || 0; // Disable client-side cache by default
        this.useServerSideSearchCache = options.useServerSideSearchCache || false;
        this.logger = options.logger || $12a0a9c6f1b1d712$var$logger;
        this.logLevel = options.logLevel || "warn";
        this.logger.setLevel(this.logLevel);
        this.additionalHeaders = options.additionalHeaders;
        this.httpAgent = options.httpAgent;
        this.httpsAgent = options.httpsAgent;
        this.showDeprecationWarnings(options);
        this.validate();
    }
    Configuration.prototype.validate = function() {
        if (this.nodes == null || this.nodes.length === 0 || this.validateNodes()) throw new $f6qFb.MissingConfigurationError("Ensure that nodes[].protocol, nodes[].host and nodes[].port are set");
        if (this.nearestNode != null && this.isNodeMissingAnyParameters(this.nearestNode)) throw new $f6qFb.MissingConfigurationError("Ensure that nearestNodes.protocol, nearestNodes.host and nearestNodes.port are set");
        if (this.apiKey == null) throw new $f6qFb.MissingConfigurationError("Ensure that apiKey is set");
        return true;
    };
    Configuration.prototype.validateNodes = function() {
        var _this = this;
        return this.nodes.some(function(node) {
            return _this.isNodeMissingAnyParameters(node);
        });
    };
    Configuration.prototype.isNodeMissingAnyParameters = function(node) {
        return ![
            "protocol",
            "host",
            "port",
            "path"
        ].every(function(key) {
            return node.hasOwnProperty(key);
        }) && node["url"] == null;
    };
    Configuration.prototype.setDefaultPathInNode = function(node) {
        if (node != null && !node.hasOwnProperty("path")) node["path"] = "";
        return node;
    };
    Configuration.prototype.setDefaultPortInNode = function(node) {
        if (node != null && !node.hasOwnProperty("port") && node.hasOwnProperty("protocol")) switch(node["protocol"]){
            case "https":
                node["port"] = 443;
                break;
            case "http":
                node["port"] = 80;
                break;
        }
        return node;
    };
    Configuration.prototype.showDeprecationWarnings = function(options) {
        if (options.timeoutSeconds) this.logger.warn("Deprecation warning: timeoutSeconds is now renamed to connectionTimeoutSeconds");
        if (options.masterNode) this.logger.warn("Deprecation warning: masterNode is now consolidated to nodes, starting with Typesense Server v0.12");
        if (options.readReplicaNodes) this.logger.warn("Deprecation warning: readReplicaNodes is now consolidated to nodes, starting with Typesense Server v0.12");
    };
    Configuration.prototype.shuffleArray = function(array) {
        var _a;
        for(var i = array.length - 1; i > 0; i--){
            var j = Math.floor(Math.random() * (i + 1));
            _a = [
                array[j],
                array[i]
            ], array[i] = _a[0], array[j] = _a[1];
        }
    };
    return Configuration;
}();
module.exports.default = $12a0a9c6f1b1d712$var$Configuration;

});
parcelRegister("hrNpa", function(module, exports) {
/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/ (function(root, definition) {
    "use strict";
    if (typeof define === 'function' && define.amd) define(definition);
    else if (0, module.exports) module.exports = definition();
    else root.log = definition();
})(module.exports, function() {
    "use strict";
    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";
    var isIE = typeof window !== undefinedType && typeof window.navigator !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];
    var _loggersByName = {};
    var defaultLogger = null;
    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') return method.bind(obj);
        else try {
            return Function.prototype.bind.call(method, obj);
        } catch (e) {
            // Missing bind shim or IE8 + Modernizr, fallback to wrapping
            return function() {
                return Function.prototype.apply.apply(method, [
                    obj,
                    arguments
                ]);
            };
        }
    }
    // Trace() doesn't print the message in IE, so for that case we need to wrap it
    function traceForIE() {
        if (console.log) {
            if (console.log.apply) console.log.apply(console, arguments);
            else // In old IE, native console methods themselves don't have apply().
            Function.prototype.apply.apply(console.log, [
                console,
                arguments
            ]);
        }
        if (console.trace) console.trace();
    }
    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') methodName = 'log';
        if (typeof console === undefinedType) return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        else if (methodName === 'trace' && isIE) return traceForIE;
        else if (console[methodName] !== undefined) return bindMethod(console, methodName);
        else if (console.log !== undefined) return bindMethod(console, 'log');
        else return noop;
    }
    // These private functions always need `this` to be set properly
    function replaceLoggingMethods() {
        /*jshint validthis:true */ var level = this.getLevel();
        // Replace the actual methods.
        for(var i = 0; i < logMethods.length; i++){
            var methodName = logMethods[i];
            this[methodName] = i < level ? noop : this.methodFactory(methodName, level, this.name);
        }
        // Define log.log as an alias for log.debug
        this.log = this.debug;
        // Return any important warnings.
        if (typeof console === undefinedType && level < this.levels.SILENT) return "No console available for logging";
    }
    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName) {
        return function() {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this);
                this[methodName].apply(this, arguments);
            }
        };
    }
    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, _level, _loggerName) {
        /*jshint validthis:true */ return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
    }
    function Logger(name, factory) {
        // Private instance variables.
        var self = this;
        /**
       * The level inherited from a parent logger (or a global default). We
       * cache this here rather than delegating to the parent so that it stays
       * in sync with the actual logging methods that we have installed (the
       * parent could change levels but we might not have rebuilt the loggers
       * in this child yet).
       * @type {number}
       */ var inheritedLevel;
        /**
       * The default level for this logger, if any. If set, this overrides
       * `inheritedLevel`.
       * @type {number|null}
       */ var defaultLevel;
        /**
       * A user-specific level for this logger. If set, this overrides
       * `defaultLevel`.
       * @type {number|null}
       */ var userLevel;
        var storageKey = "loglevel";
        if (typeof name === "string") storageKey += ":" + name;
        else if (typeof name === "symbol") storageKey = undefined;
        function persistLevelIfPossible(levelNum) {
            var levelName = (logMethods[levelNum] || 'silent').toUpperCase();
            if (typeof window === undefinedType || !storageKey) return;
            // Use localStorage if available
            try {
                window.localStorage[storageKey] = levelName;
                return;
            } catch (ignore) {}
            // Use session cookie as fallback
            try {
                window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
            } catch (ignore) {}
        }
        function getPersistedLevel() {
            var storedLevel;
            if (typeof window === undefinedType || !storageKey) return;
            try {
                storedLevel = window.localStorage[storageKey];
            } catch (ignore) {}
            // Fallback to cookies if local storage gives us nothing
            if (typeof storedLevel === undefinedType) try {
                var cookie = window.document.cookie;
                var cookieName = encodeURIComponent(storageKey);
                var location = cookie.indexOf(cookieName + "=");
                if (location !== -1) storedLevel = /^([^;]+)/.exec(cookie.slice(location + cookieName.length + 1))[1];
            } catch (ignore) {}
            // If the stored level is not valid, treat it as if nothing was stored.
            if (self.levels[storedLevel] === undefined) storedLevel = undefined;
            return storedLevel;
        }
        function clearPersistedLevel() {
            if (typeof window === undefinedType || !storageKey) return;
            // Use localStorage if available
            try {
                window.localStorage.removeItem(storageKey);
            } catch (ignore) {}
            // Use session cookie as fallback
            try {
                window.document.cookie = encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch (ignore) {}
        }
        function normalizeLevel(input) {
            var level = input;
            if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) level = self.levels[level.toUpperCase()];
            if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) return level;
            else throw new TypeError("log.setLevel() called with invalid level: " + input);
        }
        /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */ self.name = name;
        self.levels = {
            "TRACE": 0,
            "DEBUG": 1,
            "INFO": 2,
            "WARN": 3,
            "ERROR": 4,
            "SILENT": 5
        };
        self.methodFactory = factory || defaultMethodFactory;
        self.getLevel = function() {
            if (userLevel != null) return userLevel;
            else if (defaultLevel != null) return defaultLevel;
            else return inheritedLevel;
        };
        self.setLevel = function(level, persist) {
            userLevel = normalizeLevel(level);
            if (persist !== false) persistLevelIfPossible(userLevel);
            // NOTE: in v2, this should call rebuild(), which updates children.
            return replaceLoggingMethods.call(self);
        };
        self.setDefaultLevel = function(level) {
            defaultLevel = normalizeLevel(level);
            if (!getPersistedLevel()) self.setLevel(level, false);
        };
        self.resetLevel = function() {
            userLevel = null;
            clearPersistedLevel();
            replaceLoggingMethods.call(self);
        };
        self.enableAll = function(persist) {
            self.setLevel(self.levels.TRACE, persist);
        };
        self.disableAll = function(persist) {
            self.setLevel(self.levels.SILENT, persist);
        };
        self.rebuild = function() {
            if (defaultLogger !== self) inheritedLevel = normalizeLevel(defaultLogger.getLevel());
            replaceLoggingMethods.call(self);
            if (defaultLogger === self) for(var childName in _loggersByName)_loggersByName[childName].rebuild();
        };
        // Initialize all the internal levels.
        inheritedLevel = normalizeLevel(defaultLogger ? defaultLogger.getLevel() : "WARN");
        var initialLevel = getPersistedLevel();
        if (initialLevel != null) userLevel = normalizeLevel(initialLevel);
        replaceLoggingMethods.call(self);
    }
    /*
     *
     * Top-level API
     *
     */ defaultLogger = new Logger();
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "symbol" && typeof name !== "string" || name === "") throw new TypeError("You must supply a name when creating a logger.");
        var logger = _loggersByName[name];
        if (!logger) logger = _loggersByName[name] = new Logger(name, defaultLogger.methodFactory);
        return logger;
    };
    // Grab the current global log variable in case of overwrite
    var _log = typeof window !== undefinedType ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType && window.log === defaultLogger) window.log = _log;
        return defaultLogger;
    };
    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };
    // ES6 default export, for compatibility
    defaultLogger['default'] = defaultLogger;
    return defaultLogger;
});

});

parcelRegister("f6qFb", function(module, exports) {
"use strict";
var $afec1952a8d2794f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ImportError = module.exports.TypesenseError = module.exports.ServerError = module.exports.RequestUnauthorized = module.exports.RequestMalformed = module.exports.ObjectUnprocessable = module.exports.ObjectNotFound = module.exports.ObjectAlreadyExists = module.exports.MissingConfigurationError = module.exports.HTTPError = void 0;

var $afec1952a8d2794f$var$HTTPError_1 = $afec1952a8d2794f$var$__importDefault((parcelRequire("96WQ9")));
module.exports.HTTPError = $afec1952a8d2794f$var$HTTPError_1.default;

var $afec1952a8d2794f$var$MissingConfigurationError_1 = $afec1952a8d2794f$var$__importDefault((parcelRequire("1EUqa")));
module.exports.MissingConfigurationError = $afec1952a8d2794f$var$MissingConfigurationError_1.default;

var $afec1952a8d2794f$var$ObjectAlreadyExists_1 = $afec1952a8d2794f$var$__importDefault((parcelRequire("78R8U")));
module.exports.ObjectAlreadyExists = $afec1952a8d2794f$var$ObjectAlreadyExists_1.default;

var $afec1952a8d2794f$var$ObjectNotFound_1 = $afec1952a8d2794f$var$__importDefault((parcelRequire("kmfLQ")));
module.exports.ObjectNotFound = $afec1952a8d2794f$var$ObjectNotFound_1.default;

var $afec1952a8d2794f$var$ObjectUnprocessable_1 = $afec1952a8d2794f$var$__importDefault((parcelRequire("ht6bG")));
module.exports.ObjectUnprocessable = $afec1952a8d2794f$var$ObjectUnprocessable_1.default;

var $afec1952a8d2794f$var$RequestMalformed_1 = $afec1952a8d2794f$var$__importDefault((parcelRequire("6SVaT")));
module.exports.RequestMalformed = $afec1952a8d2794f$var$RequestMalformed_1.default;

var $afec1952a8d2794f$var$RequestUnauthorized_1 = $afec1952a8d2794f$var$__importDefault((parcelRequire("hek2F")));
module.exports.RequestUnauthorized = $afec1952a8d2794f$var$RequestUnauthorized_1.default;

var $afec1952a8d2794f$var$ServerError_1 = $afec1952a8d2794f$var$__importDefault((parcelRequire("6k9FP")));
module.exports.ServerError = $afec1952a8d2794f$var$ServerError_1.default;

var $afec1952a8d2794f$var$ImportError_1 = $afec1952a8d2794f$var$__importDefault((parcelRequire("bLjS5")));
module.exports.ImportError = $afec1952a8d2794f$var$ImportError_1.default;

var $afec1952a8d2794f$var$TypesenseError_1 = $afec1952a8d2794f$var$__importDefault((parcelRequire("idWKm")));
module.exports.TypesenseError = $afec1952a8d2794f$var$TypesenseError_1.default;

});
parcelRegister("96WQ9", function(module, exports) {
"use strict";
var $6a225107c778f4eb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6a225107c778f4eb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6a225107c778f4eb$var$TypesenseError_1 = $6a225107c778f4eb$var$__importDefault((parcelRequire("idWKm")));
var $6a225107c778f4eb$var$HTTPError = /** @class */ function(_super) {
    $6a225107c778f4eb$var$__extends(HTTPError, _super);
    function HTTPError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HTTPError;
}($6a225107c778f4eb$var$TypesenseError_1.default);
module.exports.default = $6a225107c778f4eb$var$HTTPError;

});
parcelRegister("idWKm", function(module, exports) {
"use strict";
var $d44702ca66840fa9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d44702ca66840fa9$var$TypesenseError = /** @class */ function(_super) {
    $d44702ca66840fa9$var$__extends(TypesenseError, _super);
    // Source: https://stackoverflow.com/a/58417721/123545
    function TypesenseError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.name = _newTarget.name;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return TypesenseError;
}(Error);
module.exports.default = $d44702ca66840fa9$var$TypesenseError;

});


parcelRegister("1EUqa", function(module, exports) {
"use strict";
var $13554aee199f77fa$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $13554aee199f77fa$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $13554aee199f77fa$var$TypesenseError_1 = $13554aee199f77fa$var$__importDefault((parcelRequire("idWKm")));
var $13554aee199f77fa$var$MissingConfigurationError = /** @class */ function(_super) {
    $13554aee199f77fa$var$__extends(MissingConfigurationError, _super);
    function MissingConfigurationError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MissingConfigurationError;
}($13554aee199f77fa$var$TypesenseError_1.default);
module.exports.default = $13554aee199f77fa$var$MissingConfigurationError;

});

parcelRegister("78R8U", function(module, exports) {
"use strict";
var $533280c6f1b2d2dd$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $533280c6f1b2d2dd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $533280c6f1b2d2dd$var$TypesenseError_1 = $533280c6f1b2d2dd$var$__importDefault((parcelRequire("idWKm")));
var $533280c6f1b2d2dd$var$ObjectAlreadyExists = /** @class */ function(_super) {
    $533280c6f1b2d2dd$var$__extends(ObjectAlreadyExists, _super);
    function ObjectAlreadyExists() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ObjectAlreadyExists;
}($533280c6f1b2d2dd$var$TypesenseError_1.default);
module.exports.default = $533280c6f1b2d2dd$var$ObjectAlreadyExists;

});

parcelRegister("kmfLQ", function(module, exports) {
"use strict";
var $ed2218707ab70d5a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ed2218707ab70d5a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ed2218707ab70d5a$var$TypesenseError_1 = $ed2218707ab70d5a$var$__importDefault((parcelRequire("idWKm")));
var $ed2218707ab70d5a$var$ObjectNotFound = /** @class */ function(_super) {
    $ed2218707ab70d5a$var$__extends(ObjectNotFound, _super);
    function ObjectNotFound() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ObjectNotFound;
}($ed2218707ab70d5a$var$TypesenseError_1.default);
module.exports.default = $ed2218707ab70d5a$var$ObjectNotFound;

});

parcelRegister("ht6bG", function(module, exports) {
"use strict";
var $cb79f1c5d12ece33$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $cb79f1c5d12ece33$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cb79f1c5d12ece33$var$TypesenseError_1 = $cb79f1c5d12ece33$var$__importDefault((parcelRequire("idWKm")));
var $cb79f1c5d12ece33$var$ObjectUnprocessable = /** @class */ function(_super) {
    $cb79f1c5d12ece33$var$__extends(ObjectUnprocessable, _super);
    function ObjectUnprocessable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ObjectUnprocessable;
}($cb79f1c5d12ece33$var$TypesenseError_1.default);
module.exports.default = $cb79f1c5d12ece33$var$ObjectUnprocessable;

});

parcelRegister("6SVaT", function(module, exports) {
"use strict";
var $503422ed4551a3e5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $503422ed4551a3e5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $503422ed4551a3e5$var$TypesenseError_1 = $503422ed4551a3e5$var$__importDefault((parcelRequire("idWKm")));
var $503422ed4551a3e5$var$RequestMalformed = /** @class */ function(_super) {
    $503422ed4551a3e5$var$__extends(RequestMalformed, _super);
    function RequestMalformed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RequestMalformed;
}($503422ed4551a3e5$var$TypesenseError_1.default);
module.exports.default = $503422ed4551a3e5$var$RequestMalformed;

});

parcelRegister("hek2F", function(module, exports) {
"use strict";
var $c8b34a644070c93d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c8b34a644070c93d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $c8b34a644070c93d$var$TypesenseError_1 = $c8b34a644070c93d$var$__importDefault((parcelRequire("idWKm")));
var $c8b34a644070c93d$var$RequestUnauthorized = /** @class */ function(_super) {
    $c8b34a644070c93d$var$__extends(RequestUnauthorized, _super);
    function RequestUnauthorized() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RequestUnauthorized;
}($c8b34a644070c93d$var$TypesenseError_1.default);
module.exports.default = $c8b34a644070c93d$var$RequestUnauthorized;

});

parcelRegister("6k9FP", function(module, exports) {
"use strict";
var $49ac1d53cf9948e1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $49ac1d53cf9948e1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $49ac1d53cf9948e1$var$TypesenseError_1 = $49ac1d53cf9948e1$var$__importDefault((parcelRequire("idWKm")));
var $49ac1d53cf9948e1$var$ServerError = /** @class */ function(_super) {
    $49ac1d53cf9948e1$var$__extends(ServerError, _super);
    function ServerError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ServerError;
}($49ac1d53cf9948e1$var$TypesenseError_1.default);
module.exports.default = $49ac1d53cf9948e1$var$ServerError;

});

parcelRegister("bLjS5", function(module, exports) {
"use strict";
var $89037f8ac31aabcd$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $89037f8ac31aabcd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $89037f8ac31aabcd$var$TypesenseError_1 = $89037f8ac31aabcd$var$__importDefault((parcelRequire("idWKm")));
var $89037f8ac31aabcd$var$ImportError = /** @class */ function(_super) {
    $89037f8ac31aabcd$var$__extends(ImportError, _super);
    function ImportError(message, importResults) {
        var _this = _super.call(this, message) || this;
        _this.importResults = importResults;
        return _this;
    }
    return ImportError;
}($89037f8ac31aabcd$var$TypesenseError_1.default);
module.exports.default = $89037f8ac31aabcd$var$ImportError;

});



parcelRegister("4g7eM", function(module, exports) {
"use strict";
var $319e453d46b88036$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $319e453d46b88036$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $319e453d46b88036$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $319e453d46b88036$var$axios_1 = $319e453d46b88036$var$__importDefault((parcelRequire("b9hR0")));

var $f6qFb = parcelRequire("f6qFb");

var $319e453d46b88036$var$TypesenseError_1 = $319e453d46b88036$var$__importDefault((parcelRequire("idWKm")));
var $319e453d46b88036$var$APIKEYHEADERNAME = "X-TYPESENSE-API-KEY";
var $319e453d46b88036$var$HEALTHY = true;
var $319e453d46b88036$var$UNHEALTHY = false;
var $319e453d46b88036$var$ApiCall = /** @class */ function() {
    function ApiCall(configuration) {
        this.configuration = configuration;
        this.apiKey = this.configuration.apiKey;
        this.nodes = this.configuration.nodes == null ? this.configuration.nodes : JSON.parse(JSON.stringify(this.configuration.nodes)); // Make a copy, since we'll be adding additional metadata to the nodes
        this.nearestNode = this.configuration.nearestNode == null ? this.configuration.nearestNode : JSON.parse(JSON.stringify(this.configuration.nearestNode));
        this.connectionTimeoutSeconds = this.configuration.connectionTimeoutSeconds;
        this.healthcheckIntervalSeconds = this.configuration.healthcheckIntervalSeconds;
        this.numRetriesPerRequest = this.configuration.numRetries;
        this.retryIntervalSeconds = this.configuration.retryIntervalSeconds;
        this.sendApiKeyAsQueryParam = this.configuration.sendApiKeyAsQueryParam;
        this.additionalUserHeaders = this.configuration.additionalHeaders;
        this.logger = this.configuration.logger;
        this.initializeMetadataForNodes();
        this.currentNodeIndex = -1;
    }
    ApiCall.prototype.get = function(endpoint, queryParameters, _a) {
        if (queryParameters === void 0) queryParameters = {};
        var _b = _a === void 0 ? {} : _a, _c = _b.abortSignal, abortSignal = _c === void 0 ? null : _c, _d = _b.responseType, responseType = _d === void 0 ? undefined : _d;
        return $319e453d46b88036$var$__awaiter(this, void 0, void 0, function() {
            return $319e453d46b88036$var$__generator(this, function(_e) {
                return [
                    2 /*return*/ ,
                    this.performRequest("get", endpoint, {
                        queryParameters: queryParameters,
                        abortSignal: abortSignal,
                        responseType: responseType
                    })
                ];
            });
        });
    };
    ApiCall.prototype.delete = function(endpoint, queryParameters) {
        if (queryParameters === void 0) queryParameters = {};
        return $319e453d46b88036$var$__awaiter(this, void 0, void 0, function() {
            return $319e453d46b88036$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.performRequest("delete", endpoint, {
                        queryParameters: queryParameters
                    })
                ];
            });
        });
    };
    ApiCall.prototype.post = function(endpoint, bodyParameters, queryParameters, additionalHeaders) {
        if (bodyParameters === void 0) bodyParameters = {};
        if (queryParameters === void 0) queryParameters = {};
        if (additionalHeaders === void 0) additionalHeaders = {};
        return $319e453d46b88036$var$__awaiter(this, void 0, void 0, function() {
            return $319e453d46b88036$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.performRequest("post", endpoint, {
                        queryParameters: queryParameters,
                        bodyParameters: bodyParameters,
                        additionalHeaders: additionalHeaders
                    })
                ];
            });
        });
    };
    ApiCall.prototype.put = function(endpoint, bodyParameters, queryParameters) {
        if (bodyParameters === void 0) bodyParameters = {};
        if (queryParameters === void 0) queryParameters = {};
        return $319e453d46b88036$var$__awaiter(this, void 0, void 0, function() {
            return $319e453d46b88036$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.performRequest("put", endpoint, {
                        queryParameters: queryParameters,
                        bodyParameters: bodyParameters
                    })
                ];
            });
        });
    };
    ApiCall.prototype.patch = function(endpoint, bodyParameters, queryParameters) {
        if (bodyParameters === void 0) bodyParameters = {};
        if (queryParameters === void 0) queryParameters = {};
        return $319e453d46b88036$var$__awaiter(this, void 0, void 0, function() {
            return $319e453d46b88036$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.performRequest("patch", endpoint, {
                        queryParameters: queryParameters,
                        bodyParameters: bodyParameters
                    })
                ];
            });
        });
    };
    ApiCall.prototype.performRequest = function(requestType, endpoint, _a) {
        var _b, _c, _d;
        var _e = _a.queryParameters, queryParameters = _e === void 0 ? null : _e, _f = _a.bodyParameters, bodyParameters = _f === void 0 ? null : _f, _g = _a.additionalHeaders, additionalHeaders = _g === void 0 ? {} : _g, _h = _a.abortSignal, abortSignal = _h === void 0 ? null : _h, _j = _a.responseType, responseType = _j === void 0 ? undefined : _j, _k = _a.skipConnectionTimeout, skipConnectionTimeout = _k === void 0 ? false : _k;
        return $319e453d46b88036$var$__awaiter(this, void 0, void 0, function() {
            var requestNumber, lastException, _loop_1, this_1, numTries, state_1;
            return $319e453d46b88036$var$__generator(this, function(_l) {
                switch(_l.label){
                    case 0:
                        this.configuration.validate();
                        requestNumber = Date.now();
                        this.logger.debug("Request #".concat(requestNumber, ": Performing ").concat(requestType.toUpperCase(), " request: ").concat(endpoint));
                        _loop_1 = function(numTries) {
                            var node, abortListener, requestOptions, cancelToken, source_1, response, error_1;
                            return $319e453d46b88036$var$__generator(this, function(_m) {
                                switch(_m.label){
                                    case 0:
                                        node = this_1.getNextNode(requestNumber);
                                        this_1.logger.debug("Request #".concat(requestNumber, ": Attempting ").concat(requestType.toUpperCase(), " request Try #").concat(numTries, " to Node ").concat(node.index));
                                        if (abortSignal && abortSignal.aborted) return [
                                            2 /*return*/ ,
                                            {
                                                value: Promise.reject(new Error("Request aborted by caller."))
                                            }
                                        ];
                                        abortListener = void 0;
                                        _m.label = 1;
                                    case 1:
                                        _m.trys.push([
                                            1,
                                            3,
                                            5,
                                            6
                                        ]);
                                        requestOptions = {
                                            method: requestType,
                                            url: this_1.uriFor(endpoint, node),
                                            headers: Object.assign({}, this_1.defaultHeaders(), additionalHeaders, this_1.additionalUserHeaders),
                                            maxContentLength: Infinity,
                                            maxBodyLength: Infinity,
                                            responseType: responseType,
                                            validateStatus: function(status) {
                                                /* Override default validateStatus, which only considers 2xx a success.
                                                    In our case, if the server returns any HTTP code, we will handle it below.
                                                    We do this to be able to raise custom errors based on response code.
                                                 */ return status > 0;
                                            },
                                            transformResponse: [
                                                function(data, headers) {
                                                    var transformedData = data;
                                                    if (headers !== undefined && typeof data === "string" && headers["content-type"] && headers["content-type"].startsWith("application/json")) transformedData = JSON.parse(data);
                                                    return transformedData;
                                                }
                                            ]
                                        };
                                        if (skipConnectionTimeout !== true) requestOptions.timeout = this_1.connectionTimeoutSeconds * 1000;
                                        if (queryParameters && Object.keys(queryParameters).length !== 0) requestOptions.params = queryParameters;
                                        if (this_1.sendApiKeyAsQueryParam) {
                                            requestOptions.params = requestOptions.params || {};
                                            requestOptions.params["x-typesense-api-key"] = this_1.apiKey;
                                        }
                                        if (this_1.configuration.httpAgent) {
                                            this_1.logger.debug("Request #".concat(requestNumber, ": Using custom httpAgent"));
                                            requestOptions.httpAgent = this_1.configuration.httpAgent;
                                        }
                                        if (this_1.configuration.httpsAgent) {
                                            this_1.logger.debug("Request #".concat(requestNumber, ": Using custom httpsAgent"));
                                            requestOptions.httpsAgent = this_1.configuration.httpsAgent;
                                        }
                                        if (bodyParameters && (typeof bodyParameters === "string" && bodyParameters.length !== 0 || typeof bodyParameters === "object" && Object.keys(bodyParameters).length !== 0)) requestOptions.data = bodyParameters;
                                        // Translate from user-provided AbortController to the Axios request cancel mechanism.
                                        if (abortSignal) {
                                            cancelToken = $319e453d46b88036$var$axios_1.default.CancelToken;
                                            source_1 = cancelToken.source();
                                            abortListener = function() {
                                                return source_1.cancel();
                                            };
                                            abortSignal.addEventListener("abort", abortListener);
                                            requestOptions.cancelToken = source_1.token;
                                        }
                                        return [
                                            4 /*yield*/ ,
                                            (0, $319e453d46b88036$var$axios_1.default)(requestOptions)
                                        ];
                                    case 2:
                                        response = _m.sent();
                                        if (response.status >= 1 && response.status <= 499) // Treat any status code > 0 and < 500 to be an indication that node is healthy
                                        // We exclude 0 since some clients return 0 when request fails
                                        this_1.setNodeHealthcheck(node, $319e453d46b88036$var$HEALTHY);
                                        this_1.logger.debug("Request #".concat(requestNumber, ": Request to Node ").concat(node.index, " was made. Response Code was ").concat(response.status, "."));
                                        if (response.status >= 200 && response.status < 300) return [
                                            2 /*return*/ ,
                                            {
                                                value: Promise.resolve(response.data)
                                            }
                                        ];
                                        else if (response.status < 500) return [
                                            2 /*return*/ ,
                                            {
                                                value: Promise.reject(this_1.customErrorForResponse(response, (_b = response.data) === null || _b === void 0 ? void 0 : _b.message))
                                            }
                                        ];
                                        else // Retry all other HTTP errors (HTTPStatus > 500)
                                        // This will get caught by the catch block below
                                        throw this_1.customErrorForResponse(response, (_c = response.data) === null || _c === void 0 ? void 0 : _c.message);
                                        return [
                                            3 /*break*/ ,
                                            6
                                        ];
                                    case 3:
                                        error_1 = _m.sent();
                                        // This block handles retries for HTTPStatus > 500 and network layer issues like connection timeouts
                                        this_1.setNodeHealthcheck(node, $319e453d46b88036$var$UNHEALTHY);
                                        lastException = error_1;
                                        this_1.logger.warn("Request #".concat(requestNumber, ": Request to Node ").concat(node.index, " failed due to \"").concat(error_1.code, " ").concat(error_1.message).concat(error_1.response == null ? "" : " - " + JSON.stringify((_d = error_1.response) === null || _d === void 0 ? void 0 : _d.data), "\""));
                                        // this.logger.debug(error.stack)
                                        this_1.logger.warn("Request #".concat(requestNumber, ": Sleeping for ").concat(this_1.retryIntervalSeconds, "s and then retrying request..."));
                                        return [
                                            4 /*yield*/ ,
                                            this_1.timer(this_1.retryIntervalSeconds)
                                        ];
                                    case 4:
                                        _m.sent();
                                        return [
                                            3 /*break*/ ,
                                            6
                                        ];
                                    case 5:
                                        if (abortSignal && abortListener) abortSignal.removeEventListener("abort", abortListener);
                                        return [
                                            7 /*endfinally*/ 
                                        ];
                                    case 6:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        numTries = 1;
                        _l.label = 1;
                    case 1:
                        if (!(numTries <= this.numRetriesPerRequest + 1)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            5 /*yield**/ ,
                            _loop_1(numTries)
                        ];
                    case 2:
                        state_1 = _l.sent();
                        if (typeof state_1 === "object") return [
                            2 /*return*/ ,
                            state_1.value
                        ];
                        _l.label = 3;
                    case 3:
                        numTries++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        this.logger.debug("Request #".concat(requestNumber, ": No retries left. Raising last error"));
                        return [
                            2 /*return*/ ,
                            Promise.reject(lastException)
                        ];
                }
            });
        });
    };
    // Attempts to find the next healthy node, looping through the list of nodes once.
    //   But if no healthy nodes are found, it will just return the next node, even if it's unhealthy
    //     so we can try the request for good measure, in case that node has become healthy since
    ApiCall.prototype.getNextNode = function(requestNumber) {
        if (requestNumber === void 0) requestNumber = 0;
        // Check if nearestNode is set and is healthy, if so return it
        if (this.nearestNode != null) {
            this.logger.debug("Request #".concat(requestNumber, ": Nodes Health: Node ").concat(this.nearestNode.index, " is ").concat(this.nearestNode.isHealthy === true ? "Healthy" : "Unhealthy"));
            if (this.nearestNode.isHealthy === true || this.nodeDueForHealthcheck(this.nearestNode, requestNumber)) {
                this.logger.debug("Request #".concat(requestNumber, ": Updated current node to Node ").concat(this.nearestNode.index));
                return this.nearestNode;
            }
            this.logger.debug("Request #".concat(requestNumber, ": Falling back to individual nodes"));
        }
        // Fallback to nodes as usual
        this.logger.debug("Request #".concat(requestNumber, ": Nodes Health: ").concat(this.nodes.map(function(node) {
            return "Node ".concat(node.index, " is ").concat(node.isHealthy === true ? "Healthy" : "Unhealthy");
        }).join(" || ")));
        var candidateNode = this.nodes[0];
        for(var i = 0; i <= this.nodes.length; i++){
            this.currentNodeIndex = (this.currentNodeIndex + 1) % this.nodes.length;
            candidateNode = this.nodes[this.currentNodeIndex];
            if (candidateNode.isHealthy === true || this.nodeDueForHealthcheck(candidateNode, requestNumber)) {
                this.logger.debug("Request #".concat(requestNumber, ": Updated current node to Node ").concat(candidateNode.index));
                return candidateNode;
            }
        }
        // None of the nodes are marked healthy, but some of them could have become healthy since last health check.
        //  So we will just return the next node.
        this.logger.debug("Request #".concat(requestNumber, ": No healthy nodes were found. Returning the next node, Node ").concat(candidateNode.index));
        return candidateNode;
    };
    ApiCall.prototype.nodeDueForHealthcheck = function(node, requestNumber) {
        if (requestNumber === void 0) requestNumber = 0;
        var isDueForHealthcheck = Date.now() - node.lastAccessTimestamp > this.healthcheckIntervalSeconds * 1000;
        if (isDueForHealthcheck) this.logger.debug("Request #".concat(requestNumber, ": Node ").concat(node.index, " has exceeded healtcheckIntervalSeconds of ").concat(this.healthcheckIntervalSeconds, ". Adding it back into rotation."));
        return isDueForHealthcheck;
    };
    ApiCall.prototype.initializeMetadataForNodes = function() {
        var _this = this;
        if (this.nearestNode != null) {
            this.nearestNode.index = "nearestNode";
            this.setNodeHealthcheck(this.nearestNode, $319e453d46b88036$var$HEALTHY);
        }
        this.nodes.forEach(function(node, i) {
            node.index = i;
            _this.setNodeHealthcheck(node, $319e453d46b88036$var$HEALTHY);
        });
    };
    ApiCall.prototype.setNodeHealthcheck = function(node, isHealthy) {
        node.isHealthy = isHealthy;
        node.lastAccessTimestamp = Date.now();
    };
    ApiCall.prototype.uriFor = function(endpoint, node) {
        if (node.url != null) return "".concat(node.url).concat(endpoint);
        return "".concat(node.protocol, "://").concat(node.host, ":").concat(node.port).concat(node.path).concat(endpoint);
    };
    ApiCall.prototype.defaultHeaders = function() {
        var defaultHeaders = {};
        if (!this.sendApiKeyAsQueryParam) defaultHeaders[$319e453d46b88036$var$APIKEYHEADERNAME] = this.apiKey;
        defaultHeaders["Content-Type"] = "application/json";
        return defaultHeaders;
    };
    ApiCall.prototype.timer = function(seconds) {
        return $319e453d46b88036$var$__awaiter(this, void 0, void 0, function() {
            return $319e453d46b88036$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve) {
                        return setTimeout(resolve, seconds * 1000);
                    })
                ];
            });
        });
    };
    ApiCall.prototype.customErrorForResponse = function(response, messageFromServer) {
        var errorMessage = "Request failed with HTTP code ".concat(response.status);
        if (typeof messageFromServer === "string" && messageFromServer.trim() !== "") errorMessage += " | Server said: ".concat(messageFromServer);
        var error = new $319e453d46b88036$var$TypesenseError_1.default(errorMessage);
        if (response.status === 400) error = new $f6qFb.RequestMalformed(errorMessage);
        else if (response.status === 401) error = new $f6qFb.RequestUnauthorized(errorMessage);
        else if (response.status === 404) error = new $f6qFb.ObjectNotFound(errorMessage);
        else if (response.status === 409) error = new $f6qFb.ObjectAlreadyExists(errorMessage);
        else if (response.status === 422) error = new $f6qFb.ObjectUnprocessable(errorMessage);
        else if (response.status >= 500 && response.status <= 599) error = new $f6qFb.ServerError(errorMessage);
        else error = new $f6qFb.HTTPError(errorMessage);
        error.httpStatus = response.status;
        return error;
    };
    return ApiCall;
}();
module.exports.default = $319e453d46b88036$var$ApiCall;

});
parcelRegister("b9hR0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Axios", function () { return $81de6265f4aa4397$export$1c00760e9e5a4e95; });
$parcel$export(module.exports, "AxiosError", function () { return $81de6265f4aa4397$export$c1fbed17c2f6a328; });
$parcel$export(module.exports, "CanceledError", function () { return $81de6265f4aa4397$export$1ab0c6b20d94fa14; });
$parcel$export(module.exports, "isCancel", function () { return $81de6265f4aa4397$export$3b22524397b493c6; });
$parcel$export(module.exports, "CancelToken", function () { return $81de6265f4aa4397$export$fd08e3cb425f0d61; });
$parcel$export(module.exports, "VERSION", function () { return $81de6265f4aa4397$export$a4ad2735b021c132; });
$parcel$export(module.exports, "all", function () { return $81de6265f4aa4397$export$84bf76cd7afc7469; });
$parcel$export(module.exports, "Cancel", function () { return $81de6265f4aa4397$export$848c9b7ead0df967; });
$parcel$export(module.exports, "isAxiosError", function () { return $81de6265f4aa4397$export$fbafdbe06a5b5a9a; });
$parcel$export(module.exports, "spread", function () { return $81de6265f4aa4397$export$3ae0fd4797ed47c8; });
$parcel$export(module.exports, "toFormData", function () { return $81de6265f4aa4397$export$10ae0d317ea97f8b; });
$parcel$export(module.exports, "AxiosHeaders", function () { return $81de6265f4aa4397$export$4e7d6ff0f3e6520; });
$parcel$export(module.exports, "HttpStatusCode", function () { return $81de6265f4aa4397$export$a972f69c851492b3; });
$parcel$export(module.exports, "formToJSON", function () { return $81de6265f4aa4397$export$86d7c59254d6a2c9; });
$parcel$export(module.exports, "getAdapter", function () { return $81de6265f4aa4397$export$17ddc20a97d669e2; });
$parcel$export(module.exports, "mergeConfig", function () { return $81de6265f4aa4397$export$7ec1ebcfa9d8bd6a; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("9sKbf")).default; });

var $9sKbf = parcelRequire("9sKbf");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $81de6265f4aa4397$export$1c00760e9e5a4e95, AxiosError: $81de6265f4aa4397$export$c1fbed17c2f6a328, CanceledError: $81de6265f4aa4397$export$1ab0c6b20d94fa14, isCancel: $81de6265f4aa4397$export$3b22524397b493c6, CancelToken: $81de6265f4aa4397$export$fd08e3cb425f0d61, VERSION: $81de6265f4aa4397$export$a4ad2735b021c132, all: $81de6265f4aa4397$export$84bf76cd7afc7469, Cancel: $81de6265f4aa4397$export$848c9b7ead0df967, isAxiosError: $81de6265f4aa4397$export$fbafdbe06a5b5a9a, spread: $81de6265f4aa4397$export$3ae0fd4797ed47c8, toFormData: $81de6265f4aa4397$export$10ae0d317ea97f8b, AxiosHeaders: $81de6265f4aa4397$export$4e7d6ff0f3e6520, HttpStatusCode: $81de6265f4aa4397$export$a972f69c851492b3, formToJSON: $81de6265f4aa4397$export$86d7c59254d6a2c9, getAdapter: $81de6265f4aa4397$export$17ddc20a97d669e2, mergeConfig: $81de6265f4aa4397$export$7ec1ebcfa9d8bd6a } = (0, $9sKbf.default);

});
parcelRegister("9sKbf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e3a8d0b80caf166$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");

var $b8O1A = parcelRequire("b8O1A");

var $dL8HM = parcelRequire("dL8HM");

var $dPMmc = parcelRequire("dPMmc");

var $LZz0W = parcelRequire("LZz0W");

var $fkEjB = parcelRequire("fkEjB");

var $dHwgY = parcelRequire("dHwgY");

var $eWlGv = parcelRequire("eWlGv");

var $XA2mI = parcelRequire("XA2mI");

var $2rdMK = parcelRequire("2rdMK");

var $aPHuZ = parcelRequire("aPHuZ");

var $49DnR = parcelRequire("49DnR");

var $cwO49 = parcelRequire("cwO49");

var $CMJ6u = parcelRequire("CMJ6u");

var $10epZ = parcelRequire("10epZ");

var $VKSNc = parcelRequire("VKSNc");

var $eI1Qd = parcelRequire("eI1Qd");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $6e3a8d0b80caf166$var$createInstance(defaultConfig) {
    const context = new (0, $dL8HM.default)(defaultConfig);
    const instance = (0, $b8O1A.default)((0, $dL8HM.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $4vLup.default).extend(instance, (0, $dL8HM.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $4vLup.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $6e3a8d0b80caf166$var$createInstance((0, $dPMmc.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $6e3a8d0b80caf166$var$axios = $6e3a8d0b80caf166$var$createInstance((0, $LZz0W.default));
// Expose Axios class to allow class inheritance
$6e3a8d0b80caf166$var$axios.Axios = (0, $dL8HM.default);
// Expose Cancel & CancelToken
$6e3a8d0b80caf166$var$axios.CanceledError = (0, $dHwgY.default);
$6e3a8d0b80caf166$var$axios.CancelToken = (0, $eWlGv.default);
$6e3a8d0b80caf166$var$axios.isCancel = (0, $XA2mI.default);
$6e3a8d0b80caf166$var$axios.VERSION = (0, $2rdMK.VERSION);
$6e3a8d0b80caf166$var$axios.toFormData = (0, $aPHuZ.default);
// Expose AxiosError class
$6e3a8d0b80caf166$var$axios.AxiosError = (0, $49DnR.default);
// alias for CanceledError for backward compatibility
$6e3a8d0b80caf166$var$axios.Cancel = $6e3a8d0b80caf166$var$axios.CanceledError;
// Expose all/spread
$6e3a8d0b80caf166$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$6e3a8d0b80caf166$var$axios.spread = (0, $cwO49.default);
// Expose isAxiosError
$6e3a8d0b80caf166$var$axios.isAxiosError = (0, $CMJ6u.default);
// Expose mergeConfig
$6e3a8d0b80caf166$var$axios.mergeConfig = (0, $dPMmc.default);
$6e3a8d0b80caf166$var$axios.AxiosHeaders = (0, $10epZ.default);
$6e3a8d0b80caf166$var$axios.formToJSON = (thing)=>(0, $fkEjB.default)((0, $4vLup.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$6e3a8d0b80caf166$var$axios.getAdapter = (0, $VKSNc.default).getAdapter;
$6e3a8d0b80caf166$var$axios.HttpStatusCode = (0, $eI1Qd.default);
$6e3a8d0b80caf166$var$axios.default = $6e3a8d0b80caf166$var$axios;
var // this module should only have a default export
$6e3a8d0b80caf166$export$2e2bcd8739ae039 = $6e3a8d0b80caf166$var$axios;

});
parcelRegister("4vLup", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $348ee519a4aba5d7$export$2e2bcd8739ae039; });

var $b8O1A = parcelRequire("b8O1A");

var $8Dl5z = parcelRequire("8Dl5z");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $348ee519a4aba5d7$var$toString } = Object.prototype;
const { getPrototypeOf: $348ee519a4aba5d7$var$getPrototypeOf } = Object;
const $348ee519a4aba5d7$var$kindOf = ((cache)=>(thing)=>{
        const str = $348ee519a4aba5d7$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $348ee519a4aba5d7$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$348ee519a4aba5d7$var$kindOf(thing) === type;
};
const $348ee519a4aba5d7$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $348ee519a4aba5d7$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $348ee519a4aba5d7$var$isUndefined = $348ee519a4aba5d7$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $348ee519a4aba5d7$var$isBuffer(val) {
    return val !== null && !$348ee519a4aba5d7$var$isUndefined(val) && val.constructor !== null && !$348ee519a4aba5d7$var$isUndefined(val.constructor) && $348ee519a4aba5d7$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $348ee519a4aba5d7$var$isArrayBuffer = $348ee519a4aba5d7$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $348ee519a4aba5d7$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $348ee519a4aba5d7$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $348ee519a4aba5d7$var$isString = $348ee519a4aba5d7$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $348ee519a4aba5d7$var$isFunction = $348ee519a4aba5d7$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $348ee519a4aba5d7$var$isNumber = $348ee519a4aba5d7$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $348ee519a4aba5d7$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $348ee519a4aba5d7$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $348ee519a4aba5d7$var$isPlainObject = (val)=>{
    if ($348ee519a4aba5d7$var$kindOf(val) !== 'object') return false;
    const prototype = $348ee519a4aba5d7$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $348ee519a4aba5d7$var$isDate = $348ee519a4aba5d7$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $348ee519a4aba5d7$var$isFile = $348ee519a4aba5d7$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $348ee519a4aba5d7$var$isBlob = $348ee519a4aba5d7$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $348ee519a4aba5d7$var$isFileList = $348ee519a4aba5d7$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $348ee519a4aba5d7$var$isStream = (val)=>$348ee519a4aba5d7$var$isObject(val) && $348ee519a4aba5d7$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $348ee519a4aba5d7$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $348ee519a4aba5d7$var$isFunction(thing.append) && ((kind = $348ee519a4aba5d7$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $348ee519a4aba5d7$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $348ee519a4aba5d7$var$isURLSearchParams = $348ee519a4aba5d7$var$kindOfTest('URLSearchParams');
const [$348ee519a4aba5d7$var$isReadableStream, $348ee519a4aba5d7$var$isRequest, $348ee519a4aba5d7$var$isResponse, $348ee519a4aba5d7$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($348ee519a4aba5d7$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $348ee519a4aba5d7$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $348ee519a4aba5d7$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($348ee519a4aba5d7$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $348ee519a4aba5d7$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $348ee519a4aba5d7$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $348ee519a4aba5d7$var$isContextDefined = (context)=>!$348ee519a4aba5d7$var$isUndefined(context) && context !== $348ee519a4aba5d7$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $348ee519a4aba5d7$var$merge() {
    const { caseless: caseless } = $348ee519a4aba5d7$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $348ee519a4aba5d7$var$findKey(result, key) || key;
        if ($348ee519a4aba5d7$var$isPlainObject(result[targetKey]) && $348ee519a4aba5d7$var$isPlainObject(val)) result[targetKey] = $348ee519a4aba5d7$var$merge(result[targetKey], val);
        else if ($348ee519a4aba5d7$var$isPlainObject(val)) result[targetKey] = $348ee519a4aba5d7$var$merge({}, val);
        else if ($348ee519a4aba5d7$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $348ee519a4aba5d7$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $348ee519a4aba5d7$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $348ee519a4aba5d7$var$forEach(b, (val, key)=>{
        if (thisArg && $348ee519a4aba5d7$var$isFunction(val)) a[key] = (0, $b8O1A.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $348ee519a4aba5d7$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $348ee519a4aba5d7$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $348ee519a4aba5d7$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $348ee519a4aba5d7$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $348ee519a4aba5d7$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $348ee519a4aba5d7$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($348ee519a4aba5d7$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$348ee519a4aba5d7$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $348ee519a4aba5d7$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $348ee519a4aba5d7$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $348ee519a4aba5d7$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $348ee519a4aba5d7$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $348ee519a4aba5d7$var$isHTMLForm = $348ee519a4aba5d7$var$kindOfTest('HTMLFormElement');
const $348ee519a4aba5d7$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $348ee519a4aba5d7$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $348ee519a4aba5d7$var$isRegExp = $348ee519a4aba5d7$var$kindOfTest('RegExp');
const $348ee519a4aba5d7$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $348ee519a4aba5d7$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $348ee519a4aba5d7$var$freezeMethods = (obj)=>{
    $348ee519a4aba5d7$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($348ee519a4aba5d7$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$348ee519a4aba5d7$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $348ee519a4aba5d7$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $348ee519a4aba5d7$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $348ee519a4aba5d7$var$noop = ()=>{};
const $348ee519a4aba5d7$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $348ee519a4aba5d7$var$ALPHA = 'abcdefghijklmnopqrstuvwxyz';
const $348ee519a4aba5d7$var$DIGIT = '0123456789';
const $348ee519a4aba5d7$var$ALPHABET = {
    DIGIT: $348ee519a4aba5d7$var$DIGIT,
    ALPHA: $348ee519a4aba5d7$var$ALPHA,
    ALPHA_DIGIT: $348ee519a4aba5d7$var$ALPHA + $348ee519a4aba5d7$var$ALPHA.toUpperCase() + $348ee519a4aba5d7$var$DIGIT
};
const $348ee519a4aba5d7$var$generateString = (size = 16, alphabet = $348ee519a4aba5d7$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = '';
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $348ee519a4aba5d7$var$isSpecCompliantForm(thing) {
    return !!(thing && $348ee519a4aba5d7$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $348ee519a4aba5d7$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($348ee519a4aba5d7$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $348ee519a4aba5d7$var$isArray(source) ? [] : {};
                $348ee519a4aba5d7$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$348ee519a4aba5d7$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $348ee519a4aba5d7$var$isAsyncFn = $348ee519a4aba5d7$var$kindOfTest('AsyncFunction');
const $348ee519a4aba5d7$var$isThenable = (thing)=>thing && ($348ee519a4aba5d7$var$isObject(thing) || $348ee519a4aba5d7$var$isFunction(thing)) && $348ee519a4aba5d7$var$isFunction(thing.then) && $348ee519a4aba5d7$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $348ee519a4aba5d7$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $348ee519a4aba5d7$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $348ee519a4aba5d7$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $348ee519a4aba5d7$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $348ee519a4aba5d7$var$isFunction($348ee519a4aba5d7$var$_global.postMessage));
const $348ee519a4aba5d7$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($348ee519a4aba5d7$var$_global) : typeof $8Dl5z !== 'undefined' && $8Dl5z.nextTick || $348ee519a4aba5d7$var$_setImmediate;
var // *********************
$348ee519a4aba5d7$export$2e2bcd8739ae039 = {
    isArray: $348ee519a4aba5d7$var$isArray,
    isArrayBuffer: $348ee519a4aba5d7$var$isArrayBuffer,
    isBuffer: $348ee519a4aba5d7$var$isBuffer,
    isFormData: $348ee519a4aba5d7$var$isFormData,
    isArrayBufferView: $348ee519a4aba5d7$var$isArrayBufferView,
    isString: $348ee519a4aba5d7$var$isString,
    isNumber: $348ee519a4aba5d7$var$isNumber,
    isBoolean: $348ee519a4aba5d7$var$isBoolean,
    isObject: $348ee519a4aba5d7$var$isObject,
    isPlainObject: $348ee519a4aba5d7$var$isPlainObject,
    isReadableStream: $348ee519a4aba5d7$var$isReadableStream,
    isRequest: $348ee519a4aba5d7$var$isRequest,
    isResponse: $348ee519a4aba5d7$var$isResponse,
    isHeaders: $348ee519a4aba5d7$var$isHeaders,
    isUndefined: $348ee519a4aba5d7$var$isUndefined,
    isDate: $348ee519a4aba5d7$var$isDate,
    isFile: $348ee519a4aba5d7$var$isFile,
    isBlob: $348ee519a4aba5d7$var$isBlob,
    isRegExp: $348ee519a4aba5d7$var$isRegExp,
    isFunction: $348ee519a4aba5d7$var$isFunction,
    isStream: $348ee519a4aba5d7$var$isStream,
    isURLSearchParams: $348ee519a4aba5d7$var$isURLSearchParams,
    isTypedArray: $348ee519a4aba5d7$var$isTypedArray,
    isFileList: $348ee519a4aba5d7$var$isFileList,
    forEach: $348ee519a4aba5d7$var$forEach,
    merge: $348ee519a4aba5d7$var$merge,
    extend: $348ee519a4aba5d7$var$extend,
    trim: $348ee519a4aba5d7$var$trim,
    stripBOM: $348ee519a4aba5d7$var$stripBOM,
    inherits: $348ee519a4aba5d7$var$inherits,
    toFlatObject: $348ee519a4aba5d7$var$toFlatObject,
    kindOf: $348ee519a4aba5d7$var$kindOf,
    kindOfTest: $348ee519a4aba5d7$var$kindOfTest,
    endsWith: $348ee519a4aba5d7$var$endsWith,
    toArray: $348ee519a4aba5d7$var$toArray,
    forEachEntry: $348ee519a4aba5d7$var$forEachEntry,
    matchAll: $348ee519a4aba5d7$var$matchAll,
    isHTMLForm: $348ee519a4aba5d7$var$isHTMLForm,
    hasOwnProperty: $348ee519a4aba5d7$var$hasOwnProperty,
    hasOwnProp: $348ee519a4aba5d7$var$hasOwnProperty,
    reduceDescriptors: $348ee519a4aba5d7$var$reduceDescriptors,
    freezeMethods: $348ee519a4aba5d7$var$freezeMethods,
    toObjectSet: $348ee519a4aba5d7$var$toObjectSet,
    toCamelCase: $348ee519a4aba5d7$var$toCamelCase,
    noop: $348ee519a4aba5d7$var$noop,
    toFiniteNumber: $348ee519a4aba5d7$var$toFiniteNumber,
    findKey: $348ee519a4aba5d7$var$findKey,
    global: $348ee519a4aba5d7$var$_global,
    isContextDefined: $348ee519a4aba5d7$var$isContextDefined,
    ALPHABET: $348ee519a4aba5d7$var$ALPHABET,
    generateString: $348ee519a4aba5d7$var$generateString,
    isSpecCompliantForm: $348ee519a4aba5d7$var$isSpecCompliantForm,
    toJSONObject: $348ee519a4aba5d7$var$toJSONObject,
    isAsyncFn: $348ee519a4aba5d7$var$isAsyncFn,
    isThenable: $348ee519a4aba5d7$var$isThenable,
    setImmediate: $348ee519a4aba5d7$var$_setImmediate,
    asap: $348ee519a4aba5d7$var$asap
};

});
parcelRegister("b8O1A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81c73eecd10f4fc4$export$2e2bcd8739ae039; });
'use strict';
function $81c73eecd10f4fc4$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});

parcelRegister("8Dl5z", function(module, exports) {
// shim for using process in browser
var $649253074081e4d2$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $649253074081e4d2$var$cachedSetTimeout;
var $649253074081e4d2$var$cachedClearTimeout;
function $649253074081e4d2$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $649253074081e4d2$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $649253074081e4d2$var$cachedSetTimeout = setTimeout;
        else $649253074081e4d2$var$cachedSetTimeout = $649253074081e4d2$var$defaultSetTimout;
    } catch (e) {
        $649253074081e4d2$var$cachedSetTimeout = $649253074081e4d2$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $649253074081e4d2$var$cachedClearTimeout = clearTimeout;
        else $649253074081e4d2$var$cachedClearTimeout = $649253074081e4d2$var$defaultClearTimeout;
    } catch (e) {
        $649253074081e4d2$var$cachedClearTimeout = $649253074081e4d2$var$defaultClearTimeout;
    }
})();
function $649253074081e4d2$var$runTimeout(fun) {
    if ($649253074081e4d2$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($649253074081e4d2$var$cachedSetTimeout === $649253074081e4d2$var$defaultSetTimout || !$649253074081e4d2$var$cachedSetTimeout) && setTimeout) {
        $649253074081e4d2$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $649253074081e4d2$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $649253074081e4d2$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $649253074081e4d2$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $649253074081e4d2$var$runClearTimeout(marker) {
    if ($649253074081e4d2$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($649253074081e4d2$var$cachedClearTimeout === $649253074081e4d2$var$defaultClearTimeout || !$649253074081e4d2$var$cachedClearTimeout) && clearTimeout) {
        $649253074081e4d2$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $649253074081e4d2$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $649253074081e4d2$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $649253074081e4d2$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $649253074081e4d2$var$queue = [];
var $649253074081e4d2$var$draining = false;
var $649253074081e4d2$var$currentQueue;
var $649253074081e4d2$var$queueIndex = -1;
function $649253074081e4d2$var$cleanUpNextTick() {
    if (!$649253074081e4d2$var$draining || !$649253074081e4d2$var$currentQueue) return;
    $649253074081e4d2$var$draining = false;
    if ($649253074081e4d2$var$currentQueue.length) $649253074081e4d2$var$queue = $649253074081e4d2$var$currentQueue.concat($649253074081e4d2$var$queue);
    else $649253074081e4d2$var$queueIndex = -1;
    if ($649253074081e4d2$var$queue.length) $649253074081e4d2$var$drainQueue();
}
function $649253074081e4d2$var$drainQueue() {
    if ($649253074081e4d2$var$draining) return;
    var timeout = $649253074081e4d2$var$runTimeout($649253074081e4d2$var$cleanUpNextTick);
    $649253074081e4d2$var$draining = true;
    var len = $649253074081e4d2$var$queue.length;
    while(len){
        $649253074081e4d2$var$currentQueue = $649253074081e4d2$var$queue;
        $649253074081e4d2$var$queue = [];
        while(++$649253074081e4d2$var$queueIndex < len)if ($649253074081e4d2$var$currentQueue) $649253074081e4d2$var$currentQueue[$649253074081e4d2$var$queueIndex].run();
        $649253074081e4d2$var$queueIndex = -1;
        len = $649253074081e4d2$var$queue.length;
    }
    $649253074081e4d2$var$currentQueue = null;
    $649253074081e4d2$var$draining = false;
    $649253074081e4d2$var$runClearTimeout(timeout);
}
$649253074081e4d2$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $649253074081e4d2$var$queue.push(new $649253074081e4d2$var$Item(fun, args));
    if ($649253074081e4d2$var$queue.length === 1 && !$649253074081e4d2$var$draining) $649253074081e4d2$var$runTimeout($649253074081e4d2$var$drainQueue);
};
// v8 likes predictible objects
function $649253074081e4d2$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$649253074081e4d2$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$649253074081e4d2$var$process.title = 'browser';
$649253074081e4d2$var$process.browser = true;
$649253074081e4d2$var$process.env = {};
$649253074081e4d2$var$process.argv = [];
$649253074081e4d2$var$process.version = ''; // empty string to avoid regexp issues
$649253074081e4d2$var$process.versions = {};
function $649253074081e4d2$var$noop() {}
$649253074081e4d2$var$process.on = $649253074081e4d2$var$noop;
$649253074081e4d2$var$process.addListener = $649253074081e4d2$var$noop;
$649253074081e4d2$var$process.once = $649253074081e4d2$var$noop;
$649253074081e4d2$var$process.off = $649253074081e4d2$var$noop;
$649253074081e4d2$var$process.removeListener = $649253074081e4d2$var$noop;
$649253074081e4d2$var$process.removeAllListeners = $649253074081e4d2$var$noop;
$649253074081e4d2$var$process.emit = $649253074081e4d2$var$noop;
$649253074081e4d2$var$process.prependListener = $649253074081e4d2$var$noop;
$649253074081e4d2$var$process.prependOnceListener = $649253074081e4d2$var$noop;
$649253074081e4d2$var$process.listeners = function(name) {
    return [];
};
$649253074081e4d2$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$649253074081e4d2$var$process.cwd = function() {
    return '/';
};
$649253074081e4d2$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$649253074081e4d2$var$process.umask = function() {
    return 0;
};

});


parcelRegister("dL8HM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0466ac7dad7db6d$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");

var $koUS0 = parcelRequire("koUS0");

var $dEe4D = parcelRequire("dEe4D");

var $1WTNE = parcelRequire("1WTNE");

var $dPMmc = parcelRequire("dPMmc");

var $1oZ6c = parcelRequire("1oZ6c");

var $6O0Rc = parcelRequire("6O0Rc");

var $10epZ = parcelRequire("10epZ");
'use strict';
const $a0466ac7dad7db6d$var$validators = (0, $6O0Rc.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a0466ac7dad7db6d$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $dEe4D.default)(),
            response: new (0, $dEe4D.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $dPMmc.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $6O0Rc.default).assertOptions(transitional, {
            silentJSONParsing: $a0466ac7dad7db6d$var$validators.transitional($a0466ac7dad7db6d$var$validators.boolean),
            forcedJSONParsing: $a0466ac7dad7db6d$var$validators.transitional($a0466ac7dad7db6d$var$validators.boolean),
            clarifyTimeoutError: $a0466ac7dad7db6d$var$validators.transitional($a0466ac7dad7db6d$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $4vLup.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $6O0Rc.default).assertOptions(paramsSerializer, {
                encode: $a0466ac7dad7db6d$var$validators.function,
                serialize: $a0466ac7dad7db6d$var$validators.function
            }, true);
        }
        (0, $6O0Rc.default).assertOptions(config, {
            baseUrl: $a0466ac7dad7db6d$var$validators.spelling('baseURL'),
            withXsrfToken: $a0466ac7dad7db6d$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $4vLup.default).merge(headers.common, headers[config.method]);
        headers && (0, $4vLup.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $10epZ.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $1WTNE.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $1WTNE.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $dPMmc.default)(this.defaults, config);
        const fullPath = (0, $1oZ6c.default)(config.baseURL, config.url);
        return (0, $koUS0.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $4vLup.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a0466ac7dad7db6d$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $dPMmc.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $4vLup.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $dPMmc.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a0466ac7dad7db6d$var$Axios.prototype[method] = generateHTTPMethod();
    $a0466ac7dad7db6d$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a0466ac7dad7db6d$export$2e2bcd8739ae039 = $a0466ac7dad7db6d$var$Axios;

});
parcelRegister("koUS0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eda229c3b2d931f0$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");

var $5kRfi = parcelRequire("5kRfi");
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $eda229c3b2d931f0$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $eda229c3b2d931f0$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $eda229c3b2d931f0$var$encode;
    if ((0, $4vLup.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $4vLup.default).isURLSearchParams(params) ? params.toString() : new (0, $5kRfi.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("5kRfi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e281f7f7a6e8216$export$2e2bcd8739ae039; });

var $aPHuZ = parcelRequire("aPHuZ");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $3e281f7f7a6e8216$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $3e281f7f7a6e8216$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $aPHuZ.default)(params, this, options);
}
const $3e281f7f7a6e8216$var$prototype = $3e281f7f7a6e8216$var$AxiosURLSearchParams.prototype;
$3e281f7f7a6e8216$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$3e281f7f7a6e8216$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $3e281f7f7a6e8216$var$encode);
    } : $3e281f7f7a6e8216$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $3e281f7f7a6e8216$export$2e2bcd8739ae039 = $3e281f7f7a6e8216$var$AxiosURLSearchParams;

});
parcelRegister("aPHuZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e3068bf982f0a88$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");

var $49DnR = parcelRequire("49DnR");

var $7MBJ4 = parcelRequire("7MBJ4");

var $cHEiR = parcelRequire("cHEiR");
var $7e3068bf982f0a88$require$Buffer = $cHEiR.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $7e3068bf982f0a88$var$isVisitable(thing) {
    return (0, $4vLup.default).isPlainObject(thing) || (0, $4vLup.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $7e3068bf982f0a88$var$removeBrackets(key) {
    return (0, $4vLup.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $7e3068bf982f0a88$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $7e3068bf982f0a88$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $7e3068bf982f0a88$var$isFlatArray(arr) {
    return (0, $4vLup.default).isArray(arr) && !arr.some($7e3068bf982f0a88$var$isVisitable);
}
const $7e3068bf982f0a88$var$predicates = (0, $4vLup.default).toFlatObject((0, $4vLup.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $7e3068bf982f0a88$var$toFormData(obj, formData, options) {
    if (!(0, $4vLup.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $7MBJ4.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $4vLup.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $4vLup.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $4vLup.default).isSpecCompliantForm(formData);
    if (!(0, $4vLup.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $4vLup.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $4vLup.default).isBlob(value)) throw new (0, $49DnR.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $4vLup.default).isArrayBuffer(value) || (0, $4vLup.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $7e3068bf982f0a88$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $4vLup.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $4vLup.default).isArray(value) && $7e3068bf982f0a88$var$isFlatArray(value) || ((0, $4vLup.default).isFileList(value) || (0, $4vLup.default).endsWith(key, '[]')) && (arr = (0, $4vLup.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $7e3068bf982f0a88$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $4vLup.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $7e3068bf982f0a88$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($7e3068bf982f0a88$var$isVisitable(value)) return true;
        formData.append($7e3068bf982f0a88$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($7e3068bf982f0a88$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $7e3068bf982f0a88$var$isVisitable
    });
    function build(value, path) {
        if ((0, $4vLup.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $4vLup.default).forEach(value, function each(el, key) {
            const result = !((0, $4vLup.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $4vLup.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $4vLup.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $7e3068bf982f0a88$export$2e2bcd8739ae039 = $7e3068bf982f0a88$var$toFormData;

});
parcelRegister("49DnR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30668d852bc7b013$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");
'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $30668d852bc7b013$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $4vLup.default).inherits($30668d852bc7b013$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $4vLup.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $30668d852bc7b013$var$prototype = $30668d852bc7b013$var$AxiosError.prototype;
const $30668d852bc7b013$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $30668d852bc7b013$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($30668d852bc7b013$var$AxiosError, $30668d852bc7b013$var$descriptors);
Object.defineProperty($30668d852bc7b013$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$30668d852bc7b013$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($30668d852bc7b013$var$prototype);
    (0, $4vLup.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $30668d852bc7b013$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $30668d852bc7b013$export$2e2bcd8739ae039 = $30668d852bc7b013$var$AxiosError;

});

parcelRegister("7MBJ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5aaa47ae1ddb8ed3$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $5aaa47ae1ddb8ed3$export$2e2bcd8739ae039 = null;

});

parcelRegister("cHEiR", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $93f8c38eb0ce4927$export$a143d493d941bafc; }, function (v) { return $93f8c38eb0ce4927$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $93f8c38eb0ce4927$export$f99ded8fe4b79145; }, function (v) { return $93f8c38eb0ce4927$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $93f8c38eb0ce4927$export$a143d493d941bafc;
var $93f8c38eb0ce4927$export$e4cf37d7f6fb9e0a;
var $93f8c38eb0ce4927$export$f99ded8fe4b79145;
var $93f8c38eb0ce4927$export$599f31c3813fae4d;
'use strict';

var $4TlRg = parcelRequire("4TlRg");

var $eZRYS = parcelRequire("eZRYS");
const $93f8c38eb0ce4927$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$93f8c38eb0ce4927$export$a143d493d941bafc = $93f8c38eb0ce4927$var$Buffer;
$93f8c38eb0ce4927$export$e4cf37d7f6fb9e0a = $93f8c38eb0ce4927$var$SlowBuffer;
$93f8c38eb0ce4927$export$f99ded8fe4b79145 = 50;
const $93f8c38eb0ce4927$var$K_MAX_LENGTH = 0x7fffffff;
$93f8c38eb0ce4927$export$599f31c3813fae4d = $93f8c38eb0ce4927$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $93f8c38eb0ce4927$var$Buffer.TYPED_ARRAY_SUPPORT = $93f8c38eb0ce4927$var$typedArraySupport();
if (!$93f8c38eb0ce4927$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $93f8c38eb0ce4927$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($93f8c38eb0ce4927$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$93f8c38eb0ce4927$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($93f8c38eb0ce4927$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$93f8c38eb0ce4927$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $93f8c38eb0ce4927$var$createBuffer(length) {
    if (length > $93f8c38eb0ce4927$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $93f8c38eb0ce4927$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $93f8c38eb0ce4927$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $93f8c38eb0ce4927$var$allocUnsafe(arg);
    }
    return $93f8c38eb0ce4927$var$from(arg, encodingOrOffset, length);
}
$93f8c38eb0ce4927$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $93f8c38eb0ce4927$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $93f8c38eb0ce4927$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $93f8c38eb0ce4927$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($93f8c38eb0ce4927$var$isInstance(value, ArrayBuffer) || value && $93f8c38eb0ce4927$var$isInstance(value.buffer, ArrayBuffer)) return $93f8c38eb0ce4927$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($93f8c38eb0ce4927$var$isInstance(value, SharedArrayBuffer) || value && $93f8c38eb0ce4927$var$isInstance(value.buffer, SharedArrayBuffer))) return $93f8c38eb0ce4927$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $93f8c38eb0ce4927$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $93f8c38eb0ce4927$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $93f8c38eb0ce4927$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $93f8c38eb0ce4927$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $93f8c38eb0ce4927$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($93f8c38eb0ce4927$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($93f8c38eb0ce4927$var$Buffer, Uint8Array);
function $93f8c38eb0ce4927$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $93f8c38eb0ce4927$var$alloc(size, fill, encoding) {
    $93f8c38eb0ce4927$var$assertSize(size);
    if (size <= 0) return $93f8c38eb0ce4927$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $93f8c38eb0ce4927$var$createBuffer(size).fill(fill, encoding) : $93f8c38eb0ce4927$var$createBuffer(size).fill(fill);
    return $93f8c38eb0ce4927$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $93f8c38eb0ce4927$var$Buffer.alloc = function(size, fill, encoding) {
    return $93f8c38eb0ce4927$var$alloc(size, fill, encoding);
};
function $93f8c38eb0ce4927$var$allocUnsafe(size) {
    $93f8c38eb0ce4927$var$assertSize(size);
    return $93f8c38eb0ce4927$var$createBuffer(size < 0 ? 0 : $93f8c38eb0ce4927$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $93f8c38eb0ce4927$var$Buffer.allocUnsafe = function(size) {
    return $93f8c38eb0ce4927$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $93f8c38eb0ce4927$var$Buffer.allocUnsafeSlow = function(size) {
    return $93f8c38eb0ce4927$var$allocUnsafe(size);
};
function $93f8c38eb0ce4927$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$93f8c38eb0ce4927$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $93f8c38eb0ce4927$var$byteLength(string, encoding) | 0;
    let buf = $93f8c38eb0ce4927$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $93f8c38eb0ce4927$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $93f8c38eb0ce4927$var$checked(array.length) | 0;
    const buf = $93f8c38eb0ce4927$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $93f8c38eb0ce4927$var$fromArrayView(arrayView) {
    if ($93f8c38eb0ce4927$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $93f8c38eb0ce4927$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $93f8c38eb0ce4927$var$fromArrayLike(arrayView);
}
function $93f8c38eb0ce4927$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $93f8c38eb0ce4927$var$Buffer.prototype);
    return buf;
}
function $93f8c38eb0ce4927$var$fromObject(obj) {
    if ($93f8c38eb0ce4927$var$Buffer.isBuffer(obj)) {
        const len = $93f8c38eb0ce4927$var$checked(obj.length) | 0;
        const buf = $93f8c38eb0ce4927$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $93f8c38eb0ce4927$var$numberIsNaN(obj.length)) return $93f8c38eb0ce4927$var$createBuffer(0);
        return $93f8c38eb0ce4927$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $93f8c38eb0ce4927$var$fromArrayLike(obj.data);
}
function $93f8c38eb0ce4927$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $93f8c38eb0ce4927$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $93f8c38eb0ce4927$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $93f8c38eb0ce4927$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $93f8c38eb0ce4927$var$Buffer.alloc(+length);
}
$93f8c38eb0ce4927$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $93f8c38eb0ce4927$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$93f8c38eb0ce4927$var$Buffer.compare = function compare(a, b) {
    if ($93f8c38eb0ce4927$var$isInstance(a, Uint8Array)) a = $93f8c38eb0ce4927$var$Buffer.from(a, a.offset, a.byteLength);
    if ($93f8c38eb0ce4927$var$isInstance(b, Uint8Array)) b = $93f8c38eb0ce4927$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$93f8c38eb0ce4927$var$Buffer.isBuffer(a) || !$93f8c38eb0ce4927$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$93f8c38eb0ce4927$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$93f8c38eb0ce4927$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $93f8c38eb0ce4927$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $93f8c38eb0ce4927$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($93f8c38eb0ce4927$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$93f8c38eb0ce4927$var$Buffer.isBuffer(buf)) buf = $93f8c38eb0ce4927$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$93f8c38eb0ce4927$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $93f8c38eb0ce4927$var$byteLength(string, encoding) {
    if ($93f8c38eb0ce4927$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $93f8c38eb0ce4927$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $93f8c38eb0ce4927$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $93f8c38eb0ce4927$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $93f8c38eb0ce4927$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$93f8c38eb0ce4927$var$Buffer.byteLength = $93f8c38eb0ce4927$var$byteLength;
function $93f8c38eb0ce4927$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $93f8c38eb0ce4927$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $93f8c38eb0ce4927$var$utf8Slice(this, start, end);
        case 'ascii':
            return $93f8c38eb0ce4927$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $93f8c38eb0ce4927$var$latin1Slice(this, start, end);
        case 'base64':
            return $93f8c38eb0ce4927$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $93f8c38eb0ce4927$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$93f8c38eb0ce4927$var$Buffer.prototype._isBuffer = true;
function $93f8c38eb0ce4927$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$93f8c38eb0ce4927$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$93f8c38eb0ce4927$var$swap(this, i, i + 1);
    return this;
};
$93f8c38eb0ce4927$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $93f8c38eb0ce4927$var$swap(this, i, i + 3);
        $93f8c38eb0ce4927$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$93f8c38eb0ce4927$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $93f8c38eb0ce4927$var$swap(this, i, i + 7);
        $93f8c38eb0ce4927$var$swap(this, i + 1, i + 6);
        $93f8c38eb0ce4927$var$swap(this, i + 2, i + 5);
        $93f8c38eb0ce4927$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$93f8c38eb0ce4927$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $93f8c38eb0ce4927$var$utf8Slice(this, 0, length);
    return $93f8c38eb0ce4927$var$slowToString.apply(this, arguments);
};
$93f8c38eb0ce4927$var$Buffer.prototype.toLocaleString = $93f8c38eb0ce4927$var$Buffer.prototype.toString;
$93f8c38eb0ce4927$var$Buffer.prototype.equals = function equals(b) {
    if (!$93f8c38eb0ce4927$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $93f8c38eb0ce4927$var$Buffer.compare(this, b) === 0;
};
$93f8c38eb0ce4927$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $93f8c38eb0ce4927$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($93f8c38eb0ce4927$var$customInspectSymbol) $93f8c38eb0ce4927$var$Buffer.prototype[$93f8c38eb0ce4927$var$customInspectSymbol] = $93f8c38eb0ce4927$var$Buffer.prototype.inspect;
$93f8c38eb0ce4927$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($93f8c38eb0ce4927$var$isInstance(target, Uint8Array)) target = $93f8c38eb0ce4927$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$93f8c38eb0ce4927$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $93f8c38eb0ce4927$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($93f8c38eb0ce4927$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $93f8c38eb0ce4927$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($93f8c38eb0ce4927$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $93f8c38eb0ce4927$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $93f8c38eb0ce4927$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $93f8c38eb0ce4927$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$93f8c38eb0ce4927$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$93f8c38eb0ce4927$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $93f8c38eb0ce4927$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$93f8c38eb0ce4927$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $93f8c38eb0ce4927$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $93f8c38eb0ce4927$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($93f8c38eb0ce4927$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $93f8c38eb0ce4927$var$utf8Write(buf, string, offset, length) {
    return $93f8c38eb0ce4927$var$blitBuffer($93f8c38eb0ce4927$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $93f8c38eb0ce4927$var$asciiWrite(buf, string, offset, length) {
    return $93f8c38eb0ce4927$var$blitBuffer($93f8c38eb0ce4927$var$asciiToBytes(string), buf, offset, length);
}
function $93f8c38eb0ce4927$var$base64Write(buf, string, offset, length) {
    return $93f8c38eb0ce4927$var$blitBuffer($93f8c38eb0ce4927$var$base64ToBytes(string), buf, offset, length);
}
function $93f8c38eb0ce4927$var$ucs2Write(buf, string, offset, length) {
    return $93f8c38eb0ce4927$var$blitBuffer($93f8c38eb0ce4927$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$93f8c38eb0ce4927$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $93f8c38eb0ce4927$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $93f8c38eb0ce4927$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $93f8c38eb0ce4927$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $93f8c38eb0ce4927$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $93f8c38eb0ce4927$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$93f8c38eb0ce4927$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $93f8c38eb0ce4927$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $4TlRg.fromByteArray(buf);
    else return $4TlRg.fromByteArray(buf.slice(start, end));
}
function $93f8c38eb0ce4927$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $93f8c38eb0ce4927$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $93f8c38eb0ce4927$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $93f8c38eb0ce4927$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $93f8c38eb0ce4927$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $93f8c38eb0ce4927$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $93f8c38eb0ce4927$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $93f8c38eb0ce4927$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $93f8c38eb0ce4927$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $93f8c38eb0ce4927$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $93f8c38eb0ce4927$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$93f8c38eb0ce4927$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $93f8c38eb0ce4927$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $93f8c38eb0ce4927$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$93f8c38eb0ce4927$var$Buffer.prototype.readUintLE = $93f8c38eb0ce4927$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$93f8c38eb0ce4927$var$Buffer.prototype.readUintBE = $93f8c38eb0ce4927$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$93f8c38eb0ce4927$var$Buffer.prototype.readUint8 = $93f8c38eb0ce4927$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$93f8c38eb0ce4927$var$Buffer.prototype.readUint16LE = $93f8c38eb0ce4927$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$93f8c38eb0ce4927$var$Buffer.prototype.readUint16BE = $93f8c38eb0ce4927$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$93f8c38eb0ce4927$var$Buffer.prototype.readUint32LE = $93f8c38eb0ce4927$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$93f8c38eb0ce4927$var$Buffer.prototype.readUint32BE = $93f8c38eb0ce4927$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$93f8c38eb0ce4927$var$Buffer.prototype.readBigUInt64LE = $93f8c38eb0ce4927$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $93f8c38eb0ce4927$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $93f8c38eb0ce4927$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$93f8c38eb0ce4927$var$Buffer.prototype.readBigUInt64BE = $93f8c38eb0ce4927$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $93f8c38eb0ce4927$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $93f8c38eb0ce4927$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$93f8c38eb0ce4927$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$93f8c38eb0ce4927$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$93f8c38eb0ce4927$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$93f8c38eb0ce4927$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$93f8c38eb0ce4927$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$93f8c38eb0ce4927$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$93f8c38eb0ce4927$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$93f8c38eb0ce4927$var$Buffer.prototype.readBigInt64LE = $93f8c38eb0ce4927$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $93f8c38eb0ce4927$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $93f8c38eb0ce4927$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$93f8c38eb0ce4927$var$Buffer.prototype.readBigInt64BE = $93f8c38eb0ce4927$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $93f8c38eb0ce4927$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $93f8c38eb0ce4927$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$93f8c38eb0ce4927$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, 4, this.length);
    return $eZRYS.read(this, offset, true, 23, 4);
};
$93f8c38eb0ce4927$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, 4, this.length);
    return $eZRYS.read(this, offset, false, 23, 4);
};
$93f8c38eb0ce4927$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, 8, this.length);
    return $eZRYS.read(this, offset, true, 52, 8);
};
$93f8c38eb0ce4927$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkOffset(offset, 8, this.length);
    return $eZRYS.read(this, offset, false, 52, 8);
};
function $93f8c38eb0ce4927$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$93f8c38eb0ce4927$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$93f8c38eb0ce4927$var$Buffer.prototype.writeUintLE = $93f8c38eb0ce4927$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $93f8c38eb0ce4927$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$93f8c38eb0ce4927$var$Buffer.prototype.writeUintBE = $93f8c38eb0ce4927$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $93f8c38eb0ce4927$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$93f8c38eb0ce4927$var$Buffer.prototype.writeUint8 = $93f8c38eb0ce4927$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$93f8c38eb0ce4927$var$Buffer.prototype.writeUint16LE = $93f8c38eb0ce4927$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$93f8c38eb0ce4927$var$Buffer.prototype.writeUint16BE = $93f8c38eb0ce4927$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$93f8c38eb0ce4927$var$Buffer.prototype.writeUint32LE = $93f8c38eb0ce4927$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$93f8c38eb0ce4927$var$Buffer.prototype.writeUint32BE = $93f8c38eb0ce4927$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $93f8c38eb0ce4927$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $93f8c38eb0ce4927$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $93f8c38eb0ce4927$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $93f8c38eb0ce4927$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$93f8c38eb0ce4927$var$Buffer.prototype.writeBigUInt64LE = $93f8c38eb0ce4927$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $93f8c38eb0ce4927$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$93f8c38eb0ce4927$var$Buffer.prototype.writeBigUInt64BE = $93f8c38eb0ce4927$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $93f8c38eb0ce4927$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$93f8c38eb0ce4927$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $93f8c38eb0ce4927$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$93f8c38eb0ce4927$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $93f8c38eb0ce4927$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$93f8c38eb0ce4927$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$93f8c38eb0ce4927$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$93f8c38eb0ce4927$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$93f8c38eb0ce4927$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$93f8c38eb0ce4927$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$93f8c38eb0ce4927$var$Buffer.prototype.writeBigInt64LE = $93f8c38eb0ce4927$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $93f8c38eb0ce4927$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$93f8c38eb0ce4927$var$Buffer.prototype.writeBigInt64BE = $93f8c38eb0ce4927$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $93f8c38eb0ce4927$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $93f8c38eb0ce4927$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $93f8c38eb0ce4927$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $eZRYS.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$93f8c38eb0ce4927$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $93f8c38eb0ce4927$var$writeFloat(this, value, offset, true, noAssert);
};
$93f8c38eb0ce4927$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $93f8c38eb0ce4927$var$writeFloat(this, value, offset, false, noAssert);
};
function $93f8c38eb0ce4927$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $93f8c38eb0ce4927$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $eZRYS.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$93f8c38eb0ce4927$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $93f8c38eb0ce4927$var$writeDouble(this, value, offset, true, noAssert);
};
$93f8c38eb0ce4927$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $93f8c38eb0ce4927$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$93f8c38eb0ce4927$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$93f8c38eb0ce4927$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$93f8c38eb0ce4927$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$93f8c38eb0ce4927$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $93f8c38eb0ce4927$var$Buffer.isBuffer(val) ? val : $93f8c38eb0ce4927$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $93f8c38eb0ce4927$var$errors = {};
function $93f8c38eb0ce4927$var$E(sym, getMessage, Base) {
    $93f8c38eb0ce4927$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$93f8c38eb0ce4927$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$93f8c38eb0ce4927$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$93f8c38eb0ce4927$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $93f8c38eb0ce4927$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $93f8c38eb0ce4927$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $93f8c38eb0ce4927$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $93f8c38eb0ce4927$var$checkBounds(buf, offset, byteLength) {
    $93f8c38eb0ce4927$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $93f8c38eb0ce4927$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $93f8c38eb0ce4927$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $93f8c38eb0ce4927$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $93f8c38eb0ce4927$var$checkBounds(buf, offset, byteLength);
}
function $93f8c38eb0ce4927$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $93f8c38eb0ce4927$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $93f8c38eb0ce4927$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $93f8c38eb0ce4927$var$validateNumber(value, type);
        throw new $93f8c38eb0ce4927$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $93f8c38eb0ce4927$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $93f8c38eb0ce4927$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $93f8c38eb0ce4927$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $93f8c38eb0ce4927$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($93f8c38eb0ce4927$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $93f8c38eb0ce4927$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $93f8c38eb0ce4927$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $93f8c38eb0ce4927$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $93f8c38eb0ce4927$var$base64ToBytes(str) {
    return $4TlRg.toByteArray($93f8c38eb0ce4927$var$base64clean(str));
}
function $93f8c38eb0ce4927$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $93f8c38eb0ce4927$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $93f8c38eb0ce4927$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $93f8c38eb0ce4927$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $93f8c38eb0ce4927$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $93f8c38eb0ce4927$var$BufferBigIntNotDefined : fn;
}
function $93f8c38eb0ce4927$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("4TlRg", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $38fd410bea3f7187$export$d622b2ad8d90c771; }, function (v) { return $38fd410bea3f7187$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $38fd410bea3f7187$export$6100ba28696e12de; }, function (v) { return $38fd410bea3f7187$export$6100ba28696e12de = v; });
var $38fd410bea3f7187$export$a48f0734ac7c2329;
var $38fd410bea3f7187$export$d622b2ad8d90c771;
var $38fd410bea3f7187$export$6100ba28696e12de;
'use strict';
$38fd410bea3f7187$export$a48f0734ac7c2329 = $38fd410bea3f7187$var$byteLength;
$38fd410bea3f7187$export$d622b2ad8d90c771 = $38fd410bea3f7187$var$toByteArray;
$38fd410bea3f7187$export$6100ba28696e12de = $38fd410bea3f7187$var$fromByteArray;
var $38fd410bea3f7187$var$lookup = [];
var $38fd410bea3f7187$var$revLookup = [];
var $38fd410bea3f7187$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $38fd410bea3f7187$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $38fd410bea3f7187$var$i = 0, $38fd410bea3f7187$var$len = $38fd410bea3f7187$var$code.length; $38fd410bea3f7187$var$i < $38fd410bea3f7187$var$len; ++$38fd410bea3f7187$var$i){
    $38fd410bea3f7187$var$lookup[$38fd410bea3f7187$var$i] = $38fd410bea3f7187$var$code[$38fd410bea3f7187$var$i];
    $38fd410bea3f7187$var$revLookup[$38fd410bea3f7187$var$code.charCodeAt($38fd410bea3f7187$var$i)] = $38fd410bea3f7187$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$38fd410bea3f7187$var$revLookup['-'.charCodeAt(0)] = 62;
$38fd410bea3f7187$var$revLookup['_'.charCodeAt(0)] = 63;
function $38fd410bea3f7187$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $38fd410bea3f7187$var$byteLength(b64) {
    var lens = $38fd410bea3f7187$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $38fd410bea3f7187$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $38fd410bea3f7187$var$toByteArray(b64) {
    var tmp;
    var lens = $38fd410bea3f7187$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $38fd410bea3f7187$var$Arr($38fd410bea3f7187$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $38fd410bea3f7187$var$revLookup[b64.charCodeAt(i)] << 18 | $38fd410bea3f7187$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $38fd410bea3f7187$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $38fd410bea3f7187$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $38fd410bea3f7187$var$revLookup[b64.charCodeAt(i)] << 2 | $38fd410bea3f7187$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $38fd410bea3f7187$var$revLookup[b64.charCodeAt(i)] << 10 | $38fd410bea3f7187$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $38fd410bea3f7187$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $38fd410bea3f7187$var$tripletToBase64(num) {
    return $38fd410bea3f7187$var$lookup[num >> 18 & 0x3F] + $38fd410bea3f7187$var$lookup[num >> 12 & 0x3F] + $38fd410bea3f7187$var$lookup[num >> 6 & 0x3F] + $38fd410bea3f7187$var$lookup[num & 0x3F];
}
function $38fd410bea3f7187$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($38fd410bea3f7187$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $38fd410bea3f7187$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($38fd410bea3f7187$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($38fd410bea3f7187$var$lookup[tmp >> 2] + $38fd410bea3f7187$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($38fd410bea3f7187$var$lookup[tmp >> 10] + $38fd410bea3f7187$var$lookup[tmp >> 4 & 0x3F] + $38fd410bea3f7187$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("eZRYS", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $aeb0a2b22c3832b7$export$aafa59e2e03f2942; }, function (v) { return $aeb0a2b22c3832b7$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $aeb0a2b22c3832b7$export$68d8715fc104d294; }, function (v) { return $aeb0a2b22c3832b7$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $aeb0a2b22c3832b7$export$aafa59e2e03f2942;
var $aeb0a2b22c3832b7$export$68d8715fc104d294;
$aeb0a2b22c3832b7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$aeb0a2b22c3832b7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("dEe4D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ef9ed8ae7ae9309$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");
'use strict';
class $9ef9ed8ae7ae9309$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $4vLup.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $9ef9ed8ae7ae9309$export$2e2bcd8739ae039 = $9ef9ed8ae7ae9309$var$InterceptorManager;

});

parcelRegister("1WTNE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16b67ded0a8d4583$export$2e2bcd8739ae039; });

var $lCHoB = parcelRequire("lCHoB");

var $XA2mI = parcelRequire("XA2mI");

var $LZz0W = parcelRequire("LZz0W");

var $dHwgY = parcelRequire("dHwgY");

var $10epZ = parcelRequire("10epZ");

var $VKSNc = parcelRequire("VKSNc");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $16b67ded0a8d4583$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $dHwgY.default)(null, config);
}
function $16b67ded0a8d4583$export$2e2bcd8739ae039(config) {
    $16b67ded0a8d4583$var$throwIfCancellationRequested(config);
    config.headers = (0, $10epZ.default).from(config.headers);
    // Transform request data
    config.data = (0, $lCHoB.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $VKSNc.default).getAdapter(config.adapter || (0, $LZz0W.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $16b67ded0a8d4583$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $lCHoB.default).call(config, config.transformResponse, response);
        response.headers = (0, $10epZ.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $XA2mI.default)(reason)) {
            $16b67ded0a8d4583$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $lCHoB.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $10epZ.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("lCHoB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbdecf15360f4fab$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");

var $LZz0W = parcelRequire("LZz0W");

var $10epZ = parcelRequire("10epZ");
'use strict';
function $fbdecf15360f4fab$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $LZz0W.default);
    const context = response || config;
    const headers = (0, $10epZ.default).from(context.headers);
    let data = context.data;
    (0, $4vLup.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("LZz0W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0904252db7187d3f$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");

var $49DnR = parcelRequire("49DnR");

var $eFYTa = parcelRequire("eFYTa");

var $aPHuZ = parcelRequire("aPHuZ");

var $3GpOn = parcelRequire("3GpOn");

var $9XmN7 = parcelRequire("9XmN7");

var $fkEjB = parcelRequire("fkEjB");
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $0904252db7187d3f$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $4vLup.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $4vLup.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $0904252db7187d3f$var$defaults = {
    transitional: (0, $eFYTa.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $4vLup.default).isObject(data);
            if (isObjectPayload && (0, $4vLup.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $4vLup.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $fkEjB.default)(data)) : data;
            if ((0, $4vLup.default).isArrayBuffer(data) || (0, $4vLup.default).isBuffer(data) || (0, $4vLup.default).isStream(data) || (0, $4vLup.default).isFile(data) || (0, $4vLup.default).isBlob(data) || (0, $4vLup.default).isReadableStream(data)) return data;
            if ((0, $4vLup.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $4vLup.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $3GpOn.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $4vLup.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $aPHuZ.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $0904252db7187d3f$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $0904252db7187d3f$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $4vLup.default).isResponse(data) || (0, $4vLup.default).isReadableStream(data)) return data;
            if (data && (0, $4vLup.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $49DnR.default).from(e, (0, $49DnR.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $9XmN7.default).classes.FormData,
        Blob: (0, $9XmN7.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $4vLup.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $0904252db7187d3f$var$defaults.headers[method] = {};
});
var $0904252db7187d3f$export$2e2bcd8739ae039 = $0904252db7187d3f$var$defaults;

});
parcelRegister("eFYTa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aaf4203edb636d6e$export$2e2bcd8739ae039; });
'use strict';
var $aaf4203edb636d6e$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("3GpOn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ae950f893539d33$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");

var $aPHuZ = parcelRequire("aPHuZ");

var $9XmN7 = parcelRequire("9XmN7");
'use strict';
function $2ae950f893539d33$export$2e2bcd8739ae039(data, options) {
    return (0, $aPHuZ.default)(data, new (0, $9XmN7.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $9XmN7.default).isNode && (0, $4vLup.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("9XmN7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73fb4d9917e84f90$export$2e2bcd8739ae039; });

var $OAVhr = parcelRequire("OAVhr");

var $jxPQe = parcelRequire("jxPQe");
var $73fb4d9917e84f90$export$2e2bcd8739ae039 = {
    ...$jxPQe,
    ...(0, $OAVhr.default)
};

});
parcelRegister("OAVhr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09814fbd83de189d$export$2e2bcd8739ae039; });

var $aCNcz = parcelRequire("aCNcz");

var $3MTHa = parcelRequire("3MTHa");

var $java0 = parcelRequire("java0");
var $09814fbd83de189d$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $aCNcz.default,
        FormData: $3MTHa.default,
        Blob: $java0.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("aCNcz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bc39e756cc33d7c$export$2e2bcd8739ae039; });

var $5kRfi = parcelRequire("5kRfi");
'use strict';
var $7bc39e756cc33d7c$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $5kRfi.default);

});

parcelRegister("3MTHa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c210eb9cbf6b8f6$export$2e2bcd8739ae039; });
'use strict';
var $2c210eb9cbf6b8f6$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("java0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df471f5047b0e9ad$export$2e2bcd8739ae039; });
'use strict';
var $df471f5047b0e9ad$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("jxPQe", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $e3a950051a7a5a9d$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $e3a950051a7a5a9d$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $e3a950051a7a5a9d$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $e3a950051a7a5a9d$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $e3a950051a7a5a9d$export$f710a83a91838a36; });
const $e3a950051a7a5a9d$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $e3a950051a7a5a9d$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $e3a950051a7a5a9d$export$c0bcc9250309d66 = $e3a950051a7a5a9d$export$c4996c4b7b93b0bf && (!$e3a950051a7a5a9d$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($e3a950051a7a5a9d$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $e3a950051a7a5a9d$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $e3a950051a7a5a9d$export$f710a83a91838a36 = $e3a950051a7a5a9d$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("fkEjB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b297ff0b8bc9bd07$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $b297ff0b8bc9bd07$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $4vLup.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $b297ff0b8bc9bd07$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $b297ff0b8bc9bd07$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $4vLup.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $4vLup.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $4vLup.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $4vLup.default).isArray(target[name])) target[name] = $b297ff0b8bc9bd07$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $4vLup.default).isFormData(formData) && (0, $4vLup.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $4vLup.default).forEachEntry(formData, (name, value)=>{
            buildPath($b297ff0b8bc9bd07$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $b297ff0b8bc9bd07$export$2e2bcd8739ae039 = $b297ff0b8bc9bd07$var$formDataToJSON;

});


parcelRegister("10epZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bb0f9aff1db47a6$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");

var $bQS2G = parcelRequire("bQS2G");
'use strict';
const $0bb0f9aff1db47a6$var$$internals = Symbol('internals');
function $0bb0f9aff1db47a6$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $0bb0f9aff1db47a6$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $4vLup.default).isArray(value) ? value.map($0bb0f9aff1db47a6$var$normalizeValue) : String(value);
}
function $0bb0f9aff1db47a6$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $0bb0f9aff1db47a6$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $0bb0f9aff1db47a6$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $4vLup.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $4vLup.default).isString(value)) return;
    if ((0, $4vLup.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $4vLup.default).isRegExp(filter)) return filter.test(value);
}
function $0bb0f9aff1db47a6$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $0bb0f9aff1db47a6$var$buildAccessors(obj, header) {
    const accessorName = (0, $4vLup.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $0bb0f9aff1db47a6$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $0bb0f9aff1db47a6$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $4vLup.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $0bb0f9aff1db47a6$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $4vLup.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $4vLup.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $4vLup.default).isString(header) && (header = header.trim()) && !$0bb0f9aff1db47a6$var$isValidHeaderName(header)) setHeaders((0, $bQS2G.default)(header), valueOrRewrite);
        else if ((0, $4vLup.default).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $0bb0f9aff1db47a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4vLup.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $0bb0f9aff1db47a6$var$parseTokens(value);
                if ((0, $4vLup.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $4vLup.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $0bb0f9aff1db47a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4vLup.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $0bb0f9aff1db47a6$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $0bb0f9aff1db47a6$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $4vLup.default).findKey(self, _header);
                if (key && (!matcher || $0bb0f9aff1db47a6$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $4vLup.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $0bb0f9aff1db47a6$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $4vLup.default).forEach(this, (value, header)=>{
            const key = (0, $4vLup.default).findKey(headers, header);
            if (key) {
                self[key] = $0bb0f9aff1db47a6$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $0bb0f9aff1db47a6$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $0bb0f9aff1db47a6$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $4vLup.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $4vLup.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$0bb0f9aff1db47a6$var$$internals] = this[$0bb0f9aff1db47a6$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $0bb0f9aff1db47a6$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $0bb0f9aff1db47a6$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $4vLup.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$0bb0f9aff1db47a6$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $4vLup.default).reduceDescriptors($0bb0f9aff1db47a6$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $4vLup.default).freezeMethods($0bb0f9aff1db47a6$var$AxiosHeaders);
var $0bb0f9aff1db47a6$export$2e2bcd8739ae039 = $0bb0f9aff1db47a6$var$AxiosHeaders;

});
parcelRegister("bQS2G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a0e78b02f7e75d0$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $8a0e78b02f7e75d0$var$ignoreDuplicateOf = (0, $4vLup.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $8a0e78b02f7e75d0$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $8a0e78b02f7e75d0$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});



parcelRegister("XA2mI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b317707b3f88ecd$export$2e2bcd8739ae039; });
'use strict';
function $0b317707b3f88ecd$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("dHwgY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f98533267767895$export$2e2bcd8739ae039; });

var $49DnR = parcelRequire("49DnR");

var $4vLup = parcelRequire("4vLup");
'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9f98533267767895$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $49DnR.default).call(this, message == null ? 'canceled' : message, (0, $49DnR.default).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $4vLup.default).inherits($9f98533267767895$var$CanceledError, (0, $49DnR.default), {
    __CANCEL__: true
});
var $9f98533267767895$export$2e2bcd8739ae039 = $9f98533267767895$var$CanceledError;

});

parcelRegister("VKSNc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ad9b0ec87c793e8$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");

var $7MBJ4 = parcelRequire("7MBJ4");

var $h6j5R = parcelRequire("h6j5R");

var $bg4Bj = parcelRequire("bg4Bj");

var $49DnR = parcelRequire("49DnR");
const $0ad9b0ec87c793e8$var$knownAdapters = {
    http: (0, $7MBJ4.default),
    xhr: (0, $h6j5R.default),
    fetch: (0, $bg4Bj.default)
};
(0, $4vLup.default).forEach($0ad9b0ec87c793e8$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $0ad9b0ec87c793e8$var$renderReason = (reason)=>`- ${reason}`;
const $0ad9b0ec87c793e8$var$isResolvedHandle = (adapter)=>(0, $4vLup.default).isFunction(adapter) || adapter === null || adapter === false;
var $0ad9b0ec87c793e8$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $4vLup.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$0ad9b0ec87c793e8$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $0ad9b0ec87c793e8$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $49DnR.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($0ad9b0ec87c793e8$var$renderReason).join('\n') : ' ' + $0ad9b0ec87c793e8$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $49DnR.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $0ad9b0ec87c793e8$var$knownAdapters
};

});
parcelRegister("h6j5R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c731ceccaa3d7414$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");

var $awvbe = parcelRequire("awvbe");

var $eFYTa = parcelRequire("eFYTa");

var $49DnR = parcelRequire("49DnR");

var $dHwgY = parcelRequire("dHwgY");

var $cW45p = parcelRequire("cW45p");

var $9XmN7 = parcelRequire("9XmN7");

var $10epZ = parcelRequire("10epZ");

var $dKGH6 = parcelRequire("dKGH6");

var $4CED9 = parcelRequire("4CED9");
const $c731ceccaa3d7414$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $c731ceccaa3d7414$export$2e2bcd8739ae039 = $c731ceccaa3d7414$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $4CED9.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $10epZ.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $10epZ.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $awvbe.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $49DnR.default)('Request aborted', (0, $49DnR.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $49DnR.default)('Network Error', (0, $49DnR.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $eFYTa.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $49DnR.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $49DnR.default).ETIMEDOUT : (0, $49DnR.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $4vLup.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $4vLup.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $dKGH6.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $dKGH6.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $dHwgY.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $cW45p.default)(_config.url);
        if (protocol && (0, $9XmN7.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $49DnR.default)('Unsupported protocol ' + protocol + ':', (0, $49DnR.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("awvbe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a951441fc201dd6$export$2e2bcd8739ae039; });

var $49DnR = parcelRequire("49DnR");
'use strict';
function $7a951441fc201dd6$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $49DnR.default)('Request failed with status code ' + response.status, [
        (0, $49DnR.default).ERR_BAD_REQUEST,
        (0, $49DnR.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("cW45p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96ae123e8c80dadf$export$2e2bcd8739ae039; });
'use strict';
function $96ae123e8c80dadf$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("dKGH6", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $a030b069a5863d2e$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $a030b069a5863d2e$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $a030b069a5863d2e$export$5d35863c355a22a9; });

var $5WHhL = parcelRequire("5WHhL");

var $kpHjC = parcelRequire("kpHjC");

var $4vLup = parcelRequire("4vLup");
const $a030b069a5863d2e$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $5WHhL.default)(50, 250);
    return (0, $kpHjC.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $a030b069a5863d2e$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $a030b069a5863d2e$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $4vLup.default).asap(()=>fn(...args));

});
parcelRegister("5WHhL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4543f21b623ae19f$export$2e2bcd8739ae039; });
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4543f21b623ae19f$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4543f21b623ae19f$export$2e2bcd8739ae039 = $4543f21b623ae19f$var$speedometer;

});

parcelRegister("kpHjC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edc7be01db7eca98$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $edc7be01db7eca98$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $edc7be01db7eca98$export$2e2bcd8739ae039 = $edc7be01db7eca98$var$throttle;

});


parcelRegister("4CED9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35da3a6af6c3a334$export$2e2bcd8739ae039; });

var $9XmN7 = parcelRequire("9XmN7");

var $4vLup = parcelRequire("4vLup");

var $3NJbi = parcelRequire("3NJbi");

var $8O2bW = parcelRequire("8O2bW");

var $1oZ6c = parcelRequire("1oZ6c");

var $dPMmc = parcelRequire("dPMmc");

var $10epZ = parcelRequire("10epZ");

var $koUS0 = parcelRequire("koUS0");
var $35da3a6af6c3a334$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $dPMmc.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $10epZ.default).from(headers);
    newConfig.url = (0, $koUS0.default)((0, $1oZ6c.default)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $4vLup.default).isFormData(data)) {
        if ((0, $9XmN7.default).hasStandardBrowserEnv || (0, $9XmN7.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $9XmN7.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $4vLup.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $3NJbi.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $8O2bW.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("3NJbi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c48feb84373646d$export$2e2bcd8739ae039; });

var $9XmN7 = parcelRequire("9XmN7");
var $2c48feb84373646d$export$2e2bcd8739ae039 = (0, $9XmN7.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $9XmN7.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $9XmN7.default).origin), (0, $9XmN7.default).navigator && /(msie|trident)/i.test((0, $9XmN7.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("8O2bW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6694b1738c61c690$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");

var $9XmN7 = parcelRequire("9XmN7");
var $6694b1738c61c690$export$2e2bcd8739ae039 = (0, $9XmN7.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $4vLup.default).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $4vLup.default).isString(path) && cookie.push('path=' + path);
        (0, $4vLup.default).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("1oZ6c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10576d512e8e4941$export$2e2bcd8739ae039; });

var $5yq8d = parcelRequire("5yq8d");

var $2khFF = parcelRequire("2khFF");
'use strict';
function $10576d512e8e4941$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $5yq8d.default)(requestedURL)) return (0, $2khFF.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("5yq8d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40b465e853a8de3d$export$2e2bcd8739ae039; });
'use strict';
function $40b465e853a8de3d$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("2khFF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b1b2823b6041ad5$export$2e2bcd8739ae039; });
'use strict';
function $1b1b2823b6041ad5$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("dPMmc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1258c794ae5a768$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");

var $10epZ = parcelRequire("10epZ");
'use strict';
const $a1258c794ae5a768$var$headersToObject = (thing)=>thing instanceof (0, $10epZ.default) ? {
        ...thing
    } : thing;
function $a1258c794ae5a768$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $4vLup.default).isPlainObject(target) && (0, $4vLup.default).isPlainObject(source)) return (0, $4vLup.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $4vLup.default).isPlainObject(source)) return (0, $4vLup.default).merge({}, source);
        else if ((0, $4vLup.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $4vLup.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $4vLup.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $4vLup.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $4vLup.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $4vLup.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($a1258c794ae5a768$var$headersToObject(a), $a1258c794ae5a768$var$headersToObject(b), prop, true)
    };
    (0, $4vLup.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $4vLup.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("bg4Bj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8324c1ef14c72b46$export$2e2bcd8739ae039; });

var $9XmN7 = parcelRequire("9XmN7");

var $4vLup = parcelRequire("4vLup");

var $49DnR = parcelRequire("49DnR");

var $h5EPf = parcelRequire("h5EPf");

var $8FFKY = parcelRequire("8FFKY");

var $10epZ = parcelRequire("10epZ");

var $dKGH6 = parcelRequire("dKGH6");

var $4CED9 = parcelRequire("4CED9");

var $awvbe = parcelRequire("awvbe");
const $8324c1ef14c72b46$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $8324c1ef14c72b46$var$isReadableStreamSupported = $8324c1ef14c72b46$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $8324c1ef14c72b46$var$encodeText = $8324c1ef14c72b46$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $8324c1ef14c72b46$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $8324c1ef14c72b46$var$supportsRequestStream = $8324c1ef14c72b46$var$isReadableStreamSupported && $8324c1ef14c72b46$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $9XmN7.default).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $8324c1ef14c72b46$var$DEFAULT_CHUNK_SIZE = 65536;
const $8324c1ef14c72b46$var$supportsResponseStream = $8324c1ef14c72b46$var$isReadableStreamSupported && $8324c1ef14c72b46$var$test(()=>(0, $4vLup.default).isReadableStream(new Response('').body));
const $8324c1ef14c72b46$var$resolvers = {
    stream: $8324c1ef14c72b46$var$supportsResponseStream && ((res)=>res.body)
};
$8324c1ef14c72b46$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$8324c1ef14c72b46$var$resolvers[type] && ($8324c1ef14c72b46$var$resolvers[type] = (0, $4vLup.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $49DnR.default)(`Response type '${type}' is not supported`, (0, $49DnR.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $8324c1ef14c72b46$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $4vLup.default).isBlob(body)) return body.size;
    if ((0, $4vLup.default).isSpecCompliantForm(body)) {
        const _request = new Request((0, $9XmN7.default).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $4vLup.default).isArrayBufferView(body) || (0, $4vLup.default).isArrayBuffer(body)) return body.byteLength;
    if ((0, $4vLup.default).isURLSearchParams(body)) body = body + '';
    if ((0, $4vLup.default).isString(body)) return (await $8324c1ef14c72b46$var$encodeText(body)).byteLength;
};
const $8324c1ef14c72b46$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $4vLup.default).toFiniteNumber(headers.getContentLength());
    return length == null ? $8324c1ef14c72b46$var$getBodyLength(body) : length;
};
var $8324c1ef14c72b46$export$2e2bcd8739ae039 = $8324c1ef14c72b46$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $4CED9.default)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $h5EPf.default)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $8324c1ef14c72b46$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $8324c1ef14c72b46$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $4vLup.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $dKGH6.progressEventDecorator)(requestContentLength, (0, $dKGH6.progressEventReducer)((0, $dKGH6.asyncDecorator)(onUploadProgress)));
                data = (0, $8FFKY.trackStream)(_request.body, $8324c1ef14c72b46$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $4vLup.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $8324c1ef14c72b46$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($8324c1ef14c72b46$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $4vLup.default).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $dKGH6.progressEventDecorator)(responseContentLength, (0, $dKGH6.progressEventReducer)((0, $dKGH6.asyncDecorator)(onDownloadProgress), true)) || [];
            response = new Response((0, $8FFKY.trackStream)(response.body, $8324c1ef14c72b46$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $8324c1ef14c72b46$var$resolvers[(0, $4vLup.default).findKey($8324c1ef14c72b46$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $awvbe.default)(resolve, reject, {
                data: responseData,
                headers: (0, $10epZ.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $49DnR.default)('Network Error', (0, $49DnR.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $49DnR.default).from(err, err && err.code, config, request);
    }
});

});
parcelRegister("h5EPf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7129269d6d22f73$export$2e2bcd8739ae039; });

var $dHwgY = parcelRequire("dHwgY");

var $49DnR = parcelRequire("49DnR");

var $4vLup = parcelRequire("4vLup");
const $c7129269d6d22f73$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $49DnR.default) ? err : new (0, $dHwgY.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $49DnR.default)(`timeout ${timeout} of ms exceeded`, (0, $49DnR.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $4vLup.default).asap(unsubscribe);
        return signal;
    }
};
var $c7129269d6d22f73$export$2e2bcd8739ae039 = $c7129269d6d22f73$var$composeSignals;

});

parcelRegister("8FFKY", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $65028b0a465517eb$export$b0119225647bd83; });
const $65028b0a465517eb$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $65028b0a465517eb$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $65028b0a465517eb$var$readStream(iterable))yield* $65028b0a465517eb$export$71b051935044bd5d(chunk, chunkSize);
};
const $65028b0a465517eb$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $65028b0a465517eb$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $65028b0a465517eb$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("6O0Rc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f4813ced4a2404c$export$2e2bcd8739ae039; });

var $2rdMK = parcelRequire("2rdMK");

var $49DnR = parcelRequire("49DnR");
'use strict';
const $4f4813ced4a2404c$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $4f4813ced4a2404c$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $4f4813ced4a2404c$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $4f4813ced4a2404c$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $2rdMK.VERSION) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $49DnR.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $49DnR.default).ERR_DEPRECATED);
        if (version && !$4f4813ced4a2404c$var$deprecatedWarnings[opt]) {
            $4f4813ced4a2404c$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$4f4813ced4a2404c$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $4f4813ced4a2404c$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $49DnR.default)('options must be an object', (0, $49DnR.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $49DnR.default)('option ' + opt + ' must be ' + result, (0, $49DnR.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $49DnR.default)('Unknown option ' + opt, (0, $49DnR.default).ERR_BAD_OPTION);
    }
}
var $4f4813ced4a2404c$export$2e2bcd8739ae039 = {
    assertOptions: $4f4813ced4a2404c$var$assertOptions,
    validators: $4f4813ced4a2404c$var$validators
};

});
parcelRegister("2rdMK", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $1c68cbd61e8dd50c$export$a4ad2735b021c132; });
const $1c68cbd61e8dd50c$export$a4ad2735b021c132 = "1.7.9";

});



parcelRegister("eWlGv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae074d8e5b649eed$export$2e2bcd8739ae039; });

var $dHwgY = parcelRequire("dHwgY");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $ae074d8e5b649eed$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $dHwgY.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $ae074d8e5b649eed$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $ae074d8e5b649eed$export$2e2bcd8739ae039 = $ae074d8e5b649eed$var$CancelToken;

});

parcelRegister("cwO49", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91ef4f419d1e5135$export$2e2bcd8739ae039; });
'use strict';
function $91ef4f419d1e5135$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("CMJ6u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $074958c9c3a47087$export$2e2bcd8739ae039; });

var $4vLup = parcelRequire("4vLup");
'use strict';
function $074958c9c3a47087$export$2e2bcd8739ae039(payload) {
    return (0, $4vLup.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("eI1Qd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab569a620b4ad5f4$export$2e2bcd8739ae039; });
const $ab569a620b4ad5f4$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($ab569a620b4ad5f4$var$HttpStatusCode).forEach(([key, value])=>{
    $ab569a620b4ad5f4$var$HttpStatusCode[value] = key;
});
var $ab569a620b4ad5f4$export$2e2bcd8739ae039 = $ab569a620b4ad5f4$var$HttpStatusCode;

});




parcelRegister("cbDml", function(module, exports) {
"use strict";
var $8df50b148da92654$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8df50b148da92654$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8df50b148da92654$var$RESOURCEPATH = "/collections";
var $8df50b148da92654$var$Collections = /** @class */ function() {
    function Collections(apiCall) {
        this.apiCall = apiCall;
    }
    Collections.prototype.create = function(schema, options) {
        if (options === void 0) options = {};
        return $8df50b148da92654$var$__awaiter(this, void 0, void 0, function() {
            return $8df50b148da92654$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.post($8df50b148da92654$var$RESOURCEPATH, schema, options)
                ];
            });
        });
    };
    Collections.prototype.retrieve = function() {
        return $8df50b148da92654$var$__awaiter(this, void 0, void 0, function() {
            return $8df50b148da92654$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get($8df50b148da92654$var$RESOURCEPATH)
                ];
            });
        });
    };
    Object.defineProperty(Collections, "RESOURCEPATH", {
        get: function() {
            return $8df50b148da92654$var$RESOURCEPATH;
        },
        enumerable: false,
        configurable: true
    });
    return Collections;
}();
module.exports.default = $8df50b148da92654$var$Collections;

});

parcelRegister("9dH5k", function(module, exports) {
"use strict";
var $6b66bfbdbb0882e8$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6b66bfbdbb0882e8$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $6b66bfbdbb0882e8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6b66bfbdbb0882e8$var$Collections_1 = $6b66bfbdbb0882e8$var$__importDefault((parcelRequire("cbDml")));

var $6b66bfbdbb0882e8$var$Documents_1 = $6b66bfbdbb0882e8$var$__importDefault((parcelRequire("7TEyc")));

var $f6qFb = parcelRequire("f6qFb");

var $6b66bfbdbb0882e8$var$Overrides_1 = $6b66bfbdbb0882e8$var$__importDefault((parcelRequire("gPfFY")));

var $6b66bfbdbb0882e8$var$Override_1 = $6b66bfbdbb0882e8$var$__importDefault((parcelRequire("bfflW")));

var $6b66bfbdbb0882e8$var$Synonyms_1 = $6b66bfbdbb0882e8$var$__importDefault((parcelRequire("9qo0o")));

var $6b66bfbdbb0882e8$var$Synonym_1 = $6b66bfbdbb0882e8$var$__importDefault((parcelRequire("jFc3y")));

var $fbFmq = parcelRequire("fbFmq");
var $6b66bfbdbb0882e8$var$Collection = /** @class */ function() {
    function Collection(name, apiCall, configuration) {
        this.name = name;
        this.apiCall = apiCall;
        this.configuration = configuration;
        this.individualDocuments = {};
        this.individualOverrides = {};
        this.individualSynonyms = {};
        this.name = name;
        this.apiCall = apiCall;
        this.configuration = configuration;
        this._documents = new $6b66bfbdbb0882e8$var$Documents_1.default(this.name, this.apiCall, this.configuration);
        this._overrides = new $6b66bfbdbb0882e8$var$Overrides_1.default(this.name, this.apiCall);
        this._synonyms = new $6b66bfbdbb0882e8$var$Synonyms_1.default(this.name, this.apiCall);
    }
    Collection.prototype.retrieve = function() {
        return $6b66bfbdbb0882e8$var$__awaiter(this, void 0, void 0, function() {
            return $6b66bfbdbb0882e8$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    Collection.prototype.update = function(schema) {
        return $6b66bfbdbb0882e8$var$__awaiter(this, void 0, void 0, function() {
            return $6b66bfbdbb0882e8$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.patch(this.endpointPath(), schema)
                ];
            });
        });
    };
    Collection.prototype.delete = function() {
        return $6b66bfbdbb0882e8$var$__awaiter(this, void 0, void 0, function() {
            return $6b66bfbdbb0882e8$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.delete(this.endpointPath())
                ];
            });
        });
    };
    Collection.prototype.exists = function() {
        return $6b66bfbdbb0882e8$var$__awaiter(this, void 0, void 0, function() {
            var e_1;
            return $6b66bfbdbb0882e8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.retrieve()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 2:
                        e_1 = _a.sent();
                        if (e_1 instanceof $f6qFb.ObjectNotFound) return [
                            2 /*return*/ ,
                            false
                        ];
                        throw e_1;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Collection.prototype.documents = function(documentId) {
        if (!documentId) return this._documents;
        else {
            if (this.individualDocuments[documentId] === undefined) this.individualDocuments[documentId] = new $fbFmq.Document(this.name, documentId, this.apiCall);
            return this.individualDocuments[documentId];
        }
    };
    Collection.prototype.overrides = function(overrideId) {
        if (overrideId === undefined) return this._overrides;
        else {
            if (this.individualOverrides[overrideId] === undefined) this.individualOverrides[overrideId] = new $6b66bfbdbb0882e8$var$Override_1.default(this.name, overrideId, this.apiCall);
            return this.individualOverrides[overrideId];
        }
    };
    Collection.prototype.synonyms = function(synonymId) {
        if (synonymId === undefined) return this._synonyms;
        else {
            if (this.individualSynonyms[synonymId] === undefined) this.individualSynonyms[synonymId] = new $6b66bfbdbb0882e8$var$Synonym_1.default(this.name, synonymId, this.apiCall);
            return this.individualSynonyms[synonymId];
        }
    };
    Collection.prototype.endpointPath = function() {
        return "".concat($6b66bfbdbb0882e8$var$Collections_1.default.RESOURCEPATH, "/").concat(this.name);
    };
    return Collection;
}();
module.exports.default = $6b66bfbdbb0882e8$var$Collection;

});
parcelRegister("7TEyc", function(module, exports) {
"use strict";
var $5bfd1ffc8adc59d8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5bfd1ffc8adc59d8$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5bfd1ffc8adc59d8$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f6qFb = parcelRequire("f6qFb");

var $8qgSX = parcelRequire("8qgSX");
var $5bfd1ffc8adc59d8$var$Documents = /** @class */ function(_super) {
    $5bfd1ffc8adc59d8$var$__extends(Documents, _super);
    function Documents(collectionName, apiCall, configuration) {
        return _super.call(this, collectionName, apiCall, configuration) || this;
    }
    Documents.prototype.create = function(document, options) {
        if (options === void 0) options = {};
        return $5bfd1ffc8adc59d8$var$__awaiter(this, void 0, void 0, function() {
            return $5bfd1ffc8adc59d8$var$__generator(this, function(_a) {
                if (!document) throw new Error("No document provided");
                return [
                    2 /*return*/ ,
                    this.apiCall.post(this.endpointPath(), document, options)
                ];
            });
        });
    };
    Documents.prototype.upsert = function(document, options) {
        if (options === void 0) options = {};
        return $5bfd1ffc8adc59d8$var$__awaiter(this, void 0, void 0, function() {
            return $5bfd1ffc8adc59d8$var$__generator(this, function(_a) {
                if (!document) throw new Error("No document provided");
                return [
                    2 /*return*/ ,
                    this.apiCall.post(this.endpointPath(), document, Object.assign({}, options, {
                        action: "upsert"
                    }))
                ];
            });
        });
    };
    Documents.prototype.update = function(document, options) {
        if (options === void 0) options = {};
        return $5bfd1ffc8adc59d8$var$__awaiter(this, void 0, void 0, function() {
            return $5bfd1ffc8adc59d8$var$__generator(this, function(_a) {
                if (!document) throw new Error("No document provided");
                if (options["filter_by"] != null) return [
                    2 /*return*/ ,
                    this.apiCall.patch(this.endpointPath(), document, Object.assign({}, options))
                ];
                else return [
                    2 /*return*/ ,
                    this.apiCall.post(this.endpointPath(), document, Object.assign({}, options, {
                        action: "update"
                    }))
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    Documents.prototype.delete = function(query) {
        if (query === void 0) query = {};
        return $5bfd1ffc8adc59d8$var$__awaiter(this, void 0, void 0, function() {
            return $5bfd1ffc8adc59d8$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.delete(this.endpointPath(), query)
                ];
            });
        });
    };
    Documents.prototype.createMany = function(documents, options) {
        if (options === void 0) options = {};
        return $5bfd1ffc8adc59d8$var$__awaiter(this, void 0, void 0, function() {
            return $5bfd1ffc8adc59d8$var$__generator(this, function(_a) {
                this.configuration.logger.warn("createMany is deprecated and will be removed in a future version. Use import instead, which now takes both an array of documents or a JSONL string of documents");
                return [
                    2 /*return*/ ,
                    this.import(documents, options)
                ];
            });
        });
    };
    Documents.prototype.import = function(documents, options) {
        if (options === void 0) options = {};
        return $5bfd1ffc8adc59d8$var$__awaiter(this, void 0, void 0, function() {
            var documentsInJSONLFormat, resultsInJSONLFormat, resultsInJSONFormat, failedItems;
            return $5bfd1ffc8adc59d8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (Array.isArray(documents)) try {
                            documentsInJSONLFormat = documents.map(function(document) {
                                return JSON.stringify(document);
                            }).join("\n");
                        } catch (error) {
                            // if rangeerror, throw custom error message
                            if (RangeError instanceof error && (error === null || error === void 0 ? void 0 : error.includes("Too many properties to enumerate"))) throw new Error("".concat(error, "\n          It looks like you have reached a Node.js limit that restricts the number of keys in an Object: https://stackoverflow.com/questions/9282869/are-there-limits-to-the-number-of-properties-in-a-javascript-object\n\n          Please try reducing the number of keys in your document, or using CURL to import your data.\n          "));
                            // else, throw the non-range error anyways
                            throw new Error(error);
                        }
                        else documentsInJSONLFormat = documents;
                        return [
                            4 /*yield*/ ,
                            this.apiCall.performRequest("post", this.endpointPath("import"), {
                                queryParameters: options,
                                bodyParameters: documentsInJSONLFormat,
                                additionalHeaders: {
                                    "Content-Type": "text/plain"
                                },
                                skipConnectionTimeout: true
                            })
                        ];
                    case 1:
                        resultsInJSONLFormat = _a.sent();
                        if (Array.isArray(documents)) {
                            resultsInJSONFormat = resultsInJSONLFormat.split("\n").map(function(r) {
                                return JSON.parse(r);
                            });
                            failedItems = resultsInJSONFormat.filter(function(r) {
                                return r.success === false;
                            });
                            if (failedItems.length > 0) throw new $f6qFb.ImportError("".concat(resultsInJSONFormat.length - failedItems.length, " documents imported successfully, ").concat(failedItems.length, " documents failed during import. Use `error.importResults` from the raised exception to get a detailed error reason for each document."), resultsInJSONFormat);
                            else return [
                                2 /*return*/ ,
                                resultsInJSONFormat
                            ];
                        } else return [
                            2 /*return*/ ,
                            resultsInJSONLFormat
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Returns a JSONL string for all the documents in this collection
     */ Documents.prototype.export = function(options) {
        if (options === void 0) options = {};
        return $5bfd1ffc8adc59d8$var$__awaiter(this, void 0, void 0, function() {
            return $5bfd1ffc8adc59d8$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath("export"), options)
                ];
            });
        });
    };
    /**
     * Returns a NodeJS readable stream of JSONL for all the documents in this collection.
     */ Documents.prototype.exportStream = function(options) {
        if (options === void 0) options = {};
        return $5bfd1ffc8adc59d8$var$__awaiter(this, void 0, void 0, function() {
            return $5bfd1ffc8adc59d8$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath("export"), options, {
                        responseType: "stream"
                    })
                ];
            });
        });
    };
    return Documents;
}($8qgSX.SearchOnlyDocuments);
module.exports.default = $5bfd1ffc8adc59d8$var$Documents;

});
parcelRegister("8qgSX", function(module, exports) {
"use strict";
var $621dd985550f3c4b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $621dd985550f3c4b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $621dd985550f3c4b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SearchOnlyDocuments = void 0;

var $621dd985550f3c4b$var$RequestWithCache_1 = $621dd985550f3c4b$var$__importDefault((parcelRequire("l5XxM")));

var $621dd985550f3c4b$var$Collections_1 = $621dd985550f3c4b$var$__importDefault((parcelRequire("cbDml")));
var $621dd985550f3c4b$var$RESOURCEPATH = "/documents";
var $621dd985550f3c4b$var$SearchOnlyDocuments = /** @class */ function() {
    function SearchOnlyDocuments(collectionName, apiCall, configuration) {
        this.collectionName = collectionName;
        this.apiCall = apiCall;
        this.configuration = configuration;
        this.requestWithCache = new $621dd985550f3c4b$var$RequestWithCache_1.default();
    }
    SearchOnlyDocuments.prototype.clearCache = function() {
        this.requestWithCache.clearCache();
    };
    SearchOnlyDocuments.prototype.search = function(searchParameters, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheSearchResultsForSeconds, cacheSearchResultsForSeconds = _c === void 0 ? this.configuration.cacheSearchResultsForSeconds : _c, _d = _b.abortSignal, abortSignal = _d === void 0 ? null : _d;
        return $621dd985550f3c4b$var$__awaiter(this, void 0, void 0, function() {
            var additionalQueryParams, key, queryParams;
            return $621dd985550f3c4b$var$__generator(this, function(_e) {
                additionalQueryParams = {};
                if (this.configuration.useServerSideSearchCache === true) additionalQueryParams["use_cache"] = true;
                for(key in searchParameters)if (Array.isArray(searchParameters[key])) additionalQueryParams[key] = searchParameters[key].join(",");
                queryParams = Object.assign({}, searchParameters, additionalQueryParams);
                return [
                    2 /*return*/ ,
                    this.requestWithCache.perform(this.apiCall, this.apiCall.get, [
                        this.endpointPath("search"),
                        queryParams,
                        {
                            abortSignal: abortSignal
                        }
                    ], {
                        cacheResponseForSeconds: cacheSearchResultsForSeconds
                    })
                ];
            });
        });
    };
    SearchOnlyDocuments.prototype.endpointPath = function(operation) {
        return "".concat($621dd985550f3c4b$var$Collections_1.default.RESOURCEPATH, "/").concat(this.collectionName).concat($621dd985550f3c4b$var$RESOURCEPATH).concat(operation === undefined ? "" : "/" + operation);
    };
    Object.defineProperty(SearchOnlyDocuments, "RESOURCEPATH", {
        get: function() {
            return $621dd985550f3c4b$var$RESOURCEPATH;
        },
        enumerable: false,
        configurable: true
    });
    return SearchOnlyDocuments;
}();
module.exports.SearchOnlyDocuments = $621dd985550f3c4b$var$SearchOnlyDocuments;

});
parcelRegister("l5XxM", function(module, exports) {
"use strict";
var $f5b840c3da64aa96$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f5b840c3da64aa96$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f5b840c3da64aa96$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f5b840c3da64aa96$var$defaultCacheResponseForSeconds = 120;
var $f5b840c3da64aa96$var$defaultMaxSize = 100;
var $f5b840c3da64aa96$var$RequestWithCache = /** @class */ function() {
    function RequestWithCache() {
        this.responseCache = new Map();
        this.responsePromiseCache = new Map();
    }
    RequestWithCache.prototype.clearCache = function() {
        this.responseCache = new Map();
        this.responsePromiseCache = new Map();
    };
    // Todo: should probably be passed a callback instead, or an apiCall instance. Types are messy this way
    RequestWithCache.prototype.perform = function(requestContext, requestFunction, requestFunctionArguments, cacheOptions) {
        return $f5b840c3da64aa96$var$__awaiter(this, void 0, void 0, function() {
            var _a, cacheResponseForSeconds, _b, maxSize, isCacheDisabled, requestFunctionArgumentsJSON, cacheEntry, now, isEntryValid, cachePromiseEntry, isEntryValid, responsePromise, response, isCacheOverMaxSize, oldestEntry, isResponsePromiseCacheOverMaxSize, oldestEntry;
            return $f5b840c3da64aa96$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = cacheOptions.cacheResponseForSeconds, cacheResponseForSeconds = _a === void 0 ? $f5b840c3da64aa96$var$defaultCacheResponseForSeconds : _a, _b = cacheOptions.maxSize, maxSize = _b === void 0 ? $f5b840c3da64aa96$var$defaultMaxSize : _b;
                        isCacheDisabled = cacheResponseForSeconds <= 0 || maxSize <= 0;
                        if (isCacheDisabled) return [
                            2 /*return*/ ,
                            requestFunction.call.apply(requestFunction, $f5b840c3da64aa96$var$__spreadArray([
                                requestContext
                            ], requestFunctionArguments, false))
                        ];
                        requestFunctionArgumentsJSON = JSON.stringify(requestFunctionArguments);
                        cacheEntry = this.responseCache.get(requestFunctionArgumentsJSON);
                        now = Date.now();
                        if (cacheEntry) {
                            isEntryValid = now - cacheEntry.requestTimestamp < cacheResponseForSeconds * 1000;
                            if (isEntryValid) {
                                this.responseCache.delete(requestFunctionArgumentsJSON);
                                this.responseCache.set(requestFunctionArgumentsJSON, cacheEntry);
                                return [
                                    2 /*return*/ ,
                                    Promise.resolve(cacheEntry.response)
                                ];
                            } else this.responseCache.delete(requestFunctionArgumentsJSON);
                        }
                        cachePromiseEntry = this.responsePromiseCache.get(requestFunctionArgumentsJSON);
                        if (cachePromiseEntry) {
                            isEntryValid = now - cachePromiseEntry.requestTimestamp < cacheResponseForSeconds * 1000;
                            if (isEntryValid) {
                                this.responsePromiseCache.delete(requestFunctionArgumentsJSON);
                                this.responsePromiseCache.set(requestFunctionArgumentsJSON, cachePromiseEntry);
                                return [
                                    2 /*return*/ ,
                                    cachePromiseEntry.responsePromise
                                ];
                            } else this.responsePromiseCache.delete(requestFunctionArgumentsJSON);
                        }
                        responsePromise = requestFunction.call.apply(requestFunction, $f5b840c3da64aa96$var$__spreadArray([
                            requestContext
                        ], requestFunctionArguments, false));
                        this.responsePromiseCache.set(requestFunctionArgumentsJSON, {
                            requestTimestamp: now,
                            responsePromise: responsePromise
                        });
                        return [
                            4 /*yield*/ ,
                            responsePromise
                        ];
                    case 1:
                        response = _c.sent();
                        this.responseCache.set(requestFunctionArgumentsJSON, {
                            requestTimestamp: now,
                            response: response
                        });
                        isCacheOverMaxSize = this.responseCache.size > maxSize;
                        if (isCacheOverMaxSize) {
                            oldestEntry = this.responseCache.keys().next().value;
                            this.responseCache.delete(oldestEntry);
                        }
                        isResponsePromiseCacheOverMaxSize = this.responsePromiseCache.size > maxSize;
                        if (isResponsePromiseCacheOverMaxSize) {
                            oldestEntry = this.responsePromiseCache.keys().next().value;
                            this.responsePromiseCache.delete(oldestEntry);
                        }
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    return RequestWithCache;
}();
module.exports.default = $f5b840c3da64aa96$var$RequestWithCache;

});



parcelRegister("gPfFY", function(module, exports) {
"use strict";
var $c3fd91afc947e53b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c3fd91afc947e53b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c3fd91afc947e53b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $c3fd91afc947e53b$var$Collections_1 = $c3fd91afc947e53b$var$__importDefault((parcelRequire("cbDml")));
var $c3fd91afc947e53b$var$RESOURCEPATH = "/overrides";
var $c3fd91afc947e53b$var$Overrides = /** @class */ function() {
    function Overrides(collectionName, apiCall) {
        this.collectionName = collectionName;
        this.apiCall = apiCall;
    }
    Overrides.prototype.upsert = function(overrideId, params) {
        return $c3fd91afc947e53b$var$__awaiter(this, void 0, void 0, function() {
            return $c3fd91afc947e53b$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.put(this.endpointPath(overrideId), params)
                ];
            });
        });
    };
    Overrides.prototype.retrieve = function() {
        return $c3fd91afc947e53b$var$__awaiter(this, void 0, void 0, function() {
            return $c3fd91afc947e53b$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    Overrides.prototype.endpointPath = function(operation) {
        return "".concat($c3fd91afc947e53b$var$Collections_1.default.RESOURCEPATH, "/").concat(this.collectionName).concat(Overrides.RESOURCEPATH).concat(operation === undefined ? "" : "/" + operation);
    };
    Object.defineProperty(Overrides, "RESOURCEPATH", {
        get: function() {
            return $c3fd91afc947e53b$var$RESOURCEPATH;
        },
        enumerable: false,
        configurable: true
    });
    return Overrides;
}();
module.exports.default = $c3fd91afc947e53b$var$Overrides;

});

parcelRegister("bfflW", function(module, exports) {
"use strict";
var $82fd012c1c883e42$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $82fd012c1c883e42$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $82fd012c1c883e42$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $82fd012c1c883e42$var$Collections_1 = $82fd012c1c883e42$var$__importDefault((parcelRequire("cbDml")));

var $82fd012c1c883e42$var$Overrides_1 = $82fd012c1c883e42$var$__importDefault((parcelRequire("gPfFY")));
var $82fd012c1c883e42$var$Override = /** @class */ function() {
    function Override(collectionName, overrideId, apiCall) {
        this.collectionName = collectionName;
        this.overrideId = overrideId;
        this.apiCall = apiCall;
    }
    Override.prototype.retrieve = function() {
        return $82fd012c1c883e42$var$__awaiter(this, void 0, void 0, function() {
            return $82fd012c1c883e42$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    Override.prototype.delete = function() {
        return $82fd012c1c883e42$var$__awaiter(this, void 0, void 0, function() {
            return $82fd012c1c883e42$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.delete(this.endpointPath())
                ];
            });
        });
    };
    Override.prototype.endpointPath = function() {
        return "".concat($82fd012c1c883e42$var$Collections_1.default.RESOURCEPATH, "/").concat(this.collectionName).concat($82fd012c1c883e42$var$Overrides_1.default.RESOURCEPATH, "/").concat(this.overrideId);
    };
    return Override;
}();
module.exports.default = $82fd012c1c883e42$var$Override;

});

parcelRegister("9qo0o", function(module, exports) {
"use strict";
var $6dc929bde6fb0790$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6dc929bde6fb0790$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $6dc929bde6fb0790$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6dc929bde6fb0790$var$Collections_1 = $6dc929bde6fb0790$var$__importDefault((parcelRequire("cbDml")));
var $6dc929bde6fb0790$var$RESOURCEPATH = "/synonyms";
var $6dc929bde6fb0790$var$Synonyms = /** @class */ function() {
    function Synonyms(collectionName, apiCall) {
        this.collectionName = collectionName;
        this.apiCall = apiCall;
    }
    Synonyms.prototype.upsert = function(synonymId, params) {
        return $6dc929bde6fb0790$var$__awaiter(this, void 0, void 0, function() {
            return $6dc929bde6fb0790$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.put(this.endpointPath(synonymId), params)
                ];
            });
        });
    };
    Synonyms.prototype.retrieve = function() {
        return $6dc929bde6fb0790$var$__awaiter(this, void 0, void 0, function() {
            return $6dc929bde6fb0790$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    Synonyms.prototype.endpointPath = function(operation) {
        return "".concat($6dc929bde6fb0790$var$Collections_1.default.RESOURCEPATH, "/").concat(this.collectionName).concat(Synonyms.RESOURCEPATH).concat(operation === undefined ? "" : "/" + operation);
    };
    Object.defineProperty(Synonyms, "RESOURCEPATH", {
        get: function() {
            return $6dc929bde6fb0790$var$RESOURCEPATH;
        },
        enumerable: false,
        configurable: true
    });
    return Synonyms;
}();
module.exports.default = $6dc929bde6fb0790$var$Synonyms;

});

parcelRegister("jFc3y", function(module, exports) {
"use strict";
var $e50b32c5031678ce$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e50b32c5031678ce$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e50b32c5031678ce$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e50b32c5031678ce$var$Collections_1 = $e50b32c5031678ce$var$__importDefault((parcelRequire("cbDml")));

var $e50b32c5031678ce$var$Synonyms_1 = $e50b32c5031678ce$var$__importDefault((parcelRequire("9qo0o")));
var $e50b32c5031678ce$var$Synonym = /** @class */ function() {
    function Synonym(collectionName, synonymId, apiCall) {
        this.collectionName = collectionName;
        this.synonymId = synonymId;
        this.apiCall = apiCall;
    }
    Synonym.prototype.retrieve = function() {
        return $e50b32c5031678ce$var$__awaiter(this, void 0, void 0, function() {
            return $e50b32c5031678ce$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    Synonym.prototype.delete = function() {
        return $e50b32c5031678ce$var$__awaiter(this, void 0, void 0, function() {
            return $e50b32c5031678ce$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.delete(this.endpointPath())
                ];
            });
        });
    };
    Synonym.prototype.endpointPath = function() {
        return "".concat($e50b32c5031678ce$var$Collections_1.default.RESOURCEPATH, "/").concat(this.collectionName).concat($e50b32c5031678ce$var$Synonyms_1.default.RESOURCEPATH, "/").concat(this.synonymId);
    };
    return Synonym;
}();
module.exports.default = $e50b32c5031678ce$var$Synonym;

});

parcelRegister("fbFmq", function(module, exports) {
"use strict";
var $b0e7f771e98ec1aa$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b0e7f771e98ec1aa$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b0e7f771e98ec1aa$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Document = void 0;

var $b0e7f771e98ec1aa$var$Collections_1 = $b0e7f771e98ec1aa$var$__importDefault((parcelRequire("cbDml")));

var $b0e7f771e98ec1aa$var$Documents_1 = $b0e7f771e98ec1aa$var$__importDefault((parcelRequire("7TEyc")));
var $b0e7f771e98ec1aa$var$Document = /** @class */ function() {
    function Document(collectionName, documentId, apiCall) {
        this.collectionName = collectionName;
        this.documentId = documentId;
        this.apiCall = apiCall;
    }
    Document.prototype.retrieve = function() {
        return $b0e7f771e98ec1aa$var$__awaiter(this, void 0, void 0, function() {
            return $b0e7f771e98ec1aa$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    Document.prototype.delete = function() {
        return $b0e7f771e98ec1aa$var$__awaiter(this, void 0, void 0, function() {
            return $b0e7f771e98ec1aa$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.delete(this.endpointPath())
                ];
            });
        });
    };
    Document.prototype.update = function(partialDocument, options) {
        if (options === void 0) options = {};
        return $b0e7f771e98ec1aa$var$__awaiter(this, void 0, void 0, function() {
            return $b0e7f771e98ec1aa$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.patch(this.endpointPath(), partialDocument, options)
                ];
            });
        });
    };
    Document.prototype.endpointPath = function() {
        return "".concat($b0e7f771e98ec1aa$var$Collections_1.default.RESOURCEPATH, "/").concat(this.collectionName).concat($b0e7f771e98ec1aa$var$Documents_1.default.RESOURCEPATH, "/").concat(this.documentId);
    };
    return Document;
}();
module.exports.Document = $b0e7f771e98ec1aa$var$Document;

});


parcelRegister("aHzj0", function(module, exports) {
"use strict";
var $7ca94e7531bbac48$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7ca94e7531bbac48$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7ca94e7531bbac48$var$RESOURCEPATH = "/aliases";
var $7ca94e7531bbac48$var$Aliases = /** @class */ function() {
    function Aliases(apiCall) {
        this.apiCall = apiCall;
    }
    Aliases.prototype.upsert = function(name, mapping) {
        return $7ca94e7531bbac48$var$__awaiter(this, void 0, void 0, function() {
            return $7ca94e7531bbac48$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.put(this.endpointPath(name), mapping)
                ];
            });
        });
    };
    Aliases.prototype.retrieve = function() {
        return $7ca94e7531bbac48$var$__awaiter(this, void 0, void 0, function() {
            return $7ca94e7531bbac48$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get($7ca94e7531bbac48$var$RESOURCEPATH)
                ];
            });
        });
    };
    Aliases.prototype.endpointPath = function(aliasName) {
        return "".concat(Aliases.RESOURCEPATH, "/").concat(aliasName);
    };
    Object.defineProperty(Aliases, "RESOURCEPATH", {
        get: function() {
            return $7ca94e7531bbac48$var$RESOURCEPATH;
        },
        enumerable: false,
        configurable: true
    });
    return Aliases;
}();
module.exports.default = $7ca94e7531bbac48$var$Aliases;

});

parcelRegister("idxV3", function(module, exports) {
"use strict";
var $d433c088c7b0bd4c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d433c088c7b0bd4c$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d433c088c7b0bd4c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d433c088c7b0bd4c$var$Aliases_1 = $d433c088c7b0bd4c$var$__importDefault((parcelRequire("aHzj0")));
var $d433c088c7b0bd4c$var$Alias = /** @class */ function() {
    function Alias(name, apiCall) {
        this.name = name;
        this.apiCall = apiCall;
    }
    Alias.prototype.retrieve = function() {
        return $d433c088c7b0bd4c$var$__awaiter(this, void 0, void 0, function() {
            return $d433c088c7b0bd4c$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    Alias.prototype.delete = function() {
        return $d433c088c7b0bd4c$var$__awaiter(this, void 0, void 0, function() {
            return $d433c088c7b0bd4c$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.delete(this.endpointPath())
                ];
            });
        });
    };
    Alias.prototype.endpointPath = function() {
        return "".concat($d433c088c7b0bd4c$var$Aliases_1.default.RESOURCEPATH, "/").concat(this.name);
    };
    return Alias;
}();
module.exports.default = $d433c088c7b0bd4c$var$Alias;

});

parcelRegister("ktyOU", function(module, exports) {

var $cHEiR = parcelRequire("cHEiR");
var $ee8186a3997a29cc$require$Buffer = $cHEiR.Buffer;
"use strict";
var $ee8186a3997a29cc$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ee8186a3997a29cc$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aBJPx = parcelRequire("aBJPx");
var $ee8186a3997a29cc$var$RESOURCEPATH = "/keys";
var $ee8186a3997a29cc$var$Keys = /** @class */ function() {
    function Keys(apiCall) {
        this.apiCall = apiCall;
        this.apiCall = apiCall;
    }
    Keys.prototype.create = function(params) {
        return $ee8186a3997a29cc$var$__awaiter(this, void 0, void 0, function() {
            return $ee8186a3997a29cc$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.post(Keys.RESOURCEPATH, params)
                ];
            });
        });
    };
    Keys.prototype.retrieve = function() {
        return $ee8186a3997a29cc$var$__awaiter(this, void 0, void 0, function() {
            return $ee8186a3997a29cc$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get($ee8186a3997a29cc$var$RESOURCEPATH)
                ];
            });
        });
    };
    Keys.prototype.generateScopedSearchKey = function(searchKey, parameters) {
        // Note: only a key generated with the `documents:search` action will be
        // accepted by the server, when usined with the search endpoint.
        var paramsJSON = JSON.stringify(parameters);
        var digest = $ee8186a3997a29cc$require$Buffer.from((0, $aBJPx.createHmac)("sha256", searchKey).update(paramsJSON).digest("base64"));
        var keyPrefix = searchKey.substr(0, 4);
        var rawScopedKey = "".concat(digest).concat(keyPrefix).concat(paramsJSON);
        return $ee8186a3997a29cc$require$Buffer.from(rawScopedKey).toString("base64");
    };
    Object.defineProperty(Keys, "RESOURCEPATH", {
        get: function() {
            return $ee8186a3997a29cc$var$RESOURCEPATH;
        },
        enumerable: false,
        configurable: true
    });
    return Keys;
}();
module.exports.default = $ee8186a3997a29cc$var$Keys;

});
parcelRegister("aBJPx", function(module, exports) {
"use strict";

});


parcelRegister("6REhn", function(module, exports) {
"use strict";
var $4ff6eff5dd5d69be$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4ff6eff5dd5d69be$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $4ff6eff5dd5d69be$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4ff6eff5dd5d69be$var$Keys_1 = $4ff6eff5dd5d69be$var$__importDefault((parcelRequire("ktyOU")));
var $4ff6eff5dd5d69be$var$Key = /** @class */ function() {
    function Key(id, apiCall) {
        this.id = id;
        this.apiCall = apiCall;
    }
    Key.prototype.retrieve = function() {
        return $4ff6eff5dd5d69be$var$__awaiter(this, void 0, void 0, function() {
            return $4ff6eff5dd5d69be$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    Key.prototype.delete = function() {
        return $4ff6eff5dd5d69be$var$__awaiter(this, void 0, void 0, function() {
            return $4ff6eff5dd5d69be$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.delete(this.endpointPath())
                ];
            });
        });
    };
    Key.prototype.endpointPath = function() {
        return "".concat($4ff6eff5dd5d69be$var$Keys_1.default.RESOURCEPATH, "/").concat(this.id);
    };
    return Key;
}();
module.exports.default = $4ff6eff5dd5d69be$var$Key;

});

parcelRegister("ejoAV", function(module, exports) {
"use strict";
var $a6b5eafddde99f47$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a6b5eafddde99f47$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a6b5eafddde99f47$var$RESOURCEPATH = "/debug";
var $a6b5eafddde99f47$var$Debug = /** @class */ function() {
    function Debug(apiCall) {
        this.apiCall = apiCall;
    }
    Debug.prototype.retrieve = function() {
        return $a6b5eafddde99f47$var$__awaiter(this, void 0, void 0, function() {
            return $a6b5eafddde99f47$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get($a6b5eafddde99f47$var$RESOURCEPATH)
                ];
            });
        });
    };
    return Debug;
}();
module.exports.default = $a6b5eafddde99f47$var$Debug;

});

parcelRegister("5rAEm", function(module, exports) {
"use strict";
var $3f6be747e5a94b24$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3f6be747e5a94b24$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3f6be747e5a94b24$var$RESOURCEPATH = "/metrics.json";
var $3f6be747e5a94b24$var$Metrics = /** @class */ function() {
    function Metrics(apiCall) {
        this.apiCall = apiCall;
    }
    Metrics.prototype.retrieve = function() {
        return $3f6be747e5a94b24$var$__awaiter(this, void 0, void 0, function() {
            return $3f6be747e5a94b24$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get($3f6be747e5a94b24$var$RESOURCEPATH)
                ];
            });
        });
    };
    return Metrics;
}();
module.exports.default = $3f6be747e5a94b24$var$Metrics;

});

parcelRegister("dFdQs", function(module, exports) {
"use strict";
var $9f29d805fdc93706$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9f29d805fdc93706$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9f29d805fdc93706$var$RESOURCEPATH = "/health";
var $9f29d805fdc93706$var$Health = /** @class */ function() {
    function Health(apiCall) {
        this.apiCall = apiCall;
    }
    Health.prototype.retrieve = function() {
        return $9f29d805fdc93706$var$__awaiter(this, void 0, void 0, function() {
            return $9f29d805fdc93706$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get($9f29d805fdc93706$var$RESOURCEPATH)
                ];
            });
        });
    };
    return Health;
}();
module.exports.default = $9f29d805fdc93706$var$Health;

});

parcelRegister("bU3XR", function(module, exports) {
"use strict";
var $8aa7fff6a0008040$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8aa7fff6a0008040$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8aa7fff6a0008040$var$RESOURCEPATH = "/operations";
var $8aa7fff6a0008040$var$Operations = /** @class */ function() {
    function Operations(apiCall) {
        this.apiCall = apiCall;
    }
    Operations.prototype.perform = function(operationName, queryParameters) {
        if (queryParameters === void 0) queryParameters = {};
        return $8aa7fff6a0008040$var$__awaiter(this, void 0, void 0, function() {
            return $8aa7fff6a0008040$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.post("".concat($8aa7fff6a0008040$var$RESOURCEPATH, "/").concat(operationName), {}, queryParameters)
                ];
            });
        });
    };
    return Operations;
}();
module.exports.default = $8aa7fff6a0008040$var$Operations;

});

parcelRegister("8wz0y", function(module, exports) {
"use strict";
var $634c77b849a9f79e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $634c77b849a9f79e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $634c77b849a9f79e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $634c77b849a9f79e$var$RequestWithCache_1 = $634c77b849a9f79e$var$__importDefault((parcelRequire("l5XxM")));
var $634c77b849a9f79e$var$RESOURCEPATH = "/multi_search";
var $634c77b849a9f79e$var$MultiSearch = /** @class */ function() {
    function MultiSearch(apiCall, configuration, useTextContentType) {
        if (useTextContentType === void 0) useTextContentType = false;
        this.apiCall = apiCall;
        this.configuration = configuration;
        this.useTextContentType = useTextContentType;
        this.requestWithCache = new $634c77b849a9f79e$var$RequestWithCache_1.default();
    }
    MultiSearch.prototype.clearCache = function() {
        this.requestWithCache.clearCache();
    };
    MultiSearch.prototype.perform = function(searchRequests, commonParams, _a) {
        if (commonParams === void 0) commonParams = {};
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheSearchResultsForSeconds, cacheSearchResultsForSeconds = _c === void 0 ? this.configuration.cacheSearchResultsForSeconds : _c;
        return $634c77b849a9f79e$var$__awaiter(this, void 0, void 0, function() {
            var additionalHeaders, additionalQueryParams, queryParams;
            return $634c77b849a9f79e$var$__generator(this, function(_d) {
                additionalHeaders = {};
                if (this.useTextContentType) additionalHeaders["content-type"] = "text/plain";
                additionalQueryParams = {};
                if (this.configuration.useServerSideSearchCache === true) additionalQueryParams["use_cache"] = true;
                queryParams = Object.assign({}, commonParams, additionalQueryParams);
                return [
                    2 /*return*/ ,
                    this.requestWithCache.perform(this.apiCall, this.apiCall.post, [
                        $634c77b849a9f79e$var$RESOURCEPATH,
                        searchRequests,
                        queryParams,
                        additionalHeaders
                    ], {
                        cacheResponseForSeconds: cacheSearchResultsForSeconds
                    })
                ];
            });
        });
    };
    return MultiSearch;
}();
module.exports.default = $634c77b849a9f79e$var$MultiSearch;

});

parcelRegister("54pLW", function(module, exports) {
"use strict";
var $3b115147bd39c062$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3b115147bd39c062$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3b115147bd39c062$var$RESOURCEPATH = "/presets";
var $3b115147bd39c062$var$Presets = /** @class */ function() {
    function Presets(apiCall) {
        this.apiCall = apiCall;
    }
    Presets.prototype.upsert = function(presetId, params) {
        return $3b115147bd39c062$var$__awaiter(this, void 0, void 0, function() {
            return $3b115147bd39c062$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.put(this.endpointPath(presetId), params)
                ];
            });
        });
    };
    Presets.prototype.retrieve = function() {
        return $3b115147bd39c062$var$__awaiter(this, void 0, void 0, function() {
            return $3b115147bd39c062$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    Presets.prototype.endpointPath = function(operation) {
        return "".concat(Presets.RESOURCEPATH).concat(operation === undefined ? "" : "/" + operation);
    };
    Object.defineProperty(Presets, "RESOURCEPATH", {
        get: function() {
            return $3b115147bd39c062$var$RESOURCEPATH;
        },
        enumerable: false,
        configurable: true
    });
    return Presets;
}();
module.exports.default = $3b115147bd39c062$var$Presets;

});

parcelRegister("fW5Co", function(module, exports) {
"use strict";
var $b9a0a1769861578a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b9a0a1769861578a$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b9a0a1769861578a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $b9a0a1769861578a$var$Presets_1 = $b9a0a1769861578a$var$__importDefault((parcelRequire("54pLW")));
var $b9a0a1769861578a$var$Preset = /** @class */ function() {
    function Preset(presetId, apiCall) {
        this.presetId = presetId;
        this.apiCall = apiCall;
    }
    Preset.prototype.retrieve = function() {
        return $b9a0a1769861578a$var$__awaiter(this, void 0, void 0, function() {
            return $b9a0a1769861578a$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    Preset.prototype.delete = function() {
        return $b9a0a1769861578a$var$__awaiter(this, void 0, void 0, function() {
            return $b9a0a1769861578a$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.delete(this.endpointPath())
                ];
            });
        });
    };
    Preset.prototype.endpointPath = function() {
        return "".concat($b9a0a1769861578a$var$Presets_1.default.RESOURCEPATH, "/").concat(this.presetId);
    };
    return Preset;
}();
module.exports.default = $b9a0a1769861578a$var$Preset;

});

parcelRegister("gYmIV", function(module, exports) {
"use strict";
var $c5b3e05b57c92495$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $c5b3e05b57c92495$var$AnalyticsRules_1 = $c5b3e05b57c92495$var$__importDefault((parcelRequire("55i89")));

var $c5b3e05b57c92495$var$AnalyticsRule_1 = $c5b3e05b57c92495$var$__importDefault((parcelRequire("6WT9J")));
var $c5b3e05b57c92495$var$RESOURCEPATH = "/analytics";
var $c5b3e05b57c92495$var$Analytics = /** @class */ function() {
    function Analytics(apiCall) {
        this.apiCall = apiCall;
        this.individualAnalyticsRules = {};
        this.apiCall = apiCall;
        this._analyticsRules = new $c5b3e05b57c92495$var$AnalyticsRules_1.default(this.apiCall);
    }
    Analytics.prototype.rules = function(id) {
        if (id === undefined) return this._analyticsRules;
        else {
            if (this.individualAnalyticsRules[id] === undefined) this.individualAnalyticsRules[id] = new $c5b3e05b57c92495$var$AnalyticsRule_1.default(id, this.apiCall);
            return this.individualAnalyticsRules[id];
        }
    };
    Object.defineProperty(Analytics, "RESOURCEPATH", {
        get: function() {
            return $c5b3e05b57c92495$var$RESOURCEPATH;
        },
        enumerable: false,
        configurable: true
    });
    return Analytics;
}();
module.exports.default = $c5b3e05b57c92495$var$Analytics;

});
parcelRegister("55i89", function(module, exports) {
"use strict";
var $3b3b7bb3b4ff6d0d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3b3b7bb3b4ff6d0d$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3b3b7bb3b4ff6d0d$var$RESOURCEPATH = "/analytics/rules";
var $3b3b7bb3b4ff6d0d$var$AnalyticsRules = /** @class */ function() {
    function AnalyticsRules(apiCall) {
        this.apiCall = apiCall;
        this.apiCall = apiCall;
    }
    AnalyticsRules.prototype.upsert = function(name, params) {
        return $3b3b7bb3b4ff6d0d$var$__awaiter(this, void 0, void 0, function() {
            return $3b3b7bb3b4ff6d0d$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.put(this.endpointPath(name), params)
                ];
            });
        });
    };
    AnalyticsRules.prototype.retrieve = function() {
        return $3b3b7bb3b4ff6d0d$var$__awaiter(this, void 0, void 0, function() {
            return $3b3b7bb3b4ff6d0d$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    AnalyticsRules.prototype.endpointPath = function(operation) {
        return "".concat(AnalyticsRules.RESOURCEPATH).concat(operation === undefined ? "" : "/" + operation);
    };
    Object.defineProperty(AnalyticsRules, "RESOURCEPATH", {
        get: function() {
            return $3b3b7bb3b4ff6d0d$var$RESOURCEPATH;
        },
        enumerable: false,
        configurable: true
    });
    return AnalyticsRules;
}();
module.exports.default = $3b3b7bb3b4ff6d0d$var$AnalyticsRules;

});

parcelRegister("6WT9J", function(module, exports) {
"use strict";
var $50f2f1b32754cf7b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $50f2f1b32754cf7b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $50f2f1b32754cf7b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $50f2f1b32754cf7b$var$AnalyticsRules_1 = $50f2f1b32754cf7b$var$__importDefault((parcelRequire("55i89")));
var $50f2f1b32754cf7b$var$AnalyticsRule = /** @class */ function() {
    function AnalyticsRule(name, apiCall) {
        this.name = name;
        this.apiCall = apiCall;
    }
    AnalyticsRule.prototype.retrieve = function() {
        return $50f2f1b32754cf7b$var$__awaiter(this, void 0, void 0, function() {
            return $50f2f1b32754cf7b$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    AnalyticsRule.prototype.delete = function() {
        return $50f2f1b32754cf7b$var$__awaiter(this, void 0, void 0, function() {
            return $50f2f1b32754cf7b$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.delete(this.endpointPath())
                ];
            });
        });
    };
    AnalyticsRule.prototype.endpointPath = function() {
        return "".concat($50f2f1b32754cf7b$var$AnalyticsRules_1.default.RESOURCEPATH, "/").concat(this.name);
    };
    return AnalyticsRule;
}();
module.exports.default = $50f2f1b32754cf7b$var$AnalyticsRule;

});


parcelRegister("kpYim", function(module, exports) {
"use strict";
var $edd4e9c94c73a8c0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $edd4e9c94c73a8c0$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $edd4e9c94c73a8c0$var$RESOURCEPATH = "/stopwords";
var $edd4e9c94c73a8c0$var$Stopwords = /** @class */ function() {
    function Stopwords(apiCall) {
        this.apiCall = apiCall;
    }
    Stopwords.prototype.upsert = function(stopwordId, params) {
        return $edd4e9c94c73a8c0$var$__awaiter(this, void 0, void 0, function() {
            return $edd4e9c94c73a8c0$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.put(this.endpointPath(stopwordId), params)
                ];
            });
        });
    };
    Stopwords.prototype.retrieve = function() {
        return $edd4e9c94c73a8c0$var$__awaiter(this, void 0, void 0, function() {
            return $edd4e9c94c73a8c0$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    Stopwords.prototype.endpointPath = function(operation) {
        return "".concat(Stopwords.RESOURCEPATH).concat(operation === undefined ? "" : "/" + operation);
    };
    Object.defineProperty(Stopwords, "RESOURCEPATH", {
        get: function() {
            return $edd4e9c94c73a8c0$var$RESOURCEPATH;
        },
        enumerable: false,
        configurable: true
    });
    return Stopwords;
}();
module.exports.default = $edd4e9c94c73a8c0$var$Stopwords;

});

parcelRegister("aqI62", function(module, exports) {
"use strict";
var $797e89b0e25f2077$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $797e89b0e25f2077$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $797e89b0e25f2077$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $797e89b0e25f2077$var$Stopwords_1 = $797e89b0e25f2077$var$__importDefault((parcelRequire("kpYim")));
var $797e89b0e25f2077$var$Stopword = /** @class */ function() {
    function Stopword(stopwordId, apiCall) {
        this.stopwordId = stopwordId;
        this.apiCall = apiCall;
    }
    Stopword.prototype.retrieve = function() {
        return $797e89b0e25f2077$var$__awaiter(this, void 0, void 0, function() {
            return $797e89b0e25f2077$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    Stopword.prototype.delete = function() {
        return $797e89b0e25f2077$var$__awaiter(this, void 0, void 0, function() {
            return $797e89b0e25f2077$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.delete(this.endpointPath())
                ];
            });
        });
    };
    Stopword.prototype.endpointPath = function() {
        return "".concat($797e89b0e25f2077$var$Stopwords_1.default.RESOURCEPATH, "/").concat(this.stopwordId);
    };
    return Stopword;
}();
module.exports.default = $797e89b0e25f2077$var$Stopword;

});

parcelRegister("3oWtD", function(module, exports) {
"use strict";
var $27a0f94fc613df2a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $27a0f94fc613df2a$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $27a0f94fc613df2a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $27a0f94fc613df2a$var$ConversationModels_1 = $27a0f94fc613df2a$var$__importDefault((parcelRequire("5IAcY")));

var $27a0f94fc613df2a$var$ConversationModel_1 = $27a0f94fc613df2a$var$__importDefault((parcelRequire("26UoH")));
var $27a0f94fc613df2a$var$RESOURCEPATH = "/conversations";
var $27a0f94fc613df2a$var$Conversations = /** @class */ function() {
    function Conversations(apiCall) {
        this.apiCall = apiCall;
        this.individualConversationModels = {};
        this.apiCall = apiCall;
        this._conversationsModels = new $27a0f94fc613df2a$var$ConversationModels_1.default(this.apiCall);
    }
    Conversations.prototype.retrieve = function() {
        return $27a0f94fc613df2a$var$__awaiter(this, void 0, void 0, function() {
            return $27a0f94fc613df2a$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get($27a0f94fc613df2a$var$RESOURCEPATH)
                ];
            });
        });
    };
    Conversations.prototype.models = function(id) {
        if (id === undefined) return this._conversationsModels;
        else {
            if (this.individualConversationModels[id] === undefined) this.individualConversationModels[id] = new $27a0f94fc613df2a$var$ConversationModel_1.default(id, this.apiCall);
            return this.individualConversationModels[id];
        }
    };
    Object.defineProperty(Conversations, "RESOURCEPATH", {
        get: function() {
            return $27a0f94fc613df2a$var$RESOURCEPATH;
        },
        enumerable: false,
        configurable: true
    });
    return Conversations;
}();
module.exports.default = $27a0f94fc613df2a$var$Conversations;

});
parcelRegister("5IAcY", function(module, exports) {
"use strict";
var $429d260083f457a8$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $429d260083f457a8$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $429d260083f457a8$var$RESOURCEPATH = "/conversations/models";
var $429d260083f457a8$var$ConversationModels = /** @class */ function() {
    function ConversationModels(apiCall) {
        this.apiCall = apiCall;
        this.apiCall = apiCall;
    }
    ConversationModels.prototype.create = function(params) {
        return $429d260083f457a8$var$__awaiter(this, void 0, void 0, function() {
            return $429d260083f457a8$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.post(this.endpointPath(), params)
                ];
            });
        });
    };
    ConversationModels.prototype.retrieve = function() {
        return $429d260083f457a8$var$__awaiter(this, void 0, void 0, function() {
            return $429d260083f457a8$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    ConversationModels.prototype.endpointPath = function(operation) {
        return "".concat(ConversationModels.RESOURCEPATH).concat(operation === undefined ? "" : "/" + operation);
    };
    Object.defineProperty(ConversationModels, "RESOURCEPATH", {
        get: function() {
            return $429d260083f457a8$var$RESOURCEPATH;
        },
        enumerable: false,
        configurable: true
    });
    return ConversationModels;
}();
module.exports.default = $429d260083f457a8$var$ConversationModels;

});

parcelRegister("26UoH", function(module, exports) {
"use strict";
var $1897e3a452ed685d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1897e3a452ed685d$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $1897e3a452ed685d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1897e3a452ed685d$var$ConversationModels_1 = $1897e3a452ed685d$var$__importDefault((parcelRequire("5IAcY")));
var $1897e3a452ed685d$var$ConversationModel = /** @class */ function() {
    function ConversationModel(id, apiCall) {
        this.id = id;
        this.apiCall = apiCall;
    }
    ConversationModel.prototype.update = function(params) {
        return $1897e3a452ed685d$var$__awaiter(this, void 0, void 0, function() {
            return $1897e3a452ed685d$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.put(this.endpointPath(), params)
                ];
            });
        });
    };
    ConversationModel.prototype.retrieve = function() {
        return $1897e3a452ed685d$var$__awaiter(this, void 0, void 0, function() {
            return $1897e3a452ed685d$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    ConversationModel.prototype.delete = function() {
        return $1897e3a452ed685d$var$__awaiter(this, void 0, void 0, function() {
            return $1897e3a452ed685d$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.delete(this.endpointPath())
                ];
            });
        });
    };
    ConversationModel.prototype.endpointPath = function() {
        return "".concat($1897e3a452ed685d$var$ConversationModels_1.default.RESOURCEPATH, "/").concat(this.id);
    };
    return ConversationModel;
}();
module.exports.default = $1897e3a452ed685d$var$ConversationModel;

});


parcelRegister("2CfIE", function(module, exports) {
"use strict";
var $1e7b52e484471b9b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1e7b52e484471b9b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $1e7b52e484471b9b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1e7b52e484471b9b$var$Conversations_1 = $1e7b52e484471b9b$var$__importDefault((parcelRequire("3oWtD")));
var $1e7b52e484471b9b$var$Conversation = /** @class */ function() {
    function Conversation(id, apiCall) {
        this.id = id;
        this.apiCall = apiCall;
    }
    Conversation.prototype.retrieve = function() {
        return $1e7b52e484471b9b$var$__awaiter(this, void 0, void 0, function() {
            return $1e7b52e484471b9b$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.get(this.endpointPath())
                ];
            });
        });
    };
    Conversation.prototype.update = function(params) {
        return $1e7b52e484471b9b$var$__awaiter(this, void 0, void 0, function() {
            return $1e7b52e484471b9b$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.put(this.endpointPath(), params)
                ];
            });
        });
    };
    Conversation.prototype.delete = function() {
        return $1e7b52e484471b9b$var$__awaiter(this, void 0, void 0, function() {
            return $1e7b52e484471b9b$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.apiCall.delete(this.endpointPath())
                ];
            });
        });
    };
    Conversation.prototype.endpointPath = function() {
        return "".concat($1e7b52e484471b9b$var$Conversations_1.default.RESOURCEPATH, "/").concat(this.id);
    };
    return Conversation;
}();
module.exports.default = $1e7b52e484471b9b$var$Conversation;

});


parcelRegister("6EHhb", function(module, exports) {
"use strict";
var $4d880c40db97eaf9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4d880c40db97eaf9$var$Configuration_1 = $4d880c40db97eaf9$var$__importDefault((parcelRequire("1B9yQ")));

var $4d880c40db97eaf9$var$ApiCall_1 = $4d880c40db97eaf9$var$__importDefault((parcelRequire("4g7eM")));

var $4d880c40db97eaf9$var$MultiSearch_1 = $4d880c40db97eaf9$var$__importDefault((parcelRequire("8wz0y")));

var $k4EQO = parcelRequire("k4EQO");
var $4d880c40db97eaf9$var$SearchClient = /** @class */ function() {
    function SearchClient(options) {
        var _a;
        options.sendApiKeyAsQueryParam = (_a = options.sendApiKeyAsQueryParam) !== null && _a !== void 0 ? _a : true;
        if (options.sendApiKeyAsQueryParam === true && (options.apiKey || "").length > 2000) {
            console.warn("[typesense] API Key is longer than 2000 characters which is over the allowed limit, so disabling sending it as a query parameter.");
            options.sendApiKeyAsQueryParam = false;
        }
        this.configuration = new $4d880c40db97eaf9$var$Configuration_1.default(options);
        this.apiCall = new $4d880c40db97eaf9$var$ApiCall_1.default(this.configuration);
        this.multiSearch = new $4d880c40db97eaf9$var$MultiSearch_1.default(this.apiCall, this.configuration, true);
        this.individualCollections = {};
    }
    SearchClient.prototype.clearCache = function() {
        this.multiSearch.clearCache();
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(this.individualCollections).forEach(function(_a) {
            var _ = _a[0], collection = _a[1];
            collection.documents().clearCache();
        });
    };
    SearchClient.prototype.collections = function(collectionName) {
        if (!collectionName) throw new Error("Typesense.SearchClient only supports search operations, so the collectionName that needs to be searched must be specified. Use Typesense.Client if you need to access the collection object.");
        else {
            if (this.individualCollections[collectionName] === undefined) this.individualCollections[collectionName] = new $k4EQO.SearchOnlyCollection(collectionName, this.apiCall, this.configuration);
            return this.individualCollections[collectionName];
        }
    };
    return SearchClient;
}();
module.exports.default = $4d880c40db97eaf9$var$SearchClient;

});
parcelRegister("k4EQO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SearchOnlyCollection = void 0;

var $8qgSX = parcelRequire("8qgSX");
var $e9d3de7d03ef6d17$var$SearchOnlyCollection = /** @class */ function() {
    function SearchOnlyCollection(name, apiCall, configuration) {
        this.name = name;
        this.apiCall = apiCall;
        this.configuration = configuration;
        this._documents = new $8qgSX.SearchOnlyDocuments(this.name, this.apiCall, this.configuration);
    }
    SearchOnlyCollection.prototype.documents = function() {
        return this._documents;
    };
    return SearchOnlyCollection;
}();
module.exports.SearchOnlyCollection = $e9d3de7d03ef6d17$var$SearchOnlyCollection;

});



parcelRegister("0gOMs", function(module, exports) {
"use strict";

var $9suN4 = parcelRequire("9suN4");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SearchRequestAdapter = void 0;

var $000d0bea0972b94f$var$_regenerator = $9suN4((parcelRequire("iQvf5")));

var $000d0bea0972b94f$var$_asyncToGenerator2 = $9suN4((parcelRequire("H0Kw6")));

var $000d0bea0972b94f$var$_slicedToArray2 = $9suN4((parcelRequire("i6rxi")));

var $000d0bea0972b94f$var$_classCallCheck2 = $9suN4((parcelRequire("6RERu")));

var $000d0bea0972b94f$var$_createClass2 = $9suN4((parcelRequire("1XdEY")));
var $000d0bea0972b94f$var$SearchRequestAdapter = /*#__PURE__*/ function() {
    function SearchRequestAdapter(instantsearchRequests, typesenseClient, configuration) {
        (0, $000d0bea0972b94f$var$_classCallCheck2["default"])(this, SearchRequestAdapter);
        this.instantsearchRequests = instantsearchRequests;
        this.typesenseClient = typesenseClient;
        this.configuration = configuration;
        this.additionalSearchParameters = configuration.additionalSearchParameters;
        this.collectionSpecificSearchParameters = configuration.collectionSpecificSearchParameters;
    }
    (0, $000d0bea0972b94f$var$_createClass2["default"])(SearchRequestAdapter, [
        {
            key: "_shouldUseExactMatchForField",
            value: function _shouldUseExactMatchForField(fieldName, collectionName) {
                var _this$configuration$c, _this$configuration$f;
                if (((_this$configuration$c = this.configuration.collectionSpecificFilterByOptions) === null || _this$configuration$c === void 0 || (_this$configuration$c = _this$configuration$c[collectionName]) === null || _this$configuration$c === void 0 || (_this$configuration$c = _this$configuration$c[fieldName]) === null || _this$configuration$c === void 0 ? void 0 : _this$configuration$c.exactMatch) === false || ((_this$configuration$f = this.configuration.filterByOptions) === null || _this$configuration$f === void 0 || (_this$configuration$f = _this$configuration$f[fieldName]) === null || _this$configuration$f === void 0 ? void 0 : _this$configuration$f.exactMatch) === false) return false;
                else return true;
            }
        },
        {
            key: "_adaptFacetFilters",
            value: function _adaptFacetFilters(facetFilters, collectionName) {
                var _this = this;
                var adaptedResult = "";
                if (!facetFilters) return adaptedResult;
                /**
       * Need to transform:
       *  facetFilters = [["field1:value1", "field1:value2"], "field2:value3", "field2:value4"]
       *
       * Into this:
       *  field1:=[value1,value2] && field2:=value3 && field2:=value4
       *
       * Steps:
       *  - For each item in facetFilters
       *    - If item is array
       *      - OR values together.
       *      - Warn if field names are not the same
       *    - If item is string, convert to facet:=value format
       *  - Join strings by &&
       */ var transformedTypesenseFilters = facetFilters.map(function(item) {
                    if (Array.isArray(item)) {
                        // Need to transform:
                        // facetFilters = ["field1:value1", "field1:value2", "facetN:valueN"]
                        //
                        // Into this:
                        // intermediateFacetFilters = {
                        //     "field1": ["value1", "value2"],
                        //     "fieldN": ["valueN"]
                        // }
                        var intermediateFacetFilters = {};
                        item.forEach(function(facetFilter) {
                            var _this$_parseFacetFilt = _this._parseFacetFilter(facetFilter), fieldName = _this$_parseFacetFilt.fieldName, fieldValue = _this$_parseFacetFilt.fieldValue;
                            intermediateFacetFilters[fieldName] = intermediateFacetFilters[fieldName] || [];
                            intermediateFacetFilters[fieldName].push(fieldValue);
                        });
                        if (Object.keys(intermediateFacetFilters).length > 1) console.error("[Typesense-Instantsearch-Adapter] Typesense does not support cross-field ORs at the moment. The adapter could not OR values between these fields: ".concat(Object.keys(intermediateFacetFilters).join(",")));
                         // Pick first value from intermediateFacetFilters
                        var fieldName = Object.keys(intermediateFacetFilters)[0];
                        var fieldValues = intermediateFacetFilters[fieldName]; // Need to transform:
                        // intermediateFacetFilters = {
                        //     "field1": ["value1", "value2"],
                        // }
                        //
                        // Into this:
                        // field1:=[value1,value2]
                        // Partition values into included and excluded values
                        var _fieldValues$reduce3 = fieldValues.reduce(function(result, fieldValue) {
                            if (fieldValue.startsWith("-") && !_this._isNumber(fieldValue)) result[0].push(fieldValue.substring(1));
                            else result[1].push(fieldValue);
                            return result;
                        }, [
                            [],
                            []
                        ]), _fieldValues$reduce4 = (0, $000d0bea0972b94f$var$_slicedToArray2["default"])(_fieldValues$reduce3, 2), excludedFieldValues = _fieldValues$reduce4[0], includedFieldValues = _fieldValues$reduce4[1];
                        var typesenseFilterStringComponents = [];
                        if (includedFieldValues.length > 0) {
                            var operator = _this._shouldUseExactMatchForField(fieldName, collectionName) ? ":=" : ":";
                            typesenseFilterStringComponents.push("".concat(fieldName).concat(operator, "[").concat(includedFieldValues.map(function(v) {
                                return _this._escapeFacetValue(v);
                            }).join(","), "]"));
                        }
                        if (excludedFieldValues.length > 0) {
                            var _operator = _this._shouldUseExactMatchForField(fieldName, collectionName) ? ":!=" : ":!";
                            typesenseFilterStringComponents.push("".concat(fieldName).concat(_operator, "[").concat(excludedFieldValues.map(function(v) {
                                return _this._escapeFacetValue(v);
                            }).join(","), "]"));
                        }
                        var typesenseFilterString = typesenseFilterStringComponents.filter(function(f) {
                            return f;
                        }).join(" && ");
                        return typesenseFilterString;
                    } else {
                        // Need to transform:
                        //  fieldName:fieldValue
                        // Into
                        //  fieldName:=fieldValue
                        var _this$_parseFacetFilt3 = _this._parseFacetFilter(item), _fieldName = _this$_parseFacetFilt3.fieldName, fieldValue = _this$_parseFacetFilt3.fieldValue;
                        var _typesenseFilterString;
                        if (fieldValue.startsWith("-") && !_this._isNumber(fieldValue)) {
                            var _operator2 = _this._shouldUseExactMatchForField(_fieldName, collectionName) ? ":!=" : ":!";
                            _typesenseFilterString = "".concat(_fieldName).concat(_operator2, "[").concat(_this._escapeFacetValue(fieldValue.substring(1)), "]");
                        } else {
                            var _operator3 = _this._shouldUseExactMatchForField(_fieldName, collectionName) ? ":=" : ":";
                            _typesenseFilterString = "".concat(_fieldName).concat(_operator3, "[").concat(_this._escapeFacetValue(fieldValue), "]");
                        }
                        return _typesenseFilterString;
                    }
                });
                adaptedResult = transformedTypesenseFilters.join(" && "); // console.log(`${JSON.stringify(facetFilters)} => ${adaptedResult}`);
                return adaptedResult;
            }
        },
        {
            key: "_parseFacetFilter",
            value: function _parseFacetFilter(facetFilter) {
                var _this$configuration$f2;
                var filterStringMatchingRegex, facetFilterMatches, fieldName, fieldValue; // This is helpful when the filter looks like `facetName:with:colons:facetValue:with:colons` and the default regex above parses the filter as `facetName:with:colons:facetValue:with` and `colon`.
                // So if a facetValue can contain a colon, we ask users to pass in all possible facetable fields in `facetableFieldsWithSpecialCharacters` when instantiating the adapter, so we can explicitly match against that.
                if (((_this$configuration$f2 = this.configuration.facetableFieldsWithSpecialCharacters) === null || _this$configuration$f2 === void 0 ? void 0 : _this$configuration$f2.length) > 0) {
                    // escape any Regex special characters, source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
                    var sanitizedFacetableFieldsWithSpecialCharacters = this.configuration.facetableFieldsWithSpecialCharacters.flat().map(function(f) {
                        return f.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                    });
                    filterStringMatchingRegex = new RegExp("^(".concat(sanitizedFacetableFieldsWithSpecialCharacters.join("|"), "):(.*)$"));
                    facetFilterMatches = facetFilter.match(filterStringMatchingRegex);
                    if (facetFilterMatches != null) {
                        fieldName = "".concat(facetFilterMatches[1]);
                        fieldValue = "".concat(facetFilterMatches[2]);
                        return {
                            fieldName: fieldName,
                            fieldValue: fieldValue
                        };
                    }
                } // If we haven't found any matches yet
                // Use the default filter parsing regex, which assumes that only facet names have colons, and not facet values
                filterStringMatchingRegex = this.constructor.DEFAULT_FACET_FILTER_STRING_MATCHING_REGEX;
                facetFilterMatches = facetFilter.match(filterStringMatchingRegex); // console.log(filterStringMatchingRegex);
                // console.log(facetFilter);
                // console.log(facetFilterMatches);
                if (facetFilterMatches == null) console.error("[Typesense-Instantsearch-Adapter] Parsing failed for a facet filter `".concat(facetFilter, "` with the Regex `").concat(filterStringMatchingRegex, "`. If you have field names with special characters, be sure to add them to a parameter called `facetableFieldsWithSpecialCharacters` when instantiating the adapter."));
                else {
                    fieldName = "".concat(facetFilterMatches[1]).concat(facetFilterMatches[2]);
                    fieldValue = "".concat(facetFilterMatches[3]);
                }
                return {
                    fieldName: fieldName,
                    fieldValue: fieldValue
                };
            }
        },
        {
            key: "_escapeFacetValue",
            value: function _escapeFacetValue(value) {
                // Don't escape booleans, integers or floats
                if (typeof value === "boolean" || value === "true" || value === "false" || this._isNumber(value)) return value;
                return "`".concat(value, "`");
            }
        },
        {
            key: "_isNumber",
            value: function _isNumber(value) {
                return Number.isInteger(value % 1) || // Mod 1 will automatically try converting string values to integer/float
                !!(value % 1); // Is Float
            }
        },
        {
            key: "_adaptNumericFilters",
            value: function _adaptNumericFilters(numericFilters) {
                var _this2 = this;
                // Need to transform this:
                // ["field1<=634", "field1>=289", "field2<=5", "field3>=3"]
                // to:
                // "field1:=[634..289] && field2:<=5 && field3:>=3"
                var adaptedResult = "";
                if (!numericFilters) return adaptedResult;
                 // Transform to intermediate structure:
                // {
                //   field1: {
                //     "<=": 634,
                //     ">=": 289
                //   },
                //   field2: {
                //     "<=": 5
                //   },
                //   field3: {
                //     ">=": 3
                //   }
                // };
                var filtersHash = {};
                numericFilters.forEach(function(filter) {
                    var _this2$_parseNumericF = _this2._parseNumericFilter(filter), fieldName = _this2$_parseNumericF.fieldName, operator = _this2$_parseNumericF.operator, fieldValue = _this2$_parseNumericF.fieldValue;
                    filtersHash[fieldName] = filtersHash[fieldName] || {};
                    filtersHash[fieldName][operator] = fieldValue;
                }); // Transform that to:
                //  "field1:=[634..289] && field2:<=5 && field3:>=3"
                var adaptedFilters = [];
                Object.keys(filtersHash).forEach(function(field) {
                    if (filtersHash[field]["<="] != null && filtersHash[field][">="] != null) adaptedFilters.push("".concat(field, ":=[").concat(filtersHash[field][">="], "..").concat(filtersHash[field]["<="], "]"));
                    else if (filtersHash[field]["<="] != null) adaptedFilters.push("".concat(field, ":<=").concat(filtersHash[field]["<="]));
                    else if (filtersHash[field][">="] != null) adaptedFilters.push("".concat(field, ":>=").concat(filtersHash[field][">="]));
                    else if (filtersHash[field]["="] != null) adaptedFilters.push("".concat(field, ":=").concat(filtersHash[field]["="]));
                    else console.warn("[Typesense-Instantsearch-Adapter] Unsupported operator found ".concat(JSON.stringify(filtersHash[field])));
                });
                adaptedResult = adaptedFilters.join(" && ");
                return adaptedResult;
            }
        },
        {
            key: "_parseNumericFilter",
            value: function _parseNumericFilter(numericFilter) {
                var _this$configuration$f3;
                var filterStringMatchingRegex, numericFilterMatches;
                var fieldName, operator, fieldValue; // The following is helpful when the facetName has special characters like > and the default regex fails to parse it properly.
                // So we ask users to pass in facetable fields in `facetableFieldsWithSpecialCharactersWithSpecialCharacters` when instantiating the adapter, so we can explicitly match against that.
                if (((_this$configuration$f3 = this.configuration.facetableFieldsWithSpecialCharacters) === null || _this$configuration$f3 === void 0 ? void 0 : _this$configuration$f3.length) > 0) {
                    // escape any Regex special characters, source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
                    var sanitizedFacetableFieldsWithSpecialCharacters = this.configuration.facetableFieldsWithSpecialCharacters.map(function(f) {
                        return f.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                    });
                    filterStringMatchingRegex = new RegExp("^(".concat(sanitizedFacetableFieldsWithSpecialCharacters.join("|"), ")(<=|>=|>|<|=)(.*)$"));
                    numericFilterMatches = numericFilter.match(filterStringMatchingRegex);
                    if (numericFilterMatches != null) {
                        // If no matches are found or if the above didn't trigger, fall back to the default regex
                        var _numericFilterMatches = numericFilterMatches;
                        var _numericFilterMatches2 = (0, $000d0bea0972b94f$var$_slicedToArray2["default"])(_numericFilterMatches, 4);
                        fieldName = _numericFilterMatches2[1];
                        operator = _numericFilterMatches2[2];
                        fieldValue = _numericFilterMatches2[3];
                        return {
                            fieldName: fieldName,
                            operator: operator,
                            fieldValue: fieldValue
                        };
                    }
                } // If we haven't found any matches yet, fall back to the default regex
                filterStringMatchingRegex = this.constructor.DEFAULT_NUMERIC_FILTER_STRING_MATCHING_REGEX;
                numericFilterMatches = numericFilter.match(filterStringMatchingRegex); // console.log(filterStringMatchingRegex);
                // console.log(numericFilter);
                // console.log(numericFilterMatches);
                if (numericFilterMatches == null) console.error("[Typesense-Instantsearch-Adapter] Parsing failed for a numeric filter `".concat(numericFilter, "` with the Regex `").concat(filterStringMatchingRegex, "`. If you have field names with special characters, be sure to add them to a parameter called `facetableFieldsWithSpecialCharacters` when instantiating the adapter."));
                else {
                    var _numericFilterMatches3 = numericFilterMatches;
                    var _numericFilterMatches4 = (0, $000d0bea0972b94f$var$_slicedToArray2["default"])(_numericFilterMatches3, 4);
                    fieldName = _numericFilterMatches4[1];
                    operator = _numericFilterMatches4[2];
                    fieldValue = _numericFilterMatches4[3];
                }
                return {
                    fieldName: fieldName,
                    operator: operator,
                    fieldValue: fieldValue
                };
            }
        },
        {
            key: "_adaptGeoFilter",
            value: function _adaptGeoFilter(_ref) {
                var insideBoundingBox = _ref.insideBoundingBox, aroundRadius = _ref.aroundRadius, aroundLatLng = _ref.aroundLatLng, insidePolygon = _ref.insidePolygon;
                // Give this parameter first priority if it exists, since
                if (insideBoundingBox) {
                    var x1, y1, x2, y2;
                    if (Array.isArray(insideBoundingBox)) {
                        var _insideBoundingBox$fl = insideBoundingBox.flat();
                        var _insideBoundingBox$fl2 = (0, $000d0bea0972b94f$var$_slicedToArray2["default"])(_insideBoundingBox$fl, 4);
                        x1 = _insideBoundingBox$fl2[0];
                        y1 = _insideBoundingBox$fl2[1];
                        x2 = _insideBoundingBox$fl2[2];
                        y2 = _insideBoundingBox$fl2[3];
                    } else {
                        var _insideBoundingBox$sp = insideBoundingBox.split(",");
                        var _insideBoundingBox$sp2 = (0, $000d0bea0972b94f$var$_slicedToArray2["default"])(_insideBoundingBox$sp, 4);
                        x1 = _insideBoundingBox$sp2[0];
                        y1 = _insideBoundingBox$sp2[1];
                        x2 = _insideBoundingBox$sp2[2];
                        y2 = _insideBoundingBox$sp2[3];
                    }
                    return "".concat(this.configuration.geoLocationField, ":(").concat(x1, ", ").concat(y1, ", ").concat(x1, ", ").concat(y2, ", ").concat(x2, ", ").concat(y2, ", ").concat(x2, ", ").concat(y1, ")");
                }
                if (aroundLatLng || aroundRadius) {
                    if (!aroundRadius || aroundRadius === "all") throw new Error("[Typesense-Instantsearch-Adapter] In Typesense, geo-filtering around a lat/lng also requires a numerical radius. So the `aroundRadius` parameter is required when `aroundLatLng` is used. If you intend to just geo-sort around a lat/long, you want to use the sortBy InstantSearch widget (or a virtual sortBy custom widget).");
                    var adaptedAroundRadius = "".concat(parseFloat(aroundRadius) / 1000, " km"); // aroundRadius is in meters
                    return "".concat(this.configuration.geoLocationField, ":(").concat(aroundLatLng, ", ").concat(adaptedAroundRadius, ")");
                }
                if (insidePolygon) {
                    var coordinates = insidePolygon;
                    if (Array.isArray(insidePolygon)) coordinates = insidePolygon.flat().join(",");
                    return "".concat(this.configuration.geoLocationField, ":(").concat(coordinates, ")");
                }
            }
        },
        {
            key: "_adaptFilters",
            value: function _adaptFilters(instantsearchParams, collectionName) {
                var adaptedFilters = []; // `filters` can be used with the `Configure` widget
                // However the format needs to be in the Typesense filter_by format, instead of Algolia filter format.
                if (instantsearchParams.filters) adaptedFilters.push(instantsearchParams.filters);
                adaptedFilters.push(this._adaptFacetFilters(instantsearchParams.facetFilters, collectionName));
                adaptedFilters.push(this._adaptNumericFilters(instantsearchParams.numericFilters));
                adaptedFilters.push(this._adaptGeoFilter(instantsearchParams));
                return adaptedFilters.filter(function(filter) {
                    return filter && filter !== "";
                }).join(" && ");
            }
        },
        {
            key: "_adaptIndexName",
            value: function _adaptIndexName(indexName) {
                return indexName.match(this.constructor.INDEX_NAME_MATCHING_REGEX)[1];
            }
        },
        {
            key: "_adaptSortBy",
            value: function _adaptSortBy(indexName) {
                return indexName.match(this.constructor.INDEX_NAME_MATCHING_REGEX)[3];
            }
        },
        {
            key: "_adaptFacetBy",
            value: function _adaptFacetBy(facets, collectionName) {
                var _this3 = this;
                return [
                    facets
                ].flat().map(function(facet) {
                    var _this3$configuration$;
                    if ((_this3$configuration$ = _this3.configuration.collectionSpecificFacetByOptions) !== null && _this3$configuration$ !== void 0 && (_this3$configuration$ = _this3$configuration$[collectionName]) !== null && _this3$configuration$ !== void 0 && _this3$configuration$[facet]) return "".concat(facet).concat(_this3.configuration.collectionSpecificFacetByOptions[collectionName][facet]);
                    else if (_this3.configuration.facetByOptions[facet]) return "".concat(facet).concat(_this3.configuration.facetByOptions[facet]);
                    else return facet;
                }).join(",");
            }
        },
        {
            key: "_buildSearchParameters",
            value: function _buildSearchParameters(instantsearchRequest) {
                var params = instantsearchRequest.params;
                var indexName = instantsearchRequest.indexName;
                var adaptedCollectionName = this._adaptIndexName(indexName); // Convert all common parameters to snake case
                var snakeCasedAdditionalSearchParameters = {};
                for(var _i = 0, _Object$entries = Object.entries(this.additionalSearchParameters); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i2 = (0, $000d0bea0972b94f$var$_slicedToArray2["default"])(_Object$entries[_i], 2), key = _Object$entries$_i2[0], value = _Object$entries$_i2[1];
                    snakeCasedAdditionalSearchParameters[this._camelToSnakeCase(key)] = value;
                } // Override, collection specific parameters
                if (this.collectionSpecificSearchParameters[adaptedCollectionName]) for(var _i2 = 0, _Object$entries2 = Object.entries(this.collectionSpecificSearchParameters[adaptedCollectionName]); _i2 < _Object$entries2.length; _i2++){
                    var _Object$entries2$_i2 = (0, $000d0bea0972b94f$var$_slicedToArray2["default"])(_Object$entries2[_i2], 2), _key = _Object$entries2$_i2[0], _value = _Object$entries2$_i2[1];
                    snakeCasedAdditionalSearchParameters[this._camelToSnakeCase(_key)] = _value;
                }
                var typesenseSearchParams = Object.assign({}, snakeCasedAdditionalSearchParameters);
                var adaptedSortBy = this._adaptSortBy(indexName);
                Object.assign(typesenseSearchParams, {
                    collection: adaptedCollectionName,
                    q: params.query === "" || params.query === undefined ? "*" : params.query,
                    facet_by: snakeCasedAdditionalSearchParameters.facet_by || this._adaptFacetBy(params.facets, adaptedCollectionName),
                    filter_by: this._adaptFilters(params, adaptedCollectionName) || snakeCasedAdditionalSearchParameters.filter_by,
                    sort_by: adaptedSortBy || snakeCasedAdditionalSearchParameters.sort_by,
                    max_facet_values: params.maxValuesPerFacet,
                    page: (params.page || 0) + 1
                });
                if (params.hitsPerPage) typesenseSearchParams.per_page = params.hitsPerPage;
                if (params.facetQuery) {
                    typesenseSearchParams.facet_query = "".concat(params.facetName, ":").concat(params.facetQuery);
                    typesenseSearchParams.per_page = 0;
                } // If a custom vector query is specified, set q=*
                if (params.typesenseVectorQuery) typesenseSearchParams.vector_query = params.typesenseVectorQuery;
                 // console.log(params);
                // console.log(typesenseSearchParams);
                // Filter out empty or null values, so we don't accidentally override values set in presets
                // eslint-disable-next-line no-unused-vars
                return Object.fromEntries(Object.entries(typesenseSearchParams).filter(function(_ref2) {
                    var _ref3 = (0, $000d0bea0972b94f$var$_slicedToArray2["default"])(_ref2, 2), _ = _ref3[0], v = _ref3[1];
                    return v != null && v !== "";
                }));
            }
        },
        {
            key: "_camelToSnakeCase",
            value: function _camelToSnakeCase(str) {
                return str.split(/(?=[A-Z])/).join("_").toLowerCase();
            }
        },
        {
            key: "request",
            value: function() {
                var _request = (0, $000d0bea0972b94f$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $000d0bea0972b94f$var$_regenerator["default"].mark(function _callee() {
                    var _this4 = this;
                    var searches;
                    return $000d0bea0972b94f$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                // console.log(this.instantsearchRequests);
                                searches = this.instantsearchRequests.map(function(instantsearchRequest) {
                                    return _this4._buildSearchParameters(instantsearchRequest);
                                });
                                return _context.abrupt("return", this.typesenseClient.multiSearch.perform({
                                    searches: searches
                                }));
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function request() {
                    return _request.apply(this, arguments);
                }
                return request;
            }()
        }
    ], [
        {
            key: "INDEX_NAME_MATCHING_REGEX",
            get: function get() {
                return new RegExp("^(.+?)(?=(/sort/(.*))|$)");
            }
        },
        {
            key: "DEFAULT_FACET_FILTER_STRING_MATCHING_REGEX",
            get: function get() {
                return new RegExp("(.*)((?!:).):(?!:)(.*)");
            }
        },
        {
            key: "DEFAULT_NUMERIC_FILTER_STRING_MATCHING_REGEX",
            get: function get() {
                return new RegExp("(.*?)(<=|>=|>|<|=)(.*)");
            }
        }
    ]);
    return SearchRequestAdapter;
}();
module.exports.SearchRequestAdapter = $000d0bea0972b94f$var$SearchRequestAdapter;

});
parcelRegister("i6rxi", function(module, exports) {

var $eHcID = parcelRequire("eHcID");

var $cUEhx = parcelRequire("cUEhx");

var $5CWRA = parcelRequire("5CWRA");

var $kmvQ3 = parcelRequire("kmvQ3");
function $d2de25a2c8d645c9$var$_slicedToArray(r, e) {
    return $eHcID(r) || $cUEhx(r, e) || $5CWRA(r, e) || $kmvQ3();
}
module.exports = $d2de25a2c8d645c9$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eHcID", function(module, exports) {
function $ab2ef28de612aee0$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $ab2ef28de612aee0$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cUEhx", function(module, exports) {
function $9669f61f0d4bec52$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $9669f61f0d4bec52$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5CWRA", function(module, exports) {

var $fiAvJ = parcelRequire("fiAvJ");
function $418e2967b26e3c66$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fiAvJ(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fiAvJ(r, a) : void 0;
    }
}
module.exports = $418e2967b26e3c66$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fiAvJ", function(module, exports) {
function $b234dbb7b4fea5ea$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $b234dbb7b4fea5ea$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("kmvQ3", function(module, exports) {
function $ed2e8f306ddc0755$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $ed2e8f306ddc0755$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("aFsEy", function(module, exports) {
"use strict";

var $9suN4 = parcelRequire("9suN4");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SearchResponseAdapter = void 0;

var $7c43f5a6e3f83414$var$_typeof2 = $9suN4((parcelRequire("lyHQD")));

var $7c43f5a6e3f83414$var$_slicedToArray2 = $9suN4((parcelRequire("i6rxi")));

var $7c43f5a6e3f83414$var$_toConsumableArray2 = $9suN4((parcelRequire("hQc63")));

var $7c43f5a6e3f83414$var$_defineProperty2 = $9suN4((parcelRequire("jnR56")));

var $7c43f5a6e3f83414$var$_classCallCheck2 = $9suN4((parcelRequire("6RERu")));

var $7c43f5a6e3f83414$var$_createClass2 = $9suN4((parcelRequire("1XdEY")));

var $9nkv7 = parcelRequire("9nkv7");
function $7c43f5a6e3f83414$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7c43f5a6e3f83414$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7c43f5a6e3f83414$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $7c43f5a6e3f83414$var$_defineProperty2["default"])(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7c43f5a6e3f83414$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $7c43f5a6e3f83414$var$SearchResponseAdapter = /*#__PURE__*/ function() {
    function SearchResponseAdapter(typesenseResponse, instantsearchRequest, configuration) {
        var allTypesenseResponses = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
        (0, $7c43f5a6e3f83414$var$_classCallCheck2["default"])(this, SearchResponseAdapter);
        this.typesenseResponse = typesenseResponse;
        this.instantsearchRequest = instantsearchRequest;
        this.configuration = configuration;
        this.allTypesenseResponses = allTypesenseResponses;
    }
    (0, $7c43f5a6e3f83414$var$_createClass2["default"])(SearchResponseAdapter, [
        {
            key: "_adaptGroupedHits",
            value: function _adaptGroupedHits(typesenseGroupedHits) {
                var _this = this;
                var adaptedResult = [];
                adaptedResult = typesenseGroupedHits.map(function(groupedHit) {
                    var adaptedHits = _this._adaptHits(groupedHit.hits);
                    adaptedHits.forEach(function(hit) {
                        hit["group_key"] = hit["_group_key"] = groupedHit.group_key;
                        if (groupedHit.found) hit["_group_found"] = groupedHit.found;
                    });
                    return adaptedHits;
                }); // adaptedResult is now in the form of [[{}, {}], [{}, {}], ...]
                //  where each element in the outermost array corresponds to a group.
                if (this.configuration.flattenGroupedHits) // We flatten it to [{}, {}, {}]
                adaptedResult = adaptedResult.flat();
                else // We flatten it to [{ ..., grouped_hits: [{}, {}] }, {}, {}]
                // We set the first element in the group as the hit, and then add a new key called grouped_hits with the other hits
                adaptedResult = adaptedResult.map(function(adaptedGroupedHit) {
                    return $7c43f5a6e3f83414$var$_objectSpread($7c43f5a6e3f83414$var$_objectSpread({}, adaptedGroupedHit[0]), {}, {
                        _grouped_hits: adaptedGroupedHit
                    });
                });
                return adaptedResult;
            }
        },
        {
            key: "_adaptHits",
            value: function _adaptHits(typesenseHits) {
                var _this2 = this;
                var adaptedResult = [];
                adaptedResult = typesenseHits.map(function(typesenseHit) {
                    var adaptedHit = $7c43f5a6e3f83414$var$_objectSpread({}, typesenseHit.document);
                    adaptedHit.objectID = typesenseHit.document.id;
                    adaptedHit._snippetResult = _this2._adaptHighlightResult(typesenseHit, "snippet");
                    adaptedHit._highlightResult = _this2._adaptHighlightResult(typesenseHit, "value");
                    adaptedHit._rawTypesenseHit = typesenseHit; // Add metadata fields to result, if a field with that name doesn't already exist
                    [
                        "text_match",
                        "geo_distance_meters",
                        "curated",
                        "text_match_info",
                        "hybrid_search_info",
                        "vector_distance"
                    ].forEach(function(metadataField) {
                        if (Object.keys(typesenseHit).includes(metadataField) && !Object.keys(adaptedHit).includes(metadataField)) adaptedHit[metadataField] = typesenseHit[metadataField];
                    });
                    var geoLocationValue = adaptedHit[_this2.configuration.geoLocationField];
                    if (geoLocationValue) adaptedHit._geoloc = {
                        lat: geoLocationValue[0],
                        lng: geoLocationValue[1]
                    };
                    return adaptedHit;
                });
                return adaptedResult;
            }
        },
        {
            key: "_adaptHighlightResult",
            value: function _adaptHighlightResult(typesenseHit, snippetOrValue) {
                var result = {}; // If there is a highlight object available (as of v0.24.0),
                // And the highlight object uses the highlight format available in v0.24.0.rcn32 and above
                //  use that instead of the highlights array, since it supports highlights of nested fields
                if (typesenseHit.highlight != null && this.isHighlightPost0240RCN32Format(typesenseHit.highlight)) this.adaptHighlightObject(typesenseHit, result, snippetOrValue);
                else this.adaptHighlightsArray(typesenseHit, result, snippetOrValue);
                return result;
            }
        },
        {
            key: "isHighlightPost0240RCN32Format",
            value: function isHighlightPost0240RCN32Format(highlight) {
                return highlight.full == null && highlight.snippet == null;
            }
        },
        {
            key: "adaptHighlightsArray",
            value: function adaptHighlightsArray(typesenseHit, result, snippetOrValue) {
                var _this3 = this;
                // Algolia lists all searchable attributes in this key, even if there are no matches
                // So do the same and then override highlights
                Object.assign.apply(Object, [
                    result
                ].concat((0, $7c43f5a6e3f83414$var$_toConsumableArray2["default"])(Object.entries(typesenseHit.document).map(function(_ref) {
                    var _ref2 = (0, $7c43f5a6e3f83414$var$_slicedToArray2["default"])(_ref, 2), attribute = _ref2[0], value = _ref2[1];
                    return (0, $7c43f5a6e3f83414$var$_defineProperty2["default"])({}, attribute, {
                        value: value,
                        matchLevel: "none",
                        matchedWords: []
                    });
                }))));
                typesenseHit.highlights.forEach(function(highlight) {
                    result[highlight.field] = {
                        value: highlight[snippetOrValue] || highlight["".concat(snippetOrValue, "s")],
                        matchLevel: "full",
                        matchedWords: highlight.matched_tokens
                    };
                    if (highlight.indices) result[highlight.field]["matchedIndices"] = highlight.indices;
                }); // Now convert any values that have an array value
                // Also, replace highlight tag
                Object.entries(result).forEach(function(_ref4) {
                    var _ref5 = (0, $7c43f5a6e3f83414$var$_slicedToArray2["default"])(_ref4, 2), k = _ref5[0], v = _ref5[1];
                    var attribute = k;
                    var value = v.value, matchLevel = v.matchLevel, matchedWords = v.matchedWords, matchedIndices = v.matchedIndices;
                    if (value == null) result[attribute] = _this3._adaptHighlightNullValue();
                    else if (Array.isArray(value)) {
                        // Algolia lists all values of the key in highlights, even those that don't have any highlights
                        // So add all values of the array field, including highlights
                        result[attribute] = [];
                        typesenseHit.document[attribute].forEach(function(unhighlightedValueFromArray, index) {
                            if (matchedIndices && matchedIndices.includes(index)) result[attribute].push({
                                value: _this3._adaptHighlightTag("".concat(value[matchedIndices.indexOf(index)]), _this3.instantsearchRequest.params.highlightPreTag, _this3.instantsearchRequest.params.highlightPostTag),
                                matchLevel: matchLevel,
                                matchedWords: matchedWords[index]
                            });
                            else if ((0, $7c43f5a6e3f83414$var$_typeof2["default"])(unhighlightedValueFromArray) === "object") // Handle arrays of objects
                            // Side note: Typesense does not support highlights for nested objects in this `highlights` array,
                            //  so we pass in an empty object below
                            result[attribute].push(_this3._adaptHighlightInObjectValue(unhighlightedValueFromArray, {}, snippetOrValue));
                            else result[attribute].push({
                                value: "".concat(unhighlightedValueFromArray),
                                matchLevel: "none",
                                matchedWords: []
                            });
                        });
                    } else if ((0, $7c43f5a6e3f83414$var$_typeof2["default"])(value) === "object") // Handle nested objects
                    // Side note: Typesense does not support highlights for nested objects in this `highlights` array,
                    //  so we pass in an empty object below
                    result[attribute] = _this3._adaptHighlightInObjectValue(value, {}, snippetOrValue);
                    else // Convert all values to strings
                    result[attribute].value = _this3._adaptHighlightTag("".concat(value), _this3.instantsearchRequest.params.highlightPreTag, _this3.instantsearchRequest.params.highlightPostTag);
                });
            }
        },
        {
            key: "adaptHighlightObject",
            value: function adaptHighlightObject(typesenseHit, result, snippetOrValue) {
                Object.assign(result, this._adaptHighlightInObjectValue(typesenseHit.document, typesenseHit.highlight, snippetOrValue));
            }
        },
        {
            key: "_adaptHighlightInObjectValue",
            value: function _adaptHighlightInObjectValue(objectValue, highlightObjectValue, snippetOrValue) {
                var _this4 = this;
                return Object.assign.apply(Object, [
                    {}
                ].concat((0, $7c43f5a6e3f83414$var$_toConsumableArray2["default"])(Object.entries(objectValue).map(function(_ref6) {
                    var _ref7 = (0, $7c43f5a6e3f83414$var$_slicedToArray2["default"])(_ref6, 2), attribute = _ref7[0], value = _ref7[1];
                    var adaptedValue;
                    if (value == null) adaptedValue = _this4._adaptHighlightNullValue();
                    else if (Array.isArray(value)) {
                        var _highlightObjectValue;
                        adaptedValue = _this4._adaptHighlightInArrayValue(value, (_highlightObjectValue = highlightObjectValue === null || highlightObjectValue === void 0 ? void 0 : highlightObjectValue[attribute]) !== null && _highlightObjectValue !== void 0 ? _highlightObjectValue : [], snippetOrValue);
                    } else if ((0, $7c43f5a6e3f83414$var$_typeof2["default"])(value) === "object") {
                        var _highlightObjectValue2;
                        adaptedValue = _this4._adaptHighlightInObjectValue(value, (_highlightObjectValue2 = highlightObjectValue === null || highlightObjectValue === void 0 ? void 0 : highlightObjectValue[attribute]) !== null && _highlightObjectValue2 !== void 0 ? _highlightObjectValue2 : {}, snippetOrValue);
                    } else adaptedValue = _this4._adaptHighlightInPrimitiveValue(value, highlightObjectValue === null || highlightObjectValue === void 0 ? void 0 : highlightObjectValue[attribute], snippetOrValue);
                    return (0, $7c43f5a6e3f83414$var$_defineProperty2["default"])({}, attribute, adaptedValue);
                }))));
            }
        },
        {
            key: "_adaptHighlightInArrayValue",
            value: function _adaptHighlightInArrayValue(arrayValue, highlightArrayValue, snippetOrValue) {
                var _this5 = this;
                return arrayValue.map(function(value, index) {
                    var adaptedValue;
                    if (value == null) adaptedValue = _this5._adaptHighlightNullValue();
                    else if (Array.isArray(value)) {
                        var _highlightArrayValue$;
                        adaptedValue = _this5._adaptHighlightInArrayValue(value, (_highlightArrayValue$ = highlightArrayValue === null || highlightArrayValue === void 0 ? void 0 : highlightArrayValue[index]) !== null && _highlightArrayValue$ !== void 0 ? _highlightArrayValue$ : [], snippetOrValue);
                    } else if ((0, $7c43f5a6e3f83414$var$_typeof2["default"])(value) === "object") {
                        var _highlightArrayValue$2;
                        adaptedValue = _this5._adaptHighlightInObjectValue(value, (_highlightArrayValue$2 = highlightArrayValue === null || highlightArrayValue === void 0 ? void 0 : highlightArrayValue[index]) !== null && _highlightArrayValue$2 !== void 0 ? _highlightArrayValue$2 : {}, snippetOrValue);
                    } else adaptedValue = _this5._adaptHighlightInPrimitiveValue(value, highlightArrayValue === null || highlightArrayValue === void 0 ? void 0 : highlightArrayValue[index], snippetOrValue);
                    return adaptedValue;
                });
            }
        },
        {
            key: "_adaptHighlightInPrimitiveValue",
            value: function _adaptHighlightInPrimitiveValue(primitiveValue, highlightPrimitiveValue, snippetOrValue) {
                if (highlightPrimitiveValue != null) {
                    var _ref9, _highlightPrimitiveVa;
                    return {
                        value: this._adaptHighlightTag("".concat((_ref9 = (_highlightPrimitiveVa = highlightPrimitiveValue[snippetOrValue]) !== null && _highlightPrimitiveVa !== void 0 ? _highlightPrimitiveVa : highlightPrimitiveValue["highlight"]) !== null && _ref9 !== void 0 ? _ref9 : highlightPrimitiveValue["snippet"]), this.instantsearchRequest.params.highlightPreTag, this.instantsearchRequest.params.highlightPostTag),
                        matchLevel: (highlightPrimitiveValue.matched_tokens || []).length > 0 ? "full" : "none",
                        matchedWords: highlightPrimitiveValue.matched_tokens || []
                    };
                } else return {
                    // Convert all values to strings
                    value: this._adaptHighlightTag("".concat(primitiveValue), this.instantsearchRequest.params.highlightPreTag, this.instantsearchRequest.params.highlightPostTag),
                    matchLevel: "none",
                    matchedWords: []
                };
            }
        },
        {
            key: "_adaptHighlightNullValue",
            value: function _adaptHighlightNullValue() {
                return {
                    value: "",
                    matchLevel: "none",
                    matchedWords: []
                };
            }
        },
        {
            key: "_adaptFacets",
            value: function _adaptFacets(typesenseFacetCounts) {
                var adaptedResult = {};
                typesenseFacetCounts.forEach(function(facet) {
                    Object.assign(adaptedResult, (0, $7c43f5a6e3f83414$var$_defineProperty2["default"])({}, facet.field_name, Object.assign.apply(Object, [
                        {}
                    ].concat((0, $7c43f5a6e3f83414$var$_toConsumableArray2["default"])(facet.counts.map(function(count) {
                        return (0, $7c43f5a6e3f83414$var$_defineProperty2["default"])({}, count.value, count.count);
                    }))))));
                });
                return adaptedResult;
            }
        },
        {
            key: "_adaptFacetStats",
            value: function _adaptFacetStats(typesenseFacetCounts) {
                var adaptedResult = {};
                typesenseFacetCounts.forEach(function(facet) {
                    if (Object.keys(facet.stats).length > 0) Object.assign(adaptedResult, (0, $7c43f5a6e3f83414$var$_defineProperty2["default"])({}, facet.field_name, facet.stats));
                });
                return adaptedResult;
            }
        },
        {
            key: "_adaptRenderingContent",
            value: function _adaptRenderingContent(typesenseFacetCounts) {
                var _adaptedResult$facetO;
                var adaptedResult = Object.assign({}, this.configuration.renderingContent); // Only set facet ordering if the user has not set one
                if (((_adaptedResult$facetO = adaptedResult.facetOrdering) === null || _adaptedResult$facetO === void 0 || (_adaptedResult$facetO = _adaptedResult$facetO.facets) === null || _adaptedResult$facetO === void 0 ? void 0 : _adaptedResult$facetO.order) == null) {
                    adaptedResult.facetOrdering = adaptedResult.facetOrdering || {};
                    adaptedResult.facetOrdering.facets = adaptedResult.facetOrdering.facets || {};
                    adaptedResult.facetOrdering.facets.order = (0, $7c43f5a6e3f83414$var$_toConsumableArray2["default"])(new Set(typesenseFacetCounts.map(function(fc) {
                        return fc["field_name"];
                    }).concat(this.allTypesenseResponses.map(function(r) {
                        return r.facet_counts || [];
                    }).flat().map(function(fc) {
                        return fc["field_name"];
                    }).filter(function(f) {
                        return f;
                    }))));
                }
                return adaptedResult;
            }
        },
        {
            key: "adapt",
            value: function adapt() {
                var adaptedRenderingContent = this._adaptRenderingContent(this.typesenseResponse.facet_counts || []);
                var adaptedResult = $7c43f5a6e3f83414$var$_objectSpread({
                    hits: this.typesenseResponse.grouped_hits ? this._adaptGroupedHits(this.typesenseResponse.grouped_hits) : this._adaptHits(this.typesenseResponse.hits),
                    nbHits: this.typesenseResponse.found,
                    page: this.typesenseResponse.page - 1,
                    nbPages: this._adaptNumberOfPages(),
                    hitsPerPage: this.typesenseResponse.request_params.per_page,
                    facets: this._adaptFacets(this.typesenseResponse.facet_counts || []),
                    facets_stats: this._adaptFacetStats(this.typesenseResponse.facet_counts || {}),
                    query: this.typesenseResponse.request_params.q,
                    processingTimeMS: this.typesenseResponse.search_time_ms
                }, Object.keys(adaptedRenderingContent).length > 0 ? {
                    renderingContent: adaptedRenderingContent
                } : null); // console.log(adaptedResult);
                return adaptedResult;
            }
        }
    ]);
    return SearchResponseAdapter;
}();
module.exports.SearchResponseAdapter = $7c43f5a6e3f83414$var$SearchResponseAdapter;
Object.assign($7c43f5a6e3f83414$var$SearchResponseAdapter.prototype, $9nkv7.utils);

});
parcelRegister("hQc63", function(module, exports) {

var $gmm4P = parcelRequire("gmm4P");

var $fOMMA = parcelRequire("fOMMA");

var $5CWRA = parcelRequire("5CWRA");

var $3urkR = parcelRequire("3urkR");
function $cfd0ad29586195d9$var$_toConsumableArray(r) {
    return $gmm4P(r) || $fOMMA(r) || $5CWRA(r) || $3urkR();
}
module.exports = $cfd0ad29586195d9$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gmm4P", function(module, exports) {

var $fiAvJ = parcelRequire("fiAvJ");
function $be8fd36c87913215$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $fiAvJ(r);
}
module.exports = $be8fd36c87913215$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fOMMA", function(module, exports) {
function $b8415dbe7d58f84e$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $b8415dbe7d58f84e$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3urkR", function(module, exports) {
function $28a960b7c1d99559$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $28a960b7c1d99559$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jnR56", function(module, exports) {

var $hGj3F = parcelRequire("hGj3F");
function $03a447994818920d$var$_defineProperty(e, r, t) {
    return (r = $hGj3F(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $03a447994818920d$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9nkv7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utils = void 0;
var $6d362a188c2e01a4$var$utils = {
    _adaptHighlightTag: function _adaptHighlightTag(value, highlightPreTag, highlightPostTag) {
        return value.replace(new RegExp("<mark>", "g"), highlightPreTag || "<mark>").replace(new RegExp("</mark>", "g"), highlightPostTag || "</mark>");
    },
    _adaptNumberOfPages: function _adaptNumberOfPages() {
        var result = this.typesenseResponse.found / this.typesenseResponse.request_params.per_page;
        if (Number.isFinite(result)) return Math.ceil(result);
        else return 1;
    }
};
module.exports.utils = $6d362a188c2e01a4$var$utils;

});


parcelRegister("eXaZk", function(module, exports) {
"use strict";

var $9suN4 = parcelRequire("9suN4");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FacetSearchResponseAdapter = void 0;

var $ae2f1965e9a4e348$var$_classCallCheck2 = $9suN4((parcelRequire("6RERu")));

var $ae2f1965e9a4e348$var$_createClass2 = $9suN4((parcelRequire("1XdEY")));

var $9nkv7 = parcelRequire("9nkv7");
var $ae2f1965e9a4e348$var$FacetSearchResponseAdapter = /*#__PURE__*/ function() {
    function FacetSearchResponseAdapter(typesenseResponse, instantsearchRequest) {
        (0, $ae2f1965e9a4e348$var$_classCallCheck2["default"])(this, FacetSearchResponseAdapter);
        this.typesenseResponse = typesenseResponse;
        this.instantsearchRequest = instantsearchRequest;
    }
    (0, $ae2f1965e9a4e348$var$_createClass2["default"])(FacetSearchResponseAdapter, [
        {
            key: "_adaptFacetHits",
            value: function _adaptFacetHits(typesenseFacetCounts) {
                var _this = this;
                var adaptedResult = {};
                var facet = typesenseFacetCounts.find(function(facet) {
                    return facet.field_name === _this.instantsearchRequest.params.facetName;
                });
                adaptedResult = facet.counts.map(function(facetCount) {
                    return {
                        value: facetCount.value,
                        highlighted: _this._adaptHighlightTag(facetCount.highlighted, _this.instantsearchRequest.params.highlightPreTag, _this.instantsearchRequest.params.highlightPostTag),
                        count: facetCount.count
                    };
                });
                return adaptedResult;
            }
        },
        {
            key: "adapt",
            value: function adapt() {
                var adaptedResult = {
                    facetHits: this._adaptFacetHits(this.typesenseResponse.facet_counts),
                    exhaustiveFacetsCount: true,
                    processingTimeMS: this.typesenseResponse.search_time_ms
                };
                return adaptedResult;
            }
        }
    ]);
    return FacetSearchResponseAdapter;
}();
module.exports.FacetSearchResponseAdapter = $ae2f1965e9a4e348$var$FacetSearchResponseAdapter;
Object.assign($ae2f1965e9a4e348$var$FacetSearchResponseAdapter.prototype, $9nkv7.utils);

});



//# sourceMappingURL=index.b43ed3ba.js.map
